'use-strict';

var root = document.body;

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function getCookie(cname) {
  let name = cname + '=';
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

function deleteCookie(cname) {
  document.cookie = cname + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

function setCookie(cname, cvalue, exdays) {
  const date = new Date();
  date.setTime(date.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = 'expires=' + date.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

function setCookiePopup(name, value, minutes) {
  let expires = "";
  if (minutes) {
    const date = new Date();
    date.setTime(date.getTime() + (minutes * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  };
}

function cartStateForPromotionRefresh(cartState) {
  if (!cartState?.items || cartState.item_count == null) return null;
  const { sections: _sections, ...cartSnapshot } = cartState;
  return cartSnapshot;
}

function closeCartPromotionDiscoverPanels() {
  const openPanels = document.querySelectorAll(
    '.ss-cart-promotion-discover.is-open'
  );
  openPanels.forEach((panel) => {
    panel.classList.remove('is-open');
  });
  return openPanels.length > 0;
}

function pinMinicartProductListActions(scope = document) {
  if (!scope?.querySelectorAll) return;
  const productItems = scope.querySelectorAll(
    '.cart-recommend .swiper-cart-upsell-minicart .product-item, .instagram-shop-recommendations .swiper-cart-upsell-minicart .product-item'
  );
  productItems.forEach((productItem) => {
    const mediaContainer = productItem.querySelector('.product-item__inner');
    const actionContainer = productItem.querySelector('.product-list-action');
    if (
      !mediaContainer
      || !actionContainer
      || mediaContainer.contains(actionContainer)
    ) {
      return;
    }
    actionContainer.classList.add('minicart-product-list-action-on-media');
    mediaContainer.appendChild(actionContainer);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  pinMinicartProductListActions(document);
});

function isVisibleVariantPickerElement(element) {
  if (!element) return false;
  const style = window.getComputedStyle(element);
  return (
    style.display !== 'none'
    && style.visibility !== 'hidden'
    && element.getClientRects().length > 0
  );
}

function getFirstVisibleVariantPicker(scope, sectionId) {
  if (!scope || !sectionId) return null;
  const pickers = [
    ...scope.querySelectorAll(
      `variant-radios-detail[data-section="${sectionId}"], variant-group-detail[data-section="${sectionId}"], variant-radios-sticky[data-section="${sectionId}"], variant-group-sticky[data-section="${sectionId}"]`
    ),
  ];
  if (pickers.length === 0) return null;
  return pickers.find((picker) => isVisibleVariantPickerElement(picker)) || pickers[0];
}

function getSelectedValuesFromVariantPicker(picker) {
  if (!picker) return [];

  const getOptionName = (container, selectedOption = null) => {
    const selectedInput = container.querySelector?.('[data-variant-input]:checked');
    const input = selectedInput || container.querySelector?.('[data-variant-input]');
    const optionName = selectedOption?.dataset?.name
      || input?.name
      || container.querySelector?.('[data-option-name]')?.dataset?.optionName
      || container.querySelector?.('.form__label .bold')?.textContent
      || '';

    return `${optionName}`.replace(/:\s*$/, '').trim();
  };

  const formatOptionSummary = (name, value) => {
    const optionValue = `${value || ''}`.trim();
    if (optionValue === '') return '';

    const optionName = `${name || ''}`.trim();
    return optionName !== '' ? `${optionName}:${optionValue}` : optionValue;
  };

  const collectValue = (container) => {
    const checkedInput = container.querySelector('[data-variant-input]:checked');
    if (checkedInput) {
      const checkedValue = `${checkedInput.value || ''}`.trim();
      if (checkedValue !== '') return formatOptionSummary(getOptionName(container), checkedValue);
    }

    const select = container.tagName === 'SELECT' ? container : container.querySelector('select');
    if (select) {
      const selectedOption = select.options?.[select.selectedIndex];
      const selectedValue = `${selectedOption?.dataset?.value || selectedOption?.textContent || ''}`.trim();
      if (selectedValue !== '') return formatOptionSummary(getOptionName(container, selectedOption), selectedValue);
    }

    return formatOptionSummary(
      getOptionName(container),
      `${container.querySelector('.option_value')?.textContent || ''}`.trim()
    );
  };

  const wrappers = [...picker.querySelectorAll('.product-form__input')];
  if (wrappers.length > 0) {
    return wrappers.map((wrapper) => collectValue(wrapper)).filter(Boolean);
  }

  return [...picker.children]
    .filter((child) => child.tagName === 'SELECT')
    .map((select) => collectValue(select))
    .filter(Boolean);
}

function hasMissingSelectionsInVariantPicker(picker) {
  if (!picker || picker.dataset.variantSelectionMode !== 'manual') return false;
  const wrappers = [...picker.querySelectorAll('.product-form__input')];
  if (wrappers.length === 0) return false;

  return wrappers.some((wrapper) => {
    const checkedInput = wrapper.querySelector('[data-variant-input]:checked');
    if (checkedInput) return false;

    const select = wrapper.querySelector('select');
    if (select) {
      const selectedOption = select.options?.[select.selectedIndex];
      const selectedValue = `${selectedOption?.dataset?.value || selectedOption?.textContent || ''}`.trim();
      return selectedValue === '';
    }

    const optionValue = `${wrapper.querySelector('.option_value')?.textContent || ''}`.trim();
    return optionValue === '';
  });
}

function getVariantSummaryFromVariantData(variant) {
  if (!variant) return '';

  const optionValues = (Array.isArray(variant.options)
    ? variant.options
    : [variant.option1, variant.option2, variant.option3]
  )
    .map((value) => `${value || ''}`.trim())
    .filter(Boolean);

  if (optionValues.length > 0) return optionValues.join(', ');

  const title = `${variant.title || ''}`.trim();
  if (title !== '' && title !== 'Default Title') return title;

  return '';
}

function getSelectedVariantSummaryText(scope, sectionId) {
  if (!scope || !sectionId) return '';

  const picker = getFirstVisibleVariantPicker(scope, sectionId);
  if (picker) {
    if (hasMissingSelectionsInVariantPicker(picker)) return '';

    const selectedValues = getSelectedValuesFromVariantPicker(picker);
    if (selectedValues.length > 0) {
      return selectedValues.join(', ');
    }

    const pickerVariantScript = picker.querySelector('script[data-selected-variant]');
    if (pickerVariantScript) {
      try {
        return getVariantSummaryFromVariantData(
          JSON.parse(pickerVariantScript.textContent || '{}')
        );
      } catch (error) {
        return '';
      }
    }
  }

  const fallbackScript = scope.querySelector('script[data-selected-variant]');
  if (!fallbackScript) return '';

  try {
    return getVariantSummaryFromVariantData(
      JSON.parse(fallbackScript.textContent || '{}')
    );
  } catch (error) {
    return '';
  }
}

function syncSelectedVariantSummaries(scope, sectionId) {
  if (!scope || !sectionId) return;

  const summaryText = getSelectedVariantSummaryText(scope, sectionId);
  const hasSummaryText = summaryText !== '';
  scope
    .querySelectorAll(`[data-selected-variant-summary][data-section="${sectionId}"]`)
    .forEach((summary) => {
      const value = summary.querySelector('[data-selected-variant-summary-value]');
      if (value) {
        value.textContent = summaryText;
      }

      if (hasSummaryText) {
        summary.removeAttribute('hidden');
      } else {
        summary.setAttribute('hidden', 'hidden');
      }
    });

  scope
    .querySelectorAll(
      `.selected-variant-summary--main-product[data-selected-variant-summary][data-section="${sectionId}"]`
    )
    .forEach((summary) => {
      const buttons = summary.closest('.product-form__buttons');
      if (buttons) {
        buttons.classList.toggle('has-selected-variant-summary-mobile', hasSummaryText);
      }
    });
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target?.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options['hideElement'] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    'change',
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return formatString.replace(placeholderRegex, value);
};

function HoverIntent(elements, userConfig) {
  const defaultOptions = {
    exitDelay: 180,
    interval: 100,
    sensitivity: 6,
  };
  let config = {};
  let currX, currY, prevX, prevY;
  let allElems, pollTimer, exitTimer;
  const extend = function (defaults, userArgs) {
    for (let i in userArgs) {
      defaults[i] = userArgs[i];
    }
    return defaults;
  };
  const mouseTrack = function (ev) {
    currX = ev.pageX;
    currY = ev.pageY;
  };
  const mouseCompare = function (targetElem) {
    const distX = prevX - currX,
      distY = prevY - currY;
    const distance = Math.sqrt(distX * distX + distY * distY);
    if (distance < config.sensitivity) {
      clearTimeout(exitTimer);
      for (let elem of allElems) {
        if (elem.isActive) {
          config.onExit(elem);
          elem.isActive = false;
        }
      }
      config.onEnter(targetElem);
      targetElem.isActive = true;
    } else {
      prevX = currX;
      prevY = currY;
      pollTimer = setTimeout(function () {
        mouseCompare(targetElem);
      }, config.interval);
    }
  };
  const init = function (elements, userConfig) {
    if (!userConfig || !userConfig.onEnter || !userConfig.onExit) {
      throw 'onEnter and onExit callbacks must be provided';
    }
    config = extend(defaultOptions, userConfig);
    allElems = elements;
    for (let elem of allElems) {
      if (!elem) return;
      elem.isActive = false;
      elem.addEventListener('mousemove', mouseTrack);
      elem.addEventListener('mouseenter', function (ev) {
        prevX = ev.pageX;
        prevY = ev.pageY;
        if (elem.isActive) {
          clearTimeout(exitTimer);
          return;
        }
        pollTimer = setTimeout(function () {
          mouseCompare(elem);
        }, config.interval);
      });
      elem.addEventListener('mouseleave', function (ev) {
        clearTimeout(pollTimer);
        if (!elem.isActive) return;
        exitTimer = setTimeout(function () {
          config.onExit(elem);
          elem.isActive = false;
        }, config.exitDelay);
      });
    }
  };
  init(elements, userConfig);
}

function initComparisons() {
  var x, i;
  x = document.getElementsByClassName('img-comp-overlay');
  for (i = 0; i < x.length; i++) {
    compareImages(x[i]);
  }
  function compareImages(img) {
    var slider,
      img,
      clicked = 0,
      w;
    w = img.offsetWidth;
    const icc = img.closest('.img-comp-container');
    if (icc) {
      slider = icc.querySelector('.image-comparison__button');
    }
    if (slider) {
      slider.addEventListener('touchstart', slideReady);
      slider.addEventListener('mousedown', slideReady);
    }
    window.addEventListener('mouseup', slideFinish);
    window.addEventListener('touchend', slideFinish);
    function slideReady(e) {
      e.preventDefault();
      clicked = 1;
      window.addEventListener('mousemove', slideMove);
      window.addEventListener('touchmove', slideMove);
    }
    function slideFinish() {
      clicked = 0;
    }
    function slideMove(e) {
      var pos;
      if (clicked == 0) return false;
      pos = getCursorPos(e);
      if (pos < 0) pos = 0;
      if (pos > w) pos = w;
      slide(pos);
    }
    function getCursorPos(e) {
      var a,
        x = 0;
      e = e.changedTouches ? e.changedTouches[0] : e;
      a = img.getBoundingClientRect();
      x = e.pageX - a.left;
      x = x - window.pageXOffset;

      return x;
    }
    function slide(x) {
      if (slider) {
        var x_ps = x + slider.offsetWidth / 2 + 10;
        var percent = (x_ps / w) * 100;
        if (percent >= 100 - ((slider.offsetWidth / 2 + 10) / w) * 100) {
          percent = 100 - ((slider.offsetWidth / 2 + 10) / w) * 100;
        }
      }

      img
        .closest('.img-comp-container')
        .setAttribute('style', '--percent: ' + percent.toFixed(4) + '%;');
    }
  }
}
initComparisons();

function initLazyloadItem() {
  const lazyVideos = document.querySelectorAll('video.lazy-video-item');

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const video = entry.target;
          const poster = video.dataset.poster;
          const src = video.dataset.src;

          if (poster) {
            video.setAttribute('poster', poster);
            video.removeAttribute('data-poster');
            video.setAttribute('src', src);
            video.removeAttribute('data-src');
          }

          video.querySelectorAll('source').forEach((source) => {
            const source_src = source.dataset.src;
            if (source_src) {
              source.setAttribute('src', source_src);
              source.removeAttribute('data-src');
            }
          });

          video.classList.remove('lazy-video-item');
          observer.unobserve(video); // Stop observing once loaded
        }
      });
    },
    { threshold: 0.1 } // Trigger when 10% of the video is visible
  );

  lazyVideos.forEach((video) => observer.observe(video));
}

// Initialize lazy loading item
initLazyloadItem();

function initLazyload() {
  window.addEventListener('scroll', () => {
    this.scrollLazyload();
  });
  let pos = window.pageYOffset;
  if (pos > 40) {
    this.scrollLazyload();
  }
}
initLazyload();

function scrollLazyload() {
  document.querySelectorAll('video.lazy-video').forEach((el) => {
    scrollLazyloadItem(el);
  });
  const productMarqueeBadges = document.querySelectorAll('.product__marquee-badges');
  productMarqueeBadges.forEach((el) => {
    if (el.querySelector("template")) {
      const content = document.createElement("div");
      content.appendChild(
        el.querySelector("template").content.firstElementChild.cloneNode(true)
      );
      const animationMarquee = content.querySelectorAll('.animation-marquee');
      animationMarquee.forEach((el_animation) => {
        el.appendChild(el_animation);
      });
      el.querySelector("template").remove();
    }
  });
}

function scrollLazyloadItem(el) {
  const poster = el.dataset.poster;
  const src = el.dataset.src;
  if (poster) {
    el.setAttribute('poster', poster);
    el.removeAttribute('data-poster');
    el.setAttribute('src', src);
    el.removeAttribute('data-src');
  }
  el.querySelectorAll('source').forEach((source) => {
    const source_src = source.dataset.src;
    if (source_src) {
      source.setAttribute('src', source_src);
      source.removeAttribute('data-src');
    }
  });
  el.classList.remove('lazy-video');
}

function eventFlashingBrowseTab() {
  var enable = window.flashingBrowseTab?.enable,
    myTimer,
    message,
    titleTag = document.getElementsByTagName('title')[0],
    first_notification = window.flashingBrowseTab?.firstNotification,
    secondary_notification = window.flashingBrowseTab?.secondaryNotification;
  if (enable && titleTag) {
    var originalTitle = titleTag.innerText;
    var isActive = true;
    document.addEventListener('visibilitychange', () => {
      document.visibilityState === 'visible'
        ? (function () {
            if (isActive) return;
            clearInterval(myTimer), (titleTag.innerText = originalTitle);
          })()
        : (function () {
            var i = 1;
            if (
              ((isActive = false),
              !first_notification || !secondary_notification)
            )
              return;
            myTimer = setInterval(function () {
              if (i == 1) {
                message = first_notification;
                i = 2;
              } else {
                message = secondary_notification;
                i = 1;
              }
              titleTag.innerText = message;
            }, 2000);
          })();
    });
  }
}
eventFlashingBrowseTab();

function initializeLazyLoad() {
  const videoPlaceholders = document.querySelectorAll('.lazy-video-link');
  const loadYouTubeVideo = (element) => {
    const videoId = element.getAttribute('data-video-id');
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.youtube.com/embed/${videoId}?controls=0&autoplay=1&mute=1&playsinline=1&loop=1&playlist=${videoId}`;
    iframe.allowFullscreen = true;
    iframe.frameBorder = '0';
    iframe.allow =
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    element.innerHTML = '';
    element.appendChild(iframe);
  };
  const loadVimeoVideo = (element) => {
    const videoId = element.getAttribute('data-video-id');
    const iframe = document.createElement('iframe');
    iframe.src = `https://player.vimeo.com/video/${videoId}?controls=0background=1&autoplay=1&muted=1&loop=1`;
    iframe.allowFullscreen = true;
    iframe.allow = 'autoplay; fullscreen; picture-in-picture';
    iframe.frameBorder = '0';
    element.innerHTML = '';
    element.appendChild(iframe);
  };
  const loadVideo = (element) => {
    const videoType = element.getAttribute('data-video-type');
    if (videoType === 'youtube') {
      loadYouTubeVideo(element);
    } else if (videoType === 'vimeo') {
      loadVimeoVideo(element);
    }
  };
  const lazyLoadVideos = () => {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadVideo(entry.target);
          observer.unobserve(entry.target);
        }
      });
    });
    videoPlaceholders.forEach((videoPlaceholder) => {
      observer.observe(videoPlaceholder);
    });
  };
  lazyLoadVideos();
}
initializeLazyLoad();

const slideAnime = (() => {
  let isAnimating = false;

  return (setOptions) => {
    const defaultOptions = {
      target: false,
      animeType: 'slideToggle',
      duration: 250,
      easing: 'ease',
      isDisplayStyle: 'block',
      parent: false,
      addFunction: () => {},
    };
    const options = Object.assign({}, defaultOptions, setOptions);
    const target = options.target;
    const ownAnimate = options.ownAnimate;
    if (ownAnimate) {
      isAnimating = false;
    }
    const parent = options.parent;
    if (!target) {
      return;
    }

    if (isAnimating) {
      return;
    }
    isAnimating = true;
    parent.classList?.toggle('opened');

    let animeType = options.animeType;
    const styles = getComputedStyle(target);
    if (animeType === 'slideToggle') {
      animeType = styles.display === 'none' ? 'slideDown' : 'slideUp';
    }
    if (
      (animeType === 'slideUp' && styles.display === 'none') ||
      (animeType === 'slideDown' && styles.display !== 'none') ||
      (animeType !== 'slideUp' && animeType !== 'slideDown')
    ) {
      isAnimating = false;
      return false;
    }
    target.style.overflow = 'hidden';
    const duration = options.duration;
    const easing = options.easing;
    const isDisplayStyle = options.isDisplayStyle;

    if (animeType === 'slideDown') {
      target.style.display = isDisplayStyle;
    }
    const heightVal = {
      height: target.getBoundingClientRect().height + 'px',
      marginTop: styles.marginTop,
      marginBottom: styles.marginBottom,
      paddingTop: styles.paddingTop,
      paddingBottom: styles.paddingBottom,
    };

    Object.keys(heightVal).forEach((key) => {
      if (parseFloat(heightVal[key]) === 0) {
        delete heightVal[key];
      }
    });
    if (Object.keys(heightVal).length === 0) {
      isAnimating = false;
      return false;
    }
    let slideAnime;
    if (animeType === 'slideDown') {
      Object.keys(heightVal).forEach((key) => {
        target.style[key] = 0;
      });
      slideAnime = target.animate(heightVal, {
        duration: duration,
        easing: easing,
      });
    } else if (animeType === 'slideUp') {
      Object.keys(heightVal).forEach((key) => {
        target.style[key] = heightVal[key];
        heightVal[key] = 0;
      });
      slideAnime = target.animate(heightVal, {
        duration: duration,
        easing: easing,
      });
    }
    slideAnime.finished.then(() => {
      options.addFunction();
      target.style.overflow = '';
      Object.keys(heightVal).forEach((key) => {
        target.style[key] = '';
      });
      if (animeType === 'slideUp') {
        target.style.display = 'none';
      }
      isAnimating = false;
    });
  };
})();

class MultiContent extends SlideSection {
  constructor() {
    super();
    this.enable = this.dataset.enable;
    this.swiperSlideInnerHtml = this.innerHTML;
    this.init();
  }
  init() {
    if (this.enable == 'true') {
      let width = window.innerWidth;
      window.addEventListener('resize', () => {
        const newWidth = window.innerWidth;
        if (newWidth <= 767 && width > 767) {
          this.actionOnMobile();
        }
        if (newWidth > 767 && width <= 767) {
          this.actionOutMobile();
        }
        width = newWidth;
      });
      if (width <= 576) {
        this.actionOnMobile();
      } else {
        this.actionOutMobile();
      }
    }
  }
  actionOnMobile() {
    this.classList.add('swiper');
    const html = this.swiperSlideInnerHtml.replaceAll(
      'section__block',
      'swiper-slide'
    );
    const wrapper = `<div class='swiper-wrapper'>${html}</div> <div
    class="swiper-pagination  ${
      this.enable && this.dataset.mobile != 1.5 ? 'flex' : 'hidden'
    } px-15 lh-1 bottom-30 justify-content-center"
    style="--swiper-pagination-bottom: 3rem;--swiper-pagination-position: static;"
  ></div> `;
    this.innerHTML = wrapper;
    this.initSlide();
  }
  actionOutMobile() {
    if (this.classList.contains('swiper')) {
      this.classList.remove('swiper');
      this.innerHTML = this.swiperSlideInnerHtml;
    }
  }
}
customElements.define('multi-content', MultiContent);
var getScrollBarWidth = (function () {
  return {
    init: function () {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.width = '100px';
      scrollDiv.style.height = '100px';
      scrollDiv.style.overflow = 'scroll';
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      document.body.appendChild(scrollDiv);
      var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
      return scrollbarWidth;
    },
  };
})();
var wishlistHeader = (function () {
  return {
    init: function () {
      this.handleCount();
    },
    handleCount: function () {
      const wishlist = document.querySelectorAll('.wishlist-count');
      const items = JSON.parse(localStorage.getItem('glozin__wishlist-items'));
      wishlist.forEach((item) => {
        item.innerText = items !== null && items.length != 0 ? items.length : 0;
      });
    },
  };
})();
wishlistHeader.init();

var BlsSearchShopify = (function () {
  return {
    init: function () {
      var predictive = document.querySelector('#predictive-search');
      if (predictive) {
        this.setupEventListeners();
      }
      const form = document.querySelector('#search-form');
      document.querySelectorAll('.top-search-toggle').forEach((navToggle) => {
        navToggle.addEventListener('click', (e) => {
          const target = e.currentTarget;
          if (!form.classList.contains('open')) {
            form.classList.add('open');
            target.classList.add('open');
            document.documentElement.classList.add(
              'open-drawer',
              'open-search'
            );
            root.style.setProperty(
              'padding-right',
              getScrollBarWidth.init() + 'px'
            );
            setTimeout(function () {
              form.querySelector('input[type="search"]').focus();
            }, 100);
          } else {
            form.classList.remove('open');
            target.classList.remove('open');
            document.documentElement.classList.remove(
              'open-drawer',
              'open-search'
            );
            root.style.removeProperty('padding-right');
          }
        });
      });
      document.querySelectorAll('.btn-search-close').forEach((navToggle) => {
        navToggle.addEventListener('click', () => {
          form.classList.remove('open');
          document
            .querySelector('.dropdown-toggle .top-search-toggle')
            .classList.remove('open');
          document.documentElement.classList.remove(
            'open-drawer',
            'open-search'
          );
          root.style.removeProperty('padding-right');
        });
      });
      const sf = document.querySelector('.search-full');
      if (sf) {
        const hs = sf.closest('.header_search');
        document.addEventListener('click', (e) => {
          const ehs = e.target.closest('.header_search');
          if (!ehs) {
            if (hs) {
              const ps = hs.querySelector('.popup-search');
              if (ps) {
                ps.classList.remove('popup-search-show');
                if (
                  document.documentElement.classList.contains('open-search')
                ) {
                  document.documentElement.classList.remove(
                    'open-drawer',
                    'open-search'
                  );
                  root.style.removeProperty('padding-right');
                }
              }
            }
          } else {
            const ps = ehs.querySelector('.popup-search');
            if (ps) {
              ps.classList.add('popup-search-show');
              if (
                e.target &&
                e.target.classList.contains('popup-search-show')
              ) {
                ps.classList.remove('popup-search-show');
                document.documentElement.classList.remove(
                  'open-drawer',
                  'open-search'
                );
                root.style.removeProperty('padding-right');
              } else {
                document.documentElement.classList.add(
                  'open-drawer',
                  'open-search'
                );
                root.style.setProperty(
                  'padding-right',
                  getScrollBarWidth.init() + 'px'
                );
              }
            }
          }
        });
      }
    },
    setupEventListeners: function () {
      const input = document.querySelector('input[type="search"]');
      const form = document.querySelector('form.search');
      form.addEventListener('submit', this.onFormSubmit.bind(this));
      input.addEventListener(
        'input',
        this.debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
      input.addEventListener('focus', this.onFocus.bind(this));
      document.addEventListener('focusout', this.onFocusOut.bind(this));
      document.addEventListener('keyup', this.onKeyup.bind(this));
    },

    debounce: function (fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    },

    getQuery: function () {
      return document.querySelector('input[type="search"]').value.trim();
    },

    onChange: function () {
      const searchTerm = this.getQuery();
      if (!searchTerm.length) {
        this.close(true);
        return;
      }
      this.getSearchResults(searchTerm);
    },

    onFormSubmit: function (event) {
      if (
        !this.getQuery().length ||
        this.querySelector('[aria-selected="true"] a')
      )
        event.preventDefault();
    },

    onFocus: function () {
      const searchTerm = this.getQuery();
      if (!searchTerm.length) return;
      if (
        document
          .querySelector('#predictive-search')
          .classList.contains('results')
      ) {
        this.open();
      } else {
        this.getSearchResults(searchTerm);
      }
    },

    onFocusOut: function () {
      setTimeout(() => {
        if (!document.contains(document.activeElement)) this.close();
      });
    },

    onKeyup: function (event) {
      if (!this.getQuery().length) this.close(true);
      event.preventDefault();

      switch (event.code) {
        case 'ArrowUp':
          this.switchOption('up');
          break;
        case 'ArrowDown':
          this.switchOption('down');
          break;
        case 'Enter':
          this.selectOption();
          break;
      }
    },

    switchOption: function (direction) {
      if (!this.getAttribute('open')) return;
      const moveUp = direction === 'up';
      const selectedElement = document.querySelector('[aria-selected="true"]');
      const allElements = document.querySelectorAll('li');
      let activeElement = document.querySelector('li');

      if (moveUp && !selectedElement) return;

      this.statusElement.textContent = '';

      if (!moveUp && selectedElement) {
        activeElement = selectedElement.nextElementSibling || allElements[0];
      } else if (moveUp) {
        activeElement =
          selectedElement.previousElementSibling ||
          allElements[allElements.length - 1];
      }

      if (activeElement === selectedElement) return;

      activeElement.setAttribute('aria-selected', true);
      if (selectedElement) selectedElement.setAttribute('aria-selected', false);
      document
        .querySelector('input[type="search"]')
        .setAttribute('aria-activedescendant', activeElement.id);
    },

    selectOption: function () {
      const selectedProduct = document.querySelector(
        '[aria-selected="true"] a, [aria-selected="true"] button'
      );

      if (selectedProduct) selectedProduct.click();
    },

    getSearchResults: function (searchTerm) {
      const cachedResults = {};
      const queryKey = searchTerm.replace(' ', '-').toLowerCase();
      this.setLiveRegionLoadingState();
      if (cachedResults[queryKey]) {
        this.renderSearchResults(cachedResults[queryKey]);
        return;
      }
      var section_id = 'search-predictive-grid';
      if (document.querySelector('.predictive_search_suggest')) {
        var search_url = `${
          routes?.predictive_search_url
        }?q=${encodeURIComponent(
          searchTerm
        )}&resources[options][fields]=title,tag,vendor,product_type,variants.title,variants.sku&resources[options][prefix]=last&resources[options][unavailable_products]=last&resources[type]=query,product,collection,page,article&section_id=${section_id}`;
      } else {
        var search_url = `${routes.search_url}?q=${encodeURIComponent(
          searchTerm
        )}&options[prefix]=last&options[unavailable_products]=last&type=query,product,collection,page,article&section_id=${section_id}`;
      }
      fetch(`${search_url}`)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }
          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#shopify-section-' + section_id + '').innerHTML;
          cachedResults[queryKey] = resultsMarkup;
          this.renderSearchResults(resultsMarkup);
        })
        .catch((error) => {
          this.close();
          throw error;
        });
    },

    setLiveRegionLoadingState: function () {
      document.querySelector('#search_mini_form').classList.add('loading');
      document.querySelector('#predictive-search').classList.add('loading');
    },

    setLiveRegionResults: function () {
      document.querySelector('#search_mini_form').classList.remove('loading');
      document.querySelector('#predictive-search').classList.remove('loading');
    },

    renderSearchResults: function (resultsMarkup) {
      document.querySelector('[data-predictive-search]').innerHTML =
        resultsMarkup;
      document.querySelector('#predictive-search').classList.add('results');
      if (document.querySelector('.search-not-sugges')) {
        document
          .querySelector('.search-not-sugges')
          .classList.remove('search-hidden');
        document.documentElement.classList.add('open-drawer', 'open-search');
        root.style.setProperty(
          'padding-right',
          getScrollBarWidth.init() + 'px'
        );
      }
      const quick_search = document.querySelector('#quick-search');
      if (quick_search) {
        quick_search.classList.add('hidden');
      }
      this.setLiveRegionResults();
      this.open();
    },

    open: function () {
      document
        .querySelector('input[type="search"]')
        .setAttribute('aria-expanded', true);
      this.isOpen = true;
    },

    close: function (clearSearchTerm = false) {
      if (clearSearchTerm) {
        document.querySelector('input[type="search"]').value = '';
        document
          .querySelector('#predictive-search')
          .classList.remove('results');
        if (document.querySelector('.search-not-sugges')) {
          document
            .querySelector('.search-not-sugges')
            .classList.add('search-hidden');
          document.documentElement.classList.remove(
            'open-drawer',
            'open-search'
          );
          root.style.removeProperty('padding-right');
        }

        const quick_search = document.querySelector('#quick-search');
        if (quick_search) {
          quick_search.classList.remove('hidden');
        }
      }
      const selected = document.querySelector('[aria-selected="true"]');
      if (selected) selected.setAttribute('aria-selected', false);
      document
        .querySelector('input[type="search"]')
        .setAttribute('aria-activedescendant', '');
      document
        .querySelector('input[type="search"]')
        .setAttribute('aria-expanded', false);
      this.resultsMaxHeight = false;
      document
        .querySelector('[data-predictive-search]')
        .removeAttribute('style');
      this.isOpen = false;
    },
  };
})();
BlsSearchShopify.init();

class HeaderSearch extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    const _this = this;
    const header = this.closest('header');
    if (
      header.classList.contains('popup-search-mobile') &&
      this.classList.contains('search_type_default')
    ) {
      let sectionId = header.dataset.sectionId;
      if (window.innerWidth < 767) {
        _this.fetchUrl(
          `${window.location.pathname}?section_id=${sectionId}&type=popup&ajax=1`
        );
      }
      let width = window.innerWidth;
      window.addEventListener('resize', function () {
        const newWidth = window.innerWidth;
        if (newWidth <= 767 && width > 767) {
          _this.fetchUrl(
            `${window.location.pathname}?section_id=${sectionId}&type=popup&ajax=1`
          );
        }
        if (newWidth > 767 && width <= 767) {
          _this.fetchUrl(
            `${window.location.pathname}?section_id=${sectionId}&type=default&ajax=1`
          );
        }
        width = newWidth;
      });
    }
  }
  fetchUrl(url) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const newSection = new DOMParser()
          .parseFromString(responseText, 'text/html')
          .querySelector('header-search').innerHTML;
        document.querySelector('header-search').innerHTML = newSection;
      })
      .catch((e) => {
        throw e;
      })
      .finally(() => {
        BlsSearchShopify.init();
      });
  }
}
customElements.define('header-search', HeaderSearch);

class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.notification = document.getElementById('header__minicart');
    this.giftwrap = document.querySelector('.add-giftwrap');
    this.startTime = Date.now();
    this.querySelectorAll('.minicart__wrapper .close-cart-button').forEach(
      (closeButton) =>
        closeButton.addEventListener('click', this.close.bind(this))
    );
    this.querySelectorAll('.minicart__action').forEach((navToggle) => {
      navToggle.addEventListener(
        'click',
        (e) => {
          e.preventDefault();
          if (
            this.notification
              .querySelector('.minicart__wrapper')
              .classList.contains('open')
          ) {
            this.close();
          } else {
            this.open();
          }
        },
        false
      );
    });
    this.currentItemCount = Array.from(
      this.querySelectorAll('[data-cart-quantity-input]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.onCartAddonClick = this.cartAddons.bind(this);
    this.pendingQuantityUpdates = new Map();
    this.quantityUpdateTimer = 0;
    this.addEventListener('change', this.onChange.bind(this));
    this.cartAction();
    this.addonsUpdate();
    this.handleMinicartTab();
  }

  handleBodyClick(evt) {
    const target = evt.target instanceof Element ? evt.target : null;
    const eventPath =
      typeof evt.composedPath === 'function' ? evt.composedPath() : [];
    const clickedInsideMinicart =
      eventPath.includes(this) || (target && this.contains(target));
    if (
      !clickedInsideMinicart &&
      !target?.closest('.cart-quick-edit-modal') &&
      !target?.closest('.tingle-modal')
    ) {
      this.close();
    }
  }

  cartAction() {
    this.querySelectorAll('.close-cart').forEach((navToggle) => {
      navToggle.addEventListener(
        'click',
        (e) => {
          e.preventDefault();
          if (
            this.notification
              .querySelector('.minicart__wrapper')
              .classList.contains('open')
          ) {
            this.close();
          }
        },
        false
      );
    });
    this.querySelectorAll('.cart-addons button').forEach((button) => {
      button.removeEventListener('click', this.onCartAddonClick, false);
      button.addEventListener('click', this.onCartAddonClick, false);
    });

    document.querySelectorAll('.addon-actions .btn-save').forEach((button) => {
      button.removeEventListener(
        'click',
        this.cartAddonsSave.bind(this),
        false
      );
      button.addEventListener('click', this.cartAddonsSave.bind(this), false);
    });

    this.querySelectorAll('.add-giftwrap').forEach((giftwrap) => {
      giftwrap.removeEventListener(
        'click',
        this.addGiftwrapClick.bind(this),
        false
      );
      giftwrap.addEventListener(
        'click',
        this.addGiftwrapClick.bind(this),
        false
      );
    });

    this.querySelectorAll('.addon-actions .btn-cancel').forEach(
      (addonCancel) => {
        addonCancel.addEventListener(
          'click',
          (e) => {
            e.preventDefault();
            const target = e.currentTarget;
            this.closeAddonState(target);
          },
          false
        );
      }
    );
  }

  addonsUpdate() {
    const address_country = document.getElementById('address_country');
    const address_province = document.getElementById('address_province');
    if (address_country && address_province) {
      new Shopify.CountryProvinceSelector(
        'address_country',
        'address_province',
        { hideElement: 'address_province_container' }
      );
    }
    // 删除 discount_code 的 localStorage 逻辑,因为 MinicartDiscount 不使用它
    // const discount_code = document.querySelector('.discount_code');
    // const code = localStorage.getItem('discount_code');
    // if (code && discount_code) {
    //   document.querySelector('.discount_code').value = code;
    // }
  }

  getMinicartWrapper(target = null) {
    if (target instanceof Element) {
      const wrapper = target.closest('.minicart__wrapper');
      if (wrapper) return wrapper;
    }
    return (
      this.querySelector('.minicart__wrapper') ||
      this.notification?.querySelector('.minicart__wrapper')
    );
  }

  getAddonPanel(target, action) {
    if (!action) return null;
    const wrapper = this.getMinicartWrapper(target);
    return (
      wrapper?.querySelector(`.cart__addon-content[id="${action}"]`) ||
      wrapper?.querySelector(`#${action}`) ||
      document.getElementById(action)
    );
  }

  getOpenAddonAction(root) {
    const panel = root?.querySelector('.cart__addon-content.is-open[id]');
    if (!panel?.id) return '';
    const button = Array.from(
      root.querySelectorAll('.mini_cart_addon_btn.open[data-open]')
    ).find((candidate) => candidate.getAttribute('data-open') === panel.id);
    return button ? panel.id : '';
  }

  restoreOpenAddonState(root, action) {
    if (!root || !action) return;
    const panel = Array.from(
      root.querySelectorAll('.cart__addon-content[id]')
    ).find((candidate) => candidate.id === action);
    const button = Array.from(
      root.querySelectorAll('.mini_cart_addon_btn[data-open]')
    ).find((candidate) => candidate.getAttribute('data-open') === action);
    if (!panel || !button) return;
    panel.classList.add('is-open');
    button.classList.add('open');
    if (button.hasAttribute('aria-expanded')) {
      button.setAttribute('aria-expanded', 'true');
    }
  }

  closeAddonState(target) {
    this.closeAllAddonStates(target);
  }

  closeAllAddonStates(target) {
    const wrapper = this.getMinicartWrapper(target);
    if (!wrapper) return;
    wrapper
      .querySelectorAll('.cart__addon-content.is-open')
      .forEach((panel) => panel.classList.remove('is-open'));
    wrapper
      .querySelectorAll('.mini_cart_addon_btn.open')
      .forEach((button) => {
        button.classList.remove('open');
        if (button.hasAttribute('aria-expanded')) {
          button.setAttribute('aria-expanded', 'false');
        }
      });
  }

  cartAddons(event) {
    event.preventDefault();
    const target = event.currentTarget;
    const open = target.getAttribute('data-open');
    const panel = this.getAddonPanel(target, open);
    if (!panel) return;
    if (!panel.classList.contains('is-open')) {
      this.closeAllAddonStates(target);
      panel.classList.add('is-open');
      target.classList.add('open');
      if (target.hasAttribute('aria-expanded')) {
        target.setAttribute('aria-expanded', 'true');
      }
      if (open == 'shipping') {
        const address_country = document.getElementById('address_country');
        const address_province = document.getElementById('address_province');
        if (address_country && address_province) {
          new Shopify.CountryProvinceSelector(
            'address_country',
            'address_province',
            { hideElement: 'address_province_container' }
          );
        }
      }
    } else if (open == 'note') {
      this.closeAddonState(target, open);
    } else {
      this.closeAddonState(target, open);
    }
  }

  fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: `application/${type}`,
      },
    };
  }

  toastSuccess(message, anchorElement = null) {
    if (!message || typeof showToast !== 'function') return;
    const toast = this.createToast(message, 'success');
    showToast(toast, 2000, 'modal-success', anchorElement);
  }

  createToast(message, type) {
    const isSuccess = type === 'success';
    const iconColor = isSuccess ? '#537D5B' : '#8C3A3A';
    const className = isSuccess
      ? 'newsletter-form__message--success success'
      : 'line-item-error-1 error';

    const iconPath = isSuccess
      ? `<path d="m6.033 8.992 1.972 1.98 3.952-3.96"/><path d="M7.973 1.178c.565-.482 1.49-.482 2.062 0l1.293 1.113c.245.213.704.385 1.03.385h1.392c.867 0 1.579.712 1.579 1.579v1.39c0 .32.172.786.384 1.032l1.113 1.292c.483.565.483 1.49 0 2.062l-1.113 1.293a1.813 1.813 0 0 0-.384 1.03v1.392c0 .867-.712 1.579-1.58 1.579h-1.39c-.32 0-.786.172-1.031.384l-1.293 1.113c-.564.483-1.489.483-2.062 0L6.681 15.71a1.813 1.813 0 0 0-1.031-.384H4.234c-.867 0-1.579-.712-1.579-1.58v-1.398c0-.32-.172-.778-.376-1.023l-1.105-1.301c-.474-.565-.474-1.48 0-2.045L2.28 6.677c.204-.246.376-.704.376-1.023V4.247c0-.868.712-1.58 1.58-1.58H5.65c.319 0 .785-.171 1.03-.384l1.293-1.105Z"/>`
      : `<path d="M7.977 1.198c.573-.482 1.498-.482 2.054 0l1.293 1.105a1.89 1.89 0 0 0 1.039.376h1.39c.868 0 1.58.712 1.58 1.58v1.39c0 .328.171.786.376 1.031l1.105 1.293c.482.573.482 1.497 0 2.054l-1.105 1.292c-.204.246-.376.704-.376 1.031v1.391c0 .867-.712 1.58-1.58 1.58h-1.39c-.328 0-.786.171-1.031.376L10.039 16.8c-.573.483-1.497.483-2.054 0l-1.292-1.104c-.246-.205-.712-.377-1.031-.377H4.23c-.867 0-1.58-.712-1.58-1.579v-1.399c0-.319-.163-.785-.367-1.023l-1.105-1.3c-.474-.565-.474-1.481 0-2.046l1.105-1.3c.204-.246.368-.705.368-1.024V4.267c0-.868.712-1.58 1.579-1.58h1.415c.328 0 .786-.171 1.031-.376l1.301-1.113ZM7 11l4-4M11 11 7 7"/>`;

    return `
      <div class="mt-10 ${className} form__message inline-flex align-center" tabindex="-1">
        <svg width="18" height="18" fill="none" class="flex-auto">
          <g stroke="${iconColor}" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.3">
            ${iconPath}
          </g>
        </svg>
        <span class="ml-5">${message}</span>
      </div>
    `;
  }

  cartAddonsSave(event) {
    event.preventDefault();
    const target = event.currentTarget;
    const action = target.getAttribute('data-action');
    if (action == 'coupon') {
      const discountForm = document.querySelector('minicart-discount form');
      if (discountForm) {
        discountForm.dispatchEvent(new Event('submit', { cancelable: true }));
      }
      this.closeAddonState(target, action);
    } else if (action == 'note') {
      const noteInput =
        target.closest('.cart__addon-content')?.querySelector('.cart-note') ||
        target.closest('.minicart__wrapper')?.querySelector('.cart-note') ||
        document.querySelector('.cart-note');
      const body = JSON.stringify({
        note: noteInput?.value || '',
      });
      fetch(`${routes?.cart_update_url}`, {
        ...this.fetchConfig(),
        ...{ body },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error('Failed to update cart note');
          }
          return response.json();
        })
        .then(() => {
          const toastAnchor =
            target.closest('.minicart__wrapper')?.querySelector('.cart-addons') ||
            this.querySelector('.cart-addons') ||
            document.querySelector('.cart-addons');
          this.toastSuccess(
            cartStrings?.order_note_saved || 'Order note has been saved.',
            toastAnchor
          );
        })
        .catch((error) => {
          throw error;
        });
      this.closeAddonState(target, action);
    } else if (action == 'shipping') {
      var e = {};
      (e.zip = document.querySelector('#AddressZip').value || ''),
        (e.country = document.querySelector('#address_country').value || ''),
        (e.province = document.querySelector('#address_province').value || ''),
        this._getCartShippingRatesForDestination(e);
    }
  }

  _getCartShippingRatesForDestination(event) {
    fetch(
      `${window.Shopify.routes.root}cart/shipping_rates.json?shipping_address%5Bzip%5D=${event.zip}&shipping_address%5Bcountry%5D=${event.country}&shipping_address%5Bprovince%5D=${event.province}`
    )
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const message = document.querySelector('.addon-message');
        for (var item of document.querySelectorAll('.addon-message p')) {
          item.remove();
        }
        const { showDeliveryDays, deliveryDayOne, deliveryDaysOther } =
          message.dataset;
        const parsedState = JSON.parse(state);
        if (parsedState && parsedState.shipping_rates) {
          if (parsedState.shipping_rates.length > 0) {
            message.classList.remove('error', 'warning');
            message.classList.add('success');
            const p = document.createElement('p');
            p.innerText = cartStrings?.shipping_rate.replace(
              '{{address}}',
              event.zip + ', ' + event.country + ' ' + event.province
            );
            message.appendChild(p);
            parsedState.shipping_rates.map((rate) => {
              let daysShipping = '';
              if (rate.delivery_days.length > 0 && showDeliveryDays == 'true') {
                let typeDay = deliveryDayOne;
                const day = rate.delivery_days[0];
                const dayAt = rate.delivery_days.at(-1);
                if (day > 1) typeDay = deliveryDaysOther;
                if (day === dayAt) {
                  daysShipping = `(${day} ${typeDay})`;
                } else {
                  daysShipping = `(${day} - ${dayAt} ${typeDay})`;
                }
              }
              const rateNode = document.createElement('p');
              rateNode.innerHTML =
                rate.name +
                ': ' +
                Shopify.formatMoney(rate.price, cartStrings?.money_format) +
                ' ' +
                daysShipping;
              message.appendChild(rateNode);
            });
          } else {
            message.classList.remove('error', 'success');
            message.classList.add('warning');
            const p = document.createElement('p');
            p.innerText = cartStrings?.no_shipping;
            message.appendChild(p);
          }
        } else {
          message.classList.remove('success', 'warning');
          message.classList.add('error');
          Object.entries(parsedState).map((error) => {
            const message_error = `${error[1][0]}`;
            const p = document.createElement('p');
            p.innerText = message_error;
            message.appendChild(p);
          });
        }
      })
      .catch((error) => {
        throw error;
      });
  }

  addGiftwrapClick(event) {
    event.preventDefault();
    const target = event.currentTarget;
    if (
      !target ||
      target.classList.contains('loading') ||
      target.getAttribute('aria-disabled') === 'true'
    ) {
      return;
    }
    const variant_id = Number(target.getAttribute('data-variant-id'));
    if (!Number.isFinite(variant_id) || variant_id <= 0) {
      if (typeof showToast === 'function') {
        showToast(
          this.createToast(cartStrings?.error || 'Unable to add gift wrap.', 'error'),
          5000,
          'modal-error',
          this.getMinicartWrapper(target)
        );
      }
      return;
    }
    const config = fetchConfig('json');
    config.body = JSON.stringify({
      id: variant_id,
      quantity: 1,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });
    target.classList.add('loading');
    target.setAttribute('aria-disabled', 'true');
    fetch(`${routes?.cart_add_url}`, config)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        if (parsedState.message) {
          if (typeof showToast === 'function') {
            showToast(
              this.createToast(
                parsedState.description || parsedState.message,
                'error'
              ),
              5000,
              'modal-error',
              this.getMinicartWrapper(target)
            );
          }
          return;
        }
        fetch('/cart.json')
          .then((res) => res.json())
          .then((cart) => {
            if (cart.item_count != undefined) {
              document.querySelectorAll('.cart-count').forEach((el) => {
                if (el.classList.contains('cart-count-drawer')) {
                  el.innerHTML = `(${cart.item_count})`;
                } else {
                  el.innerHTML = cart.item_count > 100 ? '~' : cart.item_count;
                }
              });
              if (document.querySelector('header-total-price')) {
                document.querySelector('header-total-price').updateTotal(cart);
              }
            }
          })
          .catch((error) => {
            throw error;
          });
        this.renderContents(parsedState);
      })
      .catch((e) => {
        throw e;
      })
      .finally(() => {
        target.classList.remove('loading');
        target.removeAttribute('aria-disabled');
      });
  }

  onChange(event) {
    if (!event.target.matches('[data-cart-quantity-input]')) return;
    const id = event.target.dataset.id;
    if (!id) return;
    this.scheduleQuantityUpdate(id, event.target.value, event.target, 300);
  }

  scheduleQuantityUpdate(id, quantity, target, delay = 0) {
    if (!id) return Promise.resolve(false);
    this.pendingQuantityUpdates.set(String(id), {
      id: String(id),
      quantity: Math.max(0, Number(quantity) || 0),
      currentQuantity: target?.dataset?.value,
      target,
      name: document.activeElement?.getAttribute('name') || '',
    });
    const task = () => this.updateQuantity();
    const coordinator = window.SilkSilkyCartCoordinator;
    if (coordinator?.scheduleMutation) {
      return coordinator
        .scheduleMutation('minicart-quantities', task, delay)
        .catch(() => false);
    }
    window.clearTimeout(this.quantityUpdateTimer);
    return new Promise((resolve) => {
      this.quantityUpdateTimer = window.setTimeout(() => {
        Promise.resolve(task()).then(resolve, () => resolve(false));
      }, delay);
    });
  }

  updateQuantity() {
    const pendingUpdates = new Map(this.pendingQuantityUpdates);
    const activeUpdate = Array.from(pendingUpdates.values()).at(-1);
    if (!activeUpdate) return Promise.resolve(false);
    const { id, target: _this } = activeUpdate;
    const updates = {};
    this.querySelectorAll('[data-cart-quantity-input]').forEach((input) => {
      if (input.dataset.id) {
        updates[input.dataset.id] = Math.max(0, Number(input.value) || 0);
      }
    });
    pendingUpdates.forEach((update) => {
      updates[update.id] = update.quantity;
    });
    const body = JSON.stringify({
      updates,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });
    this.notification.classList.add('start', 'loading');
    const cartRecommend = document.querySelector('.cart-recommend');
    if (cartRecommend && cartRecommend.classList.contains('open')) {
      cartRecommend.classList.remove('open');
    }
    return fetch(`${routes?.cart_update_url}`, {
      ...fetchConfig(),
      body,
      ssCartCoordinatorInternal: true,
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        if (parsedState.errors) {
          this.updateMessageErrors(id, parsedState.errors, _this);
          throw new Error(String(parsedState.errors));
        }
        if (parsedState.item_count != undefined) {
          document.querySelectorAll('.cart-count').forEach((el) => {
            if (el.classList.contains('cart-count-drawer')) {
              el.innerHTML = `(${parsedState.item_count})`;
            } else {
              el.innerHTML =
                parsedState.item_count > 100 ? '~' : parsedState.item_count;
            }
          });
          if (document.querySelector('header-total-price')) {
            document
              .querySelector('header-total-price')
              .updateTotal(parsedState);
          }
        }
        if (document.querySelector('.quantity__label')) {
          const items = parsedState.items;
          const pro_id = document
            .querySelector('.quantity__label')
            .getAttribute('data-pro-id');
          var variant_id, variant_quantity;
          items.forEach(function (item) {
            variant_id = item.variant_id;
            if (variant_id == pro_id) {
              document.querySelector('.quantity-cart').innerHTML =
                item.quantity;
              document
                .querySelector('.quantity__label')
                .classList.remove('hidden');
              variant_quantity = pro_id;
              return;
            }
          });
          if (!variant_quantity) {
            document.querySelector('.quantity-cart').innerHTML = 0;
            document.querySelector('.quantity__label').classList.add('hidden');
          }
        }

        if (document.querySelector('header-total-price')) {
          document.querySelector('header-total-price').updateTotal(parsedState);
        }
        if (!parsedState.error && parsedState.item_count != undefined) {
          this.renderContents(parsedState);
        }
        pendingUpdates.forEach((update, updateKey) => {
          if (this.pendingQuantityUpdates.get(updateKey) === update) {
            this.pendingQuantityUpdates.delete(updateKey);
          }
        });
        return true;
      })
      .catch((e) => {
        throw e;
      })
      .finally(() => {
        this.notification.classList.add('finish');
        setTimeout(() => {
          this.notification?.classList.remove('start', 'loading', 'finish');
        }, 500);
        const cartRecommend = document.querySelector('.cart-recommend');
        if (
          cartRecommend &&
          !cartRecommend.classList.contains('hidden-recommend')
        ) {
          if (cartRecommend.classList.contains('cart-recommend-custom')) {
            const cartUpsellItem =
              document.querySelectorAll('.cart-upsell-item');
            const cartUpsellSlide = document.querySelectorAll(
              '.swiper-cart-upsell .swiper-slide'
            );
            if (cartUpsellItem.length > 0) {
              setTimeout(function () {
                cartRecommend.classList.add('open');
              }, 800);
            } else if (cartUpsellSlide.length === 0) {
              cartRecommend.classList.remove('block');
              cartRecommend.classList.add('hidden');
            }
          } else {
            setTimeout(function () {
              cartRecommend.classList.add('open');
            }, 800);
          }
        }
      });
  }

  updateMessageErrors(line, message, target) {
    if (target?.dataset?.value != null) {
      target.value = target.dataset.value;
    }
    const lineItemError = document.getElementById(
      `CartDrawer-LineItemError-${line}`
    );
    if (lineItemError)
      lineItemError.querySelector('.cart-item__error-text').textContent =
        message;
  }

  open() {
    if (!this.notification.classList.contains('go_to_cart_page')) {
      this.notification
        .querySelector('.minicart__wrapper')
        .classList.add('open');
      document.documentElement.classList.add('open-drawer', 'open-minicart');
      if (this.notification.classList.contains('open_drawer')) {
        root.style.setProperty(
          'padding-right',
          getScrollBarWidth.init() + 'px'
        );
      }
      document.dispatchEvent(new Event('ss:cart:promotion:refresh'));
      this.notification
        .querySelector('.minicart__action')
        .classList.add('open');
    } else {
      this.notification.querySelector('a').click();
    }
    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
      },
      { once: true }
    );
    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification
      .querySelector('.minicart__wrapper')
      .classList.remove('open');
    this.notification.querySelector('.minicart__action').classList.add('open');
    document.documentElement.classList.remove('open-drawer', 'open-minicart');
    root.style.removeProperty('padding-right');
    if (document.querySelector('minicart-recommendations-beside')) {
      document
        .querySelector('minicart-recommendations-beside')
        .classList.remove('open');
    }
    document.body.removeEventListener('click', this.onBodyClick);
    for (var item of document.querySelectorAll('.addon')) {
      item.classList.remove('is-open');
    }
    for (var item of document.querySelectorAll('.open')) {
      item.classList.remove('open');
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'minicart-form',
        section: 'minicart-form',
        selector: '#MinicartCartPanel',
      },
    ];
  }

  renderContents(cartState, options = {}) {
    if (!cartState?.sections) return false;

    let didRender = false;
    this.getSectionsToRender().forEach((section) => {
      const selector = section.selector || `#${section.id}`;
      const elementToReplace = document.querySelector(selector);
      const sectionMarkup = cartState.sections[section.section || section.id];
      if (!elementToReplace || !sectionMarkup) return;
      const openAddonAction = this.getOpenAddonAction(elementToReplace);

      const html = new DOMParser().parseFromString(sectionMarkup, 'text/html');
      const nextSection = html.querySelector(selector);
      if (!nextSection) return;

      this.restoreOpenAddonState(nextSection, openAddonAction);
      elementToReplace.innerHTML = nextSection.innerHTML;
      didRender = true;
    });

    if (!didRender) return false;

    this.currentItemCount = Array.from(
      this.querySelectorAll('[data-cart-quantity-input]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );
    this.cartAction();
    this.addonsUpdate();
    pinMinicartProductListActions(document);
    const loyaltyRuntime = window.SilkSilkyLoyaltyCartRedemption;
    if (loyaltyRuntime && typeof loyaltyRuntime.initialize === 'function') {
      loyaltyRuntime.initialize();
    }

    if (options.notifyPromotion !== false) {
      document.dispatchEvent(
        new CustomEvent('ss:cart:promotion:refresh', {
          detail: {
            source: 'minicart-section-render',
            cart: cartStateForPromotionRefresh(cartState),
            refreshLoyalty: options.refreshLoyalty === true,
          },
        })
      );
    }

    return true;
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  handleMinicartTab() {
    const tabMinicart = this.querySelectorAll('.minicart-tab');
    const tabMinicartContent = this.querySelectorAll('.minicart-tabs-content');
    tabMinicart.forEach((tab) => {
      tab.addEventListener('click', function () {
        const targetTab = this.getAttribute('data-tab');
        tabMinicart.forEach(link => link.classList.remove('active'));
        this.classList.add('active');
        tabMinicartContent.forEach(pane => pane.classList.remove('active'));
        if (targetTab === 'tab-cart') {
          const targetPanes = document.querySelectorAll(`.${targetTab}`);
          targetPanes.forEach(pane => pane.classList.add('active'));
        } else {
          const targetPane = document.getElementById(targetTab);
          if (targetPane) {
            targetPane.classList.add('active');
          }
          if (targetTab === 'tab-visited') {
            const recentlyViewedGrid = document.querySelector('recently-viewed-products-grid');
            if (recentlyViewedGrid) {
              recentlyViewedGrid.initData();
            }
          }
        }
      });
    });
  }
}
customElements.define('cart-notification', CartNotification);

class MinicartItemEdit extends PopupBase {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const key = this.getAttribute('data-key');
      const quantity = this.getAttribute('data-quantity');
      const href = this.getAttribute('href');
      const variantId = this.getAttribute('data-id');
      const requestUrl = new URL(href, window.location.origin);
      if (!requestUrl.searchParams.get('variant') && variantId) {
        requestUrl.searchParams.set('variant', variantId);
      }
      const currentSearch = new URLSearchParams(window.location.search);
      ['preview_theme_id', '_fd', 'pb', '_ab', '_sc', '_ss'].forEach((param) => {
        const value = currentSearch.get(param);
        if (value && !requestUrl.searchParams.get(param)) {
          requestUrl.searchParams.set(param, value);
        }
      });
      const themeId = window.Shopify?.theme?.id;
      if (themeId && !requestUrl.searchParams.get('preview_theme_id')) {
        requestUrl.searchParams.set('preview_theme_id', String(themeId));
      }
      requestUrl.searchParams.set('section_id', 'cart-quick-edit');
      requestUrl.searchParams.set('_', String(Date.now()));
      fetch(requestUrl.toString())
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            throw error;
          }
          return response.text();
        })
        .then((response) => {
          const resultsMarkup = new DOMParser()
            .parseFromString(response, 'text/html')
            .getElementById('shopify-section-cart-quick-edit');
          this.initPopup(
            resultsMarkup,
            `<h3 class="title-popup h5 my-0 px-20 px-md-30 py-20 border-bottom">${this.dataset?.textHeader}</h3>`
          );
        })
        .catch((error) => {
          throw error;
        })
        .finally(() => {
          if (document.querySelector('[data-template-quick-cart-edit]')) {
            document
              .querySelector('[data-template-quick-cart-edit]')
              .setAttribute('data-line', key);
          }
          if (
            document.querySelector(
              '.product-form-quick-edit quantity-input input'
            )
          ) {
            document.querySelector(
              '.product-form-quick-edit quantity-input input'
            ).value = quantity;
          }
        });
    });
  }
}
customElements.define('minicart-item-edit', MinicartItemEdit);

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange() {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === 'plus' ||
    event.target.closest('button').name === 'plus'
      ? this.input.stepUp()
      : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
      this.updatePriceLabel();
      this.dataset.quantityLabel = this.input.value;

  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      if (buttonMinus) {
        buttonMinus.classList.toggle('disabled', value <= min);
        if (this.classList.contains('quantity--minicart')) {
          const shouldShowDelete = value <= min + 1;
          buttonMinus.classList.toggle('is-delete', shouldShowDelete);
          const labelMinus = buttonMinus.dataset.labelMinus;
          const labelRemove = buttonMinus.dataset.labelRemove;
          if (labelMinus && labelRemove) {
            buttonMinus.setAttribute(
              'aria-label',
              shouldShowDelete ? labelRemove : labelMinus
            );
          }
        }
      }
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }

  updatePriceLabel() {
    const dataSectionId = this.dataset.sectionId;
    const priceLabel = document.querySelector(`.product-${dataSectionId}`)?.closest('product-form').querySelector('.price-label');
    const priceLabelMobile = this.closest('.product-popup-mobile')?.querySelector('.price-label');
    const priceLabelSticky = document.querySelector(`.sticky-product-${dataSectionId}`)?.closest('product-form').querySelector('.price-label');
    const priceLabelMinicartEdit = this.closest('product-form-quick-edit')?.querySelector('.price-label');
    if (!priceLabel || !dataSectionId) return;
    const pricePerItem = priceLabel.dataset.price;
    const quantity = parseInt(this.input.value);
    const totalPrice = pricePerItem * quantity;
    priceLabel.textContent = Shopify.formatMoney(
      totalPrice,
      cartStrings.money_default_format)
    if (priceLabelSticky) {
      priceLabelSticky.textContent = Shopify.formatMoney(
        totalPrice,
        cartStrings.money_default_format)
    }
    if(priceLabelMobile){
      priceLabelMobile.textContent = Shopify.formatMoney(
        totalPrice,
        cartStrings.money_default_format)
    }
    if (priceLabelMinicartEdit) {
      priceLabelMinicartEdit.textContent = Shopify.formatMoney(
        totalPrice,
        cartStrings.money_default_format)
    }
  }
}

customElements.define('quantity-input', QuantityInput);

let BlsMainMenuShopify = (function () {
  return {
    init: function () {
      this.initMenu();
      this.initMainMenu();
      this.initVerticalMenu();
    },
    initMenu: function () {
      const _this = this;
      let categoriesListMenuMobile = document.querySelector(
        '.navigation:not(.nav-responsive) .categories-list-menu-mobile'
      );
      let categoriesListMenu = document.querySelector(
        '.navigation:not(.nav-responsive) [data-menu="categories-list"]'
      );
      let categoriesListMenuVertical = document.querySelector(
        '[data-menu="verticalmenu-list"]'
      );
      let categoriesListMenuVerticalMobile = document.querySelector(
        '.verticalmenu-mobile'
      );
      let horizontalList = document.querySelector('.navigation:not(.nav-responsive) .horizontal-list');
      let windowWidth = window.innerWidth;
      HoverIntent([...document.querySelectorAll('.menu-parent')].filter((item) => !item.closest('responsive-navigation')), {
        onEnter: function (targetItem) {
          targetItem.classList.add('visible');
        },
        onExit: function (targetItem) {
          targetItem.classList.remove('visible');
        },
      });
      window.addEventListener('resize', function () {
        activeMenuTab(windowWidth);
      });
      document.querySelectorAll('.menu-mobile-title a').forEach((tabToggle) => {
        if (tabToggle.closest('responsive-navigation')) return;
        tabToggle.addEventListener(
          'click',
          (e) => {
            e.preventDefault();
            const target = e.currentTarget;
            const data = target.dataset.menu;
            for (var item_title of document.querySelectorAll(
              '.menu-mobile-title a'
            )) {
              item_title.classList.remove('active');
            }
            target.classList.add('active');
            if (data == 'categories-list') {
              horizontalList.style.display = 'none';
              categoriesListMenuMobile.style.display = 'block';
            } else if (data == 'verticalmenu-list') {
              horizontalList.style.display = 'none';
              categoriesListMenuVerticalMobile.style.display = 'block';
            } else {
              horizontalList.style.display = 'block';
              if (categoriesListMenuMobile) {
                categoriesListMenuMobile.style.display = 'none';
              }
              if (categoriesListMenuVerticalMobile) {
                categoriesListMenuVerticalMobile.style.display = 'none';
              }
            }
          },
          false
        );
      });
      activeMenuTab(windowWidth);
      function activeMenuTab(windowWidth) {
        if (windowWidth <= 1024) {
          if (
            (horizontalList &&
              categoriesListMenu?.classList.contains('active')) ||
            categoriesListMenuVertical?.classList.contains('active')
          ) {
            horizontalList.style.display = 'none';
          }
          if (
            categoriesListMenuVerticalMobile &&
            categoriesListMenuVertical.classList.contains('active')
          ) {
            categoriesListMenuVerticalMobile.style.display = 'block';
          }
        } else {
          if (
            categoriesListMenuMobile &&
            categoriesListMenu.classList.contains('active')
          ) {
            categoriesListMenuMobile.style.display = 'none';
          }

          if (
            categoriesListMenuVerticalMobile &&
            categoriesListMenuVertical.classList.contains('active')
          ) {
            categoriesListMenuVerticalMobile.style.display = 'none';
          }

          if (
            (horizontalList &&
              categoriesListMenu?.classList.contains('active')) ||
            categoriesListMenuVertical?.classList.contains('active')
          ) {
            horizontalList.style.display = 'inline-flex';
          }
        }
      }
    },
    initMainMenu: function () {
      var _this = this;
      const header = document.querySelector('header');
      const sticky = header?.getAttribute('data-sticky');
      const sticky_mobile = header?.getAttribute('data-sticky-mobile');
      const verticalmenu = document.querySelector('.verticalmenu-list');
      const main_menu = document.querySelector('.navigation.horizontal:not(.nav-responsive)');
      document.querySelectorAll('.nav-toggle').forEach((navToggle) => {
        if (navToggle.closest('header')?.querySelector('responsive-navigation')) return;
        navToggle.addEventListener('click', (e) => {
          const target = e.currentTarget;
          if (document.documentElement.classList.contains('nav-open')) {
            root.style.removeProperty('padding-right');
            document.documentElement.classList.remove('nav-open');
            target.classList.remove('open');
            if (!main_menu) {
              document.documentElement.classList.remove('nav-verticalmenu');
            }
          } else {
            root.style.setProperty(
              'padding-right',
              getScrollBarWidth.init() + 'px'
            );
            document.documentElement.classList.add('nav-open');
            target.classList.add('open');
            if (!main_menu) {
              document.documentElement.classList.add('nav-verticalmenu');
            }
          }
        });
      });
      if (verticalmenu && main_menu) {
        const article = document.querySelector('.verticalmenu-html');
        const limitItemShow = article.dataset.limitshowitem;
        const html_title =
          '<a data-menu="verticalmenu-list" href="#">' +
          window.menuStrings?.verticalTitle +
          '</a>';
        const verticalmenu_html =
          document.querySelector('.verticalmenu-list').innerHTML;
        const el = document.createElement('ul');
        el.classList.add('verticalmenu-list');
        el.classList.add('verticalmenu-mobile');
        el.style.display = 'none';
        el.setAttribute('data-limitshowitem', limitItemShow);
        el.innerHTML = verticalmenu_html;
        main_menu.querySelector('.mobile-menu-content').appendChild(el);
        main_menu
          .querySelector('.menu-mobile-title')
          .insertAdjacentHTML('beforeend', html_title);
      }

      let width = screen.width;
      document
        .querySelectorAll('li.menu-parent .submenu')
        .forEach((menuItem, index) => {
          if (menuItem.closest('responsive-navigation')) return;
          if (width > 1024) {
            menuItem.addEventListener('mouseenter', (e) => {
              const target = e.currentTarget;
              target.closest('.menu-parent').classList.add('active-submenu');
            });
            menuItem.addEventListener('mouseleave', (e) => {
              const target = e.currentTarget;
              target.closest('.menu-parent').classList.remove('active-submenu');
            });
          }
        });
      let announcement_bar = 0;
      let top_bar = 0;
      let headerpage = 0;
      let headerSpaceH = 0;
      let headerh = 0;
      const updateHeaderMetrics = () => {
        announcement_bar =
          document.querySelector('.section-announcement-bar')?.clientHeight || 0;
        top_bar = document.querySelector('.section-top-bar')?.clientHeight || 0;
        headerpage = header?.clientHeight || 0;
        headerSpaceH =
          document.getElementById('header-sticky')?.offsetHeight || 0;
        headerh = announcement_bar + top_bar + headerSpaceH;
        document.body?.style.setProperty('--height-bar', `${announcement_bar}px`);
        document.body?.style.setProperty('--height-header', `${headerpage}px`);
        document.body?.style.setProperty('--height-topbar', `${top_bar}px`);
      };
      updateHeaderMetrics();
      document.addEventListener(
        'theme:header-metrics:update',
        updateHeaderMetrics
      );
      if (header && sticky != 'none') {
        if (sticky_mobile == 'false' && window.innerWidth < 1025) {
          return;
        }
        let check = 0;
        let sec_header = header.closest('.section-header');
        if (sticky === 'on-scroll-up') {
          sec_header.classList.add('scroll-up');
        }
        window.addEventListener('scroll', () => {
          stickyFunction();
        });
        document.addEventListener('theme:header-metrics:update', () => {
          stickyFunction();
        });
        function stickyFunction() {
          let wpy = window.scrollY;

          if (sec_header) {
            if (sticky === 'always') {
              if (wpy > headerh) {
                sec_header.classList.add(
                  'shopify-section-header-sticky',
                  'animate'
                );
              } else {
                sec_header.classList.remove(
                  'shopify-section-header-sticky',
                  'animate'
                );
              }
            } else {
              if (wpy > 0) {
                if (wpy > headerh) {
                  sec_header.classList.add('scr-pass-header');
                  if (wpy > check) {
                    sec_header.classList.add('shopify-section-header-hidden');
                  } else {
                    sec_header.classList.remove(
                      'shopify-section-header-hidden'
                    );
                    sec_header.classList.add('animate');
                  }
                  sec_header.classList.add('header-sticky');
                  sec_header.classList.add('shopify-section-header-sticky');
                  check = wpy;
                } else {
                  sec_header.classList.remove('header-sticky');
                  sec_header.classList.remove('scr-pass-header');
                  check = 0;
                }
              } else {
                sec_header.classList.remove(
                  'shopify-section-header-hidden',
                  'header-sticky'
                );
                sec_header.classList.remove(
                  'animate',
                  'shopify-section-header-sticky'
                );
              }
            }
          }
        }
      }
      if (main_menu) {
        let width = window.innerWidth;
        if (width > 1024) {
          _this.addCssSubMenu();
        }
        window.addEventListener(
          'resize',
          function (event) {
            if (width > 1024) {
              _this.addCssSubMenu();
            }
          },
          true
        );
      }
    },
    onMenuMobileItem: function () {
      var menu_submenu = ".subchildmenu .level-1 open-children-toggle";
      document.querySelectorAll(menu_submenu).forEach((childrenToggle) => {
        childrenToggle.addEventListener("click", (e) => {
          const target = e.currentTarget;
          const parent = target.parentElement;
          const submenu = parent.closest('li').querySelector(".sub-children-menu");
          slideAnime({
            target: submenu,
            animeType: "slideToggle",
          });
          if (!parent.querySelector("a").classList.contains("active")) {
            parent.querySelector("a").classList.add("active");
          } else {
            parent.querySelector("a").classList.remove("active");
          }
        });
      });
    },
    initVerticalMenu: function () {
      let width = screen.width;
      const article = document.querySelector('.verticalmenu-html');
      if (article === null) return;
      const limitItemShow = article.dataset.limitshowitem;
      const lenghtLi = document.querySelectorAll(
        '.verticalmenu-html .level0'
      ).length;
      if (width > 1024) {
        if (lenghtLi > limitItemShow) {
          var lineItem = Array.from(
            document.querySelectorAll('.verticalmenu-html .level0')
          );
          lineItem.forEach((element, index) => {
            if (index > limitItemShow - 1) {
              const item = lineItem[index];
              if (item.classList.contains('expand-menu-link')) {
                return;
              }
              item.classList.add('orther-link');
              item.style.display = 'none';
            }
          });
          document.querySelector(
            '.verticalmenu-html .expand-menu-link'
          ).style.display = 'block';
          document
            .querySelector('.verticalmenu-html .expand-menu-link a')
            .addEventListener(
              'click',
              (e) => {
                e.preventDefault();
                const target = e.currentTarget;
                const parent = target.parentElement;
                if (!parent.classList.contains('expanding')) {
                  parent.classList.add('expanding');
                  parent.querySelector('a').innerHTML =
                    window.menuStrings?.hideMenus;
                  for (var item of document.querySelectorAll(
                    '.verticalmenu-html .level0.orther-link'
                  )) {
                    showAnime(item);
                  }
                } else {
                  parent.classList.remove('expanding');
                  parent.querySelector('a').innerHTML =
                    window.menuStrings?.moreMenus;
                  for (var item of document.querySelectorAll(
                    '.verticalmenu-html .level0.orther-link'
                  )) {
                    hideAnime(item);
                  }
                }
              },
              false
            );
        } else {
          document.querySelector('.expand-menu-link').style.display = 'none';
        }
      }
      if (document.querySelector('.vertical_menu .title-menu-dropdown')) {
        document
          .querySelector('.vertical_menu .title-menu-dropdown')
          .addEventListener('click', (event) => {
            event.preventDefault();
            const target = event.currentTarget;
            const closest = target.closest('.vertical-menu');
            if (closest.classList.contains('open')) {
              closest.classList.remove('open');
            } else {
              closest.classList.add('open');
            }
          });
      }
    },
    addCssSubMenu: function () {
      const submenus = document.querySelectorAll('.horizontal-list .mega-menu-fix-width');
      if (!submenus.length) return;
      const bodyWidth = window.innerWidth
      const header = document.querySelector('header');
      const submenu_center = document.querySelector('.submenu-center');
      const width_sub_center = 800;
      if (!header || bodyWidth < 1024) return;
      const padding = 30;
      submenus.forEach((submenu) => {
          if (submenu_center) {
            const submenu_data = submenu.getBoundingClientRect();
            const width = submenu_data.width;
            const left = submenu_data.left;
            const right = submenu_data.right;
            if (width_sub_center <= width) {
              const left_style = (left - (right - bodyWidth)) / 2;
              submenu.style.left = left_style + 'px';
            }
          } else {
            const elementWidth = submenu.clientWidth;
            const elementLeft = submenu.offsetLeft;
            if (bodyWidth - (elementWidth + elementLeft) < 0) {
              const left = bodyWidth - (elementWidth + elementLeft);
              left = left + elementLeft - padding;
              if (elementLeft < 0) {
                left = 0;
              }
              submenu.style.left = left + 'px';
            }
          }
        });
    },
  };
})();
// BlsMainMenuShopify.init();
document.addEventListener('DOMContentLoaded', () => {
  BlsMainMenuShopify.initMenu();

  requestAnimationFrame(() => {
    BlsMainMenuShopify.initMainMenu();
    BlsMainMenuShopify.initVerticalMenu();
  });
});

class OpenChildrenToggle extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onToggle.bind(this), false);
  }
  onToggle() {
    const parent = this.parentElement;
    if (parent) {
      if (!parent.classList.contains('is-open')) {
        parent.classList.add('is-open');
      } else {
        parent.classList.remove('is-open');
      }
      const submenu = parent.closest('li').querySelector(".sub-children-menu");
      if (submenu) {
        slideAnime({
          target: submenu,
          animeType: "slideToggle",
        });
        if (!parent.querySelector("a").classList.contains("active")) {
          parent.querySelector("a").classList.add("active");
        } else {
          parent.querySelector("a").classList.remove("active");
        }
      }
    }
  }
}
customElements.define('open-children-toggle', OpenChildrenToggle);

class CloseMenu extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onClose.bind(this), false);
  }
  onClose() {
    document.documentElement.classList.remove('nav-open');
    document.querySelector('.nav-toggle').classList.remove('open');
    document.querySelectorAll('menu-item').forEach((item) => {
      item.classList.remove('is-open');
    });
  }
}
customElements.define('close-menu', CloseMenu);

class ReviewProduct extends HTMLElement {
  constructor() {
    super();
    this.productHandle = this.dataset.productHandle;
    if (document.body.classList.contains('index')) {
      window.addEventListener('scroll', () => {
        this.fetchDataReviewProduct();
      });
      let pos = window.pageYOffset;
      if (pos > 0 || document.body.classList.contains('review-lazy')) {
        this.fetchDataReviewProduct();
      }
    } else {
      this.fetchDataReviewProduct();
    }
  }
  fetchDataReviewProduct() {
    if (!this.classList.contains('review-product-added')) {
      return;
    }
    this.classList.remove('review-product-added');
    this.innerHTML = this.querySelector('.product-review-json').innerHTML;
    this.classList.remove('inline-loading');
  }
}
customElements.define('review-product', ReviewProduct);

class BackMenu extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onBackMenu.bind(this), false);
  }
  onBackMenu() {
    if (this.classList.contains('back-lv1')) {
      this.closest('.level-1')
        .querySelector('menu-item')
        .classList.remove('is-open');
    } else {
      this.closest('.level0')
        .querySelector('menu-item')
        .classList.remove('is-open');
    }
  }
}
customElements.define('back-menu', BackMenu);

var BlsLoginPopup = (function () {
  return {
    init: function () {
      this.showLogin();
    },
    clickTab: function (modal) {
      const hidden = document.querySelectorAll('[data-login-hidden]');
      const show = document.querySelectorAll('[data-login-show]');
      const iTitle = document.querySelector('#login-popup .login-heading');
      show.forEach((e) => {
        var s = e?.dataset.loginShow;
        e.addEventListener('click', function (el) {
          el.preventDefault();
          hidden.forEach((eh) => {
            var h = eh?.dataset.loginHidden;
            if (eh.getAttribute('aria-hidden') === 'true' && s === h) {
              eh.setAttribute('aria-hidden', 'false');
              if (iTitle) {
                iTitle.innerText = s;
              }
            } else {
              eh.setAttribute('aria-hidden', 'true');
            }
          });
        });
      });
    },
    showLogin: function () {
      if (this._boundShowLogin) return;

      this._boundShowLogin = true;
      document.addEventListener('click', (e) => {
        const action = e.target.closest('.action-login-popup');
        if (!action) return;

        e.preventDefault();
        this.fetchDataLogin();
      });
    },
    fetchDataLogin: function () {
      const url = `${window.location.pathname}?section_id=login-popup`;
      const _this = this;
      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = parser.parseFromString(responseText, 'text/html');
          const content = html.querySelector('#login-popup');
          if (content) {
            const modal = new tingle.modal({
              footer: false,
              stickyFooter: false,
              closeMethods: ['overlay', 'button', 'escape'],
              closeLabel: 'Close',
              cssClass: ['login-popup-modal'],
              onOpen: function () {},
              onClose: function () {},
              beforeClose: function () {
                return true;
              },
            });
            modal.setContent(content);
            modal.open();

            document
              .querySelectorAll('.login__popup-button-close')
              .forEach((navToggle) => {
                navToggle.addEventListener(
                  'click',
                  (e) => {
                    e.preventDefault();
                    modal.close();
                  },
                  false
                );
              });
          }
          _this.clickTab();
        })
        .catch((e) => {
          throw e;
        });
    },
  };
})();
BlsLoginPopup.init();

function initAccountSheetProductSwipers(scope = document) {
  if (typeof Swiper !== 'function') return;

  scope
    .querySelectorAll('[data-account-sheet-product-swiper]')
    .forEach((swiperElement) => {
      const slides = swiperElement.querySelectorAll(
        '.swiper-wrapper > .swiper-slide'
      );
      if (!slides.length) return;

      if (swiperElement.swiper) {
        swiperElement.swiper.update();
        return;
      }

      new Swiper(swiperElement, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        freeMode: {
          enabled: true,
          momentum: true,
          sticky: false,
        },
        grabCursor: true,
        watchOverflow: true,
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true,
        },
        scrollbar: {
          el: swiperElement.querySelector('.swiper-scrollbar'),
          draggable: true,
        },
      });
    });
}

const ACCOUNT_SHEET_COUNTRY_CODES =
  'AF,AX,AL,DZ,AD,AO,AI,AG,AR,AM,AW,AC,AU,AT,AZ,BS,BH,BD,BB,BY,BE,BZ,BJ,BM,BT,BO,BA,BW,BR,IO,VG,BN,BG,BF,BI,KH,CM,CA,CV,BQ,KY,CF,TD,CL,CN,CX,CC,CO,KM,CG,CD,CK,CR,HR,CW,CY,CZ,CI,DK,DJ,DM,DO,EC,EG,SV,GQ,ER,EE,SZ,ET,FK,FO,FJ,FI,FR,GF,PF,TF,GA,GM,GE,DE,GH,GI,GR,GL,GD,GP,GT,GG,GN,GW,GY,HT,HN,HK,HU,IS,IN,ID,IQ,IE,IM,IL,IT,JM,JP,JE,JO,KZ,KE,KI,XK,KW,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MO,MG,MW,MY,MV,ML,MT,MQ,MR,MU,YT,MX,MD,MC,MN,ME,MS,MA,MZ,MM,NA,NR,NP,NL,NC,NZ,NI,NE,NG,NU,NF,MK,NO,OM,PK,PS,PA,PG,PY,PE,PH,PN,PL,PT,QA,RE,RO,RU,RW,WS,SM,ST,SA,SN,RS,SC,SL,SG,SX,SK,SI,SB,SO,ZA,GS,KR,SS,ES,LK,BL,SH,KN,LC,MF,PM,VC,SD,SR,SJ,SE,CH,TW,TJ,TZ,TH,TL,TG,TK,TO,TT,TA,TN,TR,TM,TC,TV,UM,UG,UA,AE,GB,US,UY,UZ,VU,VA,VE,VN,WF,EH,YE,ZM,ZW'.split(',');

const ACCOUNT_SHEET_REGION_LABELS = {
  AC: 'Ascension Island',
  TA: 'Tristan da Cunha',
  XK: 'Kosovo',
};

const ACCOUNT_SHEET_PROVINCE_LABEL_BY_COUNTRY = {
  AU: 'State/territory',
  CA: 'Province',
  CN: 'Province',
  JP: 'Prefecture',
  US: 'State',
};

const ACCOUNT_SHEET_PROVINCES_BY_COUNTRY = {
  AU: [
    ['ACT', 'Australian Capital Territory'],
    ['NSW', 'New South Wales'],
    ['NT', 'Northern Territory'],
    ['QLD', 'Queensland'],
    ['SA', 'South Australia'],
    ['TAS', 'Tasmania'],
    ['VIC', 'Victoria'],
    ['WA', 'Western Australia'],
  ],
  CA: [
    ['AB', 'Alberta'],
    ['BC', 'British Columbia'],
    ['MB', 'Manitoba'],
    ['NB', 'New Brunswick'],
    ['NL', 'Newfoundland and Labrador'],
    ['NT', 'Northwest Territories'],
    ['NS', 'Nova Scotia'],
    ['NU', 'Nunavut'],
    ['ON', 'Ontario'],
    ['PE', 'Prince Edward Island'],
    ['QC', 'Quebec'],
    ['SK', 'Saskatchewan'],
    ['YT', 'Yukon'],
  ],
  CN: [
    ['AH', 'Anhui'],
    ['BJ', 'Beijing'],
    ['CQ', 'Chongqing'],
    ['FJ', 'Fujian'],
    ['GS', 'Gansu'],
    ['GD', 'Guangdong'],
    ['GX', 'Guangxi'],
    ['GZ', 'Guizhou'],
    ['HI', 'Hainan'],
    ['HE', 'Hebei'],
    ['HL', 'Heilongjiang'],
    ['HA', 'Henan'],
    ['HK', 'Hong Kong'],
    ['HB', 'Hubei'],
    ['HN', 'Hunan'],
    ['NM', 'Inner Mongolia'],
    ['JS', 'Jiangsu'],
    ['JX', 'Jiangxi'],
    ['JL', 'Jilin'],
    ['LN', 'Liaoning'],
    ['MO', 'Macao'],
    ['NX', 'Ningxia'],
    ['QH', 'Qinghai'],
    ['SN', 'Shaanxi'],
    ['SD', 'Shandong'],
    ['SH', 'Shanghai'],
    ['SX', 'Shanxi'],
    ['SC', 'Sichuan'],
    ['TJ', 'Tianjin'],
    ['TW', 'Taiwan'],
    ['XZ', 'Tibet'],
    ['XJ', 'Xinjiang'],
    ['YN', 'Yunnan'],
    ['ZJ', 'Zhejiang'],
  ],
  JP: [
    ['01', 'Hokkaido'],
    ['02', 'Aomori'],
    ['03', 'Iwate'],
    ['04', 'Miyagi'],
    ['05', 'Akita'],
    ['06', 'Yamagata'],
    ['07', 'Fukushima'],
    ['08', 'Ibaraki'],
    ['09', 'Tochigi'],
    ['10', 'Gunma'],
    ['11', 'Saitama'],
    ['12', 'Chiba'],
    ['13', 'Tokyo'],
    ['14', 'Kanagawa'],
    ['15', 'Niigata'],
    ['16', 'Toyama'],
    ['17', 'Ishikawa'],
    ['18', 'Fukui'],
    ['19', 'Yamanashi'],
    ['20', 'Nagano'],
    ['21', 'Gifu'],
    ['22', 'Shizuoka'],
    ['23', 'Aichi'],
    ['24', 'Mie'],
    ['25', 'Shiga'],
    ['26', 'Kyoto'],
    ['27', 'Osaka'],
    ['28', 'Hyogo'],
    ['29', 'Nara'],
    ['30', 'Wakayama'],
    ['31', 'Tottori'],
    ['32', 'Shimane'],
    ['33', 'Okayama'],
    ['34', 'Hiroshima'],
    ['35', 'Yamaguchi'],
    ['36', 'Tokushima'],
    ['37', 'Kagawa'],
    ['38', 'Ehime'],
    ['39', 'Kochi'],
    ['40', 'Fukuoka'],
    ['41', 'Saga'],
    ['42', 'Nagasaki'],
    ['43', 'Kumamoto'],
    ['44', 'Oita'],
    ['45', 'Miyazaki'],
    ['46', 'Kagoshima'],
    ['47', 'Okinawa'],
  ],
  US: [
    ['AL', 'Alabama'],
    ['AK', 'Alaska'],
    ['AS', 'American Samoa'],
    ['AZ', 'Arizona'],
    ['AR', 'Arkansas'],
    ['CA', 'California'],
    ['CO', 'Colorado'],
    ['CT', 'Connecticut'],
    ['DE', 'Delaware'],
    ['DC', 'Washington DC'],
    ['FM', 'Micronesia'],
    ['FL', 'Florida'],
    ['GA', 'Georgia'],
    ['GU', 'Guam'],
    ['HI', 'Hawaii'],
    ['ID', 'Idaho'],
    ['IL', 'Illinois'],
    ['IN', 'Indiana'],
    ['IA', 'Iowa'],
    ['KS', 'Kansas'],
    ['KY', 'Kentucky'],
    ['LA', 'Louisiana'],
    ['ME', 'Maine'],
    ['MH', 'Marshall Islands'],
    ['MD', 'Maryland'],
    ['MA', 'Massachusetts'],
    ['MI', 'Michigan'],
    ['MN', 'Minnesota'],
    ['MS', 'Mississippi'],
    ['MO', 'Missouri'],
    ['MT', 'Montana'],
    ['NE', 'Nebraska'],
    ['NV', 'Nevada'],
    ['NH', 'New Hampshire'],
    ['NJ', 'New Jersey'],
    ['NM', 'New Mexico'],
    ['NY', 'New York'],
    ['NC', 'North Carolina'],
    ['ND', 'North Dakota'],
    ['MP', 'Northern Mariana Islands'],
    ['OH', 'Ohio'],
    ['OK', 'Oklahoma'],
    ['OR', 'Oregon'],
    ['PW', 'Palau'],
    ['PA', 'Pennsylvania'],
    ['PR', 'Puerto Rico'],
    ['RI', 'Rhode Island'],
    ['SC', 'South Carolina'],
    ['SD', 'South Dakota'],
    ['TN', 'Tennessee'],
    ['TX', 'Texas'],
    ['UT', 'Utah'],
    ['VT', 'Vermont'],
    ['VI', 'US Virgin Islands'],
    ['VA', 'Virginia'],
    ['WA', 'Washington'],
    ['WV', 'West Virginia'],
    ['WI', 'Wisconsin'],
    ['WY', 'Wyoming'],
    ['AA', 'Armed Forces Americas'],
    ['AE', 'Armed Forces Europe'],
    ['AP', 'Armed Forces Pacific'],
  ],
};

class CustomerAccountSheet extends HTMLElement {
  constructor() {
    super();
    this.panel = this.querySelector('.customer-account-sheet__panel');
    this.activeTrigger = null;
    this.openTriggerSelector = [
      '.action-customer-account-sheet',
      '[data-open-customer-account-sheet]',
    ].join(', ');
    this.onDocumentOpenClick = this.onDocumentOpenClick.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onOpenRequest = this.onOpenRequest.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.observer = null;
    this.accountData = null;
    this.measurements = null;
    this.addresses = [];
    this.drawerDataLoaded = false;
    this.drawerDataLoading = false;
    this.ordersLoaded = false;
    this.ordersLoading = false;
    this.customerAccountAuthorizationUrl = '';
    this.customerAccountAuthorizationStatus = '';
    this.vipTierColorCache = new Map();
  }

  connectedCallback() {
    document.addEventListener('click', this.onDocumentOpenClick, true);
    document.addEventListener('click', this.onDocumentClick);
    document.addEventListener('keydown', this.onKeyDown);
    this.addEventListener('submit', this.onSubmit);
    this.addEventListener('change', this.onChange);
    window.addEventListener(
      'silksilky:open-customer-account-sheet',
      this.onOpenRequest
    );
    this.observer = new MutationObserver(() => this.syncShopLoginButton());
    this.observer.observe(this, { childList: true, subtree: true });
    this.populateAddressCountryOptions();
    this.syncShopLoginButton();
    this.handleCustomerAccountAuthorizationReturn();
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocumentOpenClick, true);
    document.removeEventListener('click', this.onDocumentClick);
    document.removeEventListener('keydown', this.onKeyDown);
    this.removeEventListener('submit', this.onSubmit);
    this.removeEventListener('change', this.onChange);
    window.removeEventListener(
      'silksilky:open-customer-account-sheet',
      this.onOpenRequest
    );
    this.observer?.disconnect();
  }

  onDocumentOpenClick(event) {
    const trigger = this.getOpenTrigger(event);
    if (!trigger || this.contains(trigger)) return;

    event.preventDefault();
    event.stopPropagation();
    this.open(
      trigger,
      trigger.dataset.customerAccountSheetPanel || 'for-you',
      trigger.dataset.customerAccountSheetForm || ''
    );
  }

  onDocumentClick(event) {
    const trigger = this.getOpenTrigger(event);
    if (trigger) {
      event.preventDefault();
      this.open(
        trigger,
        trigger.dataset.customerAccountSheetPanel || 'for-you',
        trigger.dataset.customerAccountSheetForm || ''
      );
      return;
    }

    const tab = event.target.closest('[data-account-sheet-tab]');
    if (tab && this.contains(tab)) {
      event.preventDefault();
      this.switchTab(tab.dataset.accountSheetTab);
      return;
    }

    const ordersRetry = event.target.closest?.(
      '[data-account-sheet-orders-retry]'
    );
    if (ordersRetry && this.contains(ordersRetry)) {
      event.preventDefault();
      this.retryOrders();
      return;
    }

    const profileEdit = event.target.closest?.('[data-account-sheet-profile-edit]');
    if (profileEdit && this.contains(profileEdit)) {
      event.preventDefault();
      this.openProfileForm();
      return;
    }

    const profileCancel = event.target.closest?.('[data-account-sheet-profile-cancel]');
    if (profileCancel && this.contains(profileCancel)) {
      event.preventDefault();
      this.closeProfileForm();
      return;
    }

    const measurementsEdit = event.target.closest?.('[data-account-sheet-measurements-edit]');
    if (measurementsEdit && this.contains(measurementsEdit)) {
      event.preventDefault();
      this.openMeasurementsForm();
      return;
    }

    const measurementsCancel = event.target.closest?.('[data-account-sheet-measurements-cancel]');
    if (measurementsCancel && this.contains(measurementsCancel)) {
      event.preventDefault();
      this.closeMeasurementsForm();
      return;
    }

    const addressAdd = event.target.closest?.('[data-account-sheet-address-add]');
    if (addressAdd && this.contains(addressAdd)) {
      event.preventDefault();
      this.openAddressForm();
      return;
    }

    const addressEdit = event.target.closest?.('[data-account-sheet-address-edit]');
    if (addressEdit && this.contains(addressEdit)) {
      event.preventDefault();
      this.openAddressForm(addressEdit.dataset.accountSheetAddressEdit);
      return;
    }

    const addressDelete = event.target.closest?.('[data-account-sheet-address-delete]');
    if (addressDelete && this.contains(addressDelete)) {
      event.preventDefault();
      this.deleteAddress(addressDelete.dataset.accountSheetAddressDelete);
      return;
    }

    const addressDefault = event.target.closest?.('[data-account-sheet-address-default]');
    if (addressDefault && this.contains(addressDefault)) {
      event.preventDefault();
      this.setDefaultAddress(addressDefault.dataset.accountSheetAddressDefault);
      return;
    }

    const addressCancel = event.target.closest?.('[data-account-sheet-address-cancel]');
    if (addressCancel && this.contains(addressCancel)) {
      event.preventDefault();
      this.closeAddressForm();
      return;
    }

    if (event.target.closest('[data-account-sheet-close]')) {
      event.preventDefault();
      this.close();
    }
  }

  onSubmit(event) {
    const form = event.target;
    if (!form || !this.contains(form)) return;

    if (form.matches('[data-account-sheet-profile-form]')) {
      event.preventDefault();
      this.saveProfile(form);
      return;
    }

    if (form.matches('[data-account-sheet-measurements-form]')) {
      event.preventDefault();
      this.saveMeasurements(form);
      return;
    }

    if (form.matches('[data-account-sheet-address-form]')) {
      event.preventDefault();
      this.saveAddress(form);
    }
  }

  onChange(event) {
    const unit = event.target?.closest?.('[data-account-sheet-measurements-unit]');
    if (unit && this.contains(unit)) {
      this.updateMeasurementsUnitFields(unit.value);
      return;
    }

    const country = event.target?.closest?.('[data-account-sheet-country-select]');
    if (country && this.contains(country)) {
      this.updateAddressProvinceOptions(country.value);
    }
  }

  onOpenRequest(event) {
    event.preventDefault();
    this.open(
      null,
      event.detail?.panel || 'for-you',
      event.detail?.form || ''
    );
  }

  onKeyDown(event) {
    if (event.key === 'Escape' && this.hasAttribute('open')) {
      if (this.closeActiveFormModal()) {
        event.preventDefault();
        return;
      }
      this.close();
    }
  }

  open(trigger, panelName = 'for-you', formName = '') {
    const minicartWasOpen = this.closeMinicart();
    this.activeTrigger = minicartWasOpen ? null : trigger || document.activeElement;
    this.requestedFormName = formName;
    this.switchTab(panelName, false);
    this.setAttribute('open', '');
    document.documentElement.classList.add(
      'open-drawer',
      'open-customer-account-sheet'
    );
    root.style.setProperty('padding-right', getScrollBarWidth.init() + 'px');
    document
      .querySelectorAll(
        '.action-customer-account-sheet, [data-open-customer-account-sheet]'
      )
      .forEach((element) => element.setAttribute('aria-expanded', 'true'));
    this.syncShopLoginButton();
    setTimeout(() => this.syncShopLoginButton(), 300);
    this.initProductSwipers();
    setTimeout(() => this.initProductSwipers(), 300);
    const dataReady = this.loadDrawerData({ force: Boolean(formName) });
    if (formName) {
      Promise.resolve(dataReady).then(() => {
        if (
          !this.hasAttribute('open') ||
          !this.drawerDataLoaded ||
          this.requestedFormName !== formName
        ) {
          return;
        }
        this.openRequestedForm(formName);
      });
    }
    requestAnimationFrame(() => {
      this.panel?.focus({ preventScroll: true });
    });
  }

  close() {
    if (!this.hasAttribute('open')) return;
    this.requestedFormName = '';
    this.closeActiveFormModal();
    this.removeAttribute('open');
    document.documentElement.classList.remove(
      'open-drawer',
      'open-customer-account-sheet'
    );
    root.style.removeProperty('padding-right');
    document
      .querySelectorAll(
        '.action-customer-account-sheet, [data-open-customer-account-sheet]'
      )
      .forEach((element) => element.setAttribute('aria-expanded', 'false'));
    this.activeTrigger?.focus({ preventScroll: true });
  }

  switchTab(tabName, scrollToTop = true) {
    const activePanel = this.querySelector(
      `[data-account-sheet-panel="${tabName}"]`
    );
    if (!activePanel) return;

    this.querySelectorAll('[data-account-sheet-panel]').forEach((panel) => {
      const isActive = panel === activePanel;
      panel.toggleAttribute('hidden', !isActive);
      panel.classList.toggle('is-active', isActive);
    });

    this.querySelectorAll('[data-account-sheet-tab]').forEach((tab) => {
      const isActive = tab.dataset.accountSheetTab === tabName;
      tab.classList.remove('is-active', 'active');
      if (isActive) {
        tab.classList.add('is-active', 'active');
      }
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    if (scrollToTop) {
      this.panel?.scrollTo({ top: 0, behavior: 'smooth' });
    }

    if (tabName === 'orders') {
      this.loadOrders();
    }

    this.initProductSwipers();
  }

  openFormModal(selector) {
    const modal = this.querySelector(selector);
    if (!modal) return;
    modal.hidden = false;
    modal.setAttribute('open', '');
  }

  closeFormModal(selector) {
    const modal = this.querySelector(selector);
    if (!modal) return;
    modal.hidden = true;
    modal.removeAttribute('open');
  }

  closeActiveFormModal() {
    const modal = this.querySelector('.customer-account-sheet__form-modal[open]');
    if (!modal) return false;
    if (modal.matches('[data-account-sheet-profile-modal]')) {
      this.closeProfileForm();
      return true;
    }
    if (modal.matches('[data-account-sheet-measurements-modal]')) {
      this.closeMeasurementsForm();
      return true;
    }
    if (modal.matches('[data-account-sheet-address-modal]')) {
      this.closeAddressForm();
      return true;
    }
    modal.hidden = true;
    modal.removeAttribute('open');
    return true;
  }

  openRequestedForm(formName) {
    if (formName === 'profile') {
      this.openProfileForm();
    } else if (formName === 'measurements') {
      this.openMeasurementsForm();
    }
  }

  initProductSwipers() {
    requestAnimationFrame(() => initAccountSheetProductSwipers(this));
  }

  async loadOrders({ force = false } = {}) {
    if (
      this.dataset.authenticated !== 'true' ||
      (!force && this.ordersLoaded) ||
      this.ordersLoading
    ) {
      return;
    }

    this.ordersLoading = true;
    this.setOrdersState('loading');
    try {
      const payload = await this.apiRequest('/customer/orders?first=6');
      if (payload?.authenticated !== true) {
        this.setOrdersState('error');
        return;
      }

      if (payload.customerAccountAuthorized !== true) {
        this.customerAccountAuthorizationUrl = String(
          payload.authorizationUrl || ''
        );
        if (
          this.customerAccountAuthorizationStatus === 'required' ||
          this.customerAccountAuthorizationStatus === 'error' ||
          !this.startCustomerAccountAuthorization(false)
        ) {
          this.setOrdersState('error');
        }
        return;
      }

      this.customerAccountAuthorizationStatus = 'success';
      this.renderOrders(payload.orders);
      this.ordersLoaded = true;
    } catch (_error) {
      this.setOrdersState('error');
    } finally {
      this.ordersLoading = false;
    }
  }

  retryOrders() {
    if (
      this.customerAccountAuthorizationUrl &&
      this.customerAccountAuthorizationStatus !== 'success' &&
      this.startCustomerAccountAuthorization(true)
    ) {
      return;
    }
    this.ordersLoaded = false;
    this.loadOrders({ force: true });
  }

  startCustomerAccountAuthorization(interactive) {
    if (!this.customerAccountAuthorizationUrl) return false;

    let authorizationUrl;
    try {
      authorizationUrl = new URL(
        this.customerAccountAuthorizationUrl,
        window.location.origin
      );
    } catch (_error) {
      return false;
    }
    if (
      authorizationUrl.origin !== window.location.origin ||
      !/^\/apps\/[a-z0-9-]+\/customer-account\/authorize$/i.test(
        authorizationUrl.pathname
      )
    ) {
      return false;
    }

    const attemptKey = `silksilky:customer-account-auth:${this.normalizeProxyPath(
      this.dataset.proxyPath
    )}`;
    if (!interactive) {
      const lastAttempt = Number(sessionStorage.getItem(attemptKey) || 0);
      if (Date.now() - lastAttempt < 5 * 60 * 1000) return false;
      sessionStorage.setItem(attemptKey, String(Date.now()));
    } else {
      sessionStorage.removeItem(attemptKey);
      authorizationUrl.searchParams.set('interactive', 'true');
    }

    const returnUrl = new URL(window.location.href);
    returnUrl.searchParams.delete('customer_account_auth');
    returnUrl.searchParams.set('customer_account_sheet', 'orders');
    returnUrl.hash = '';
    authorizationUrl.searchParams.set(
      'returnTo',
      `${returnUrl.pathname}${returnUrl.search}`
    );
    if (this.dataset.locale) {
      authorizationUrl.searchParams.set('locale', this.dataset.locale);
    }
    if (this.dataset.defaultCountryCode) {
      authorizationUrl.searchParams.set(
        'regionCountry',
        this.dataset.defaultCountryCode
      );
    }
    window.location.assign(authorizationUrl.toString());
    return true;
  }

  handleCustomerAccountAuthorizationReturn() {
    const url = new URL(window.location.href);
    const requestedPanel = url.searchParams.get('customer_account_sheet');
    const status = url.searchParams.get('customer_account_auth') || '';
    if (requestedPanel !== 'orders' && !status) return;

    this.customerAccountAuthorizationStatus = status;
    const attemptKey = `silksilky:customer-account-auth:${this.normalizeProxyPath(
      this.dataset.proxyPath
    )}`;
    if (status) sessionStorage.removeItem(attemptKey);

    url.searchParams.delete('customer_account_sheet');
    url.searchParams.delete('customer_account_auth');
    window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
    if (requestedPanel === 'orders') {
      requestAnimationFrame(() => this.open(null, 'orders'));
    }
  }

  setOrdersState(state) {
    const loading = this.querySelector('[data-account-sheet-orders-loading]');
    const error = this.querySelector('[data-account-sheet-orders-error]');
    const list = this.querySelector('[data-account-sheet-orders-list]');
    const empty = this.querySelector('[data-account-sheet-orders-empty]');
    const more = this.querySelector('[data-account-sheet-orders-more]');
    loading?.toggleAttribute('hidden', state !== 'loading');
    error?.toggleAttribute('hidden', state !== 'error');
    list?.toggleAttribute('hidden', true);
    empty?.toggleAttribute('hidden', true);
    more?.toggleAttribute('hidden', true);
  }

  renderOrders(orders) {
    const list = this.querySelector('[data-account-sheet-orders-list]');
    if (!list) return;

    const cards = (Array.isArray(orders) ? orders : [])
      .map((order) => this.createOrderCard(order))
      .filter(Boolean);
    list.replaceChildren(...cards);

    const loading = this.querySelector('[data-account-sheet-orders-loading]');
    const error = this.querySelector('[data-account-sheet-orders-error]');
    const empty = this.querySelector('[data-account-sheet-orders-empty]');
    const more = this.querySelector('[data-account-sheet-orders-more]');
    loading?.toggleAttribute('hidden', true);
    error?.toggleAttribute('hidden', true);
    list.toggleAttribute('hidden', cards.length === 0);
    empty?.toggleAttribute('hidden', cards.length !== 0);
    more?.toggleAttribute('hidden', cards.length === 0);
  }

  createOrderCard(order) {
    const orderUrl = this.normalizeOrderUrl(order?.url);
    if (!orderUrl || !order?.id || !order?.name) return null;

    const card = document.createElement('a');
    card.className = 'customer-account-sheet__order-card no-underline';
    card.href = orderUrl;
    card.target = '_blank';
    card.rel = 'nofollow noopener';
    card.dataset.accountSheetOrderId = String(order.id);

    const media = document.createElement('span');
    media.className = 'customer-account-sheet__order-media';
    media.setAttribute('aria-hidden', 'true');
    const imageUrl = this.normalizeOrderUrl(order.lineItem?.image?.url);
    if (imageUrl) {
      const image = document.createElement('img');
      image.src = imageUrl;
      image.alt = '';
      image.loading = 'lazy';
      image.width = 180;
      media.append(image);
    } else {
      media.append(this.createOrderPlaceholder());
    }
    if (
      Number.isInteger(order.additionalLineItemCount) &&
      order.additionalLineItemCount > 0
    ) {
      const count = document.createElement('span');
      count.className = 'customer-account-sheet__order-count';
      count.textContent = `+${order.additionalLineItemCount}`;
      media.append(count);
    }

    const summary = document.createElement('span');
    summary.className = 'customer-account-sheet__order-summary';
    const nameRow = document.createElement('span');
    nameRow.className = 'customer-account-sheet__order-name-row';
    const name = document.createElement('span');
    name.className = 'customer-account-sheet__order-name';
    name.textContent = String(order.name);
    nameRow.append(name);

    const statusLabel = this.getOrderShipmentSummaryLabel(order.shipmentSummary);
    if (statusLabel) {
      const status = document.createElement('span');
      status.className = 'customer-account-sheet__order-status';
      status.textContent = statusLabel;
      const ariaLabel = String(
        this.dataset.deliveryStatusLabelTemplate || ''
      ).replace('__STATUS__', statusLabel);
      if (ariaLabel) status.setAttribute('aria-label', ariaLabel);
      nameRow.append(status);
    }
    summary.append(nameRow);

    if (order.lineItem?.name) {
      const title = document.createElement('span');
      title.className = 'customer-account-sheet__order-title';
      title.textContent = String(order.lineItem.name);
      summary.append(title);
    }
    const processedAt = this.formatOrderDate(order.processedAt);
    if (processedAt) {
      const meta = document.createElement('span');
      meta.className = 'customer-account-sheet__order-meta';
      meta.textContent = processedAt;
      summary.append(meta);
    }

    const total = document.createElement('span');
    total.className = 'customer-account-sheet__order-total';
    total.textContent = this.formatOrderMoney(order.total);
    card.append(media, summary, total);
    return card;
  }

  createOrderPlaceholder() {
    const placeholder = document.createElement('span');
    placeholder.className = 'customer-account-sheet__order-placeholder';
    const namespace = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(namespace, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    const path = document.createElementNS(namespace, 'path');
    path.setAttribute(
      'd',
      'M5 4h14a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1Zm2 12 3.5-3.5 2.5 2.5 1.5-1.5L18 17M9 9h.01'
    );
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '1.5');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');
    svg.append(path);
    placeholder.append(svg);
    return placeholder;
  }

  normalizeOrderUrl(value) {
    try {
      const url = new URL(String(value || ''), window.location.origin);
      return url.protocol === 'https:' || url.protocol === 'http:'
        ? url.toString()
        : '';
    } catch (_error) {
      return '';
    }
  }

  formatOrderDate(value) {
    const date = new Date(value || '');
    if (!Number.isFinite(date.getTime())) return '';
    try {
      return new Intl.DateTimeFormat(
        this.dataset.locale || document.documentElement.lang || undefined,
        { year: 'numeric', month: 'short', day: 'numeric' }
      ).format(date);
    } catch (_error) {
      return '';
    }
  }

  formatOrderMoney(total) {
    const amount = Number(total?.amount);
    const currency = String(total?.currencyCode || '').toUpperCase();
    if (!Number.isFinite(amount) || !/^[A-Z]{3}$/.test(currency)) return '';
    try {
      return new Intl.NumberFormat(
        this.dataset.locale || document.documentElement.lang || undefined,
        { style: 'currency', currency }
      ).format(amount);
    } catch (_error) {
      return `${total.amount} ${currency}`;
    }
  }

  getOrderShipmentSummaryLabel(summary) {
    if (!summary?.code) return '';

    if (summary.code === 'delivered') {
      const deliveredAt = this.formatOrderShipmentDate(summary.deliveredAt);
      if (deliveredAt) {
        return String(this.dataset.shipmentDeliveredOnTemplate || '').replace(
          '__DATE__',
          deliveredAt
        );
      }
      return this.dataset.shipmentDeliveredLabel || '';
    }

    const labels = {
      attempted_delivery: this.dataset.shipmentAttemptedDeliveryLabel,
      cancelled: this.dataset.shipmentCancelledLabel,
      confirmed: this.dataset.shipmentConfirmedLabel,
      delayed: this.dataset.shipmentDelayedLabel,
      delivery_issue: this.dataset.shipmentDeliveryIssueLabel,
      multiple_shipments: this.dataset.shipmentMultipleLabel,
      on_its_way: this.dataset.shipmentOnItsWayLabel,
      out_for_delivery: this.dataset.shipmentOutForDeliveryLabel,
      picked_up: this.dataset.shipmentPickedUpLabel,
      ready_for_pickup: this.dataset.shipmentReadyForPickupLabel,
    };
    return labels[summary.code] || '';
  }

  formatOrderShipmentDate(value) {
    const date = new Date(value || '');
    if (!Number.isFinite(date.getTime())) return '';

    try {
      const options = {
        month: 'short',
        day: 'numeric',
      };
      if (date.getFullYear() !== new Date().getFullYear()) {
        options.year = 'numeric';
      }
      return new Intl.DateTimeFormat(
        this.dataset.locale || document.documentElement.lang || undefined,
        options
      ).format(date);
    } catch (_error) {
      return '';
    }
  }

  async loadDrawerData({ force = false } = {}) {
    const mount = this.querySelector('[data-account-sheet-loyalty]');
    if (!force && this.drawerDataLoaded) {
      return;
    }
    if (!force && this.drawerDataLoading) {
      return new Promise((resolve) => {
        this.addEventListener('customer-account-sheet:data-ready', resolve, {
          once: true,
        });
      });
    }

    const proxyPath = this.normalizeProxyPath(this.dataset.proxyPath);
    const params = new URLSearchParams();
    this.appendParam(params, 'locale', this.dataset.locale);
    this.appendParam(params, 'currencyCode', this.dataset.currencyCode);
    const endpoint = `${proxyPath}/customer/account-sheet/bootstrap${
      params.toString() ? `?${params}` : ''
    }`;

    this.drawerDataLoading = true;
    if (mount) {
      mount.dataset.state = 'loading';
    }

    try {
      const payload = await this.fetchJson(endpoint);
      this.accountData = payload;
      if (mount && mount.dataset.authenticated === 'true') {
        this.renderLoyaltySummary(mount, payload);
      }
      this.renderCustomerProfile(payload);
      this.renderCustomerMeasurements(payload);
      this.renderCustomerAddresses(payload);
      this.drawerDataLoaded = true;
    } catch (error) {
      if (mount) {
        mount.dataset.state = 'error';
      }
      this.showFallbackForError(error);
    } finally {
      this.drawerDataLoading = false;
      this.dispatchEvent(new Event('customer-account-sheet:data-ready'));
    }
  }

  renderCustomerProfile(payload) {
    const customer = payload?.customer || {};
    const profile = payload?.profile || customer?.profile || {};
    const firstName = this.firstString(customer.firstName);
    const lastName = this.firstString(customer.lastName);
    const fullName = this.firstString(
      [firstName, lastName].filter(Boolean).join(' '),
      customer.name,
      customer.email
    );
    const email = this.firstString(customer.email);
    const gender = this.normalizeGenderValue(this.firstString(profile.gender));
    const birthday = this.firstString(profile.birthday);

    this.setText(
      '[data-account-sheet-profile-email]',
      email || this.notProvidedLabel()
    );
    this.setText(
      '[data-account-sheet-profile-name]',
      fullName || this.notProvidedLabel()
    );
    const hiHeadingTemplate = this.dataset.hiHeadingTemplate || '__NAME__';
    this.setText(
      '[data-account-sheet-hi-heading]',
      hiHeadingTemplate.replace('__NAME__', fullName || email || '')
    );
    this.setText(
      '[data-account-sheet-profile-gender]',
      gender ? this.getGenderLabel(gender) : this.notProvidedLabel()
    );
    this.setText(
      '[data-account-sheet-profile-birthday]',
      birthday || this.notProvidedLabel()
    );

    const form = this.querySelector('[data-account-sheet-profile-form]');
    if (form && form.hidden) {
      this.setFormFieldValue(form, 'firstName', firstName);
      this.setFormFieldValue(form, 'lastName', lastName);
      this.setFormFieldValue(form, 'gender', gender);
      this.setFormFieldValue(form, 'birthday', birthday);
    }
  }

  openProfileForm() {
    const form = this.querySelector('[data-account-sheet-profile-form]');
    const customer = this.accountData?.customer || {};
    const profile = this.accountData?.profile || {};
    if (!form) return;

    this.setFormFieldValue(
      form,
      'firstName',
      this.firstString(customer.firstName)
    );
    this.setFormFieldValue(
      form,
      'lastName',
      this.firstString(customer.lastName)
    );
    this.setFormFieldValue(
      form,
      'gender',
      this.normalizeGenderValue(this.firstString(profile.gender))
    );
    this.setFormFieldValue(form, 'birthday', this.firstString(profile.birthday));
    this.clearFormError('[data-account-sheet-profile-error]');
    this.hideElement('[data-account-sheet-profile-fallback]');
    form.hidden = false;
    this.openFormModal('[data-account-sheet-profile-modal]');
    form.querySelector('select, input')?.focus({ preventScroll: true });
  }

  closeProfileForm() {
    this.querySelector('[data-account-sheet-profile-form]')?.setAttribute(
      'hidden',
      ''
    );
    this.closeFormModal('[data-account-sheet-profile-modal]');
    this.clearFormError('[data-account-sheet-profile-error]');
  }

  async saveProfile(form) {
    this.setFormBusy(form, true);
    this.clearFormError('[data-account-sheet-profile-error]');
    try {
      const payload = await this.apiRequest('/customer/profile', {
        method: 'POST',
        body: {
          firstName: this.getFormFieldValue(form, 'firstName'),
          lastName: this.getFormFieldValue(form, 'lastName'),
          gender: this.getFormFieldValue(form, 'gender'),
          birthday: this.getFormFieldValue(form, 'birthday'),
        },
      });
      this.accountData = {
        ...(this.accountData || {}),
        customer: {
          ...((this.accountData || {}).customer || {}),
          ...(payload.customer || {}),
        },
        profile: payload.profile || {},
      };
      this.renderCustomerProfile({
        ...(this.accountData || {}),
        customer: this.accountData.customer || {},
        profile: payload.profile || {},
      });
      this.closeProfileForm();
    } catch (error) {
      this.showFormError(
        '[data-account-sheet-profile-error]',
        this.errorMessage(
          error,
          this.dataset.profileSaveError || 'Unable to save profile.'
        )
      );
      if (this.shouldShowFallback(error)) {
        this.showElement('[data-account-sheet-profile-fallback]');
      }
    } finally {
      this.setFormBusy(form, false);
    }
  }

  renderCustomerMeasurements(payload) {
    const measurements = this.normalizeMeasurementsPayload(payload?.measurements);
    const summary = this.querySelector('[data-account-sheet-measurements-summary]');
    this.measurements = measurements;

    if (summary) {
      const rows = this.getMeasurementSummaryRows(measurements);
      summary.replaceChildren();
      if (!rows.length) {
        summary.textContent = this.measurementsEmptyLabel();
      } else {
        rows.forEach((row) => {
          summary.append(this.createMeasurementItem(row.label, row.value));
        });
      }
    }

    const form = this.querySelector('[data-account-sheet-measurements-form]');
    if (form && form.hidden) {
      this.populateMeasurementsForm(form, measurements);
    }
  }

  openMeasurementsForm() {
    const form = this.querySelector('[data-account-sheet-measurements-form]');
    if (!form) return;

    this.populateMeasurementsForm(
      form,
      this.measurements || this.accountData?.measurements || null
    );
    this.clearFormError('[data-account-sheet-measurements-error]');
    this.hideElement('[data-account-sheet-measurements-fallback]');
    form.hidden = false;
    this.openFormModal('[data-account-sheet-measurements-modal]');
    form.querySelector('input, select')?.focus({ preventScroll: true });
  }

  closeMeasurementsForm() {
    this.querySelector('[data-account-sheet-measurements-form]')?.setAttribute(
      'hidden',
      ''
    );
    this.closeFormModal('[data-account-sheet-measurements-modal]');
    this.clearFormError('[data-account-sheet-measurements-error]');
  }

  async saveMeasurements(form) {
    this.setFormBusy(form, true);
    this.clearFormError('[data-account-sheet-measurements-error]');
    try {
      const payload = await this.apiRequest('/customer/measurements', {
        method: 'POST',
        body: this.collectMeasurementsForm(form),
      });
      this.accountData = {
        ...(this.accountData || {}),
        measurements: payload.measurements || null,
      };
      this.renderCustomerMeasurements(this.accountData);
      this.closeMeasurementsForm();
    } catch (error) {
      this.showFormError(
        '[data-account-sheet-measurements-error]',
        this.errorMessage(
          error,
          this.dataset.measurementsSaveError || 'Unable to save measurements.'
        )
      );
      if (this.shouldShowFallback(error)) {
        this.showElement('[data-account-sheet-measurements-fallback]');
      }
    } finally {
      this.setFormBusy(form, false);
    }
  }

  collectMeasurementsForm(form) {
    const displayUnit =
      this.getFormFieldValue(form, 'displayUnit') === 'cm' ? 'cm' : 'in';
    return {
      displayUnit,
      bust: this.getFormFieldValue(form, 'bust'),
      waist: this.getFormFieldValue(form, 'waist'),
      hip: this.getFormFieldValue(form, 'hip'),
      torso: this.getFormFieldValue(form, 'torso'),
      braBand: this.getFormFieldValue(form, 'braBand'),
      cupSize: this.getFormFieldValue(form, 'cupSize'),
      weight: this.getFormFieldValue(form, 'weight'),
      heightCm: this.getFormFieldValue(form, 'heightCm'),
      heightFeet: this.getFormFieldValue(form, 'heightFeet'),
      heightInches: this.getFormFieldValue(form, 'heightInches'),
    };
  }

  populateMeasurementsForm(form, measurements) {
    const normalized = this.normalizeMeasurementsPayload(measurements);
    const displayUnit = normalized?.displayUnit === 'cm' ? 'cm' : 'in';
    const values = normalized?.measurements || {};
    const bra = normalized?.bra || {};

    this.setFormFieldValue(form, 'displayUnit', displayUnit);
    this.setFormFieldValue(
      form,
      'bust',
      this.toDisplayLengthValue(values.bustCm, displayUnit)
    );
    this.setFormFieldValue(
      form,
      'waist',
      this.toDisplayLengthValue(values.waistCm, displayUnit)
    );
    this.setFormFieldValue(
      form,
      'hip',
      this.toDisplayLengthValue(values.hipCm, displayUnit)
    );
    this.setFormFieldValue(
      form,
      'torso',
      this.toDisplayLengthValue(values.torsoCm, displayUnit)
    );
    this.setFormFieldValue(form, 'braBand', this.firstString(bra.band));
    this.setFormFieldValue(form, 'cupSize', this.firstString(bra.cup));
    this.setFormFieldValue(
      form,
      'weight',
      this.toDisplayWeightValue(values.weightKg, displayUnit)
    );

    if (displayUnit === 'cm') {
      this.setFormFieldValue(
        form,
        'heightCm',
        this.formatMeasurementNumber(values.heightCm)
      );
      this.setFormFieldValue(form, 'heightFeet', '');
      this.setFormFieldValue(form, 'heightInches', '');
    } else {
      const height = this.toImperialHeight(values.heightCm);
      this.setFormFieldValue(form, 'heightCm', '');
      this.setFormFieldValue(form, 'heightFeet', height.feet);
      this.setFormFieldValue(form, 'heightInches', height.inches);
    }

    form.dataset.measurementsDisplayUnit = displayUnit;
    this.updateMeasurementsUnitFields(displayUnit, { convert: false });
  }

  updateMeasurementsUnitFields(unit, options = {}) {
    const displayUnit = unit === 'cm' ? 'cm' : 'in';
    const form = this.querySelector('[data-account-sheet-measurements-form]');
    const previousUnit = form?.dataset.measurementsDisplayUnit || displayUnit;

    if (form && options.convert && previousUnit !== displayUnit) {
      this.convertMeasurementsFormValues(form, previousUnit, displayUnit);
    }

    this.querySelectorAll('[data-account-sheet-length-unit]').forEach(
      (element) => {
        element.textContent =
          displayUnit === 'cm'
            ? this.measurementsCmLabel()
            : this.measurementsInchLabel();
      }
    );
    this.querySelectorAll('[data-account-sheet-weight-unit]').forEach(
      (element) => {
        element.textContent =
          displayUnit === 'cm'
            ? this.measurementsKgLabel()
            : this.measurementsLbsLabel();
      }
    );
    this.querySelector('[data-account-sheet-height-imperial]')?.toggleAttribute(
      'hidden',
      displayUnit === 'cm'
    );
    this.querySelector('[data-account-sheet-height-metric]')?.toggleAttribute(
      'hidden',
      displayUnit !== 'cm'
    );

    if (form) {
      form.dataset.measurementsDisplayUnit = displayUnit;
    }
  }

  convertMeasurementsFormValues(form, fromUnit, toUnit) {
    ['bust', 'waist', 'hip', 'torso'].forEach((field) => {
      const value = this.toMeasurementNumber(this.getFormFieldValue(form, field));
      if (value === null) return;
      this.setFormFieldValue(
        form,
        field,
        this.formatMeasurementNumber(
          fromUnit === 'cm' ? value / 2.54 : value * 2.54
        )
      );
    });

    const weight = this.toMeasurementNumber(this.getFormFieldValue(form, 'weight'));
    if (weight !== null) {
      this.setFormFieldValue(
        form,
        'weight',
        this.formatMeasurementNumber(
          fromUnit === 'cm' ? weight / 0.45359237 : weight * 0.45359237
        )
      );
    }

    if (toUnit === 'cm') {
      const heightCm = this.heightFieldsToCm(
        this.getFormFieldValue(form, 'heightFeet'),
        this.getFormFieldValue(form, 'heightInches')
      );
      this.setFormFieldValue(
        form,
        'heightCm',
        this.formatMeasurementNumber(heightCm)
      );
      this.setFormFieldValue(form, 'heightFeet', '');
      this.setFormFieldValue(form, 'heightInches', '');
    } else {
      const height = this.toImperialHeight(
        this.toMeasurementNumber(this.getFormFieldValue(form, 'heightCm'))
      );
      this.setFormFieldValue(form, 'heightCm', '');
      this.setFormFieldValue(form, 'heightFeet', height.feet);
      this.setFormFieldValue(form, 'heightInches', height.inches);
    }
  }

  getMeasurementSummaryRows(measurements) {
    const normalized = this.normalizeMeasurementsPayload(measurements);
    if (!normalized) return [];

    const displayUnit = normalized.displayUnit === 'cm' ? 'cm' : 'in';
    const values = normalized.measurements || {};
    const bra = normalized.bra || {};
    const rows = [];
    this.addMeasurementSummaryRow(
      rows,
      this.dataset.measurementsBustLabel || 'Bust',
      this.formatLengthSummary(values.bustCm, displayUnit)
    );
    this.addMeasurementSummaryRow(
      rows,
      this.dataset.measurementsWaistLabel || 'Waist',
      this.formatLengthSummary(values.waistCm, displayUnit)
    );
    this.addMeasurementSummaryRow(
      rows,
      this.dataset.measurementsHipLabel || 'Hip',
      this.formatLengthSummary(values.hipCm, displayUnit)
    );
    this.addMeasurementSummaryRow(
      rows,
      this.dataset.measurementsTorsoLabel || 'Torso',
      this.formatLengthSummary(values.torsoCm, displayUnit)
    );
    this.addMeasurementSummaryRow(
      rows,
      this.dataset.measurementsHeightLabel || 'Height',
      this.formatHeightSummary(values.heightCm, displayUnit)
    );
    this.addMeasurementSummaryRow(
      rows,
      this.dataset.measurementsWeightLabel || 'Weight',
      this.formatWeightSummary(values.weightKg, displayUnit)
    );
    this.addMeasurementSummaryRow(
      rows,
      this.dataset.measurementsBraSizeLabel || 'Bra Size',
      this.firstString(bra.band)
    );
    this.addMeasurementSummaryRow(
      rows,
      this.dataset.measurementsCupSizeLabel || 'Cup Size',
      this.firstString(bra.cup)
    );
    return rows;
  }

  addMeasurementSummaryRow(rows, label, value) {
    if (!value) return;
    rows.push({ label, value });
  }

  createMeasurementItem(label, value) {
    const item = document.createElement('span');
    const labelElement = document.createElement('span');
    const valueElement = document.createElement('span');
    item.className = 'customer-account-sheet__measurement-item';
    labelElement.className = 'customer-account-sheet__measurement-label';
    valueElement.className = 'customer-account-sheet__measurement-value';
    labelElement.textContent = label;
    valueElement.textContent = value;
    item.append(labelElement, valueElement);
    return item;
  }

  normalizeMeasurementsPayload(measurements) {
    if (!measurements || typeof measurements !== 'object') return null;
    const values =
      measurements.measurements && typeof measurements.measurements === 'object'
        ? measurements.measurements
        : {};
    return {
      ...measurements,
      displayUnit: measurements.displayUnit === 'cm' ? 'cm' : 'in',
      measurements: values,
      bra:
        measurements.bra && typeof measurements.bra === 'object'
          ? measurements.bra
          : {},
    };
  }

  toDisplayLengthValue(value, displayUnit) {
    const number = this.toMeasurementNumber(value);
    if (number === null) return '';
    return this.formatMeasurementNumber(
      displayUnit === 'cm' ? number : number / 2.54
    );
  }

  toDisplayWeightValue(value, displayUnit) {
    const number = this.toMeasurementNumber(value);
    if (number === null) return '';
    return this.formatMeasurementNumber(
      displayUnit === 'cm' ? number : number / 0.45359237
    );
  }

  formatLengthSummary(value, displayUnit) {
    const displayValue = this.toDisplayLengthValue(value, displayUnit);
    if (!displayValue) return '';
    return `${displayValue} ${
      displayUnit === 'cm'
        ? this.measurementsCmLabel()
        : this.measurementsInchesLabel()
    }`;
  }

  formatWeightSummary(value, displayUnit) {
    const displayValue = this.toDisplayWeightValue(value, displayUnit);
    if (!displayValue) return '';
    return `${displayValue} ${
      displayUnit === 'cm'
        ? this.measurementsKgLabel()
        : this.measurementsLbsLabel()
    }`;
  }

  formatHeightSummary(value, displayUnit) {
    const number = this.toMeasurementNumber(value);
    if (number === null) return '';
    if (displayUnit === 'cm') {
      return `${this.formatMeasurementNumber(number)} ${this.measurementsCmLabel()}`;
    }
    const height = this.toImperialHeight(number);
    return `${height.feet || 0} ${this.measurementsFeetLabel()} ${
      height.inches || 0
    } ${this.measurementsInchesLabel()}`;
  }

  toImperialHeight(value) {
    const number = this.toMeasurementNumber(value);
    if (number === null) {
      return { feet: '', inches: '' };
    }
    let totalInches = Math.round((number / 2.54) * 10) / 10;
    let feet = Math.floor(totalInches / 12);
    let inches = Math.round((totalInches - feet * 12) * 10) / 10;
    if (inches >= 12) {
      feet += 1;
      inches = 0;
    }
    return {
      feet: String(feet),
      inches: this.formatMeasurementNumber(inches),
    };
  }

  heightFieldsToCm(feetValue, inchesValue) {
    const feet = this.toMeasurementNumber(feetValue) || 0;
    const inches = this.toMeasurementNumber(inchesValue) || 0;
    if (!feet && !inches) return null;
    return feet * 30.48 + inches * 2.54;
  }

  formatMeasurementNumber(value) {
    const number = this.toMeasurementNumber(value);
    if (number === null) return '';
    const rounded = Math.round(number * 10) / 10;
    return Number.isInteger(rounded)
      ? String(rounded)
      : String(rounded).replace(/\.0$/, '');
  }

  measurementsEmptyLabel() {
    return this.decodeHtmlEntities(
      this.dataset.measurementsEmptyLabel || "You haven't added measurements yet"
    );
  }

  measurementsCmLabel() {
    return this.decodeHtmlEntities(this.dataset.measurementsCmLabel || 'cm');
  }

  measurementsKgLabel() {
    return this.decodeHtmlEntities(this.dataset.measurementsKgLabel || 'kg');
  }

  measurementsLbsLabel() {
    return this.decodeHtmlEntities(this.dataset.measurementsLbsLabel || 'lbs');
  }

  measurementsInchLabel() {
    return this.decodeHtmlEntities(this.dataset.measurementsInchLabel || 'inch');
  }

  measurementsFeetLabel() {
    return this.decodeHtmlEntities(this.dataset.measurementsFeetLabel || 'ft');
  }

  measurementsInchesLabel() {
    return this.decodeHtmlEntities(this.dataset.measurementsInchesLabel || 'in');
  }

  toMeasurementNumber(value) {
    if (value === null || value === undefined) return null;
    if (typeof value === 'string' && !value.trim()) return null;
    const number = Number(value);
    return Number.isFinite(number) ? number : null;
  }

  renderCustomerAddresses(payload) {
    const addresses = Array.isArray(payload?.addresses) ? payload.addresses : [];
    const defaultAddress = payload?.defaultAddress || null;
    this.addresses = addresses.length
      ? addresses
      : defaultAddress
        ? [defaultAddress]
        : [];
    this.renderAddressList();
  }

  renderAddressList() {
    const list = this.querySelector('[data-account-sheet-addresses-list]');
    const empty = this.querySelector('[data-account-sheet-addresses-empty]');
    if (!list) return;

    list.replaceChildren();
    this.addresses.forEach((address) => {
      list.append(this.createAddressCard(address));
    });
    empty?.toggleAttribute('hidden', this.addresses.length > 0);
  }

  createAddressCard(address) {
    const card = document.createElement('article');
    const header = document.createElement('div');
    const title = document.createElement('div');
    const lines = document.createElement('div');
    const actions = document.createElement('div');
    const id = String(address?.id || '');

    card.className = 'customer-account-sheet__address-card';
    header.className = 'customer-account-sheet__address-card-header';
    title.className = 'customer-account-sheet__address-title';
    title.textContent =
      [address?.firstName, address?.lastName].filter(Boolean).join(' ') ||
      this.notProvidedLabel();
    header.append(title);

    if (address?.isDefault) {
      const badge = document.createElement('span');
      badge.className = 'customer-account-sheet__address-badge';
      badge.textContent = this.dataset.defaultAddressLabel || 'Default';
      header.append(badge);
    }

    lines.className = 'customer-account-sheet__address-lines';
    this.getAddressLines(address).forEach((line) => {
      const row = document.createElement('span');
      row.textContent = line;
      lines.append(row);
    });

    actions.className = 'customer-account-sheet__address-actions';
    actions.append(
      this.createIconButton(
        this.dataset.editLabel || 'Edit',
        'data-account-sheet-address-edit',
        id,
        'pencil'
      )
    );
    if (!address?.isDefault) {
      actions.append(
        this.createIconButton(
          this.dataset.setDefaultLabel || 'Set default',
          'data-account-sheet-address-default',
          id,
          'star'
        )
      );
    }
    actions.append(
      this.createIconButton(
        this.dataset.deleteLabel || 'Delete',
        'data-account-sheet-address-delete',
        id,
        'trash-2'
      )
    );

    card.append(header, lines, actions);
    return card;
  }

  createIconButton(label, dataAttribute, value, iconName) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'customer-account-sheet__icon-button btn-reset';
    button.setAttribute('aria-label', label);
    button.title = label;
    button.setAttribute(dataAttribute, value);
    button.append(this.createLucideIcon(iconName));

    const hiddenLabel = document.createElement('span');
    hiddenLabel.className = 'visually-hidden';
    hiddenLabel.textContent = label;
    button.append(hiddenLabel);
    return button;
  }

  createLucideIcon(iconName) {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');

    const paths = {
      pencil: [
        ['path', { d: 'M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z' }],
        ['path', { d: 'm15 5 4 4' }],
      ],
      star: [
        ['path', { d: 'M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z' }],
      ],
      'trash-2': [
        ['path', { d: 'M3 6h18' }],
        ['path', { d: 'M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6' }],
        ['path', { d: 'M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2' }],
        ['line', { x1: '10', x2: '10', y1: '11', y2: '17' }],
        ['line', { x1: '14', x2: '14', y1: '11', y2: '17' }],
      ],
    };

    (paths[iconName] || paths.pencil).forEach(([tag, attributes]) => {
      const element = document.createElementNS('http://www.w3.org/2000/svg', tag);
      Object.entries(attributes).forEach(([name, value]) => {
        element.setAttribute(name, value);
      });
      svg.append(element);
    });
    return svg;
  }

  getAddressLines(address) {
    const formatted = Array.isArray(address?.formatted)
      ? address.formatted.filter(Boolean)
      : [];
    if (formatted.length) return formatted;

    return [
      address?.company,
      address?.address1,
      address?.address2,
      [address?.city, this.getProvinceLabel(address?.countryCode, address?.provinceCode), address?.zip]
        .filter(Boolean)
        .join(', '),
      this.getCountryLabel(address?.countryCode),
      address?.phone,
    ].filter(Boolean);
  }

  openAddressForm(addressId = '') {
    const form = this.querySelector('[data-account-sheet-address-form]');
    if (!form) return;

    const address = addressId ? this.findAddress(addressId) : null;
    const countryCode =
      this.normalizeCountryCode(address?.countryCode) ||
      this.normalizeCountryCode(this.dataset.defaultCountryCode) ||
      'US';
    this.setFormFieldValue(form, 'id', address?.id || '');
    [
      'firstName',
      'lastName',
      'company',
      'address1',
      'address2',
      'city',
      'zip',
      'phone',
    ].forEach((field) => {
      this.setFormFieldValue(form, field, address?.[field] || '');
    });
    this.populateAddressCountryOptions();
    this.setFormFieldValue(form, 'countryCode', countryCode);
    this.updateAddressProvinceOptions(countryCode, address?.provinceCode || '');
    this.setFormFieldValue(form, 'setAsDefault', Boolean(address?.isDefault));
    this.clearFormError('[data-account-sheet-address-error]');
    this.hideElement('[data-account-sheet-address-fallback]');
    form.hidden = false;
    this.openFormModal('[data-account-sheet-address-modal]');
    form.querySelector('[data-account-sheet-country-select]')?.focus({ preventScroll: true });
  }

  closeAddressForm() {
    this.querySelector('[data-account-sheet-address-form]')?.setAttribute(
      'hidden',
      ''
    );
    this.closeFormModal('[data-account-sheet-address-modal]');
    this.clearFormError('[data-account-sheet-address-error]');
  }

  async saveAddress(form) {
    this.setFormBusy(form, true);
    this.clearFormError('[data-account-sheet-address-error]');
    const addressId = this.getFormFieldValue(form, 'id');
    const endpoint = addressId
      ? `/customer/addresses/${encodeURIComponent(addressId)}`
      : '/customer/addresses';
    try {
      await this.apiRequest(endpoint, {
        method: 'POST',
        body: this.collectAddressForm(form),
      });
      await this.loadDrawerData({ force: true });
      this.closeAddressForm();
    } catch (error) {
      this.showFormError(
        '[data-account-sheet-address-error]',
        this.errorMessage(
          error,
          this.dataset.addressSaveError || 'Unable to save address.'
        )
      );
      if (this.shouldShowFallback(error)) {
        this.showElement('[data-account-sheet-address-fallback]');
      }
    } finally {
      this.setFormBusy(form, false);
    }
  }

  async deleteAddress(addressId) {
    if (!addressId) return;
    const message = this.dataset.addressDeleteConfirm || 'Delete this address?';
    if (message && !window.confirm(message)) return;

    try {
      await this.apiRequest(
        `/customer/addresses/${encodeURIComponent(addressId)}/delete`,
        { method: 'POST' }
      );
      await this.loadDrawerData({ force: true });
    } catch (error) {
      this.openFormModal('[data-account-sheet-address-modal]');
      this.showFormError(
        '[data-account-sheet-address-error]',
        this.errorMessage(
          error,
          this.dataset.addressDeleteError || 'Unable to delete address.'
        )
      );
      if (this.shouldShowFallback(error)) {
        this.showElement('[data-account-sheet-address-fallback]');
      }
    }
  }

  async setDefaultAddress(addressId) {
    if (!addressId) return;
    try {
      await this.apiRequest(
        `/customer/addresses/${encodeURIComponent(addressId)}/default`,
        { method: 'POST' }
      );
      await this.loadDrawerData({ force: true });
    } catch (error) {
      this.openFormModal('[data-account-sheet-address-modal]');
      this.showFormError(
        '[data-account-sheet-address-error]',
        this.errorMessage(
          error,
          this.dataset.defaultAddressUpdateError ||
            'Unable to update default address.'
        )
      );
      if (this.shouldShowFallback(error)) {
        this.showElement('[data-account-sheet-address-fallback]');
      }
    }
  }

  collectAddressForm(form) {
    const provinceField = this.querySelector('[data-account-sheet-province-field]');
    return {
      firstName: this.getFormFieldValue(form, 'firstName'),
      lastName: this.getFormFieldValue(form, 'lastName'),
      company: this.getFormFieldValue(form, 'company'),
      address1: this.getFormFieldValue(form, 'address1'),
      address2: this.getFormFieldValue(form, 'address2'),
      city: this.getFormFieldValue(form, 'city'),
      provinceCode: provinceField?.hidden
        ? ''
        : this.getFormFieldValue(form, 'provinceCode'),
      countryCode: this.getFormFieldValue(form, 'countryCode'),
      zip: this.getFormFieldValue(form, 'zip'),
      phone: this.getFormFieldValue(form, 'phone'),
      setAsDefault: Boolean(this.getFormField(form, 'setAsDefault')?.checked),
    };
  }

  populateAddressCountryOptions() {
    const select = this.querySelector('[data-account-sheet-country-select]');
    if (!select || select.dataset.accountSheetPopulated === 'true') return;

    const selectedValue = this.normalizeCountryCode(select.value);
    const fragment = document.createDocumentFragment();
    const placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = select.options[0]?.textContent || 'Country/region';
    fragment.append(placeholder);

    ACCOUNT_SHEET_COUNTRY_CODES.forEach((code) => {
      const option = document.createElement('option');
      option.value = code;
      option.textContent = this.getCountryLabel(code);
      fragment.append(option);
    });

    select.replaceChildren(fragment);
    select.dataset.accountSheetPopulated = 'true';
    if (selectedValue) {
      this.setFormFieldValue(select.form, 'countryCode', selectedValue);
    }
  }

  updateAddressProvinceOptions(countryCode, selectedValue = '') {
    const form = this.querySelector('[data-account-sheet-address-form]');
    const provinceField = this.querySelector('[data-account-sheet-province-field]');
    const provinceLabel = this.querySelector('[data-account-sheet-province-label]');
    const provinceSelect = this.querySelector('[data-account-sheet-province-select]');
    const normalizedCountry = this.normalizeCountryCode(countryCode);
    const provinces = ACCOUNT_SHEET_PROVINCES_BY_COUNTRY[normalizedCountry] || [];
    if (!form || !provinceField || !provinceSelect) return;

    provinceSelect.replaceChildren();
    if (!provinces.length) {
      provinceField.hidden = true;
      provinceSelect.required = false;
      return;
    }

    const placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent =
      ACCOUNT_SHEET_PROVINCE_LABEL_BY_COUNTRY[normalizedCountry] ||
      provinceLabel?.textContent ||
      'Province';
    provinceSelect.append(placeholder);

    provinces.forEach(([code, label]) => {
      const option = document.createElement('option');
      option.value = code;
      option.textContent = label;
      provinceSelect.append(option);
    });

    if (provinceLabel) {
      provinceLabel.textContent =
        ACCOUNT_SHEET_PROVINCE_LABEL_BY_COUNTRY[normalizedCountry] ||
        'Province';
    }
    provinceField.hidden = false;
    provinceSelect.required = true;
    this.setAddressProvinceValue(form, selectedValue);
  }

  setAddressProvinceValue(form, value) {
    const provinceSelect = this.getFormField(form, 'provinceCode');
    if (!provinceSelect) return;
    const normalized = String(value || '').trim();
    if (!normalized) {
      provinceSelect.value = '';
      return;
    }

    const directValue = normalized.toUpperCase();
    const directOption = Array.from(provinceSelect.options).find(
      (option) => option.value.toUpperCase() === directValue
    );
    if (directOption) {
      provinceSelect.value = directOption.value;
      return;
    }

    const labelOption = Array.from(provinceSelect.options).find(
      (option) => option.textContent.trim().toLowerCase() === normalized.toLowerCase()
    );
    provinceSelect.value = labelOption?.value || '';
  }

  getCountryLabel(countryCode) {
    const code = this.normalizeCountryCode(countryCode);
    if (!code) return '';
    if (ACCOUNT_SHEET_REGION_LABELS[code]) return ACCOUNT_SHEET_REGION_LABELS[code];
    try {
      return (
        new Intl.DisplayNames([document.documentElement.lang || 'en'], {
          type: 'region',
        }).of(code) || code
      );
    } catch {
      return code;
    }
  }

  getProvinceLabel(countryCode, provinceCode) {
    const code = String(provinceCode || '').trim();
    if (!code) return '';
    const country = this.normalizeCountryCode(countryCode);
    const provinces = ACCOUNT_SHEET_PROVINCES_BY_COUNTRY[country] || [];
    const match = provinces.find(
      ([value, label]) =>
        value.toLowerCase() === code.toLowerCase() ||
        label.toLowerCase() === code.toLowerCase()
    );
    return match?.[1] || code;
  }

  normalizeCountryCode(value) {
    const code = String(value || '').trim().toUpperCase();
    return ACCOUNT_SHEET_COUNTRY_CODES.includes(code) ? code : '';
  }

  findAddress(addressId) {
    return this.addresses.find(
      (address) => String(address?.id || '') === String(addressId || '')
    );
  }

  async apiRequest(path, options = {}) {
    const proxyPath = this.normalizeProxyPath(this.dataset.proxyPath);
    const headers = {
      Accept: 'application/json',
      ...(options.headers || {}),
    };
    const init = {
      credentials: 'same-origin',
      ...options,
      headers,
    };
    if (options.body && typeof options.body !== 'string') {
      headers['Content-Type'] = 'application/json';
      init.body = JSON.stringify(options.body);
    }
    return this.fetchJson(`${proxyPath}${path}`, init);
  }

  async fetchJson(url, init = {}) {
    const response = await fetch(url, {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
      },
      ...init,
    });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok || payload?.ok === false) {
      throw {
        status: response.status,
        ...payload,
      };
    }
    return payload;
  }

  setText(selector, value) {
    const element = this.querySelector(selector);
    if (element) {
      element.textContent = value;
    }
  }

  getGenderLabel(value) {
    const normalized = this.normalizeGenderValue(value);
    const options = Array.from(
      this.querySelectorAll('[data-account-sheet-profile-form] option')
    );
    return (
      options.find((option) => option.value === normalized)?.textContent ||
      normalized ||
      this.notProvidedLabel()
    );
  }

  normalizeGenderValue(value) {
    const normalized = String(value || '').trim();
    switch (normalized.toLowerCase()) {
      case 'female':
        return 'Female';
      case 'male':
        return 'Male';
      case 'other':
      case 'non_binary':
      case 'prefer_not_to_say':
        return 'Other';
      default:
        return normalized;
    }
  }

  getFormField(form, name) {
    return form?.elements?.namedItem?.(name) || null;
  }

  getFormFieldValue(form, name) {
    const field = this.getFormField(form, name);
    return typeof field?.value === 'string' ? field.value.trim() : '';
  }

  setFormFieldValue(form, name, value) {
    const field = this.getFormField(form, name);
    if (!field) return;
    if (field.type === 'checkbox') {
      field.checked = Boolean(value);
      return;
    }
    field.value = value == null ? '' : String(value);
  }

  setFormBusy(form, isBusy) {
    form
      ?.querySelectorAll('input, select, button')
      .forEach((element) => {
        element.disabled = isBusy;
      });
  }

  clearFormError(selector) {
    const element = this.querySelector(selector);
    if (!element) return;
    element.textContent = '';
    element.hidden = true;
  }

  showFormError(selector, message) {
    const element = this.querySelector(selector);
    if (!element) return;
    element.textContent = message;
    element.hidden = false;
  }

  hideElement(selector) {
    const element = this.querySelector(selector);
    if (element) {
      element.hidden = true;
    }
  }

  showElement(selector) {
    const element = this.querySelector(selector);
    if (element) {
      element.hidden = false;
    }
  }

  showFallbackForError(error) {
    if (!this.shouldShowFallback(error)) return;
    this.showElement('[data-account-sheet-profile-fallback]');
    this.showElement('[data-account-sheet-measurements-fallback]');
    this.showElement('[data-account-sheet-address-fallback]');
  }

  shouldShowFallback(error) {
    const message = this.errorMessage(error, '').toLowerCase();
    return (
      [401, 403, 404, 405].includes(Number(error?.status)) ||
      message.includes('scope') ||
      message.includes('permission') ||
      message.includes('write_customers') ||
      message.includes('not found')
    );
  }

  errorMessage(error, fallback) {
    const userErrors = Array.isArray(error?.userErrors) ? error.userErrors : [];
    const message = userErrors
      .map((item) => item?.message)
      .filter(Boolean)
      .join(' ');
    return message || error?.message || fallback;
  }

  notProvidedLabel() {
    return this.dataset.notProvidedLabel || 'Not provided';
  }

  decodeHtmlEntities(value) {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = String(value || '');
    return textarea.value;
  }

  getOpenTrigger(event) {
    const trigger = event?.target?.closest?.(this.openTriggerSelector);
    if (trigger) return trigger;

    if (typeof event?.composedPath !== 'function') return null;
    return (
      event
        .composedPath()
        .find((element) => element?.matches?.(this.openTriggerSelector)) || null
    );
  }

  closeMinicart() {
    const cart = document.querySelector('cart-notification');
    const minicart =
      cart?.querySelector('.header__minicart') ||
      document.querySelector('.header__minicart');
    const wrapper = minicart?.querySelector('.minicart__wrapper');
    const isOpen =
      document.documentElement.classList.contains('open-minicart') ||
      wrapper?.classList.contains('open');

    if (!isOpen) return false;

    wrapper?.classList.remove('open');
    minicart?.querySelector('.minicart__action')?.classList.remove('open');
    document.documentElement.classList.remove('open-minicart', 'open-drawer');
    root.style.removeProperty('padding-right');
    document
      .querySelector('minicart-recommendations-beside')
      ?.classList.remove('open');
    document
      .querySelectorAll('.addon.is-open')
      .forEach((element) => element.classList.remove('is-open'));
    if (cart?.onBodyClick) {
      document.body.removeEventListener('click', cart.onBodyClick);
    }

    return true;
  }

  renderLoyaltySummary(mount, payload) {
    const summary = payload?.summary || payload?.loyalty?.summary || payload?.loyalty;
    const points = this.firstFiniteNumber(
      summary?.availablePoints,
      summary?.points,
      summary?.pointsBalance
    );
    const pointsWrapper = mount.querySelector('[data-account-sheet-points-wrapper]');
    const pointsElement = mount.querySelector('[data-account-sheet-points]');
    const pointsDetails = mount.querySelector('[data-account-sheet-points-details]');
    const pointsLabel = mount.dataset.labelPoints || 'Points';
    const formattedPoints =
      points === null ? pointsLabel : `${this.formatNumber(points)} ${pointsLabel}`;
    if (pointsElement) {
      pointsElement.textContent = formattedPoints;
    }

    const vipTier = summary?.vipTier || payload?.vipTier || {};
    const vipTierName =
      vipTier?.name || summary?.vipTierName || payload?.vipTierName || '';
    const vipTierColor = this.resolveVipTierColor(vipTier, vipTierName);
    const vipTierIconUrl = this.resolveVipTierIconUrl(vipTier);
    const vipElement = mount.querySelector('[data-account-sheet-vip]');
    if (vipElement) {
      vipElement.textContent = vipTierName;
      this.applyVipTierColor(vipElement, vipTierColor);
      this.applyVipTierIconColor(vipElement, vipTierIconUrl);
      vipElement.toggleAttribute('hidden', !vipTierName);
    }

    const detailRows = [];
    if (points !== null) {
      detailRows.push({
        label: mount.dataset.labelPointsAvailable || 'Available',
        value: formattedPoints,
      });
    }
    if (vipTierName) {
      detailRows.push({
        label: mount.dataset.labelCurrentTier || 'Current tier',
        value: vipTierName,
      });
    }

    this.addPointsDetailRow(
      detailRows,
      mount.dataset.labelPointsPending || 'Pending',
      this.firstFiniteNumber(summary?.pendingPoints, summary?.pointsPending),
      pointsLabel
    );
    this.addPointsDetailRow(
      detailRows,
      mount.dataset.labelPointsLifetime || 'Lifetime earned',
      this.firstFiniteNumber(
        summary?.lifetimePoints,
        summary?.totalEarnedPoints,
        summary?.pointsEarned,
        summary?.earnedPoints,
        summary?.totalEarned
      ),
      pointsLabel
    );
    this.addPointsDetailRow(
      detailRows,
      mount.dataset.labelPointsRedeemed || 'Redeemed',
      this.firstFiniteNumber(
        summary?.redeemedPoints,
        summary?.pointsRedeemed,
        summary?.spentPoints,
        summary?.usedPoints
      ),
      pointsLabel
    );
    this.addPointsDetailRow(
      detailRows,
      mount.dataset.labelPointsExpiring || 'Expiring soon',
      this.firstFiniteNumber(summary?.expiringPoints, summary?.pointsExpiring),
      pointsLabel
    );
    this.addPointsDetailRow(
      detailRows,
      mount.dataset.labelPointsNextReward || 'To next reward',
      this.firstFiniteNumber(
        summary?.nextRewardPoints,
        summary?.pointsToNextReward,
        summary?.pointsUntilNextReward,
        summary?.nextReward?.pointsNeeded
      ),
      pointsLabel
    );

    this.renderPointsDetails(pointsDetails, detailRows);
    if (pointsWrapper) {
      pointsWrapper.toggleAttribute('hidden', points === null);
    }
    mount.dataset.state = 'ready';
  }

  addPointsDetailRow(rows, label, value, pointsLabel) {
    if (value === null) return;
    rows.push({
      label,
      value: `${this.formatNumber(value)} ${pointsLabel}`,
    });
  }

  renderPointsDetails(container, rows) {
    if (!container) return;
    container.replaceChildren();
    rows.forEach((row) => {
      const wrapper = document.createElement('div');
      const term = document.createElement('dt');
      const description = document.createElement('dd');
      wrapper.className = 'customer-account-sheet__points-detail-row';
      term.textContent = row.label;
      description.textContent = row.value;
      wrapper.append(term, description);
      container.append(wrapper);
    });
  }

  applyVipTierColor(element, color) {
    if (!element) return;
    if (color) {
      element.style.setProperty('--account-sheet-vip-color', color);
      return;
    }
    element.style.removeProperty('--account-sheet-vip-color');
  }

  applyVipTierIconColor(element, iconUrl) {
    const normalizedUrl = String(iconUrl || '').trim();
    if (!element || !normalizedUrl) return;
    element.dataset.accountSheetVipIconUrl = normalizedUrl;
    this.extractDominantImageColor(normalizedUrl)
      .then((color) => {
        if (!color || element.dataset.accountSheetVipIconUrl !== normalizedUrl) return;
        this.applyVipTierColor(element, color);
      })
      .catch(() => {});
  }

  resolveVipTierColor(tier, tierName) {
    const perks = tier?.perks || {};
    const explicitColor = this.firstCssColor(
      tier?.iconColor,
      tier?.icon_color,
      tier?.color,
      tier?.accentColor,
      tier?.accent_color,
      tier?.badgeColor,
      tier?.badge_color,
      perks.iconColor,
      perks.icon_color,
      perks.color,
      perks.accentColor,
      perks.accent_color,
      perks.badgeColor,
      perks.badge_color
    );
    if (explicitColor) return explicitColor;

    const normalizedName = String(tierName || '').toLowerCase();
    if (normalizedName.includes('essential')) return '#b98b5d';
    if (normalizedName.includes('silver')) return '#8c96a3';
    if (normalizedName.includes('gold')) return '#c49a3a';
    if (normalizedName.includes('platinum')) return '#7d8ea3';
    if (normalizedName.includes('diamond')) return '#6eaec8';
    if (normalizedName.includes('elite')) return '#806196';
    if (normalizedName.includes('vip')) return '#8f4d5b';

    const rank = this.toFiniteNumber(tier?.rank);
    if (rank === 1) return '#b98b5d';
    if (rank === 2) return '#8c96a3';
    if (rank === 3) return '#c49a3a';
    if (rank === 4) return '#7d8ea3';
    return '';
  }

  resolveVipTierIconUrl(tier) {
    return (
      this.firstString(
        tier?.iconUrl,
        tier?.iconURL,
        tier?.icon_url,
        tier?.icon?.url,
        tier?.imageUrl,
        tier?.image_url
      ) || ''
    );
  }

  extractDominantImageColor(url) {
    const normalizedUrl = String(url || '').trim();
    if (!normalizedUrl) return Promise.resolve('');
    if (this.vipTierColorCache.has(normalizedUrl)) {
      return Promise.resolve(this.vipTierColorCache.get(normalizedUrl));
    }

    return this.loadImage(normalizedUrl).then((image) => {
      const canvas = document.createElement('canvas');
      const size = 32;
      const width = Math.max(1, image.naturalWidth || image.width || size);
      const height = Math.max(1, image.naturalHeight || image.height || size);
      const scale = Math.min(size / width, size / height, 1);
      canvas.width = Math.max(1, Math.round(width * scale));
      canvas.height = Math.max(1, Math.round(height * scale));

      const context = canvas.getContext('2d', { willReadFrequently: true });
      if (!context) return '';
      context.drawImage(image, 0, 0, canvas.width, canvas.height);

      const pixels = context.getImageData(0, 0, canvas.width, canvas.height).data;
      const buckets = new Map();
      for (let index = 0; index < pixels.length; index += 4) {
        const alpha = pixels[index + 3];
        if (alpha < 64) continue;

        const red = pixels[index];
        const green = pixels[index + 1];
        const blue = pixels[index + 2];
        if (this.isLowSignalPixel(red, green, blue)) continue;

        const key = [
          Math.round(red / 24) * 24,
          Math.round(green / 24) * 24,
          Math.round(blue / 24) * 24,
        ].join(',');
        const existing = buckets.get(key) || { count: 0, red: 0, green: 0, blue: 0 };
        existing.count += alpha / 255;
        existing.red += red * alpha;
        existing.green += green * alpha;
        existing.blue += blue * alpha;
        buckets.set(key, existing);
      }

      let dominant = null;
      buckets.forEach((bucket) => {
        if (!dominant || bucket.count > dominant.count) {
          dominant = bucket;
        }
      });
      if (!dominant) return '';

      const alphaTotal = dominant.count * 255;
      const color = this.rgbToHex(
        Math.round(dominant.red / alphaTotal),
        Math.round(dominant.green / alphaTotal),
        Math.round(dominant.blue / alphaTotal)
      );
      this.vipTierColorCache.set(normalizedUrl, color);
      return color;
    });
  }

  loadImage(url) {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.crossOrigin = 'anonymous';
      image.decoding = 'async';
      image.onload = () => resolve(image);
      image.onerror = reject;
      image.src = url;
    });
  }

  isLowSignalPixel(red, green, blue) {
    const max = Math.max(red, green, blue);
    const min = Math.min(red, green, blue);
    const saturation = max === 0 ? 0 : (max - min) / max;
    return max > 238 || max < 24 || saturation < 0.08;
  }

  rgbToHex(red, green, blue) {
    return `#${[red, green, blue]
      .map((value) => value.toString(16).padStart(2, '0'))
      .join('')}`;
  }

  firstCssColor(...values) {
    for (const value of values) {
      const color = this.normalizeCssColor(value);
      if (color) return color;
    }
    return '';
  }

  firstString(...values) {
    for (const value of values) {
      const text = String(value || '').trim();
      if (text) return text;
    }
    return '';
  }

  normalizeCssColor(value) {
    const color = String(value || '').trim();
    if (!color) return '';
    if (/^#[0-9a-f]{3,8}$/i.test(color)) return color;
    if (/^(rgb|rgba|hsl|hsla)\(/i.test(color)) {
      return typeof CSS === 'undefined' || CSS.supports('color', color) ? color : '';
    }
    return typeof CSS !== 'undefined' && CSS.supports('color', color) ? color : '';
  }

  appendParam(params, key, value) {
    const normalized = String(value || '').trim();
    if (normalized) {
      params.set(key, normalized);
    }
  }

  normalizeProxyPath(path) {
    const normalized = String(path || '').trim() || '/apps/silksilky-app';
    const proxyPath = normalized.endsWith('/') ? normalized.slice(0, -1) : normalized;
    return proxyPath;
  }

  toFiniteNumber(value) {
    const number = Number(value);
    return Number.isFinite(number) ? number : null;
  }

  firstFiniteNumber(...values) {
    for (const value of values) {
      const number = this.toFiniteNumber(value);
      if (number !== null) return number;
    }
    return null;
  }

  formatNumber(value) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        maximumFractionDigits: 0,
      }).format(value);
    } catch (_error) {
      return String(Math.round(value));
    }
  }

  syncShopLoginButton() {
    this.querySelectorAll('.customer-account-sheet__shop-login').forEach(
      (shopLogin) => {
        shopLogin
          .querySelectorAll(':scope > :not(script):not(style), iframe, button')
          .forEach((element) => {
            element.style.setProperty('box-sizing', 'border-box', 'important');
            element.style.setProperty('display', 'block', 'important');
            element.style.setProperty('width', '100%', 'important');
            element.style.setProperty('max-width', 'none', 'important');
            element.style.setProperty(
              'height',
              'var(--account-sheet-login-height)',
              'important'
            );
            element.style.setProperty(
              'min-height',
              'var(--account-sheet-login-height)',
              'important'
            );
            element.style.setProperty('overflow', 'hidden', 'important');
            element.style.setProperty('border-radius', 'var(--btn-radius)', 'important');
            element.style.setProperty(
              'font-size',
              'var(--account-sheet-login-font-size)',
              'important'
            );
            element.style.setProperty('line-height', '1.2', 'important');
          });

        shopLogin
          .querySelectorAll('script, style')
          .forEach((element) => {
            element.style.setProperty('display', 'none', 'important');
          });

        shopLogin
          .querySelectorAll(':scope > :not(script):not(style)')
          .forEach((element) => {
            const shadowButton = element.shadowRoot?.querySelector('button');
            if (!shadowButton) return;
            shadowButton.style.setProperty('box-sizing', 'border-box', 'important');
            shadowButton.style.setProperty('width', '100%', 'important');
            shadowButton.style.setProperty('max-width', 'none', 'important');
            shadowButton.style.setProperty(
              'height',
              'var(--account-sheet-login-height)',
              'important'
            );
            shadowButton.style.setProperty(
              'min-height',
              'var(--account-sheet-login-height)',
              'important'
            );
            shadowButton.style.setProperty(
              'border-radius',
              'var(--btn-radius)',
              'important'
            );
          });
      });
  }
}

if (!customElements.get('customer-account-sheet')) {
  customElements.define('customer-account-sheet', CustomerAccountSheet);
}

class BackToTop extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.backToTop.bind(this), false);
  }

  connectedCallback() {
    window.addEventListener('scroll', this.updateScrollPercentage.bind(this));
  }

  backToTop() {
    if (document.documentElement.scrollTop > 0 || document.body.scrollTop > 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }

  updateScrollPercentage() {
    const scrollHeight =
      document.documentElement.scrollHeight || document.body.scrollHeight;
    const scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;
    const clientHeight =
      document.documentElement.clientHeight || document.body.clientHeight;
    const scrollPercentage = (scrollTop / (scrollHeight - clientHeight)) * 100;
    this.style.setProperty('--height', scrollPercentage.toFixed(2) + '%');
    if (scrollTop > 200) {
      this.classList.add('show');
    } else {
      this.classList.remove('show');
    }
  }
}
customElements.define('back-to-top', BackToTop);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
      button: this.querySelector('.button-localization'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener(
      'click',
      this.openSelector.bind(this)
    );
    this.elements.button.addEventListener(
      'focusout',
      this.closeSelector.bind(this)
    );
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
    this.querySelectorAll('a').forEach((item) =>
      item.addEventListener('click', this.onItemClick.bind(this))
    );
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.handleChangeUrl();
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target != this && !target.closest('localization-form')) {
      this.hidePanel();
    }
  }

  hidePanel() {
    document.body.removeEventListener('click', this.onBodyClick);
    this.elements.button.classList.remove('open');
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    if (event.currentTarget.classList.contains('store-redirect')) return;
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    if (this.elements.button.classList.contains('open')) {
      this.hidePanel();
    } else {
      document.body.addEventListener('click', this.onBodyClick);
      this.elements.button.focus();
      for (var item of document.querySelectorAll('.button-localization')) {
        item.classList.remove('open');
      }
      this.elements.button.classList.add('open');
    }
  }

  closeSelector(event) {
    const shouldClose =
      event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }

  handleChangeUrl() {
    const storeRedirect = this.querySelector('.store-redirect__action');
    const dataStoreRedirect = storeRedirect?.dataset.predirect == 'true';
    const currentUrl = window.location.href;
    const subUrl = new URL(currentUrl).pathname; 
    if (dataStoreRedirect) {
      this.querySelectorAll('.store-redirect__link').forEach((item) => {
        if (item.href) {
          item.href = item.href.replace(/\/+$/, '') + subUrl;
        }
      })
    }
  }
}
customElements.define('localization-form', LocalizationForm);

class CollapsibleBlock extends HTMLElement {
  constructor() {
    super();
    const _this = this;
    const block = _this.querySelectorAll('.collapsible-heading');
    block.forEach((event) => {
      event.addEventListener('click', (e) => {
        const target = e.currentTarget;
        const parent = target.parentElement;
        const footerContent = parent.querySelector('.collapsible-content');
        if (
          _this.closest('.collection-filter') &&
          _this
            .closest('.collection-filter')
            .classList.contains('horizontal') &&
          window.innerWidth > 1024
        ) {
          if (!_this.classList.contains('active')) {
            if (document.querySelector('collapsible-block.active')) {
              document
                .querySelector('collapsible-block.active')
                .classList.remove('active');
            }
            _this.classList.add('active');
          } else {
            _this.classList.remove('active');
          }
        } else {
          slideAnime({
            target: footerContent,
            animeType: 'slideToggle',
          });
          if (!_this.classList.contains('active')) {
            _this.classList.add('active');
          } else {
            _this.classList.remove('active');
          }
        }
      });
    });
    document.body.addEventListener('click', this.handleBodyClick.bind(this));
  }
  handleBodyClick(evt) {
    const target = evt.target;
    if (
      target != this &&
      !target.closest('collapsible-block') &&
      document.querySelector('.collection-filter') &&
      document
        .querySelector('.collection-filter')
        .classList.contains('horizontal') &&
      window.innerWidth > 1024
    ) {
      const block = document
        .querySelector('.collection-filter')
        .querySelectorAll('collapsible-block');
      block.forEach((collapsible) => {
        collapsible.classList.remove('active');
      });
    }
  }
}
customElements.define('collapsible-block', CollapsibleBlock);

class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    const _this = this;
    this.close = _this.querySelector('.announcement-bar-close');
    if (this.close) {
      this.close.addEventListener('click', () => {
        slideAnime({
          target: _this,
          animeType: 'slideToggle',
          addFunction: () => {
            _this.refreshHeaderMetrics();
          },
        });
        sessionStorage.setItem('announcement_bar', 'false');
      });
    }
  }

  getAnnouncementBlockElements() {
    return Array.from(this.querySelectorAll('[data-announcement-block-id]'));
  }

  getAnnouncementBlockIds() {
    return [...new Set(
      this.getAnnouncementBlockElements()
        .map((element) => element.dataset.announcementBlockId)
        .filter(Boolean)
    )];
  }

  getVisibleAnnouncementBlockIds() {
    return [...new Set(
      this.getAnnouncementBlockElements()
        .filter((element) => !element.classList.contains('hidden'))
        .map((element) => element.dataset.announcementBlockId)
        .filter(Boolean)
    )];
  }

  getAnnouncementElementsById(blockId) {
    return this.getAnnouncementBlockElements().filter(
      (element) => element.dataset.announcementBlockId === blockId
    );
  }

  isSlideAnnouncement() {
    return Boolean(this.querySelector('slide-section'));
  }

  hideAnnouncementBar() {
    this.classList.add('hidden');
    this.setAttribute('hidden', 'hidden');
    this.style.display = 'none';

    const sectionWrapper = this.closest('.section-announcement-bar');
    if (sectionWrapper) {
      sectionWrapper.classList.add('hidden');
      sectionWrapper.setAttribute('hidden', 'hidden');
      sectionWrapper.style.display = 'none';
    }

    this.refreshHeaderMetrics();
  }

  refreshHeaderMetrics() {
    requestAnimationFrame(() => {
      document.dispatchEvent(new CustomEvent('theme:header-metrics:update'));
    });
  }

  toggleSlideControls(shouldShow) {
    this.querySelectorAll('.announcement-slide .swiper-arrow').forEach((arrow) => {
      arrow.classList.toggle('hidden', !shouldShow);
    });
  }

  refreshSlideAnnouncementSlides() {
    const slideSection = this.querySelector('slide-section');
    if (!slideSection) return;

    const swiperWrapper = slideSection.querySelector('.swiper-wrapper');
    if (!swiperWrapper) return;

    if (slideSection.globalSlide) {
      if (
        slideSection.globalSlide.params?.loop &&
        typeof slideSection.globalSlide.loopDestroy === 'function'
      ) {
        slideSection.globalSlide.loopDestroy();
      }
      if (typeof slideSection.globalSlide.destroy === 'function') {
        slideSection.globalSlide.destroy(true, true);
      }
      slideSection.globalSlide = null;
    }

    swiperWrapper
      .querySelectorAll('.swiper-slide-duplicate, .swiper-slide.hidden')
      .forEach((slide) => {
        slide.remove();
      });

    const remainingSlides = Array.from(swiperWrapper.children).filter((slide) =>
      slide.classList.contains('swiper-slide')
    );

    if (remainingSlides.length <= 1) {
      this.toggleSlideControls(false);
      return;
    }

    this.toggleSlideControls(true);
    slideSection.initSlide();
  }

  expireAnnouncementBlock(blockId) {
    if (!blockId) {
      this.hideAnnouncementBar();
      return;
    }

    const totalBlocks = this.getAnnouncementBlockIds().length;
    if (totalBlocks <= 1) {
      this.hideAnnouncementBar();
      return;
    }

    this.getAnnouncementElementsById(blockId).forEach((element) => {
      element.classList.add('hidden');
      element.setAttribute('hidden', 'hidden');
      element.setAttribute('aria-hidden', 'true');
    });

    if (this.isSlideAnnouncement()) {
      this.refreshSlideAnnouncementSlides();
    }

    if (this.getVisibleAnnouncementBlockIds().length === 0) {
      this.hideAnnouncementBar();
    }
  }
}
customElements.define('announcement-bar', AnnouncementBar);

class VideoSection extends HTMLElement {
  constructor() {
    super();
    this.thumb = this.querySelector('.video-thumbnail');
    this.video_iframe = this.querySelector('.video-has-bg iframe');
    this.init();
  }

  init() {
    if (this.video_iframe) {
      this.video_iframe.addEventListener('load', () => {
        if (this.thumb) {
          this.thumb.remove();
        }
      });
    }
  }
}
customElements.define('video-section', VideoSection);

class AgeVerifier extends HTMLElement {
  constructor() {
    super();
    this.ageVerifyDetail = this.querySelector('.age-verify-detail');
    this.declineVerifyDetail = this.querySelector('.decline-verify-detail');
    this.init();
    this.mainFunction();
  }
  init() {
    const _this = this;
    if (!Shopify.designMode) {
      if (!getCookie('age_verifier')) {
        this.classList.add('active');
        this.declineVerifyDetail.classList.add('hidden');
        this.ageVerifyDetail.classList.remove('hidden');
      } else {
        if (getCookie('age_verifier') == 'false') {
          this.classList.add('active');
          this.declineVerifyDetail.classList.remove('hidden');
          this.ageVerifyDetail.classList.add('hidden');
        } else {
          this.remove();
        }
      }
    }
  }

  mainFunction() {
    const approve = this.querySelector('.age-verifier-approve');
    const decline = this.querySelector('.age-verifier-decline');
    const returnBtn = this.querySelector('.age-verifier-return');
    if (returnBtn) {
      returnBtn.addEventListener('click', () => this.handleReturn());
    }

    if (!approve || !decline) return;
    approve.addEventListener('click', () => this.handleApprove());
    decline.addEventListener('click', () => this.handleDecline());
  }
  handleReturn() {
    if (!Shopify.designMode) {
      setCookie('age_verifier', 'false', '-1');
      this.init();
    }
  }
  handleDecline() {
    if (!Shopify.designMode) {
      setCookie('age_verifier', 'false', '365');
      this.init();
    }
  }
  handleApprove() {
    setCookie('age_verifier', 'true', 'false');
    this.classList.add('fadeOut');
    setTimeout(() => {
      this.remove();
    }, 1000);
  }
}
customElements.define('age-verifier', AgeVerifier);

class PromotionPopup extends HTMLElement {
  constructor() {
    super();
    const timeDelayd = this.dataset.delayed;
    this.times = this.dataset.showAgain;
    setTimeout(() => {
      this.init();
    }, timeDelayd * 1000);
  }

  init() {
    const _this = this;
    const s = _this?.dataset.show;
    const m = _this?.dataset.showMb === 'true';
    if (!Shopify.designMode) {
      if (s === 'show-on-all-pages' || s === 'show-on-homepage') {
        if (getCookie('promotion-popup') === '') {
          const modal = new tingle.modal({
            footer: false,
            stickyFooter: false,
            closeMethods: ['overlay', 'button', 'escape'],
            closeLabel: 'Close',
            cssClass: [
              `promotion-popup-modal`,
              `${m ? 'enable-on-mobile' : 'show-all'}`,
            ],
          });
          modal.setContent(_this.innerHTML);
          modal.open();
          _this.copyPromotion();
          _this.checkNotShowPromotion();
        }
      }
    }
  }
  checkNotShowPromotion() {
    const check = document.querySelector(
      '.promotion-popup-modal .do-not-show-again'
    );
    if (check) {
      check.addEventListener('click', (e) => {
        setCookiePopup('promotion-popup', 1, this.times);
        document
          .querySelector('.promotion-popup-modal .tingle-modal__close')
          .click();
      });
    }
  }
  copyPromotion() {
    const cp = document.querySelectorAll('.promotion-popup-modal .discount');
    if (cp !== null) {
      cp.forEach((e) => {
        e.addEventListener('click', (el) => {
          el.preventDefault();
          navigator.clipboard.writeText(e?.dataset.code);
          e.classList.add('action-copy');
          setTimeout(() => {
            e.classList.remove('action-copy');
          }, 1500);
        });
      });
    }
  }
}
customElements.define('promotion-popup', PromotionPopup);

class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    const timeDelayd = this.dataset.delayed;
    this.times = this.dataset.showAgain;
    setTimeout(() => {
      this.init();
    }, timeDelayd * 1000);
  }
  init() {
    const sectionId = this.dataset.sectionId;
    const url = `${window.location.pathname}?section_id=${sectionId}&ajax=1`;
    fetch(`${url}`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }
        return response.text();
      })
      .then((responseText) => {
        const newSection = new DOMParser()
          .parseFromString(responseText, 'text/html')
          .querySelector('newsletter-popup').innerHTML;
        document.querySelector('newsletter-popup').innerHTML = newSection;
      })
      .catch((error) => {
        throw error;
      })
      .finally(() => {
        this.initPopup();
      });
  }

  initPopup() {
    const _this = this;
    const s = _this?.dataset.show;
    const m = _this?.dataset.showMb === 'true';
    if (!Shopify.designMode) {
      const cookie = getCookie('newsletter_popup');
      const width = window.innerWidth;
      if (!m && width < 768) {
        return false;
      }
      if ((s == 'show_homepage' || s == 'show_all_page') && cookie === '') {
        const modal = new tingle.modal({
          footer: false,
          stickyFooter: false,
          closeMethods: ['overlay', 'button', 'escape'],
          closeLabel: 'Close',
          cssClass: [
            `newsletter-popup-modal`,
            `${m ? 'show-all' : 'disable-on-mobile'}`,
          ],
        });
        modal.setContent(_this.innerHTML);
        modal.open();
        _this.onShowNewletter();
      }
    }
  }

  onShowNewletter() {
    const _this = this;
    const setC = document.querySelector(
      '.newsletter-popup-modal .newsletter-popup__dont-show'
    );
    if (!setC) return;
    setC.addEventListener('click', _this.notShow.bind(_this));
    setC.addEventListener(
      'keypress',
      function (event) {
        if (event.key === 'Enter') {
          _this.notShow.bind(_this)(event);
        }
      }.bind(_this),
      false
    );
  }

  notShow(e) {
    e.preventDefault();
    setCookiePopup('newsletter_popup', 30, this.times);
    document
      .querySelector('.newsletter-popup-modal .tingle-modal__close')
      .click();
  }
}
customElements.define('newsletter-popup', NewsletterPopup);

class TiktokVideo extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    const _this = this;
    window.addEventListener('scroll', () => {
      let wpy = window.scrollY;
      if (wpy > 0) {
        this.scrollLazyloadVideo();
      }
    });
    let pos = window.pageYOffset;
    if (pos > 40) {
      this.scrollLazyloadVideo();
    }
  }

  scrollLazyloadVideo() {
    const _this = this;
    if (!_this.classList.contains('tiktok-loading')) {
      return;
    }
    _this.classList.remove('tiktok-loading');
    const sectionId = _this.dataset.sectionId;
    const url = `${window.location.pathname}?section_id=${sectionId}&ajax=1`;
    fetch(`${url}`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }
        return response.text();
      })
      .then((responseText) => {
        const newSection = new DOMParser()
          .parseFromString(responseText, 'text/html')
          .querySelector('tiktok-video').innerHTML;
        _this.innerHTML = newSection;
      })
      .catch((error) => {
        throw error;
      })
      .finally(() => {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://www.tiktok.com/embed.js';
        document.body.appendChild(script);
      });
  }
}
customElements.define('tiktok-video', TiktokVideo);

var returnMessageWhenSubmit = (function () {
  return {
    init: function () {
      this.checkUrlReturn();
    },
    checkUrlReturn: function () {
      const popupDiscount = document.body.dataset.popupDiscount === "true";
      const getUrl = window.location.href;
      let classModal = '';
      if (
        getUrl.indexOf('ContactFooter') >= 1
      ){
        classModal = 'popup-modal-footer';
      }else{
        classModal = 'popup-modal-newsletter';
      }
      if (
        getUrl.indexOf('customer_posted=true#newsletter-form') >= 1 ||
        getUrl.indexOf('customer_posted=true') >= 1
      ) {
        if (popupDiscount) {
          this.showDiscountPopup(classModal);
        }else{
          this.handleMessageSuccessPopup();
        }
        setCookie('newsletter_popup', 30, 1);
        const newURL = location.href.split('?')[0];
        window.history.pushState('object', document.title, newURL);
      }

      if (
        getUrl.indexOf('contact%5Btags%5D=newsletter&form_type=customer') >= 1
      ) {
        this.handleMessageErrorPopup();
        const newURL = location.href.split('?')[0];
        window.history.pushState('object', document.title, newURL);
      }
    },

    handleMessageSuccessPopup: function () {
      const url = `${window.location.pathname}?section_id=form-message`;
      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            'text/html'
          );
          const elementSuccessMessage = html.querySelector(
            '.newsletter-form__success-message-wrapper'
          );
          const elementMessage = elementSuccessMessage.querySelector(
            '.newsletter-form__message'
          );
          showToast(elementSuccessMessage.innerHTML, 5000, 'modal-success');
        })
        .catch((e) => {
          throw e;
        });
    },

    showDiscountPopup: function (classModal) {
      const url = `${window.location.pathname}?section_id=discount-popup&ajax=1`;
      fetch(`${url}`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }
        return response.text();
      })
      .then((responseText) => {
        const newSection = new DOMParser()
          .parseFromString(responseText, 'text/html')
          .querySelector('discount-popup').innerHTML;
          const modal = new tingle.modal({
            footer: false,
            stickyFooter: false,
            closeMethods: ['overlay', 'button', 'escape'],
            closeLabel: 'Close',
            cssClass: ['discount-popup-modal', classModal],
          });
          modal.setContent(newSection);
          modal.open();
      })
      .catch((error) => {
        throw error;
      })
      .finally(() => {
        this.copyPromotion();
      });
    },

    copyPromotion: function() {
      const cp = document.querySelectorAll('.discount-popup-modal .discount');
      if (cp !== null) {
        cp.forEach((e) => {
          e.addEventListener('click', (el) => {
            el.preventDefault();
            navigator.clipboard.writeText(e?.dataset.code);
            e.classList.add('action-copy');
            setTimeout(() => {
              e.classList.remove('action-copy');
            }, 1500);
          });
        });
      }
    },

    handleMessageErrorPopup: function () {
      const url = `${window.location.pathname}?section_id=form-message`;
      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            'text/html'
          );
          const elementErrorMessage = html.querySelector(
            '.newsletter-form__error-message-wrapper'
          );
          const elementMessage = elementErrorMessage.querySelector(
            '.newsletter-form__message'
          );
          showToast(elementErrorMessage.innerHTML, 5000, 'modal-error');
        })
        .catch((e) => {
          throw e;
        });
    },
  };
})();
returnMessageWhenSubmit.init();
class NavBar extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    document.body.classList.add('mobi-navigation-bar');
  }
}
customElements.define('mobile-navigation-bar', NavBar);

class IconBox extends SlideSection {
  constructor() {
    super();
    this.enable = this.dataset.enable;
    this.swiperSlideInnerHtml = this.innerHTML;
    this.init();
  }
  init() {
    if (this.enable == 'true') {
      let width = window.innerWidth;
      window.addEventListener('resize', () => {
        const newWidth = window.innerWidth;
        if (newWidth <= 767 && width > 767) {
          this.actionOnMobile();
        }
        if (newWidth > 767 && width <= 767) {
          this.actionOutMobile();
        }
        width = newWidth;
      });
      if (width <= 767) {
        this.actionOnMobile();
      } else {
        this.actionOutMobile();
      }
    }
  }
  actionOnMobile() {
    this.classList.add('swiper');
    this.classList.remove('grid', 'grid-cols');
    const html = this.swiperSlideInnerHtml.replaceAll(
      'sec__icon-switch-slide',
      'swiper-slide'
    );
    const wrapper = `<div class='swiper-wrapper'>${html}</div> <div
    class="swiper-pagination  ${
      this.enable && this.dataset.mobile != 1.5 ? 'flex' : 'hidden'
    } px-15 lh-1 bottom-30 justify-content-center"
    style="--swiper-pagination-bottom: 3rem;--swiper-pagination-position: static;"
  ></div> `;
    this.innerHTML = wrapper;
    this.initSlide();
  }
  actionOutMobile() {
    this.classList.remove('swiper');
    this.classList.add('grid', 'grid-cols');
    this.innerHTML = this.swiperSlideInnerHtml;
  }
}
customElements.define('icon-box', IconBox);

class PaginateLoadmore extends HTMLElement {
  constructor() {
    super();
    this.initLoadMore();
    if (this.classList.contains('collection-infinite-scroll')) {
      this.querySelector('a').addEventListener(
        'click',
        (e) => {
          for (var item of document.querySelectorAll(
            '.sec__collections-list .collection-item.grid-custom-item'
          )) {
            item.classList.remove('hidden');
          }
          this.remove();
        },
        false
      );
    }
  }
  initLoadMore() {
    this.querySelectorAll('.actions-loadmore').forEach((loadMore) => {
      var _this = this;
      if (loadMore.classList.contains('infinit-scrolling')) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach((entry) => {
              if (entry.intersectionRatio === 1) {
                _this.loadMoreItem(loadMore);
              }
            });
          },
          { threshold: 1.0 }
        );
        observer.observe(loadMore);
      } else {
        loadMore.addEventListener(
          'click',
          (event) => {
            event.preventDefault();
            const target = event.currentTarget;
            _this.loadMoreItem(target);
          },
          false
        );
      }
    });
  }
  loadMoreItem(target) {
    const loadMore_url = target.getAttribute('href');
    const _this = this;
    _this.toggleLoading(target, true);
    fetch(`${loadMore_url}`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }
        return response.text();
      })
      .then((responseText) => {
        const resultNodes = parser.parseFromString(responseText, 'text/html');
        const resultNodesHtml = resultNodes.querySelectorAll(
          '.loadmore-lists .loadmore-item'
        );
        resultNodesHtml.forEach((prodNode) =>
          document.querySelector('.loadmore-lists').appendChild(prodNode)
        );
        const load_more = resultNodes.querySelector('.actions-loadmore');
        document.querySelector('.load-more-bar').innerHTML =
          resultNodes.querySelector('.load-more-bar').innerHTML;
        if (load_more) {
          target.setAttribute('href', load_more.getAttribute('href'));
        } else {
          target.remove();
        }
        _this.toggleLoading(target, false);
      })
      .catch((error) => {
        throw error;
      })
      .finally(() => {
        initLazyloadItem();
      });
  }
  toggleLoading(event, loading) {
    if (event) {
      const method = loading ? 'add' : 'remove';
      event.classList[method]('loading');
    }
  }
}
customElements.define('loadmore-button', PaginateLoadmore);

class SingleItem extends HTMLElement {
  constructor() {
    super();
    this.position = this.dataset.position;
    this.section = this.closest('.section-slide-single');
    this.init();
  }
  init() {
    this.addEventListener('click', this.onClick.bind(this));
  }
  onClick() {
    if (this.section && this.position) {
      const slideSEction = this.section.querySelector(`slide-section-single`);
      const allDots = this.section.querySelectorAll(`single-item`);
      allDots.forEach((dot) => {
        dot.classList.remove('active');
      });
      this.classList.add('active');
      if (slideSEction) {
        slideSEction.functionGoto(this.position);
      }
    }
  }
}
customElements.define('single-item', SingleItem);

class SlideSectionSingle extends SlideSection {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.initSlide();
  }
  functionGoto(position) {
    this.globalSlide.slideToLoop(position - 1, 500);
  }
}
customElements.define('slide-section-single', SlideSectionSingle);

class CartUpsell extends HTMLElement {
  constructor() {
    super();
  }
  init() {
    this.connectedCallback();
  }
  connectedCallback() {
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.swiper-wrapper');
        if (recommendations && recommendations.innerHTML.trim().length) {
          if (this.querySelector('.swiper-wrapper')) {
            this.querySelector('.swiper-wrapper').innerHTML =
              recommendations.innerHTML;
            pinMinicartProductListActions(this);
          }
        } else {
          this.classList.add('hidden');
        }
      })
      .finally(() => {})
      .catch((e) => {
        console.error(e);
      });
  }
}
customElements.define('minicart-recommendations', CartUpsell);

class CartUpsellBeside extends HTMLElement {
  constructor() {
    super();
  }
  init() {
    this.connectedCallback();
  }
  connectedCallback() {
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendationsBeside = html.querySelector(
          '.cart-upsell-wrapper'
        );
        if (
          recommendationsBeside &&
          recommendationsBeside.innerHTML.trim().length
        ) {
          if (this.querySelector('.cart-upsell-wrapper')) {
            this.querySelector('.cart-upsell-wrapper').innerHTML =
              recommendationsBeside.innerHTML;
          }
        } else {
          this.classList.add('hidden');
        }
      })
      .finally(() => {
      })
      .catch((e) => {
        console.error(e);
      });
  }
}
customElements.define('minicart-recommendations-beside', CartUpsellBeside);

class CartUpsellHeading extends HTMLElement {
  constructor() {
    super();
    if (this.querySelector('.button-close-beside')) {
      this.querySelector('.button-close-beside').addEventListener(
        'click',
        (e) => {
          const target = e.currentTarget;
          const closeBeside = target.closest('.cart-recommend');
          closeBeside.classList.remove('open');
        },
        false
      );
    }
  }
}
customElements.define('minicart-recommendations-heading', CartUpsellHeading);

document.addEventListener('click', (e) => {
  const toggle = e.target.closest('.minicart-recommendations-toggle');
  if (!toggle) return;
  const cartRecommend = toggle.closest('.cart-recommend');
  if (!cartRecommend) return;
  const isCollapsed = cartRecommend.classList.toggle(
    'minicart-recommendations--collapsed'
  );
  toggle.setAttribute('aria-expanded', !isCollapsed);
});

class MinicartRecommendationOptions extends HTMLElement {
  constructor() {
    super();
    this.onColorClick = this.onColorClick.bind(this);
    this.onSizeChange = this.onSizeChange.bind(this);
  }

  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.moveActionToMedia();
    this.data = this.parseData();
    if (!this.data || !Array.isArray(this.data.variants)) {
      console.warn('[minicart-recommendations] init skipped: invalid data', {
        productId: this.dataset.productId || null,
        productHandle: this.dataset.productHandle || null,
        hasData: !!this.data,
      });
      return;
    }

    this.variants = this.data.variants.map((variant) => ({
      id: variant?.id,
      available: !!variant?.available,
      options: Array.isArray(variant?.options)
        ? variant.options.map((value) => this.normalizeValue(value))
        : [],
    }));
    if (this.variants.length === 0) return;

    this.defaultOptions = Array.isArray(this.data.defaultOptions)
      ? this.data.defaultOptions.map((value) => this.normalizeValue(value))
      : [];
    const maxVariantOptionCount = this.variants.reduce((max, variant) => {
      const count = Array.isArray(variant.options) ? variant.options.length : 0;
      return Math.max(max, count);
    }, 0);
    const parsedOptionCount = Number(this.data.optionCount);
    this.optionCount =
      Number.isInteger(parsedOptionCount) && parsedOptionCount > 0
        ? parsedOptionCount
        : Math.max(maxVariantOptionCount, this.defaultOptions.length, 1);
    while (this.defaultOptions.length < this.optionCount) {
      this.defaultOptions.push(null);
    }

    this.colorIndex = this.normalizeIndex(this.data.colorIndex);
    this.sizeIndex = this.normalizeIndex(this.data.sizeIndex);
    this.colorButtons = Array.from(
      this.querySelectorAll('[data-recommendation-color]')
    );
    this.sizeSelect = this.querySelector('[data-recommendation-size]');
    this.variantInput = this.querySelector('input[name="id"]');
    this.submitButton = this.querySelector('button[type="submit"]');
    this.addLabel = this.submitButton?.dataset.addLabel || 'Add+';
    this.soldOutLabel =
      this.submitButton?.dataset.soldOutLabel ||
      window.variantStrings?.soldOut ||
      'Sold out';
    console.log('[minicart-recommendations] init', {
      productId: this.dataset.productId || null,
      productHandle: this.dataset.productHandle || null,
      colorIndex: this.colorIndex,
      sizeIndex: this.sizeIndex,
      colorButtonCount: this.colorButtons.length,
      hasSizeSelect: !!this.sizeSelect,
      variantsCount: this.variants.length,
    });
    this.applyColorButtonStyles();

    this.colorButtons.forEach((button) =>
      button.addEventListener('click', this.onColorClick, false)
    );
    if (this.sizeSelect) {
      this.sizeSelect.addEventListener('change', this.onSizeChange, false);
    }

    if (this.colorIndex > -1 && this.colorButtons.length > 0) {
      const activeColorButton =
        this.colorButtons.find((button) =>
          button.classList.contains('is-active')
        ) || this.colorButtons[0];
      this.setActiveColor(activeColorButton, false);
    }

    if (this.sizeSelect && this.sizeIndex > -1 && this.sizeSelect.options.length) {
      const defaultSize = this.defaultOptions[this.sizeIndex];
      if (defaultSize != null) {
        const sizeOption = Array.from(this.sizeSelect.options).find(
          (option) => option.value === defaultSize
        );
        if (sizeOption) {
          this.sizeSelect.value = sizeOption.value;
        }
      }
    }

    this.refreshVariant();
  }

  moveActionToMedia() {
    const actionContainer = this.closest('.product-list-action');
    const productItem = this.closest('.product-item');
    const mediaContainer = productItem?.querySelector('.product-item__inner');
    if (!actionContainer || !mediaContainer || mediaContainer.contains(actionContainer)) {
      return;
    }
    actionContainer.classList.add('minicart-product-list-action-on-media');
    mediaContainer.appendChild(actionContainer);
  }

  disconnectedCallback() {
    this.colorButtons?.forEach((button) =>
      button.removeEventListener('click', this.onColorClick, false)
    );
    if (this.sizeSelect) {
      this.sizeSelect.removeEventListener('change', this.onSizeChange, false);
    }
  }

  parseData() {
    const dataNode = this.querySelector('.minicart-recommendation-options__data');
    if (!dataNode) return null;
    try {
      return JSON.parse(dataNode.textContent || '{}');
    } catch (error) {
      console.warn('[minicart-recommendations] parse data failed', {
        productId: this.dataset.productId || null,
        productHandle: this.dataset.productHandle || null,
        error: error?.message || error,
      });
      return null;
    }
  }

  normalizeIndex(position) {
    const numericPosition = Number(position);
    if (!Number.isInteger(numericPosition) || numericPosition < 1) {
      return -1;
    }
    return numericPosition - 1;
  }

  normalizeValue(value) {
    if (value === undefined || value === null) return null;
    return `${value}`;
  }

  checkColor(colorValue = '') {
    const normalizedColor = `${colorValue}`.trim();
    if (!normalizedColor) return false;
    const style = new Option().style;
    style.color = '';
    style.color = normalizedColor;
    return style.color !== '';
  }

  applyColorButtonStyles() {
    if (!this.colorButtons?.length) return;
    this.colorButtons.forEach((button) => {
      const colorName = `${button.dataset.colorName || ''}`.trim();
      const customValue = `${button.dataset.customValue || ''}`.trim();
      const optionSwatchValue = `${button.dataset.optionSwatchValue || ''}`.trim();
      if (customValue) {
        button.classList.add(customValue);
      }
      if (!button.style.getPropertyValue('--swatch-native') && optionSwatchValue) {
        button.style.setProperty('--swatch-native', optionSwatchValue);
      }
      if (!button.style.getPropertyValue('--swatch-fallback') && this.checkColor(colorName)) {
        button.style.setProperty('--swatch-fallback', colorName);
      }
      const computedStyle = window.getComputedStyle(button);
      const hasVisualSwatch = [
        '--swatch-native',
        '--swatch-metaobject',
        '--swatch-theme',
        '--swatch-fallback',
      ].some((property) => computedStyle.getPropertyValue(property).trim());
      if (!hasVisualSwatch) {
        button.style.setProperty('--swatch-fallback', '#d7d7d7');
      }
    });
  }

  getSelectedOptions() {
    const selectedOptions = this.defaultOptions.slice(0, this.optionCount);
    if (this.colorIndex > -1 && this.colorButtons?.length) {
      const activeColor = this.colorButtons.find((button) =>
        button.classList.contains('is-active')
      );
      if (activeColor?.dataset.recommendationColor != null) {
        selectedOptions[this.colorIndex] = this.normalizeValue(
          activeColor.dataset.recommendationColor
        );
      }
    }
    if (this.sizeIndex > -1 && this.sizeSelect) {
      selectedOptions[this.sizeIndex] = this.normalizeValue(this.sizeSelect.value);
    }
    while (selectedOptions.length < this.optionCount) {
      selectedOptions.push(null);
    }
    return selectedOptions;
  }

  isExactMatch(variant, selectedOptions) {
    if (!variant || !Array.isArray(selectedOptions)) return false;
    for (let index = 0; index < this.optionCount; index += 1) {
      const expected = this.normalizeValue(selectedOptions[index]);
      const actual = this.normalizeValue(variant.options[index]);
      if (expected !== actual) return false;
    }
    return true;
  }

  hasAvailableVariantForColor(colorValue, selectedOptions) {
    if (this.colorIndex < 0) return false;
    const normalizedColor = this.normalizeValue(colorValue);
    if (normalizedColor == null) return false;
    return this.variants.some((variant) => {
      if (!variant.available) return false;
      if (
        this.normalizeValue(variant.options[this.colorIndex]) !== normalizedColor
      ) {
        return false;
      }
      for (let index = 0; index < this.optionCount; index += 1) {
        if (index === this.colorIndex || index === this.sizeIndex) continue;
        const expected = this.normalizeValue(selectedOptions[index]);
        if (expected == null) continue;
        if (this.normalizeValue(variant.options[index]) !== expected) return false;
      }
      return true;
    });
  }

  updateColorOptions() {
    if (this.colorIndex < 0 || !this.colorButtons?.length) return;
    const selectedOptions = this.getSelectedOptions();
    this.colorButtons.forEach((button) => {
      const colorValue = button.dataset.recommendationColor;
      const hasAvailableVariant = this.hasAvailableVariantForColor(
        colorValue,
        selectedOptions
      );
      button.hidden = !hasAvailableVariant;
      button.disabled = !hasAvailableVariant;
      button.setAttribute('aria-hidden', hasAvailableVariant ? 'false' : 'true');
      if (!hasAvailableVariant) {
        button.classList.remove('is-active');
        button.setAttribute('aria-pressed', 'false');
      }
    });
    const activeColorButton = this.colorButtons.find(
      (button) => button.classList.contains('is-active') && !button.disabled
    );
    if (activeColorButton) return;

    const firstEnabledColorButton = this.colorButtons.find(
      (button) => !button.disabled
    );
    if (firstEnabledColorButton) {
      this.setActiveColor(firstEnabledColorButton, false);
      return;
    }
    this.colorButtons.forEach((button) => {
      button.classList.remove('is-active');
      button.setAttribute('aria-pressed', 'false');
    });
  }

  findVariant(selectedOptions) {
    const exactAvailableMatch = this.variants.find(
      (variant) => variant.available && this.isExactMatch(variant, selectedOptions)
    );
    if (exactAvailableMatch) return exactAvailableMatch;

    const filteredVariants = this.variants.filter((variant) => {
      if (
        this.colorIndex > -1 &&
        selectedOptions[this.colorIndex] != null &&
        this.normalizeValue(variant.options[this.colorIndex]) !==
          this.normalizeValue(selectedOptions[this.colorIndex])
      ) {
        return false;
      }
      if (
        this.sizeIndex > -1 &&
        selectedOptions[this.sizeIndex] != null &&
        this.normalizeValue(variant.options[this.sizeIndex]) !==
          this.normalizeValue(selectedOptions[this.sizeIndex])
      ) {
        return false;
      }
      return true;
    });

    const exactMatch = this.variants.find((variant) =>
      this.isExactMatch(variant, selectedOptions)
    );

    return (
      filteredVariants.find((variant) => variant.available) ||
      exactMatch ||
      this.variants.find((variant) => variant.available) ||
      this.variants[0] ||
      null
    );
  }

  setActiveColor(button, shouldRefresh = true) {
    if (!button || button.disabled) return;
    this.colorButtons.forEach((colorButton) => {
      const isActive = colorButton === button;
      colorButton.classList.toggle('is-active', isActive);
      colorButton.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
    this.updateProductImageByColor(button);
    if (shouldRefresh) {
      this.refreshVariant();
    }
  }

  updateProductImageByColor(colorButton) {
    const imageUrl = (colorButton?.dataset?.imageProduct || '').trim();
    if (!imageUrl) return;
    const productItem = this.closest('.product-item');
    if (!productItem) return;
    const mediaEl = productItem.querySelector(
      '.product__media img, .product-item__media--ratio img, .product-image.first-image'
    );
    if (!mediaEl) return;
    let srcUrl = imageUrl;
    if (imageUrl.startsWith('//')) {
      srcUrl = `${window.location.protocol}${imageUrl}`;
    } else if (imageUrl.startsWith('/')) {
      srcUrl = `${window.location.origin}${imageUrl}`;
    } else if (!imageUrl.startsWith('http')) {
      srcUrl = `https:${imageUrl}`;
    }
    mediaEl.src = srcUrl;
    if (mediaEl.dataset.srcset) {
      mediaEl.dataset.srcset = srcUrl;
    }
    if (mediaEl.srcset) {
      mediaEl.srcset = srcUrl;
    }
  }

  updateSizeOptions() {
    if (!this.sizeSelect || this.sizeIndex < 0) return;
    const selectedOptions = this.getSelectedOptions();
    const options = Array.from(this.sizeSelect.options);
    options.forEach((option) => {
      const tempSelection = selectedOptions.slice();
      tempSelection[this.sizeIndex] = this.normalizeValue(option.value);
      const hasMatchingAvailableVariant = this.variants.some(
        (variant) => variant.available && this.isExactMatch(variant, tempSelection)
      );
      option.hidden = !hasMatchingAvailableVariant;
      option.disabled = !hasMatchingAvailableVariant;
    });
    const selectedOption = this.sizeSelect.selectedOptions[0];
    const firstEnabledOption = options.find((option) => !option.disabled);
    this.sizeSelect.disabled = !firstEnabledOption;
    if (selectedOption?.disabled && firstEnabledOption) {
      this.sizeSelect.value = firstEnabledOption.value;
    }
  }

  refreshVariant() {
    this.updateColorOptions();
    this.updateSizeOptions();
    const selectedOptions = this.getSelectedOptions();
    const selectedVariant = this.findVariant(selectedOptions);

    if (this.variantInput && selectedVariant?.id) {
      this.variantInput.value = selectedVariant.id;
    }

    if (this.submitButton) {
      const isAvailable = !!selectedVariant && !!selectedVariant.available;
      if (isAvailable) {
        this.submitButton.removeAttribute('disabled');
      } else {
        this.submitButton.setAttribute('disabled', 'disabled');
      }
      const label = this.submitButton.querySelector(
        '.minicart-recommendation-options__add-label'
      );
      if (label) {
        label.textContent = isAvailable ? this.addLabel : this.soldOutLabel;
      }
    }
  }

  onColorClick(event) {
    event.preventDefault();
    const button = event.currentTarget;
    if (!button || button.disabled) return;
    this.setActiveColor(button);
  }

  onSizeChange() {
    this.refreshVariant();
  }
}
customElements.define(
  'minicart-recommendation-options',
  MinicartRecommendationOptions
);

class VariantRadiosQuickEdit extends SwatchInit {
  constructor() {
    super();
    this.init();
  }

  normalizeColorText(value = '') {
    return String(value)
      .toLowerCase()
      .replace(/[\s\-_]/g, '');
  }

  getQuickEditMediaMap() {
    if (this._quickEditMediaMap) return this._quickEditMediaMap;
    const mediaMapNode = this.querySelector('[data-quick-edit-media-map]');
    const raw = mediaMapNode?.textContent || this.dataset.mediaMap;
    if (!raw) return [];
    try {
      this._quickEditMediaMap = JSON.parse(raw);
      return this._quickEditMediaMap;
    } catch (error) {
      return [];
    }
  }

  getQuickEditProductMedia() {
    if (this._quickEditProductMedia) return this._quickEditProductMedia;
    const node = this.querySelector('[data-quick-edit-product-media]');
    const raw = node?.textContent;
    if (!raw) return [];
    try {
      this._quickEditProductMedia = JSON.parse(raw);
      return this._quickEditProductMedia;
    } catch (error) {
      return [];
    }
  }

  findMediaByColorAlt(activeColor) {
    if (!activeColor) return null;
    const mediaMap = this.getQuickEditMediaMap();
    if (!Array.isArray(mediaMap) || mediaMap.length === 0) return null;
    const colorLower = activeColor.toLowerCase();
    const colorNormalized = this.normalizeColorText(activeColor);
    const altPattern = `[${activeColor}]`.toLowerCase();
    const exact = mediaMap.find((item) => {
      const alt = String(item?.alt || '').toLowerCase();
      return alt.includes(altPattern);
    });
    if (exact?.src) return { src: exact.src, source: 'alt_tag' };
    const contains = mediaMap.find((item) => {
      const alt = String(item?.alt || '').toLowerCase();
      const altNormalized = this.normalizeColorText(alt.replace(/\[|\]/g, ''));
      return alt.includes(colorLower) || altNormalized.includes(colorNormalized);
    });
    if (contains?.src) return { src: contains.src, source: 'alt_text' };
    return null;
  }

  init() {
    this.querySelectorAll('.product__color-swatches--js').forEach((btn) => {
      this.checkSwatches(btn);
    });
    this.querySelectorAll('.option-swatch-js').forEach((button) =>
      button.addEventListener('click', this.onVariantChange.bind(this), false)
    );
    this.options = Array.from(
      this.querySelectorAll('.option-swatch-js.active'),
      (select) => select.getAttribute('data-value')
    );
    this.updateMasterId();
    this.updateMedia(true);
  }

  async onVariantChange(event) {
    event.preventDefault();
    const target = event.currentTarget;
    this.productTarget = this.closest('.product__item-js') || this.closest('[data-template-quick-cart-edit]') || this.closest('form');
    const value = target.getAttribute('data-value');
    const fieldset = target.closest('fieldset');
    const isColorChange = fieldset?.classList.contains('color');
    for (var item of target
      .closest('fieldset')
      .querySelectorAll('.option-swatch-js')) {
      item.classList.remove('active');
    }
    target.classList.toggle('active');
    target
      .closest('fieldset')
      .querySelector('.swatch-selected-value').textContent = value;
    this.options = Array.from(
      this.querySelectorAll('.option-swatch-js.active'),
      (select) => select.getAttribute('data-value')
    );
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updateVariantStatuses();

    const resolveCurrentVariant = async () => {
      const result = await this.resolveVariantQuickEditAsync();
      if (result) {
        this.currentVariant = result.variant;
        this.applyQuickEditAvailability(result.availability);
      }
    };
    const { cascaded } = await this.resolveWithCascade({
      resolveVariant: resolveCurrentVariant,
      cascadeFallback: () => this.cascadeFallbackQuickEdit()
    });
    if (this.currentVariant) {
      if (isColorChange || cascaded) {
        this.updateMedia();
      }
      this.updateVariantInput();
      this.renderProductInfo();
    } else {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    }
  }

  getSelectedOptionValueIdsQuickEdit() {
    const ids = [];
    this.querySelectorAll('.product-form__input').forEach(fieldset => {
      const active = fieldset.querySelector('.option-swatch-js.active');
      const id = active?.dataset?.optionValueId;
      if (id) ids.push(id);
    });
    return ids;
  }

  async resolveVariantQuickEditAsync() {
    const productUrl = this.dataset.url;
    const sectionId = this.dataset.section;
    const optionValueIds = this.getSelectedOptionValueIdsQuickEdit();
    if (!productUrl || !sectionId) return null;
    if (optionValueIds.length === 0) return null;
    return await VariantAPI.fetchByOptionValues(productUrl, sectionId, optionValueIds);
  }

  applyQuickEditAvailability(availability) {
    if (!availability) return;
    Object.keys(availability).forEach(position => {
      const optionData = availability[position];
      Object.keys(optionData).forEach(value => {
        const { available } = optionData[value];
        const el = this.querySelector(`.option-swatch-js[data-value="${CSS.escape(value)}"]`);
        if (el) {
          el.classList.toggle('option-disabled', !available);
        }
      });
    });
  }

  async cascadeFallbackQuickEdit() {
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    let cascaded = false;
    for (let i = 1; i < inputWrappers.length; i++) {
      const wrapper = inputWrappers[i];
      const active = wrapper.querySelector('.option-swatch-js.active');
      if (active && active.classList.contains('option-disabled')) {
        const firstAvailable = wrapper.querySelector('.option-swatch-js:not(.option-disabled)');
        if (firstAvailable) {
          active.classList.remove('active');
          firstAvailable.classList.add('active');
          const label = wrapper.querySelector('.swatch-selected-value');
          if (label) label.textContent = firstAvailable.dataset.value;
          cascaded = true;
          this.options = Array.from(
            this.querySelectorAll('.option-swatch-js.active'),
            (select) => select.getAttribute('data-value')
          );
          this.updateMasterId();
          if (!this.currentVariant) {
            const result = await this.resolveVariantQuickEditAsync();
            if (result) {
              this.currentVariant = result.variant;
              this.applyQuickEditAvailability(result.availability);
            }
          }
        }
      }
    }
    return cascaded;
  }

  updateMasterId() {
    const variantData = this.getVariantData();
    this.currentVariant = variantData.find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia(isInit = false) {
    if (!this.currentVariant) return;
    const container = this.productTarget || this.closest('form') || document.getElementById(
      `product-form-quick-edit-${this.dataset.section}`
    );
    const pickupWrap = container?.querySelector('.product__media .product-pickup-img');
    const imgEl = pickupWrap?.querySelector('img') || container?.querySelector('.product__media img');
    if (!container || !imgEl) return;
    let src = null;
    let resolvedSource = 'none';
    const colorFieldset = this.querySelector('fieldset.color');
    const activeSwatch = colorFieldset?.querySelector('.option-swatch-js.active');

    if (this.currentVariant.featured_media?.preview_image?.src) {
      src = this.currentVariant.featured_media.preview_image.src;
      resolvedSource = 'variant_featured_media';
    }
    if (!src && activeSwatch?.dataset?.productImage) {
      src = activeSwatch.dataset.productImage;
      resolvedSource = activeSwatch.dataset.productImageSource || 'product_media';
    }
    if (!src) {
      const altMatched = this.findMediaByColorAlt(activeSwatch?.dataset?.value);
      if (altMatched?.src) {
        src = altMatched.src;
        resolvedSource = altMatched.source;
      }
    }
    if (src) {
      if (pickupWrap) {
        const newImg = document.createElement('img');
        newImg.src = src;
        newImg.alt = imgEl.alt || 'product';
        newImg.className = imgEl.className || 'rounded-5';
        newImg.loading = 'eager';
        newImg.width = imgEl.width || 200;
        newImg.height = imgEl.height || 200;
        pickupWrap.innerHTML = '';
        pickupWrap.appendChild(newImg);
      } else {
        const picture = imgEl.closest('picture');
        if (picture) picture.querySelectorAll('source').forEach((s) => s.removeAttribute('srcset'));
        imgEl.removeAttribute('srcset');
        imgEl.removeAttribute('data-srcset');
        imgEl.src = src;
        imgEl.loading = 'eager';
      }
    }
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-quick-edit-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  renderProductInfo() {
    if (!this.currentVariant) return;
    const compare_at_price = this.currentVariant.compare_at_price;
    const current_price = this.currentVariant.price;
    const price_format = Shopify.formatMoney(
      this.currentVariant.price,
      cartStrings?.money_format
    );
    const form = document.getElementById(
      `product-form-quick-edit-${this.dataset.section}`
    );
    form.querySelector('.price-regular .price').innerHTML = price_format;
    const price = form.querySelector('.price');
    price.classList.remove('price--sold-out', 'price--on-sale');
    price
      .querySelector('.price-regular .price')
      .classList.remove('special-price');
    if (compare_at_price && compare_at_price > current_price) {
      const compare_format = Shopify.formatMoney(
        compare_at_price,
        cartStrings?.money_default_format
      );
      if (!price.querySelector('.compare-price')) {
        var ps = price.querySelector('.price__sale');
        var sp = document.createElement('span');
        var cp = document.createElement('s');
        cp.classList.add('price-item', 'compare-price');
        sp.appendChild(cp);
        if (ps) {
          ps.appendChild(sp);
        }
      }
      if (price.querySelector('.compare-price')) {
        price.querySelector('.compare-price').innerHTML = compare_format;
      }
      price.classList.add('price--on-sale');
      price
        .querySelector('.price-regular .price')
        .classList.add('special-price');
    } else if (!this.currentVariant.available) {
      price.classList.add('price--sold-out');
    }
    this.toggleAddButton(
      !this.currentVariant.available,
      window.variantStrings?.soldOut,
    );
  }

  toggleAddButton(disable = true, text, modifyClass = true,price) {
    const productForm = document.getElementById(
      `product-form-quick-edit-${this.dataset.section}`
    );
    if (!productForm) return;
    const quantityLabel = parseInt(productForm.querySelector('quantity-input')?.dataset.quantityLabel) || 1;
    const variantPrice = this.currentVariant?.price ?? 0;
    let priceCurrent = `<span data-price="${variantPrice}" class="price-label">${Shopify.formatMoney(
      (quantityLabel * variantPrice),
      cartStrings.money_default_format
    )}</span>`;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const buttonPayment = productForm.querySelector(
      '.product-dynamic-checkout'
    );
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.innerHTML = text + ' - ' + priceCurrent;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.innerHTML = window.variantStrings?.addToCart + ' - ' + priceCurrent;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-quick-edit-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings?.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  updateVariantStatuses() {
    const data = this.getVariantData();
    if (!data || data.length <= 1) return;
    const selectedOptionOneVariants = data.filter(
      (variant) =>
        this.querySelector('.active').dataset.value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    const inputLength = inputWrappers.length;
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('.option-swatch-js')];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector('.active').dataset.value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      const optionInputsValue = inputLength > 1 ? selectedOptionOneVariants.filter(variant => variant[`option${index}`] === previousOptionSelected).map(variantOption => variantOption[`option${index + 1}`]) : data.map(variantOption => variantOption[`option${index + 1}`]);
      this.setAvailability(optionInputs, optionInputsValue, availableOptionInputsValue);
    });
  }

  setAvailability(listOfOptions, optionInputsValue, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.dataset.value)) {
        input.classList.remove('option-disabled');
        input.classList.add('available');
      } else {
        input.classList.add('option-disabled');
        input.classList.remove('available');
        if (window.variantStrings.hide_sold_out_variants) {
          input.classList.add('option-disabled')
          if (!input.classList.contains('active')) return;
          let inputsValue;
          listOfAvailableOptions.length > 0 ? inputsValue = listOfAvailableOptions : inputsValue = optionInputsValue;
          const targetSwatch = input
          .closest('.product-form__input')
          .querySelector(`.option-swatch-js[data-value="${inputsValue[0]}"]`);
        if (targetSwatch) {
          input.classList.remove('active');
          targetSwatch.classList.add('active');
        }
        this.dispatchEvent(new Event('change'));
        }
      }
    });
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('variant-radios-quick-edit', VariantRadiosQuickEdit);

if (!customElements.get('product-form-quick-edit')) {
  customElements.define(
    'product-form-quick-edit',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        this.submitButton.setAttribute('disabled', true);
        this.submitButton.classList.add('loading');
        const cartRecommend = document.querySelector('.cart-recommend');
        if (cartRecommend && cartRecommend.classList.contains('open')) {
          cartRecommend.classList.remove('open');
        }
        const quick = document.getElementById('product-form-quick-edit');
        const id = quick.getAttribute('data-line');
        const quantity = 0;
        const config_change = fetchConfig('json');
        config_change.body = JSON.stringify({
          id,
          quantity,
        });
        fetch(`${routes?.cart_change_url}`, config_change)
          .then((response) => {
            return response.text();
          })
          .catch((e) => {
            throw e;
          })
          .finally(() => {
            this.addCartAdd();
          });
      }

      addCartAdd() {
        const config = fetchConfig('json');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        fetch(`${routes?.cart_add_url}`, config)
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            this.submitButton.setAttribute('disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            fetch('/cart.json')
              .then((res) => res.json())
              .then((cart) => {
                if (cart.item_count != undefined) {
                  document.querySelectorAll('.cart-count').forEach((el) => {
                    if (el.classList.contains('cart-count-drawer')) {
                      el.innerHTML = `(${cart.item_count})`;
                    } else {
                      el.innerHTML =
                        cart.item_count > 100 ? '~' : cart.item_count;
                    }
                  });
                  if (document.querySelector('header-total-price')) {
                    document
                      .querySelector('header-total-price')
                      .updateTotal(cart);
                  }
                }
              })
              .catch((error) => {
                throw error;
              });
            const parsedState = JSON.parse(state);
            if (!parsedState.errors) {
              this.cart.renderContents(parsedState);
              document.querySelector('.tingle-modal__close').click();
            }
          })
          .catch((e) => {
            throw e;
          })
          .finally(() => {
            this.submitButton.setAttribute('disabled', false);
            this.submitButton.querySelector('span').classList.remove('hidden');
            const cartRecommend = document.querySelector('.cart-recommend');
            if (
              cartRecommend &&
              !cartRecommend.classList.contains('hidden-recommend')
            ) {
              if (cartRecommend.classList.contains('cart-recommend-custom')) {
                const cartUpsellItem =
                  document.querySelectorAll('.cart-upsell-item');
                const cartUpsellSlide = document.querySelectorAll(
                  '.swiper-cart-upsell .swiper-slide'
                );
                if (cartUpsellItem.length > 0) {
                  setTimeout(function () {
                    cartRecommend.classList.add('open');
                  }, 800);
                } else if (cartUpsellSlide.length === 0) {
                  cartRecommend.classList.remove('block');
                  cartRecommend.classList.add('hidden');
                }
              } else {
                setTimeout(function () {
                  cartRecommend.classList.add('open');
                }, 800);
              }
            }
          });
      }
    }
  );
}

class ShowPassWord extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.addEventListener('click', this.onClick.bind(this));
  }
  onClick() {
    var input = this.closest('.form-field').querySelector('input');
    if (input.type === 'password') {
      input.type = 'text';
      this.classList.add('text');
    } else {
      input.type = 'password';
      this.classList.remove('text');
    }
  }
}
customElements.define('show-pass-word', ShowPassWord);

class BeforeYouLeave extends HTMLElement {
  constructor() {
    super();
    setTimeout(() => {
      this.init();
    }, 10000);
  }
  init() {
    const sectionId = this.dataset.sectionId;
    const url = `${window.location.pathname}?section_id=${sectionId}&ajax=1`;
    fetch(`${url}`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }
        return response.text();
      })
      .then((responseText) => {
        const newSection = new DOMParser()
          .parseFromString(responseText, 'text/html')
          .querySelector('before-you-leave').innerHTML;
        document.querySelector('before-you-leave').innerHTML = newSection;
      })
      .catch((error) => {
        throw error;
      })
      .finally(() => {
        this.initPopup();
      });
  }
  initPopup() {
    const element = document.querySelector('before-you-leave');
    const delay = element?.dataset.timeDelay;
    var action = 0;
    if (element !== null) {
      var getPopup = setTimeout(() => {
        getTimeOut();
      }, (delay - 10) * 1000);

      const addMultipleListeners = (
        el,
        types,
        listener,
        options,
        useCapture
      ) => {
        types.forEach((type) =>
          el.addEventListener(type, listener, options, useCapture)
        );
      };

      addMultipleListeners(
        document.querySelector('body'),
        ['scroll', 'click', 'mousemove', 'keydown'],
        () => {
          setAction();
        }
      );
      const closeBefore = document.querySelectorAll('.close-before');
      closeBefore.forEach((event) => {
        event.addEventListener('click', () => {
          clearTimeout(getPopup);
          document.documentElement.classList.remove('open-drawer', 'open-byl');
          root.style.removeProperty('padding-right');
          element.classList.remove('open');
        });
      });

      function getTimeOut() {
        action = action + 1;
        if (action >= 1) {
          document.documentElement.classList.add('open-drawer', 'open-byl');
          root.style.setProperty(
            'padding-right',
            getScrollBarWidth.init() + 'px'
          );
          element.classList.add('open');
          const cp = element.querySelectorAll('.discount');
          if (cp !== null) {
            cp.forEach((e) => {
              e.addEventListener('click', (el) => {
                el.preventDefault();
                navigator.clipboard.writeText(e?.dataset.code);
                e.classList.add('action-copy');
                setTimeout(() => {
                  e.classList.remove('action-copy');
                }, 1500);
              });
            });
          }
        }
      }
      function setAction() {
        action = action - 1;
      }
    }
  }
}
customElements.define('before-you-leave', BeforeYouLeave);

class MiniCartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const wishlist_items = JSON.parse(
        localStorage.getItem('glozin__wishlist-items')
      );
      const productHandle = this.dataset.productHandle;
      let index = wishlist_items?.indexOf(productHandle);
      if (this.classList.contains('action-add-wishlist')) {
        if (index == -1 || index == undefined) {
          this.closest('.cart-item').querySelector(
            '.minicart__wishlist'
          ).style.display = 'block';
          this.closest('.cart-item').querySelector(
            '.minicart__product-info'
          ).style.display = 'none';
        } else {
          const cartItems = this.closest('cart-notification');
          cartItems.scheduleQuantityUpdate(
            this.dataset.index,
            0,
            this,
            0
          );
        }
      } else {
        const cartItems = this.closest('cart-notification');
        cartItems.scheduleQuantityUpdate(this.dataset.index, 0, this, 0);
      }
    });
  }
}
customElements.define('mini-cart-remove-button', MiniCartRemoveButton);

class MiniCartWishlistAction extends HTMLElement {
  constructor() {
    super();
    this.actionRemoveWishlist();
    this.actionAddWishlist();
    this.actionClose();
  }

  actionRemoveWishlist() {
    this.querySelector('.btn-minicart__remove-js').addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        const target = event.currentTarget;
        this.eventRemove(target);
      }
    );
  }

  actionAddWishlist() {
    this.querySelector('.btn-minicart__add-wishlist-js').addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        const target = event.currentTarget;
        const localListProductIds = localStorage.getItem(
          'glozin__wishlist-items'
        );
        let listProductIds = [];
        let productId = target.dataset.productId;
        if (localListProductIds) {
          const parseLocalListProductIds = JSON.parse(localListProductIds);
          let isProductIdContained =
            parseLocalListProductIds.includes(productId);
          if (!isProductIdContained) {
            listProductIds.push(...parseLocalListProductIds, productId);
          } else {
            listProductIds.push(...parseLocalListProductIds);
          }
        } else {
          listProductIds.push(productId);
        }
        const stringifyListProductIds = JSON.stringify(listProductIds);
        localStorage.setItem('glozin__wishlist-items', stringifyListProductIds);
        this.eventRemove(target);
      }
    );
  }

  eventRemove(target) {
    const cartItems = target.closest('cart-notification');
    cartItems.scheduleQuantityUpdate(target.dataset.index, 0, target, 0);
  }

  actionClose() {
    document.querySelectorAll('.cart-close-wishlist').forEach((items) => {
      items.addEventListener('click', (e) => {
        const target = e.currentTarget;
        e.preventDefault();
        target
          .closest('.cart-item')
          .querySelector('.minicart__wishlist').style.display = 'none';
        target
          .closest('.cart-item')
          .querySelector('.minicart__product-info').style.display = 'block';
      });
    });
  }
}
customElements.define('minicart-wishlist-action', MiniCartWishlistAction);

class CookieBar extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    var _this = this;
    if (!getCookie('cookie_bar')) {
      this.classList.remove('hidden');
    }
    this.querySelectorAll('.cookie-dismiss').forEach((closeCookie) => {
      closeCookie.addEventListener(
        'click',
        (e) => {
          e.preventDefault();
          const target = e.currentTarget;
          _this.remove();
          if (target.id == 'cookie-refuse') {
            setCookie('cookie_bar', 'dismiss', 7);
          } else {
            setCookie('cookie_bar', 'dismiss', 30);
          }
        },
        false
      );
    });
  }
}
customElements.define('cookie-bar', CookieBar);

class TermsConditions extends PopupBase {
  constructor() {
    super();
    this.init();
  }
  init() {
    const terms = this.querySelector('a');
    if (terms) {
      terms.addEventListener('click', (e) => {
        const target = e.currentTarget;
        const popup = document.querySelector('#popup-terms-conditions');
        if (popup) {
          const header = popup.getAttribute('data-text');
          this.initPopup(
            popup.querySelector('.terms-conditions-content').outerHTML,
            `<h3 class="title-popup h5 my-0 px-20 px-md-30 py-20 border-bottom">${header}</h3>`
          );
          target.href = 'javascript: (function(){})();';
          target.target = '_self';
        }
      });
    }
    const conditions =
      this.querySelector('.conditions_form_minicart') ||
      this.querySelector('.conditions_form_product');
    const bpb = document.querySelector('.btn-checkout');
    const dynamicCheckout = this.closest('product-form')?.querySelector(
      '.btn-checkout-dynamic'
    );
    if (conditions) {
      if (getCookie('term_conditions')) {
        conditions.setAttribute('checked', '');
        if (bpb) {
          bpb.removeAttribute('disabled');
        }
        if (dynamicCheckout) {
          dynamicCheckout.classList.remove('disabled');
        }
      }
      conditions.addEventListener('change', (event) => {
        if (bpb) {
          if (event.currentTarget.checked) {
            bpb.removeAttribute('disabled');
            setCookie('term_conditions', 1, 1);
          } else {
            bpb.setAttribute('disabled', '');
            deleteCookie('term_conditions');
          }
        }
        if (dynamicCheckout) {
          if (event.currentTarget.checked) {
            dynamicCheckout.classList.remove('disabled');
            setCookie('term_conditions', 1, 1);
          } else {
            dynamicCheckout.classList.add('disabled');
            deleteCookie('term_conditions');
          }
        }
      });
    }
  }
}
customElements.define('terms-conditions', TermsConditions);

var BlsGlozinAdminLi = (function () {
  return {
    init: function () {
      this.BlsCheckLi();
    },
    BlsCheckLi: function () {
      const _this = this;
      if (typeof glozin_app === 'object') {
        if (glozin_app.mode === 'admin') {
          if (glozin_app.action === 'active') {
            if (_this.checkCookie(glozin_app.lic) === false) {
              _this.BlsActive();
            }
          } else {
            const url =
              'https://api.blueskytechco.store/glozin/api/remove-license/?code=' +
              glozin_app.lic +
              '&domain=' +
              glozin_app.shop;
            fetch(url)
              .then((response) => response.json())
              .then((responseText) => {
                if (responseText) {
                  const dateCreate = new Date(new Date().getTime() - 36e6);
                  _this.setCookie(glozin_app.lic, dateCreate);
                }
                _this.BlsRenderHtml(3);
              })
              .catch((e) => {
                console.log(e);
              });
          }
        }
      } else {
        _this.BlsRenderHtml(0);
      }
    },
    BlsRenderHtml: function (cs) {
      const shop = window.location.hostname.replace(/\./g, '-');
      if (!document.querySelector('#' + 'bls__' + shop)) {
        const a = document.createElement('DIV');
        const n = document.createElement('DIV');
        const b = document.createElement('h3');
        const c = document.createElement('p');
        const step2p = document.createElement('p');
        const step3p = document.createElement('p');
        const elementH5 = document.createElement('h5');
        const e = document.createElement('h5');
        const f = document.createElement('h5');
        const g = document.createElement('h5');
        const h = document.createElement('strong');
        const sp1 = document.createElement('span');
        const sp2 = document.createElement('span');
        const sp3 = document.createElement('span');
        const pca = document.createElement('a');
        const eca = document.createElement('a');
        const mail = document.createElement('a');
        const br1 = document.createElement('br');
        const br2 = document.createElement('br');
        const br3 = document.createElement('br');
        const br4 = document.createElement('br');
        const spPrice = document.createElement('span');
        const spBold1 = document.createElement('span');
        const spBold2 = document.createElement('span');
        const ecbuy = document.createElement('a');

        var text = '';
        switch (cs) {
          case 1:
            text = 'This purchase code was activated for another domain!';
            break;
          case 2:
            text = 'This purchase code is invalid!';
            break;
          case 3:
            text = 'Purchase Code deleted successfully!';
            break;
          default:
            text = 'Welcome to Glozin - Shopify Themes OS 2.0 🎉 ';
            break;
        }
        const t = document.createTextNode(text);
        const s = document.createTextNode(
          'Follow these simple steps to use Glozin theme:'
        );
        const q = document.createTextNode(
          "Step 1: Add Glozin theme file to your 'Online store' > 'Theme'."
        );
        const p = document.createTextNode('Step 2: Insert purchase code');
        const k = document.createTextNode('Step 3: Activate purchase code');
        const r = document.createTextNode('Recommend: Install ');
        const ec = document.createTextNode('EComposer Page Builder');
        const fao = document.createTextNode(' - FREE Add-on for Glozin');
        const wh = document.createTextNode(
          'Why you need EComposer Page Builder?'
        );
        const ad1 = document.createTextNode(
          '- One more option to customize Glozin layouts.'
        );
        const ad2 = document.createTextNode(
          '- Provide another highly flexible editor.'
        );
        const ad3 = document.createTextNode('- Especially, ');
        const ad3_3 = document.createTextNode(
          ' for Glozin users, we offer the '
        );
        const ad3_4 = document.createTextNode(' of this app ');
        const only = document.createTextNode('only');
        const partner = document.createTextNode('Theme Partner Plan');
        const price = document.createTextNode('$114) ');
        const ad3_2 = document.createTextNode(' every year), ');
        const plan_content = document.createTextNode(
          'contact us to upgrade your plan.'
        );
        const w = document.createTextNode(
          "Go to 'Theme setting' > 'Purchase code' to insert your purchase code."
        );
        const x = document.createTextNode(
          "Go to 'Theme setting' > 'Purchase code action' and select 'Active purchase code'."
        );
        const m = document.createTextNode('👉 Get Glozin purchase code');
        const ecbuy_content = document.createTextNode(
          '👉 Install EComposer Here'
        );
        const step1 = document.createElement('DIV');
        const step2 = document.createElement('DIV');
        const step3 = document.createElement('DIV');
        const recommend = document.createElement('DIV');
        pca.setAttribute('target', '_blank');
        eca.setAttribute('target', '_blank');
        ecbuy.setAttribute('target', '_blank');
        pca.setAttribute(
          'href',
          'https://blueskytechco.gitbook.io/glozin-shopify/get-started/purchase-code-and-activation'
        );
        eca.setAttribute(
          'href',
          'https://ecomposer.app/referral?ref=Blueskytechco'
        );
        mail.setAttribute('href', 'mailto:the4studio.net@gmail.com');
        ecbuy.setAttribute(
          'href',
          'https://ecomposer.app/referral?ref=Blueskytechco'
        );
        b.setAttribute('class', `msg-${cs}`);
        eca.setAttribute('class', 'link');
        mail.setAttribute('class', 'link');
        pca.setAttribute('class', 'popup-btn');
        ecbuy.setAttribute('class', 'popup-btn ecom');
        spPrice.setAttribute('class', 'ecom-price');
        spBold1.setAttribute('class', 'ecom-bold');
        spBold2.setAttribute('class', 'ecom-bold');
        step1.setAttribute('class', 'step-1');
        step2.setAttribute('class', 'step-2');
        step3.setAttribute('class', 'step-3');
        pca.appendChild(m);
        ecbuy.appendChild(ecbuy_content);
        eca.appendChild(ec);
        step2p.appendChild(w);
        step3p.appendChild(x);
        b.appendChild(t);
        c.appendChild(s);
        elementH5.appendChild(q);
        e.appendChild(p);
        f.appendChild(k);
        g.appendChild(r);
        g.appendChild(eca);
        g.appendChild(fao);
        h.appendChild(wh);
        sp1.appendChild(ad1);
        sp2.appendChild(ad2);
        sp3.appendChild(ad3);
        spBold1.appendChild(only);
        sp3.appendChild(spBold1);
        sp3.appendChild(ad3_3);
        spBold2.appendChild(partner);
        sp3.appendChild(spBold2);
        sp3.appendChild(ad3_4);
        // spPrice.appendChild(price);
        sp3.appendChild(spPrice);
        // sp3.appendChild(ad3_2);
        mail.appendChild(plan_content);
        sp3.appendChild(mail);
        step1.appendChild(elementH5);
        step2.appendChild(e);
        step2.appendChild(step2p);
        step2.appendChild(pca);
        step3.appendChild(f);
        step3.appendChild(step3p);
        recommend.appendChild(g);
        recommend.appendChild(h);
        recommend.appendChild(br1);
        recommend.appendChild(sp1);
        recommend.appendChild(br2);
        recommend.appendChild(sp2);
        recommend.appendChild(br3);
        recommend.appendChild(sp3);
        recommend.appendChild(br4);
        recommend.appendChild(ecbuy);
        a.setAttribute('id', 'bls__not-active');
        n.appendChild(b);
        n.appendChild(c);
        n.appendChild(step1);
        n.appendChild(step2);
        n.appendChild(step3);
        // n.appendChild(recommend);
        a.appendChild(n);
        setInterval(() => {
          if (document.getElementById('bls__not-active')) {
            document
              .getElementById('bls__not-active')
              .setAttribute('style', 'display: block !important;');
          } else {
            document.querySelector('body').appendChild(a);
          }
        }, 1000);
      } else {
        document.querySelector('#' + 'bls__' + shop).remove();
      }
    },
    BlsActive: function () {
      const _this = this;
      const url =
        'https://api.blueskytechco.store/glozin/api/check-license/?code=' +
        glozin_app.lic +
        '&domain=' +
        glozin_app.shop;
      fetch(url)
        .then((response) => response.json())
        .then((responseText) => {
          if (responseText.d === false) {
            _this.BlsRenderHtml(responseText.s);
          } else if (responseText.d === true) {
            const dateCheck = new Date(new Date().getTime() + 36e6);
            _this.setCookie(glozin_app.lic, dateCheck);
          } else if (responseText.d === 'err') {
            console.log(
              responseText.err
                ? responseText.err.message
                : "Please contact to server's adminstrator!!!"
            );
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    setCookie: function (cvalue, d) {
      const v = btoa(cvalue);
      document.cookie =
        'UHVyY2hhc2VDb2Rl' + '=' + v + ';expires=' + d + ';path=/';
    },
    checkCookie: function (val) {
      const v = atob(getCookie('UHVyY2hhc2VDb2Rl'));
      if (val.length !== 0 && v == val) {
        return true;
      } else {
        return false;
      }
    },
  };
})();
// BlsGlozinAdminLi.init();

class QuickView extends PopupBase {
  constructor() {
    super();
    this.width = window.innerWidth;
    this.initResizeListener();
    this.html = null;
  }

  initResizeListener() {
    window.addEventListener('resize', () => {
      const newWidth = window.innerWidth;
      this.width = newWidth;
    });
  }

  onThisClick() {
    this.classList.add('loading');
    fetch(this.url)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector(
            '#shopify-section-product-quickview .product-quickview__content'
          );
        if (!html) return;
        this.html = html;
        this.loadScripts(html);
        html.classList.remove('hidden');
        if (this.width > 767) {
          this.initPopup(this.html);
        }else{
          this.createQuickViewMobile(this.html);
        }
      })
      .finally(() => {
        Shopify.PaymentButton.init();
        this.classList.remove('loading');
      })
      .catch((e) => {
        this.classList.remove('loading');
        console.error(e);
      });
  }

  createQuickViewMobile(html) {
    const div = document.createElement('div');
    div.classList.add('product-popup-mobile', 'product-quickview-mobile', 'show-overlay');

    this.loadScripts(html);
    html.classList.remove('hidden');

    div.appendChild(html);
    document.body.appendChild(div);

    div.addEventListener('click', () => {
      this.closeQuickViewMobile(div);
    });
    html.addEventListener('click', (event) => {
      event.stopPropagation();
    });

    setTimeout(() => {
      div.classList.add('open');
      document.querySelector('html').classList.add('overflow-hidden');
    }, 1);
  }
  closeQuickViewMobile(div) {
    div.classList.remove('open');
    document.querySelector('html').classList.remove('overflow-hidden');
    setTimeout(() => {
      div.remove();
    }, 300);
  }

  loadScripts(html) {
    const scripts = html.querySelectorAll('script');
    scripts.forEach((script) => {
      const newScript = document.createElement('script');
      newScript.src = script.src;
      newScript.textContent = script.textContent;
      document.body.appendChild(newScript).parentNode.removeChild(newScript);
    });
  }
}

class ButtonQuickView extends QuickView {
  constructor() {
    super();
    this.url = this.dataset.url;
    this.init();
  }

  init() {
    this.addEventListener('click', this.onThisClick.bind(this));
    this.addEventListener('keydown', this.onThisKeydown.bind(this));
  }

  onThisKeydown(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    this.onThisClick();
  }
}
customElements.define('button-quickview', ButtonQuickView);

class ButtonSelectOptions extends QuickView {
  constructor() {
    super();
    this.url = this.dataset.url;
    this.init();
  }

  init() {
    this.addEventListener('click', this.onThisClick.bind(this));
  }
}
customElements.define('select-option', ButtonSelectOptions);

class ButtonWishlist extends HTMLElement {
  constructor() {
    super();
    this.productId = this.dataset.productId;
    this.action = this.dataset.action || 'remove';
    this.addTooltip = this.dataset.tooltipAdd || 'Add to wishlist';
    this.removeTooltip = this.dataset.tooltipRemove || 'Remove from wishlist';
    this.redirectTooltip = this.dataset.tooltipRedirect || 'Browse wishlist';
    this.tooltipDiv = this.querySelector('.tooltip-content');
    this.init();
  }

  init() {
    this.initializeWishlistStatus();
    this.addEventListener('click', this.onThisClick.bind(this));
  }

  initializeWishlistStatus() {
    const localListProductIds = localStorage.getItem('glozin__wishlist-items');
    if (!localListProductIds) return;
    const parseLocalListProductIds = JSON.parse(localListProductIds);
    const isProductIdContained = parseLocalListProductIds.includes(
      this.productId
    );
    if (isProductIdContained) {
      this.classList.add('active');
      if (this.tooltipDiv) {
        if (this.action === 'remove') {
          this.tooltipDiv.textContent = this.removeTooltip;
        } else {
          this.tooltipDiv.textContent = this.redirectTooltip;
        }
      }
    }
  }

  actionWhenClicked(allThisProductIds, isAdd) {
    allThisProductIds.forEach((_this) => {
      if (isAdd === true) {
        _this.classList.add('active');
        const tooltipDiv = _this.querySelector('.tooltip-content');
        if (tooltipDiv) {
          if (this.action === 'remove') {
            tooltipDiv.textContent = this.removeTooltip;
          } else {
            tooltipDiv.textContent = this.redirectTooltip;
          }
        }
      } else {
        const tooltipDiv = _this.querySelector('.tooltip-content');
        if (tooltipDiv) {
          tooltipDiv.textContent = this.addTooltip;
        }
        _this.classList.remove('active');
      }
    });
  }

  getSyncTargets() {
    if (this.dataset.sync === 'self') {
      return [this];
    }
    return document.querySelectorAll(
      `button-wishlist[data-product-id="${this.productId}"]`
    );
  }

  onThisClick() {
    const localListProductIds = localStorage.getItem('glozin__wishlist-items');
    const allThisProductIds = this.getSyncTargets();
    let listProductIds = [];
    if (!this.productId) return;
    if (localListProductIds && allThisProductIds.length > 0) {
      // wishlist localstorage exists
      const parseLocalListProductIds = JSON.parse(localListProductIds);
      let isProductIdContained = parseLocalListProductIds.includes(
        this.productId
      );
      if (!isProductIdContained) {
        // case item is not in wishlist
        listProductIds.push(...parseLocalListProductIds, this.productId);
        this.actionWhenClicked(allThisProductIds, true);
      } else {
        // case item is in wishlist
        if (this.action) {
          if (this.action === 'remove') {
            const indexOfProductId = parseLocalListProductIds.indexOf(
              this.productId
            );
            parseLocalListProductIds.splice(indexOfProductId, 1);
            listProductIds.push(...parseLocalListProductIds);
            if (this.closest('.wishlist-page-main')) {
              this.closest('.wishlist-list').remove();
              const product = document.querySelectorAll(
                `.wishlist-page-section .product-item__action button-wishlist`
              );
              if (product.length < 1) {
                document
                  .querySelector('.wishlist-no-product-js')
                  .classList.remove('hidden');
              }
            } else {
              this.actionWhenClicked(allThisProductIds, false);
            }
          } else {
            listProductIds.push(...parseLocalListProductIds);
            window.location.href = `${window.shopUrl}${window.Shopify.routes.root}pages/wishlist`;
          }
        } else {
          listProductIds.push(...parseLocalListProductIds);
        }
      }
    } else {
      // wishlist localstorage not exists ==> create new local storage
      listProductIds.push(this.productId);
      this.actionWhenClicked(allThisProductIds, true);
    }
    const stringifyListProductIds = JSON.stringify(listProductIds);
    localStorage.setItem('glozin__wishlist-items', stringifyListProductIds);
    wishlistHeader.init();
    const wishlistTab = document.querySelector('wishlist-tab');
    if (wishlistTab) {
      wishlistTab.initData();
    }
  }
}
customElements.define('button-wishlist', ButtonWishlist);

class ButtonCompare extends HTMLElement {
  constructor() {
    super();
    this.productId = this.dataset.productId;
    this.action = this.dataset.action || 'remove';
    this.addTooltip = this.dataset.tooltipAdd || 'Compare';
    this.removeTooltip = this.dataset.tooltipRemove || 'Remove from compare';
    this.redirectTooltip = this.dataset.tooltipRedirect || 'Browse compare';
    this.tooltipDiv = this.querySelector('.tooltip-content');
    this.action = this.dataset.action || 'remove';
    this.init();
  }

  init() {
    this.initializeCompareStatus();
    this.addEventListener('click', this.onThisClick.bind(this));
  }

  initializeCompareStatus() {
    const localListProductIds = localStorage.getItem('glozin__compare-items');
    if (!localListProductIds) return;
    const parseLocalListProductIds = JSON.parse(localListProductIds);
    const isProductIdContained = parseLocalListProductIds.includes(
      this.productId
    );
    if (isProductIdContained) {
      this.classList.add('active');
      if (this.tooltipDiv) {
        if (this.action === 'remove') {
          this.tooltipDiv.textContent = this.removeTooltip;
        } else {
          this.tooltipDiv.textContent = this.redirectTooltip;
        }
      }
    }
  }

  actionWhenClicked(allThisProductIds, isAdd) {
    allThisProductIds.forEach((_this) => {
      if (isAdd === true) {
        _this.classList.add('active');
        const tooltipDiv = _this.querySelector('.tooltip-content');
        if (tooltipDiv) {
          if (this.action === 'remove') {
            tooltipDiv.textContent = this.removeTooltip;
          } else {
            tooltipDiv.textContent = this.redirectTooltip;
          }
        }
      } else {
        const tooltipDiv = _this.querySelector('.tooltip-content');
        if (tooltipDiv) {
          tooltipDiv.textContent = this.addTooltip;
        }
        _this.classList.remove('active');
      }
    });
  }

  onThisClick() {
    const localListProductIds = localStorage.getItem('glozin__compare-items');
    const allThisProductIds = document.querySelectorAll(
      `button-compare[data-product-id="${this.productId}"]`
    );
    let listProductIds = [];
    if (!this.productId) return;
    if (localListProductIds && allThisProductIds.length > 0) {
      // compare localstorage exists
      const parseLocalListProductIds = JSON.parse(localListProductIds);
      let isProductIdContained = parseLocalListProductIds.includes(
        this.productId
      );
      if (!isProductIdContained) {
        // case item is not in compare
        listProductIds.push(...parseLocalListProductIds, this.productId);
        this.actionWhenClicked(allThisProductIds, true);
      } else {
        // case item is in compare
        if (this.action) {
          if (this.action === 'remove') {
            const indexOfProductId = parseLocalListProductIds.indexOf(
              this.productId
            );
            parseLocalListProductIds.splice(indexOfProductId, 1);
            listProductIds.push(...parseLocalListProductIds);
            this.actionWhenClicked(allThisProductIds, false);
          } else {
            listProductIds.push(...parseLocalListProductIds);
            window.location.href = `${window.shopUrl}${window.Shopify.routes.root}pages/compare`;
          }
        } else {
          listProductIds.push(...parseLocalListProductIds);
        }
      }
    } else {
      // compare localstorage not exists ==> create new local storage
      listProductIds.push(this.productId);
      this.actionWhenClicked(allThisProductIds, true);
    }
    const stringifyListProductIds = JSON.stringify(listProductIds);
    localStorage.setItem('glozin__compare-items', stringifyListProductIds);
  }
}
customElements.define('button-compare', ButtonCompare);

class VariantAPI {
  static _cache = {};
  static _controllers = {};

  static async fetchByOptionValues(productUrl, sectionId, optionValueIds) {
    if (!productUrl || !sectionId || !optionValueIds || optionValueIds.length === 0) return null;
    const filteredIds = optionValueIds.filter(Boolean);
    if (filteredIds.length === 0) return null;

    const cacheKey = `${productUrl}|${sectionId}|${filteredIds.sort().join(',')}`;
    if (this._cache[cacheKey]) return this._cache[cacheKey];

    if (this._controllers[sectionId]) {
      this._controllers[sectionId].abort();
    }
    const controller = new AbortController();
    this._controllers[sectionId] = controller;

    const params = new URLSearchParams();
    params.set('section_id', sectionId);
    params.set('ajax', '1');
    if (filteredIds.length > 0) {
      params.set('option_values', filteredIds.join(','));
    }

    try {
      const response = await fetch(`${productUrl}?${params.toString()}`, { signal: controller.signal });
      const text = await response.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');

      const result = {
        doc,
        variant: this._extractSelectedVariant(doc),
        availability: this._extractOptionAvailability(doc),
        metafields: this._extractMetafields(doc, sectionId),
        variantQtyData: this._extractVariantQtyData(doc)
      };
      this._cache[cacheKey] = result;
      return result;
    } catch (e) {
      if (e.name === 'AbortError') return null;
      console.error('VariantAPI fetch error:', e);
      return null;
    }
  }

  static _extractSelectedVariant(doc) {
    const script = doc.querySelector('script[data-selected-variant]');
    if (script) {
      try { return JSON.parse(script.textContent); } catch (e) { /* ignore */ }
    }
    const input = doc.querySelector('input.product-variant-id[name="id"]');
    if (input && input.value) {
      const variantScript = doc.querySelector('script[type="application/json"]:not([data-selected-variant]):not(.productVariantsQty)');
      if (variantScript) {
        try {
          const variants = JSON.parse(variantScript.textContent);
          if (Array.isArray(variants)) {
            return variants.find(v => String(v.id) === String(input.value)) || null;
          }
        } catch (e) { /* ignore */ }
      }
    }
    return null;
  }

  static _extractOptionAvailability(doc) {
    const availability = {};
    doc.querySelectorAll('[data-variant-input]').forEach(input => {
      const value = input.value || input.getAttribute('value');
      const position = input.dataset.optionPosition || input.closest('fieldset')?.dataset?.optionPosition || '';
      const disabled = input.classList.contains('option-disabled');
      const optionValueId = input.dataset.optionValueId || '';
      if (!availability[position]) availability[position] = {};
      availability[position][value] = { available: !disabled, optionValueId };
    });
    doc.querySelectorAll('.option-swatch-js').forEach(el => {
      const value = el.dataset.value;
      const position = el.dataset.optionPosition || '';
      const disabled = el.classList.contains('option-disabled');
      const optionValueId = el.dataset.optionValueId || '';
      if (!availability[position]) availability[position] = {};
      availability[position][value] = { available: !disabled, optionValueId };
    });
    return availability;
  }

  static _extractMetafields(doc, sectionId) {
    const script = doc.querySelector(`#variant-metafields-${sectionId}`);
    if (script) {
      try { return JSON.parse(script.textContent); } catch (e) { /* ignore */ }
    }
    return null;
  }

  static _extractVariantQtyData(doc) {
    const script = doc.querySelector('.productVariantsQty');
    if (script) {
      try { return JSON.parse(script.textContent); } catch (e) { /* ignore */ }
    }
    return null;
  }

  static clearCache(sectionId) {
    if (sectionId) {
      Object.keys(this._cache).forEach(k => {
        if (k.includes(sectionId)) delete this._cache[k];
      });
    } else {
      this._cache = {};
    }
  }
}

function callSlideWithThumbsMethod(
  element,
  methodName,
  args = [],
  attempts = 12
) {
  if (!element || attempts <= 0) return false;

  const readinessMap = {
    appendSlide: (target) => Boolean(target.globalSlide),
    functionGoto: (target) => Boolean(target.globalSlide),
    updateSlide: (target) => Boolean(target.globalSlide),
    updateThumbSlide: (target) => Boolean(target.thumbnailSlide),
  };
  const isReady =
    typeof element[methodName] === 'function' &&
    (readinessMap[methodName]?.(element) ?? true);

  if (isReady) {
    element[methodName](...args);
    return true;
  }

  const retry = () => {
    requestAnimationFrame(() => {
      callSlideWithThumbsMethod(element, methodName, args, attempts - 1);
    });
  };

  if (!customElements.get('slide-with-thumbs')) {
    customElements.whenDefined('slide-with-thumbs').then(retry);
    return false;
  }

  retry();
  return false;
}

class SwatchFunctions extends SwatchInit {
  constructor() {
    super();
    this.init();
  }

  isManualSelectionMode() {
    return this.dataset.variantSelectionMode === 'manual';
  }

  startVariantChangeRequest() {
    this.variantChangeRequestId = (this.variantChangeRequestId || 0) + 1;
    return this.variantChangeRequestId;
  }

  isCurrentVariantChangeRequest(requestId) {
    return this.variantChangeRequestId === requestId;
  }

  hasVariantInUrl() {
    try {
      const params = new URLSearchParams(window.location.search || '');
      return !!params.get('variant');
    } catch (error) {
      return false;
    }
  }

  getVariantInputWrappers() {
    return [...this.querySelectorAll('.product-form__input')];
  }

  getColorTriggerNames() {
    this.productTarget = this.productTarget || this.closest('.product__item-js');
    const colorString = this.productTarget?.dataset.colorTrigger;
    if (!colorString) return [];
    return colorString
      .split(',')
      .map((name) => name.trim())
      .filter(Boolean);
  }

  normalizeColorValue(value) {
    return `${value || ''}`.trim().toLowerCase();
  }

  getColorInputs() {
    const colorNames = this.getColorTriggerNames();
    if (colorNames.length === 0) return [];
    return [...this.querySelectorAll('[data-variant-input]')].filter((input) =>
      colorNames.includes((input.name || '').trim())
    );
  }

  getSelectedOrFirstColorInput() {
    const colorInputs = this.getColorInputs();
    if (colorInputs.length === 0) return null;
    return (
      colorInputs.find((input) => input.checked) ||
      colorInputs.find((input) => !input.classList.contains('option-disabled')) ||
      colorInputs[0]
    );
  }

  getSelectedOrFirstColorValue() {
    const selectedInput = this.getSelectedOrFirstColorInput();
    if (selectedInput) return selectedInput.value;

    const colorNames = this.getColorTriggerNames();
    if (colorNames.length === 0) return null;
    const colorOptions = [...this.querySelectorAll('.product-sticky-js')].filter(
      (option) => colorNames.includes((option.dataset?.name || '').trim())
    );
    if (colorOptions.length === 0) return null;
    const selectedOption =
      colorOptions.find((option) => option.selected) ||
      colorOptions.find((option) => !option.classList.contains('option-disabled')) ||
      colorOptions[0];
    return (
      selectedOption?.dataset?.value ||
      selectedOption?.dataset?.colorValue ||
      selectedOption?.value ||
      null
    );
  }

  getColorOptionPosition() {
    const colorInput = this.getSelectedOrFirstColorInput();
    if (!colorInput) return null;
    const positionFromData = Number.parseInt(
      colorInput.dataset.optionPosition || '',
      10
    );
    if (Number.isFinite(positionFromData) && positionFromData > 0) {
      return positionFromData;
    }
    const wrappers = this.getVariantInputWrappers();
    const fieldset = colorInput.closest('.product-form__input');
    const index = wrappers.indexOf(fieldset);
    if (index < 0) return null;
    return index + 1;
  }

  getOptionKindFromTarget(target) {
    return (
      target?.closest?.('.product-form__input')?.dataset?.optionKind ||
      target?.dataset?.optionKind ||
      ''
    );
  }

  isStyleOptionTarget(target) {
    return this.getOptionKindFromTarget(target) === 'style';
  }

  syncMediaByChangedOption(target) {
    if (this.isStyleOptionTarget(target)) {
      this.updateMediaBySelectedStyle(target);
      return true;
    }
    return false;
  }

  updateMediaByCurrentVariant(target) {
    if (this.isStyleOptionTarget(target)) return false;
    if (this.getColorValueFromTarget?.(target)) return false;
    if (!this.currentVariant?.featured_media) return false;
    if (typeof this.updateMedia !== 'function') return false;

    this.updateMedia();
    return true;
  }

  normalizeStyleMediaValue(value) {
    return `${value || ''}`
      .toLowerCase()
      .replace(/&/g, ' ')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim()
      .replace(/\s+/g, ' ');
  }

  getStyleMediaMatchOptions(fieldset, styleValue) {
    const firstStyleInput = fieldset?.querySelector('[data-variant-input]');
    const isFirstStyleValue =
      this.normalizeStyleMediaValue(firstStyleInput?.value) ===
      this.normalizeStyleMediaValue(styleValue);

    return {
      allowSingleTokenSuffixMatch: !isFirstStyleValue,
    };
  }

  getFieldsetOptionPosition(fieldset) {
    if (!fieldset) return null;
    const wrappers = this.getVariantInputWrappers();
    const index = wrappers.indexOf(fieldset);
    return index >= 0 ? index + 1 : null;
  }

  currentVariantMatchesSelectedStyle(fieldset, styleValue) {
    if (!this.currentVariant) return false;
    const optionPosition = this.getFieldsetOptionPosition(fieldset);
    if (!optionPosition) return true;
    return (
      this.normalizeStyleMediaValue(this.currentVariant[`option${optionPosition}`]) ===
      this.normalizeStyleMediaValue(styleValue)
    );
  }

  currentVariantMediaMatchesSelectedStyle(styleValue, options = {}) {
    const mediaAlt =
      this.currentVariant?.featured_media?.alt ||
      this.currentVariant?.featured_image?.alt ||
      '';

    return (
      !mediaAlt ||
      this.isStyleMediaAltMatch(mediaAlt, styleValue, options)
    );
  }

  isStyleMediaAltMatch(altText, styleValue, options = {}) {
    const normalizedStyleValue = this.normalizeStyleMediaValue(styleValue);
    if (!normalizedStyleValue || !altText) return false;

    const normalizedAltText = this.normalizeStyleMediaValue(altText);
    if (normalizedAltText === normalizedStyleValue) return true;

    const bracketEndIndex = altText.indexOf(']');
    if (!altText.includes('[') || bracketEndIndex < 0) return false;

    const suffix = altText.slice(bracketEndIndex + 1).replace(/^[-_\s]+/, '');
    const normalizedSuffix = this.normalizeStyleMediaValue(suffix);
    if (normalizedSuffix === normalizedStyleValue) return true;

    const styleTokens = normalizedStyleValue.split(' ');
    const suffixTokens = normalizedSuffix.split(' ');
    return (
      options.allowSingleTokenSuffixMatch !== false &&
      styleTokens.length === 1 &&
      suffixTokens.length > 1 &&
      suffixTokens[suffixTokens.length - 1] === styleTokens[0]
    );
  }

  isMediaAltMatchValue(altText, value, matchMode = 'color', options = {}) {
    if (matchMode === 'style') {
      return this.isStyleMediaAltMatch(altText, value, options);
    }

    const bracketContent = this.normalizeColorValue(
      this.extractBracketContent(altText || '')
    );
    return bracketContent === this.normalizeColorValue(value);
  }

  hasMissingSelections() {
    return this.getVariantInputWrappers().some(
      (wrapper) => !wrapper.querySelector('[data-variant-input]:checked')
    );
  }

  getMissingSelectionState() {
    const firstMissing = this.getVariantInputWrappers().find(
      (wrapper) => !wrapper.querySelector('[data-variant-input]:checked')
    );
    if (!firstMissing) return null;
    const optionName = (firstMissing.querySelector('.bold')?.textContent || '')
      .replace(':', '')
      .trim();
    const chooseText = window.variantStrings?.pleaseChoose || 'Please Choose';
    const message = optionName ? `${chooseText} ${optionName}` : chooseText;
    return { firstMissing, optionName, message };
  }

  clearVariantSelectionButtonPromptState() {
    const productTarget = this.productTarget || this.closest('.product__item-js');
    if (!productTarget) return;
    productTarget.querySelectorAll('.product_submit_button').forEach((button) => {
      button.classList.remove('variant-selection-pending');
    });
  }

  applyVariantSelectionButtonPromptState(message) {
    const productTarget = this.productTarget || this.closest('.product__item-js');
    if (!productTarget || !message) return;
    productTarget.querySelectorAll('.product_submit_button').forEach((button) => {
      button.classList.add('variant-selection-pending');
      const buttonLabel = button.querySelector('.btn-label');
      if (buttonLabel) {
        const currentPriceLabel = buttonLabel.querySelector('.price-label');
        const priceLabelClone = currentPriceLabel ? currentPriceLabel.cloneNode(true) : null;
        buttonLabel.textContent = message;
        if (priceLabelClone && `${priceLabelClone.textContent || ''}`.trim() !== '') {
          buttonLabel.appendChild(document.createTextNode(' - '));
          buttonLabel.appendChild(priceLabelClone);
        }
      }
      button.removeAttribute('disabled');
    });
  }

  setVariantResolutionLoading(isLoading) {
    const productTarget = this.productTarget || this.closest('.product__item-js');
    if (!productTarget) return;
    productTarget.querySelectorAll('.product_submit_button').forEach((button) => {
      button.classList.toggle('loading', isLoading);
      if (isLoading) {
        button.setAttribute('disabled', 'disabled');
      }
    });
  }

  clearFieldsetSelection(fieldset) {
    if (!fieldset) return;
    fieldset
      .querySelectorAll('[data-variant-input]:checked')
      .forEach((input) => (input.checked = false));
    fieldset.querySelectorAll('.option_value').forEach((optionValue) => {
      optionValue.textContent = '';
    });
    fieldset
      .querySelectorAll('.select-custom.active')
      .forEach((dropdown) => dropdown.classList.remove('active'));
  }

  getFieldsetSelectedValue(fieldset, target = null) {
    if (!fieldset) return '';

    const checkedInput = fieldset.querySelector('[data-variant-input]:checked');
    if (checkedInput) {
      return `${checkedInput.value || ''}`.trim();
    }

    const select =
      target?.tagName === 'SELECT' ? target : fieldset.querySelector('select');
    if (select) {
      const selectedOption = select.options?.[select.selectedIndex];
      return `${selectedOption?.dataset?.value || selectedOption?.textContent || select.value || ''}`.trim();
    }

    if (target?.matches?.('[data-variant-input]')) {
      return `${target.value || ''}`.trim();
    }

    return '';
  }

  syncFieldsetOptionValues(target) {
    const fieldset = target?.closest?.('.product-form__input');
    if (!fieldset) return;

    const selectedValue = this.getFieldsetSelectedValue(fieldset, target);
    if (selectedValue === '') return;

    fieldset.querySelectorAll('.option_value').forEach((optionValue) => {
      optionValue.textContent = selectedValue;
    });
  }

  resetFollowingFieldsets(target) {
    return;
  }

  initializeManualSelectionState() {
    if (!this.isManualSelectionMode()) return;
    if (this.hasVariantInUrl()) return;
    const wrappers = this.getVariantInputWrappers();
    if (wrappers.length <= 1) return;
    const lastWrapper = wrappers[wrappers.length - 1];
    const shouldPreserveLastSelection =
      lastWrapper.querySelectorAll('[data-variant-input]').length === 1;
    if (!shouldPreserveLastSelection) {
      this.clearFieldsetSelection(lastWrapper);
    }
    this.updateOptions();
    this.updateMasterId();
    this.updateVariantStatuses();
    if (shouldPreserveLastSelection) {
      this.syncFieldsetOptionValues(
        lastWrapper.querySelector('[data-variant-input]:checked')
      );
    } else {
      this.clearVariantInput();
    }
    this.updateMediaBySelectedColor();
    const missingSelection = this.getMissingSelectionState();
    if (missingSelection) {
      this.applyVariantSelectionButtonPromptState(missingSelection.message);
    } else {
      this.clearVariantSelectionButtonPromptState();
    }
  }

  getProductForms() {
    return document.querySelectorAll(
      `#product-form-${this.dataset.section}, #sticky-addcart-form-${this.dataset.section}`
    );
  }

  clearVariantInput() {
    this.getProductForms().forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (!input) return;
      input.value = '';
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateMediaBySelectedColor(target) {
    this.productTarget = this.productTarget || this.closest('.product__item-js');
    const directColorValue = this.getColorValueFromTarget?.(target);
    const colorValue = directColorValue || this.getSelectedOrFirstColorValue();
    if (!colorValue) return;
    if (typeof this.updateMediaGroup === 'function') {
      this.updateMediaGroup(colorValue);
      return;
    } else if (typeof this.scrollToMediaByAlt === 'function') {
      this.scrollToMediaByAlt(colorValue);
      return;
    }

    if (typeof this.updateMedia !== 'function') return;
    let optionPosition = null;
    if (directColorValue && target) {
      const wrappers = this.getVariantInputWrappers();
      const changedFieldset = target.closest('.product-form__input');
      optionPosition = wrappers.indexOf(changedFieldset) + 1;
    }
    if (!optionPosition || optionPosition < 1) {
      optionPosition = this.getColorOptionPosition();
    }
    if (!optionPosition || optionPosition < 1) return;
    const normalizedColorValue = this.normalizeColorValue(colorValue);
    const fallbackVariant = this.getVariantData()?.find((variant) => {
      const optionValue = variant[`option${optionPosition}`];
      return (
        optionValue != null &&
        this.normalizeColorValue(optionValue) === normalizedColorValue &&
        variant.featured_media
      );
    });
    if (!fallbackVariant) return;
    const previousVariant = this.currentVariant;
    this.currentVariant = fallbackVariant;
    this.updateMedia();
    this.currentVariant = previousVariant;
  }

  updateMediaBySelectedStyle(target) {
    if (!this.isStyleOptionTarget(target)) return false;

    this.productTarget = this.productTarget || this.closest('.product__item-js');
    if (!this.productTarget) return false;

    const fieldset = target?.closest?.('.product-form__input');
    const styleValue = this.getFieldsetSelectedValue(fieldset, target);
    if (!styleValue || typeof this.scrollToMediaByAlt !== 'function') return false;
    const styleMatchOptions = this.getStyleMediaMatchOptions(fieldset, styleValue);

    if (
      this.currentVariant?.featured_media &&
      typeof this.updateMedia === 'function' &&
      this.currentVariantMatchesSelectedStyle(fieldset, styleValue) &&
      this.currentVariantMediaMatchesSelectedStyle(styleValue, styleMatchOptions)
    ) {
      this.updateMedia();
      return true;
    }

    return this.scrollToMediaByAlt(styleValue, {
      fallbackToVariantMedia: false,
      matchMode: 'style',
      styleMatchOptions,
    });
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  getSelectedOptionValueIds() {
    const ids = [];
    this.querySelectorAll('select, fieldset').forEach(element => {
      if (element.tagName === 'SELECT') {
        const selected = element.options[element.selectedIndex];
        const id = selected?.dataset?.optionValueId;
        if (id) ids.push(id);
      } else if (element.tagName === 'FIELDSET') {
        const checked = element.querySelector('[data-variant-input]:checked');
        const id = checked?.dataset?.optionValueId;
        if (id) ids.push(id);
      }
    });
    return ids;
  }

  async resolveVariantAsync() {
    const productUrl = this.dataset.url;
    const sectionId = this.dataset.section;
    if (!productUrl || !sectionId) return null;

    const optionValueIds = this.getSelectedOptionValueIds();
    if (optionValueIds.length === 0) return null;

    return await VariantAPI.fetchByOptionValues(productUrl, sectionId, optionValueIds);
  }

  updateVariantMetafieldContent(result) {
    if (!result || !this.dataset.section) return;
    const sectionId = this.dataset.section;
    const metafieldScript = document.getElementById(`variant-metafields-${sectionId}`);
    const nextMetafields = result.metafields;

    if (metafieldScript && nextMetafields && typeof nextMetafields === 'object') {
      try {
        const currentMetafields = JSON.parse(metafieldScript.textContent || '{}');
        metafieldScript.textContent = JSON.stringify({
          ...currentMetafields,
          ...nextMetafields,
        });
      } catch (error) {
        console.error('Error updating variant metafields:', error);
      }
    }

    if (!result.doc) return;

    const containerId = `metafile_custom_variant_${sectionId}`;
    const nextContainer = result.doc.querySelector(`#${CSS.escape(containerId)}`);
    const currentContainer = document.getElementById(containerId);

    if (currentContainer && nextContainer) {
      currentContainer.replaceWith(nextContainer.cloneNode(true));
    } else if (!currentContainer && nextContainer && metafieldScript) {
      metafieldScript.insertAdjacentElement('afterend', nextContainer.cloneNode(true));
    }
  }

  applyAvailabilityFromAPI(availability) {
    if (!availability) return;
    Object.keys(availability).forEach(position => {
      const optionData = availability[position];
      Object.keys(optionData).forEach(value => {
        const { available } = optionData[value];
        const escapedValue = CSS.escape(value);
        const escapedPosition = CSS.escape(String(position || ''));
        const scopedSelector = escapedPosition
          ? `input[data-variant-input][data-option-position="${escapedPosition}"][value="${escapedValue}"]`
          : `input[data-variant-input][value="${escapedValue}"]`;
        let inputs = [...this.querySelectorAll(scopedSelector)];
        if (inputs.length === 0 && escapedPosition) {
          inputs = [
            ...this.querySelectorAll(
              `input[data-variant-input][value="${escapedValue}"]`
            ),
          ];
        }
        inputs.forEach((input) => {
          input.classList.toggle('option-disabled', !available);
        });
      });
    });
  }

  async cascadeFallback() {
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    let cascaded = false;

    for (let i = 1; i < inputWrappers.length; i++) {
      const wrapper = inputWrappers[i];
      const checked = wrapper.querySelector('input[data-variant-input]:checked');

      if (checked && checked.classList.contains('option-disabled')) {
        const firstAvailable = wrapper.querySelector('input[data-variant-input]:not(.option-disabled)');
        if (firstAvailable) {
          checked.checked = false;
          firstAvailable.checked = true;
          cascaded = true;
          this.syncFieldsetOptionValues(firstAvailable);

          this.updateOptions();
          const result = await this.resolveVariantAsync();
          if (result) {
            this.currentVariant = result.variant;
            this.applyAvailabilityFromAPI(result.availability);
            this.updateVariantMetafieldContent(result);
          }
        }
      }
    }
    return cascaded;
  }

  showColorSwatch(){
    const _this = this;
    if(_this.show_color_swatch != null){
      if (_this.show_color_swatch.dataset.showColorSwatchMode === 'link') return;
      _this.show_color_swatch.addEventListener("click", (e) => {
        _this.dataset.colorSwatchExpanded = 'true';
        _this.classList.add('product__color-swatches--expanded');
        e.currentTarget.classList.add("hidden");
        _this.querySelectorAll(".product__color-swatches--js.hidden").forEach((btn) => {
          btn.classList.remove("hidden");
       
          setTimeout(() =>{   
            btn.classList.remove("opacity-0")
          }, 100)
        
        });
      })
    }
  }

  init() {
    this.querySelectorAll('.product__color-swatches--js').forEach((btn) => {
      this.checkSwatches(btn);
    });
    this.initAction();
    this.initializeManualSelectionState();
  }

  initAction() {
    this.addEventListener('change', this.onVariantChange);
  }

  async onVariantChange(e) {
    const requestId = this.startVariantChangeRequest();
    const isLatestRequest = () => this.isCurrentVariantChangeRequest(requestId);
    this.productTarget = this.closest('.product__item-js');
    const target = e.target;
    this.syncFieldsetOptionValues(target);
    if (this.isManualSelectionMode()) {
      this.resetFollowingFieldsets(target);
    }
    let variantQtyData = null;
    const qtyScript = this.productTarget?.querySelector('.productVariantsQty');
    if (qtyScript) {
      try { variantQtyData = JSON.parse(qtyScript.textContent); } catch (err) { /* ignore */ }
    }
    this.groupFunctionsInit();
    this.setVariantResolutionLoading(true);

    const resolveCurrentVariant = async () => {
      const result = await this.resolveVariantAsync();
      if (!isLatestRequest()) return;
      const hasMissingSelections =
        this.isManualSelectionMode() && this.hasMissingSelections();

      if (result) {
        this.applyAvailabilityFromAPI(result.availability);
        this.updateVariantMetafieldContent(result);
        if (result.variantQtyData) variantQtyData = result.variantQtyData;
      }

      if (hasMissingSelections) {
        this.currentVariant = null;
        return;
      }

      this.currentVariant = result?.variant || null;
    };
    await this.resolveWithCascade({
      resolveVariant: resolveCurrentVariant,
      cascadeFallback: () => (isLatestRequest() ? this.cascadeFallback() : false),
      allowCascade: true,
      refreshAfterCascade: async () => {
        if (!isLatestRequest()) return;
        this.updateOptions();
        this.updateMasterId();
        if (!this.currentVariant) {
          await resolveCurrentVariant();
        }
      }
    });
    if (!isLatestRequest()) return;

    if (this.currentVariant) {
      this.groupFunctionsAvailable(variantQtyData, target);
    } else {
      this.groupFunctionsUnavailable(target);
      if (!this.syncMediaByChangedOption(target)) {
        this.updateMediaBySelectedColor(target);
      }
    }
    this.setVariantResolutionLoading(false);
  }
  groupFunctionsInit() {
    this.updateOptions();
    this.updateMasterId();
    this.updatePickupAvailability();
    this.updateVariantStatuses();
    this.updateMediaSticky();
  }
  groupFunctionsUnavailable(target) {
    if (this.isManualSelectionMode() && this.hasMissingSelections()) {
      this.clearVariantInput();
      const missingSelection = this.getMissingSelectionState();
      this.toggleAddButton(false, '', false);
      if (missingSelection) {
        this.applyVariantSelectionButtonPromptState(missingSelection.message);
      } else {
        this.clearVariantSelectionButtonPromptState();
      }
      this.setAvailable();
      return;
    }
    this.clearVariantInput();
    this.clearVariantSelectionButtonPromptState();
    this.toggleAddButton(true, '', true);
    this.setUnavailable(target);
  }
  groupFunctionsAvailable(variantQtyData, target) {
    this.clearVariantSelectionButtonPromptState();
    this.updateURL();
    this.updateVariantInput();
    this.updatePrice(this.productTarget);
    this.renderProductInfor(this.productTarget, variantQtyData, target);
    if (!this.syncMediaByChangedOption(target)) {
      this.updateMediaByCurrentVariant(target);
    }
    this.updateShareUrl();
    this.setAvailable();
  }
  updatePrice(productTarget) {
    if (!this.currentVariant) return;
    if (!productTarget) return;
    const p = document.getElementById(`price-${this.dataset.section}`);
    if (p) p.classList.remove('visibility-hidden');
    const compare_at_price = this.currentVariant.compare_at_price;
    const price = this.currentVariant.price;
    const unit_price = this.currentVariant.unit_price;
    const unit_price_measurement = this.currentVariant.unit_price_measurement;
    const price_format = Shopify.formatMoney(
      this.currentVariant.price,
      window.window.themeGlobalVariables.settings.money_format
    );
    if (unit_price && unit_price_measurement) {
      const price_num = Shopify.formatMoney(
        unit_price,
        window.window.themeGlobalVariables.settings.money_format
      );
      const price_unit =
        unit_price_measurement.reference_value != 1
          ? unit_price_measurement.reference_value
          : unit_price_measurement.reference_unit;
      if (productTarget.querySelector('.unit-price .number')) {
        productTarget.querySelector('.unit-price .number').innerHTML =
          price_num;
      }
      if (productTarget.querySelector('.unit-price .unit')) {
        productTarget.querySelector('.unit-price .unit').innerHTML = price_unit;
      }
    }
    if (productTarget.querySelector(`#price-${this.dataset.section} .price-regular .price`)) {
      productTarget.querySelector(`#price-${this.dataset.section} .price-regular .price`).innerHTML =
        price_format;
    }
    const bls__price = productTarget.querySelector(
      `.product-detail__price .card-product-price`
    );
    if (bls__price) {
      if (!bls__price.querySelector('.compare-price')) {
        var ps = document.createElement('div');
        var sp = document.createElement('span');
        var cp = document.createElement('s');
        cp.classList.add('price-item', 'compare-price');
        sp.appendChild(cp);
        ps.appendChild(sp);
        ps.classList.add('price-regular');
        if (productTarget.querySelector('.card-product-price')) {
          productTarget.querySelector('.card-product-price').appendChild(ps);
        }
      }
      const cpp = bls__price.querySelector('.compare-price');

      if (cpp) {
        if (compare_at_price && compare_at_price > price) {
          const compare_format = Shopify.formatMoney(
            compare_at_price,
            window.themeGlobalVariables.settings.money_default_format
          );
          cpp.innerHTML = compare_format;
          if (bls__price.querySelector('.price-regular')) {
            bls__price
              .querySelector('.price-regular')
              .classList.add('primary-color');
          }
          if (bls__price.querySelector('.price-regular .price')) {
            bls__price
              .querySelector('.price-regular .price')
              .classList.add('price--special');
          }
        } else {
          cpp.innerHTML = '';
          if (bls__price.querySelector('.price-regular')) {
            bls__price
              .querySelector('.price-regular')
              .classList.remove('primary-color');
          }
          if (bls__price.querySelector('.price-regular .price')) {
            bls__price.querySelector('.price-regular .price').innerHTML =
              price_format;
            bls__price
              .querySelector('.price-regular .price')
              .classList.remove('price--special');
          }
        }
        if (!this.currentVariant.available) {
          bls__price.classList.add('price--sold-out');
        }
      }
    }
  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
    const quantityLabel =
      Number.parseInt(
        productForm.querySelector('quantity-input')?.dataset.quantityLabel || '',
        10
      ) || 1;
    const existingPriceLabel = addButtonText?.querySelector('.price-label');
    const existingPrice = Number.parseInt(
      existingPriceLabel?.dataset?.price || '',
      10
    );
    let selectedVariantPrice = null;
    const selectedVariantScript = this.querySelector('script[data-selected-variant]');
    if (selectedVariantScript) {
      try {
        selectedVariantPrice = Number(
          JSON.parse(selectedVariantScript.textContent || '{}')?.price
        );
      } catch (error) {
        selectedVariantPrice = null;
      }
    }
    const variantPrice = Number.isFinite(this.currentVariant?.price)
      ? this.currentVariant.price
      : Number.isFinite(existingPrice)
        ? existingPrice
        : Number.isFinite(selectedVariantPrice)
          ? selectedVariantPrice
        : null;
    const moneyFormat =
      cartStrings?.money_default_format ||
      window.themeGlobalVariables?.settings?.money_default_format ||
      window.themeGlobalVariables?.settings?.money_format;
    const priceLabelClass = existingPriceLabel?.className || 'price-label';
    const priceCurrent =
      Number.isFinite(variantPrice) && moneyFormat
        ? `<span data-price="${variantPrice}" class="${priceLabelClass}">${Shopify.formatMoney(
            quantityLabel * variantPrice,
            moneyFormat
          )}</span>`
        : '';

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) {
        addButtonText.innerHTML = priceCurrent ? `${text} - ${priceCurrent}` : text;
      }
    } else {
      addButton.removeAttribute('disabled');
      const addToCartText = window.variantStrings?.addToCart || 'Add to Cart';
      addButtonText.innerHTML = priceCurrent
        ? `${addToCartText} - ${priceCurrent}`
        : addToCartText;
    }

    if (!modifyClass) return;
  }
  setUnavailable(target) {
    this.clearVariantSelectionButtonPromptState();
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(
      `Price-Per-Item-${this.dataset.section}`
    );
    const volumeNote = document.getElementById(
      `Volume-Note-${this.dataset.section}`
    );
    const volumeTable = document.getElementById(
      `Volume-${this.dataset.section}`
    );
    const qtyRules = document.getElementById(
      `Quantity-Rules-${this.dataset.section}`
    );

    this.syncFieldsetOptionValues(target);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  setAvailable() {
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(
      `Price-Per-Item-${this.dataset.section}`
    );
    const volumeNote = document.getElementById(
      `Volume-Note-${this.dataset.section}`
    );
    const volumeTable = document.getElementById(
      `Volume-${this.dataset.section}`
    );
    const qtyRules = document.getElementById(
      `Quantity-Rules-${this.dataset.section}`
    );

    if (price && price.classList.contains('hidden'))
      price.classList.remove('hidden');
    if (inventory && inventory.classList.contains('hidden'))
      inventory.classList.remove('hidden');
    if (sku && sku.classList.contains('hidden')) sku.classList.remove('hidden');
    if (pricePerItem && pricePerItem.classList.contains('hidden'))
      pricePerItem.classList.remove('hidden');
    if (volumeNote && volumeNote.classList.contains('hidden'))
      volumeNote.classList.remove('hidden');
    if (volumeTable && volumeTable.classList.contains('hidden'))
      volumeTable.classList.remove('hidden');
    if (qtyRules && qtyRules.classList.contains('hidden'))
      qtyRules.classList.remove('hidden');
  }
  updateMedia() {
    if (!this.productTarget) return;
    const mediaGalleries = this.productTarget.querySelector('media-gallery');
    const layout = mediaGalleries?.dataset.layout;
    const mediaGalleryShopableVideo = this.productTarget.querySelector('slide-section');
    if (mediaGalleryShopableVideo) {
      const slide_items = mediaGalleryShopableVideo.querySelectorAll(
        '.video-item__product-media--ratio.swiper-slide'
      );
      if (slide_items.length == 0) return;
      if (!this.currentVariant?.featured_media) return;
      slide_items.forEach((e, index) => {
        const mediaId = e.getAttribute('data-media-id');
        if (
          mediaId &&
          mediaId ===
            `${this.dataset.section}-${this.currentVariant.featured_media.id}`
        ) {
          const position = e.getAttribute('data-position');
          mediaGalleryShopableVideo.functionGoto(position);
        }
      });
    }
    if (!layout) return;
    if (layout === 'thumbnail') {
      const swiper = mediaGalleries.querySelector('slide-with-thumbs');
      if (!swiper) return;
      if (!this.currentVariant?.featured_media) return;
      const targetMediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
      const mediaFound = this.goToThumbnailGalleryMedia(swiper, targetMediaId);
      if (!mediaFound && this.currentVariant.featured_media?.preview_image) {
        const activeImg = swiper.querySelector('.media-main-swiper .swiper-slide-active img')
          || swiper.querySelector('.media-main-swiper .swiper-slide:first-child img')
          || swiper.querySelector('.swiper-wrapper-preview .swiper-slide img');
        if (activeImg) {
          activeImg.removeAttribute('srcset');
          activeImg.src = this.currentVariant.featured_media.preview_image.src;
        }
      }
    } else {
      const targetMediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
      mediaGalleries.setActiveMedia(targetMediaId);
      const galleryViewer = mediaGalleries.querySelector('[id^="GalleryViewer"]');
      const mediaElement = galleryViewer?.querySelector(
        `[data-media-id="${targetMediaId}"]`
      );
      if (mediaElement) {
        mediaElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }
  updateMediaSticky() {
    if (!this.productTarget) return;
    if (!this.currentVariant) return;
    const stickyAddCart = this.productTarget.querySelector('sticky-add-cart');
    if (!stickyAddCart) return;
    if (!this.currentVariant.featured_media) return;
    const imgQuery = stickyAddCart.querySelector('img');
    imgQuery.src = this.currentVariant.featured_media.preview_image.src;
    imgQuery.removeAttribute('srcset');
    imgQuery.removeAttribute('sizes');
  }
  renderProductInfor(productTarget, variantQtyData, target) {
    if (!this.currentVariant) return;
    if (!productTarget) return;
    let qty = 0;
    let percent = 0;
    let sale = false;
    let soldOut = false;
    let pre_order = false;
    let av = this.currentVariant.available;
    let sku = this.currentVariant.sku;
    let im = this.currentVariant.inventory_management;
    const compare_at_price = this.currentVariant.compare_at_price;

    const price = this.currentVariant.price;
    let avaiable = productTarget.querySelector('.available-value');
    let sku_area = productTarget.querySelector('.product__sku');
    // Update option labels
    const productDetailPicker = productTarget.querySelector(
      '.product-detail__variant-picker'
    );
    if (productDetailPicker) {
      const type = productDetailPicker.dataset.type || 'swatches';

      const updateOptionValues = (selector) => {
        const optionElements = productTarget.querySelectorAll(selector);
        optionElements.forEach((element, index) => {
          const dataIndex = element.dataset.index;
          const optionValue = this.currentVariant[`option${dataIndex}`];
          if (optionValue) {
            element.innerHTML = optionValue;
          }
        });
      };
      if (type === 'swatches') {
        updateOptionValues('.option_value');
      } else {
        updateOptionValues('.option_drop_value .option_value');
        updateOptionValues('swatch-dropdown-select-value .option_value');
        const closestSwatchDropdown = target.closest('swatch-dropdown');
        if (
          closestSwatchDropdown &&
          closestSwatchDropdown.classList.contains('active')
        ) {
          closestSwatchDropdown.classList.remove('active');
        }
      }
    }

    if (sku_area) sku_area.innerHTML = sku ? sku : 'N/A';
    if (Array.isArray(variantQtyData)) {
      variantQtyData.find((variantQty) => {
        if (variantQty.id === this.currentVariant.id) {
          qty = variantQty.qty;
        }
      });
    }

    const countdown = document.querySelector('stock-countdown');
    if (countdown) {
      const itemsLeft = countdown.dataset.itemsLeft;
      const message = countdown.dataset.message;
      if (itemsLeft >= qty && message && qty >= 1) {
        countdown.classList.add('block');
        countdown.classList.remove('hidden');
        const qt = countdown.querySelector('span.count');
        const progressbar = countdown.querySelector('.progressbar-stock');
        let widthProgress;
        if ((qty / itemsLeft) * 100 > 100) {
          widthProgress = 100;
        } else {
          widthProgress = (qty / itemsLeft) * 100;
        }
        progressbar.style.width = widthProgress + '%';
        if (qt) {
          qt.innerHTML = qty;
        }
      } else {
        countdown.classList.remove('block');
        countdown.classList.add('hidden');
      }
    }

    const typePercent = productTarget.querySelector(
      '.product__badges-type-percent'
    );
    if (compare_at_price && compare_at_price > price) {
      sale = true;
      if (typePercent) {
        percent = ((compare_at_price - price) / compare_at_price) * 100;
      } else {
        percent = compare_at_price - price;
      }
    }
    if (im === null) {
      soldOut = false;
      pre_order = false;
      if (avaiable) {
        avaiable.innerHTML = window.variantStrings.inStock;
      }
    } else {
      if (av) {
        if (qty < 1) {
          pre_order = true;
          if (avaiable) {
            avaiable.innerHTML = window.variantStrings.preOrder;
          }
        } else {
          soldOut = false;
          pre_order = false;
          if (avaiable) {
            avaiable.innerHTML = window.variantStrings.inStock;
          }
          if (avaiable) {
            avaiable.innerHTML = window.variantStrings.inStock;
          }
        }
      } else {
        soldOut = true;
        if (avaiable) {
          avaiable.innerHTML = window.variantStrings.outStock;
        }
      }
    }
    this.renderLabel(sale, pre_order, soldOut, percent, productTarget);
    this.renderBtnStatus(productTarget, im, av, qty);
   try {
  const metafieldScript = document.getElementById('variant-metafields-' + this.dataset.section);
  if (metafieldScript) {
    const map = JSON.parse(metafieldScript.textContent || '{}');
    const data = map?.[this.currentVariant.id] || {};
    const container = document.getElementById('metafile_custom_variant_' + this.dataset.section);
    if (container) {
      let allHidden = true; // Giả định tất cả các phần tử sẽ được ẩn

      // Duyệt qua tất cả các trường và kiểm tra trạng thái hiển thị của chúng
      ['bust', 'waist', 'hips', 'length', 'inseam'].forEach((key) => {
        const span = container.querySelector('.meta_value[data-key="' + key + '"]');
        if (span) {
          const val = data?.[key] ?? '';
          span.textContent = val || '';
          const wrapper = span.parentElement;
          if (wrapper) {
            if (val && String(val).trim() !== '') {
              wrapper.classList.remove('hidden');
              wrapper.style.display = '';
              allHidden = false;  // Nếu có giá trị, không ẩn thẻ cha nữa
            } else {
              wrapper.classList.add('hidden');
              wrapper.style.display = 'none';
            }
          }
        }
      });

      if (allHidden) {
        container.style.display = 'none';
      } else {
        container.style.display = ''; 
      }
    }
  }
} catch (e) {
  console.error("Error processing metafields:", e);
}
  }
  renderLabel(sale, pre_order, soldOut, percent, productTarget) {
    let label = productTarget.querySelector('.product__badges');
    let sale_badge = productTarget.querySelector('.sale_badge');
    const badgeRow = productTarget.querySelector('.product-detail__badge-row');
    const productBadgesScrolling = productTarget.querySelector(
      '.product__badges-sale-scrolling'
    );
    if (sale || pre_order || soldOut) {
      if (!sale_badge && badgeRow) {
        sale_badge = document.createElement('div');
        sale_badge.classList.add('sale_badge', 'item-custom-badge__sale');
        [
          'saleColor',
          'soldOutColor',
          'preOrderColor',
          'saleBg',
          'soldOutBg',
          'preOrderBg',
          'showSale',
          'showSoldOut',
          'showPreorder',
        ].forEach((key) => {
          if (badgeRow.dataset[key]) {
            sale_badge.dataset[key] = badgeRow.dataset[key];
          }
        });
        badgeRow.prepend(sale_badge);
      }

      if (!label) {
        var element = document.createElement('div');
        element.classList.add(
          'product__badges',
          'fs-small',
          'flex',
          'flex-column',
          'flex-wrap',
          'gap-custom'
        );
        element.style.setProperty('--gap', '3');
        const rootStyles = getComputedStyle(document.documentElement);
        element.dataset.saleColor =
          sale_badge?.dataset.saleColor ||
          rootStyles.getPropertyValue('--bages-sale-color').trim();
        element.dataset.soldOutColor =
          sale_badge?.dataset.soldOutColor ||
          rootStyles.getPropertyValue('--bages-sold-out-color').trim();
        element.dataset.preOrderColor =
          sale_badge?.dataset.preOrderColor ||
          rootStyles.getPropertyValue('--bages-pre-order-color').trim();
        element.dataset.saleBg =
          sale_badge?.dataset.saleBg ||
          rootStyles.getPropertyValue('--bages-sale-bg-color').trim();
        element.dataset.soldOutBg =
          sale_badge?.dataset.soldOutBg ||
          rootStyles.getPropertyValue('--bages-sold-out-bg-color').trim();
        element.dataset.preOrderBg =
          sale_badge?.dataset.preOrderBg ||
          rootStyles.getPropertyValue('--bages-pre-order-bg-color').trim();
        element.dataset.showSale = sale_badge?.dataset.showSale || 'true';
        element.dataset.showSoldOut = sale_badge?.dataset.showSoldOut || 'true';
        element.dataset.showPreorder = sale_badge?.dataset.showPreorder || 'true';
        if (sale_badge) {
          sale_badge.appendChild(element);
          label = element;
        }
      }
    }

    if (label) {
      const saleColor = label.dataset.saleColor;
      const soldOutColor = label.dataset.soldOutColor;
      const preOrderColor = label.dataset.preOrderColor;
      const saleBg = label.dataset.saleBg;
      const soldOutBg = label.dataset.soldOutBg;
      const preOrderBg = label.dataset.preOrderBg;
      const show_sale = label?.dataset.showSale === 'true';
      const show_pre_order = label?.dataset.showPreorder === 'true';
      const show_sold_out = label?.dataset.showSoldOut === 'true';
      const prd = Shopify.formatMoney(
        percent,
        window.themeGlobalVariables.settings.money_format
      );
      const dsale = label.querySelector('.product__badges-sale');
      const dsoldout = label.querySelector('.product__badges-sold-out');
      const dpreorder = label.querySelector('.product__badges-pre-order');
      const typePrice = label.querySelector('.product__badges-type-price');
      const typePercent = label.querySelector('.product__badges-type-percent');
      if (sale && show_sale) {
        if (!dsale) {
          var elementsale = document.createElement('div');
          elementsale.classList.add(
            'product__badges-sale',
            'product__badges-inner',
            'py-8',
            'px-15',
            'align-self-start',
            'sale',
            'inline-flex',
            'content-center',
            'subheading_weight',
            'btn-rounded',
            'lh-normal',
            'text-center',
            'product__badges-type-price'
          );
          elementsale.style.setProperty('--badges-color', saleColor);
          elementsale.style.setProperty('--badges-bg', saleBg);
          elementsale.innerHTML = `${
            window.variantStrings.save ? window.variantStrings.save : 'Save'
          } ${prd}`;
          if (dsoldout) {
            label.insertBefore(elementsale, dsoldout);
          } else if (dpreorder) {
            label.insertBefore(elementsale, dpreorder);
          } else {
            label.appendChild(elementsale);
          }
        } else {
          if (typePrice) {
            dsale.innerHTML = `${
              window.variantStrings.save ? window.variantStrings.save : 'Save'
            } ${prd}`;
          } else if (typePercent) {
            dsale.innerHTML = -percent.toFixed(0) + '%';
          }
        }
      } else {
        dsale?.remove();
      }
      if (pre_order && show_pre_order) {
        if (!dpreorder) {
          var elementpo = document.createElement('div');
          elementpo.classList.add(
            'product__badges-pre-order',
            'product__badges-inner',
            'py-8',
            'px-15',
            'align-self-start',
            'pre-order',
            'inline-flex',
            'content-center',
            'subheading_weight',
            'btn-rounded',
            'lh-normal',
            'text-center'
          );
          elementpo.style.setProperty('--badges-color', preOrderColor);
          elementpo.style.setProperty('--badges-bg', preOrderBg);
          elementpo.innerHTML = window.variantStrings.preOrder
            ? window.variantStrings.preOrder
            : 'Pre-order';
          label.appendChild(elementpo);
        } else {
          dpreorder.innerHTML = window.variantStrings.preOrder
            ? window.variantStrings.preOrder
            : 'Pre-order';
        }
      } else {
        dpreorder?.remove();
      }
      if (soldOut && show_sold_out) {
        if (!dsoldout) {
          var elementso = document.createElement('div');
          elementso.classList.add(
            'product__badges-sold-out',
            'product__badges-inner',
            'py-8',
            'px-15',
            'align-self-start',
            'sold-out',
            'inline-flex',
            'content-center',
            'subheading_weight',
            'btn-rounded',
            'lh-normal',
            'text-center'
          );
          elementso.style.setProperty('--badges-color', soldOutColor);
          elementso.style.setProperty('--badges-bg', soldOutBg);
          elementso.innerHTML = window.variantStrings.soldOut
            ? window.variantStrings.soldOut
            : 'Sold out';
          label.appendChild(elementso);
        } else {
          dsoldout.innerHTML = window.variantStrings.soldOut
            ? window.variantStrings.soldOut
            : 'Sold out';
        }
      } else {
        dsoldout?.remove();
      }

      if (sale_badge && !label.querySelector('.product__badges-inner')) {
        label.remove();
        if (!sale_badge.querySelector('.product__badges')) {
          sale_badge.remove();
        }
      }
    }

    if (productBadgesScrolling && sale) {
      const dataBadgesScrolling =
        productBadgesScrolling?.dataset.textProductScrolling;
      const allProductBadgesScrolling = productBadgesScrolling.querySelectorAll(
        '.content-badges-scrolling'
      );
      allProductBadgesScrolling.forEach((content) => {
        content.innerText = dataBadgesScrolling.replace(
          '[percent_sale]',
          percent.toFixed(0) + '%'
        );
      });
    }
  }
  renderBtnStatus(productTarget, im, av, qty) {
    if (!productTarget) return;
    let btns_add_cart = productTarget.querySelectorAll(
      '.product_submit_button'
    );
    const quantityLabel = parseInt(productTarget.querySelector('quantity-input')?.dataset.quantityLabel) || 1;
    let priceCurrent = `<span data-price="${this.currentVariant.price}" class="price-label">${Shopify.formatMoney(
      (quantityLabel * this.currentVariant.price),
      cartStrings.money_default_format
    )}</span>`;
    // const quantityLabelSticky = parseInt(productTarget.querySelector('.sticky-quantity')?.dataset.quantityLabel);
    // if (quantityLabelSticky) {
    //   priceCurrent = `<span data-price="${this.currentVariant.price}" class="price-label">${Shopify.formatMoney(
    //     (quantityLabelSticky * this.currentVariant.price),
    //     cartStrings.money_default_format
    //   )}</span>`;
    // }
    btns_add_cart.forEach((btn_add_cart) => {
      btn_add_cart.classList.remove('variant-selection-pending');
      if (btn_add_cart.querySelector('.btn-label')) {
        if (im === null) {
          btn_add_cart.querySelector('.btn-label').innerHTML =
            window.variantStrings.addToCart + ' - ' + priceCurrent;
          btn_add_cart.disabled = false;
        } else {
          if (av) {
            if (qty < 1) {
              btn_add_cart.querySelector('.btn-label').innerHTML =
                window.variantStrings.preOrder + ' - ' + priceCurrent;
              btn_add_cart.disabled = false;
            } else {
              btn_add_cart.querySelector('.btn-label').innerHTML =
                window.variantStrings.addToCart + ' - ' + priceCurrent;
              btn_add_cart.disabled = false;
            }
          } else {
            btn_add_cart.querySelector('.btn-label').innerHTML =
              window.variantStrings.soldOut + ' - ' + priceCurrent;
            btn_add_cart.disabled = true;
          }
        }
      }
    });
  }
  updateVariantStatuses() {
    const variantData = this.getVariantData();
    if (!variantData || variantData.length <= 1) return;
    const inputWrappers = this.getVariantInputWrappers();
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const selectedBefore = inputWrappers
        .slice(0, index)
        .map((wrapper) => wrapper.querySelector(':checked')?.value);

      if (selectedBefore.includes(undefined)) {
        this.setInputAvailability(optionInputs, [], []);
        return;
      }

      const matchedVariants = variantData.filter((variant) =>
        selectedBefore.every(
          (value, selectedIndex) => variant[`option${selectedIndex + 1}`] === value
        )
      );
      const availableOptionInputsValue = matchedVariants
        .filter((variant) => variant.available)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      const optionInputsValue = matchedVariants.map(
        (variantOption) => variantOption[`option${index + 1}`]
      );
      this.setInputAvailability(
        optionInputs,
        optionInputsValue,
        availableOptionInputsValue
      );
    });
  }

  setInputAvailability(elementList, optionInputsValue, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('option-disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        if (optionInputsValue.length === 0) {
          element.innerText = value;
          return;
        }
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace(
              '[value]',
              value
            );
      }
    });
  }
  updateOptions() {
    this.options = [];
    Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        let array = element.value.split(' / ');
        array.forEach((item) => this.options.push(item));
      }
      if (element.tagName === 'FIELDSET') {
        this.options.push(
          Array.from(element.querySelectorAll('[data-variant-input]')).find(
            (radio) => radio.checked
          )?.value
        );
      }
    });
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }
  updateVariantInput() {
    this.getProductForms().forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (!input) return;
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  updateShareUrl() {
    const copyButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!copyButton || !copyButton.updateUrl) return;
    copyButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
    const copyParent = copyButton.closest('.share__content');
    if (!copyParent) return;
    const copySpan = copyParent.querySelector('.copy__url');
    if (!copySpan) return;
    copySpan.innerHTML = `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`;
  }
  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }
  extractBracketContent(altText) {
    if (!altText) return '';
    if (altText.includes('[') && altText.includes(']')) {
      const parts = altText.split('[');
      if (parts.length > 1) {
        const secondPart = parts[1].split(']');
        if (secondPart.length > 0) return secondPart[0];
      }
    }
    return altText;
  }
  extractBracketTagContent(altText) {
    if (!altText) return '';
    if (altText.includes('[') && altText.includes(']')) {
      const parts = altText.split('[');
      if (parts.length > 1) {
        const secondPart = parts[1].split(']');
        if (secondPart.length > 0) return secondPart[0];
      }
    }
    return '';
  }
  getColorValueFromTarget(target) {
    if (!target || !this.productTarget) return null;
    const colorString = this.productTarget.dataset.colorTrigger;
    if (!colorString) return null;
    const colorArray = colorString
      .split(',')
      .map((name) => name.trim())
      .filter(Boolean);
    const colorSelector = this.productTarget.querySelector(
      `[data-value="${CSS.escape(target.value)}"]`
    );
    const dataName = (colorSelector?.dataset.name || target.name || '').trim();
    if (!colorArray.includes(dataName)) return null;
    return colorSelector?.dataset.value || colorSelector?.dataset.colorValue || target.value;
  }
}
//Function click dropdown variant
class SwatchDropdownSelectValue extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.activeFilterSort.bind(this), false);
  }

  activeFilterSort() {
    // Remove active class from all elements except the clicked one
    document.querySelectorAll('.select-custom.active').forEach((element) => {
      if (element !== this.closest('.select-custom')) {
        element.classList.remove('active');
      }
    });

    // Toggle active class on the clicked element
    if (this.closest('.select-custom').classList.contains('active')) {
      this.closest('.select-custom').classList.remove('active');
    } else {
      this.closest('.select-custom').classList.add('active');
    }
  }
}
customElements.define(
  'swatch-dropdown-select-value',
  SwatchDropdownSelectValue
);

// Function to remove active class when clicking outside
function handleClickOutside(event) {
  if (!event.target.closest('.select-custom')) {
    document.querySelectorAll('.select-custom.active').forEach((element) => {
      element.classList.remove('active');
    });
  }
}

// Add event listener to the document
document.addEventListener('click', handleClickOutside);
// End function click dropdown variant

class VariantRadios extends SwatchFunctions {
  constructor() {
    super();
    this.show_color_swatch = this.querySelector(".show_color_swatch");
    this.cardColorResizeTimeout = null;
    this.scheduleCardSwatchInit();
  }

  init() {
    this.scheduleCardSwatchInit();
  }

  connectedCallback() {
    if (!this.cardSwatchInitialized && !this.cardSwatchInitScheduled) {
      this.scheduleCardSwatchInit();
    }
  }

  scheduleCardSwatchInit() {
    if (this.cardSwatchInitialized || this.cardSwatchInitScheduled) return;
    this.cardSwatchInitScheduled = true;

    const runInit = () => {
      this.initCardSwatches();
    };

    if ('IntersectionObserver' in window) {
      this.cardSwatchLazyObserver = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        this.cardSwatchLazyObserver?.disconnect();
        this.cardSwatchLazyObserver = null;
        runInit();
      }, {
        rootMargin: '400px 0px',
      });
      this.cardSwatchLazyObserver.observe(this);
      return;
    }

    requestAnimationFrame(runInit);
  }

  initCardSwatches() {
    if (this.cardSwatchInitialized) return;
    this.cardSwatchInitialized = true;
    this.cardSwatchLazyObserver?.disconnect();
    this.cardSwatchLazyObserver = null;
    this.show_color_swatch = this.show_color_swatch || this.querySelector(".show_color_swatch");

    this.showColorSwatch();
    this.initCardColorOverflow();
    requestAnimationFrame(() => {
      this.syncCardMediaToActiveSwatch();
    });

    this.querySelectorAll('.product__color-swatches--js').forEach((btn) => {
      this.checkSwatches(btn);
      this.variantHover(btn);
      btn.addEventListener('click', this.onVariantChange.bind(this), false);
    });
  }

  initCardColorOverflow() {
    if (!this.show_color_swatch) return;

    if (!this.cardColorToggleBound) {
      this.cardColorToggleBound = true;
      this.show_color_swatch.dataset.bound = 'true';
      this.show_color_swatch.addEventListener('click', () => {
        this.dataset.colorSwatchExpanded = 'true';
        this.classList.add('product__color-swatches--expanded');
      });
    }

    if (!this.cardColorResizeObserver && 'ResizeObserver' in window) {
      this.cardColorResizeObserver = new ResizeObserver(() => {
        this.syncCardColorOverflow();
      });
      this.cardColorResizeObserver.observe(this);
    } else if (!this.cardColorResizeObserver && !this.cardColorResizeHandler) {
      this.cardColorResizeHandler = () => {
        clearTimeout(this.cardColorResizeTimeout);
        this.cardColorResizeTimeout = setTimeout(() => {
          this.syncCardColorOverflow();
        }, 120);
      };
      window.addEventListener('resize', this.cardColorResizeHandler);
    }

    requestAnimationFrame(() => {
      this.syncCardColorOverflow();
    });
  }

  resetCardColorOverflow() {
    this.querySelectorAll('.product__color-swatches--js.hidden').forEach((swatch) => {
      swatch.classList.remove('hidden');
      swatch.classList.remove('opacity-0');
    });
  }

  hideCardColorToggle() {
    if (!this.show_color_swatch) return;
    this.show_color_swatch.classList.add('hidden');
    this.show_color_swatch.setAttribute('hidden', 'hidden');
  }

  getCardColorToggleWidth(swatches) {
    if (!this.show_color_swatch) return 0;

    const toggleClone = this.show_color_swatch.cloneNode(true);
    toggleClone.textContent = `+ ${swatches.length}`;
    toggleClone.classList.remove('hidden');
    toggleClone.removeAttribute('hidden');
    toggleClone.style.position = 'absolute';
    toggleClone.style.visibility = 'hidden';
    toggleClone.style.pointerEvents = 'none';

    this.appendChild(toggleClone);
    const toggleWidth = toggleClone.getBoundingClientRect().width || 0;
    toggleClone.remove();

    return toggleWidth;
  }

  syncCardColorOverflow() {
    if (!this.show_color_swatch) return;

    const swatches = [...this.querySelectorAll('.product__color-swatches--js')];
    if (swatches.length === 0) return;

    this.resetCardColorOverflow();

    if (this.dataset.colorSwatchExpanded === 'true') {
      this.classList.add('product__color-swatches--expanded');
      this.hideCardColorToggle();
      return;
    }

    this.classList.remove('product__color-swatches--expanded');

    const containerWidth = this.clientWidth;
    if (!containerWidth) return;

    const computedStyle = window.getComputedStyle(this);
    const gap = parseFloat(computedStyle.columnGap || computedStyle.gap || '0') || 0;
    const toggleWidth = this.getCardColorToggleWidth(swatches);

    let usedWidth = 0;
    let visibleCount = 0;

    for (let index = 0; index < swatches.length; index += 1) {
      const swatch = swatches[index];
      const swatchWidth = swatch.getBoundingClientRect().width || 0;
      const gapBefore = visibleCount > 0 ? gap : 0;
      const remainingItems = swatches.length - index - 1;
      const reserveForToggle = remainingItems > 0 ? gap + toggleWidth : 0;

      if (usedWidth + gapBefore + swatchWidth + reserveForToggle <= containerWidth || visibleCount === 0) {
        usedWidth += gapBefore + swatchWidth;
        visibleCount += 1;
        continue;
      }

      break;
    }

    if (visibleCount >= swatches.length) {
      this.hideCardColorToggle();
      return;
    }

    swatches.slice(visibleCount).forEach((swatch) => {
      swatch.classList.add('hidden');
      swatch.classList.add('opacity-0');
    });

    this.show_color_swatch.textContent = `+ ${swatches.length - visibleCount}`;
    this.show_color_swatch.classList.remove('hidden');
    this.show_color_swatch.removeAttribute('hidden');
  }

  variantHover(e) {
    const productTarget = e.closest('.product-item');
    if (!productTarget) return;

    const swiperElement = e.closest('.swiper');
    if (!swiperElement) return;

    let timeout;

    const handleMouseOut = () => {
      swiperElement.classList.remove('show-tooltip');
    };

    const handleMouseOver = () => {
      swiperElement.classList.add('show-tooltip');
    };

    e.addEventListener('mouseout', handleMouseOut, false);
    e.addEventListener('mouseover', handleMouseOver, false);
    e.addEventListener('mouseenter', handleMouseOver, false);
    e.addEventListener('mouseleave', handleMouseOut, false);
  }
  onVariantChange(e) {
    e.preventDefault();
    const target = e.currentTarget;
    if (target.classList.contains('active')) return;

    this.productTarget = this.closest('.product__item-js');
    this.position_swatch = target.dataset.position;
    const selectedProductImage = target.dataset.productImage || '';

    const activeSwatches = target
      .closest('.product__color-swatches')
      .querySelectorAll('.product__color-swatches--js');
    activeSwatches.forEach((el) => {
      el.classList.remove('active');
    });
    target.classList.add('active');

    this.applyCardMediaSource(selectedProductImage);
    requestAnimationFrame(() => {
      this.applyCardMediaSource(selectedProductImage);
      this.syncCardColorOverflow();
    });
  }

  getSelectedCardOptionValueIds() {
    const ids = [];
    this.querySelectorAll('.product__color-swatches--js.active').forEach(el => {
      const id = el.dataset?.optionValueId;
      if (id) ids.push(id);
    });
    return ids;
  }

  groupFunctionsInit(variantData) {
    this.updateOptions();
    this.updateMasterId(variantData);
  }
  groupFunctionsAvailable(variantQtyData, preferredSource = '') {
    this.updatePrice();
    this.updateMedia(preferredSource);
    if (preferredSource) {
      this.applyCardMediaSource(preferredSource);
    }
    this.renderProductInfor(variantQtyData);
    requestAnimationFrame(() => {
      if (preferredSource) {
        this.applyCardMediaSource(preferredSource);
      }
      this.syncCardColorOverflow();
    });
  }

  disconnectedCallback() {
    if (this.cardSwatchLazyObserver) {
      this.cardSwatchLazyObserver.disconnect();
      this.cardSwatchLazyObserver = null;
    }
    if (this.cardColorResizeObserver) {
      this.cardColorResizeObserver.disconnect();
      this.cardColorResizeObserver = null;
    }
    if (this.cardColorResizeHandler) {
      window.removeEventListener('resize', this.cardColorResizeHandler);
      this.cardColorResizeHandler = null;
    }
    if (this.cardColorResizeTimeout) {
      clearTimeout(this.cardColorResizeTimeout);
      this.cardColorResizeTimeout = null;
    }
    if (!this.cardSwatchInitialized) {
      this.cardSwatchInitScheduled = false;
    }
  }
  updatePrice() {
    if (!this.currentVariant) return;
    if (!this.productTarget) return;
    const p = document.getElementById(`price-${this.dataset.section}`);
    if (p) p.classList.remove('visibility-hidden');
    const compare_at_price = this.currentVariant.compare_at_price;
    const price = this.currentVariant.price;
    const unit_price = this.currentVariant.unit_price;
    const unit_price_measurement = this.currentVariant.unit_price_measurement;
    const price_format = Shopify.formatMoney(
      this.currentVariant.price,
      window.themeGlobalVariables.settings.money_format
    );
    if (unit_price && unit_price_measurement) {
      const price_num = Shopify.formatMoney(
        unit_price,
        window.themeGlobalVariables.settings.money_format
      );
      const price_unit =
        unit_price_measurement.reference_value != 1
          ? unit_price_measurement.reference_value
          : unit_price_measurement.reference_unit;
      if (this.productTarget.querySelector('.unit-price .number')) {
        this.productTarget.querySelector('.unit-price .number').innerHTML =
          price_num;
      }
      if (this.productTarget.querySelector('.unit-price .unit')) {
        this.productTarget.querySelector('.unit-price .unit').innerHTML =
          price_unit;
      }
    }
    if (this.productTarget.querySelector('.price-regular .price')) {
      this.productTarget.querySelector('.price-regular .price').innerHTML =
        price_format;
    }
    const bls__price = this.productTarget.querySelector('.card-product-price');
    if (bls__price) {
      if (!bls__price.querySelector('.compare-price')) {
        var ps = document.createElement('div');
        var sp = document.createElement('span');
        var cp = document.createElement('s');
        cp.classList.add('price-item', 'dark-gray', 'compare-price');
        sp.appendChild(cp);
        ps.appendChild(sp);
        ps.classList.add('price-sale');
        if (this.productTarget.querySelector('.card-product-price')) {
          this.productTarget
            .querySelector('.card-product-price')
            .appendChild(ps);
        }
      }
      const cpp = bls__price.querySelector('.compare-price');
      if (cpp) {
        if (compare_at_price && compare_at_price > price) {
          const compare_format = Shopify.formatMoney(
            compare_at_price,
            window.themeGlobalVariables.settings.money_default_format
          );
          cpp.innerHTML = compare_format;
          if (bls__price.querySelector('.price-regular')) {
            bls__price
              .querySelector('.price-regular')
              .classList.add('primary-color');
          }
          if (bls__price.querySelector('.price-regular .price')) {
            bls__price
              .querySelector('.price-regular .price')
              .classList.add('price--special');
          }
        } else {
          cpp.innerHTML = '';
          if (bls__price.querySelector('.price-regular')) {
            bls__price
              .querySelector('.price-regular')
              .classList.remove('primary-color');
          }
          if (bls__price.querySelector('.price-regular .price')) {
            bls__price
              .querySelector('.price-regular .price')
              .classList.remove('price--special');
            bls__price.querySelector('.price-regular .price').innerHTML =
              price_format;
          }
        }
        if (!this.currentVariant.available) {
          bls__price.classList.add('price--sold-out');
        }
      }
    }
  }
  renderProductInfor(variantQtyData) {
    if (!this.currentVariant) return;
    if (!this.productTarget) return;
    let qty = 0;
    let percent = 0;
    let sale = false;
    let soldOut = false;
    let pre_order = false;
    let av = false;
    let im = false;
    const compare_at_price = this.currentVariant.compare_at_price;
    const price = this.currentVariant.price;
    const productTarget = this.productTarget;
    const productBadgesScrolling = productTarget.querySelector(
      '.product__badges-sale-scrolling'
    );
    const typePercent = productTarget.querySelector(
      '.product__badges-type-percent'
    );
    const vqd = variantQtyData.reduce((acc, item) => {
      const existingItem = acc.find((i) => i.option === item.option);
      if (existingItem) {
        existingItem.qty += item.qty;
        if (item.available === true) {
          existingItem.available = true;
        }
        if (item.mamagement === '') {
          existingItem.mamagement = '';
        }
      } else {
        acc.push(item);
      }
      return acc;
    }, []);
    vqd.find((variantQty) => {
      if (variantQty.option === this.currentVariant.option1) {
        qty = variantQty.qty;
        av = variantQty.available;
        im = variantQty.mamagement;
      }
    });
    if (compare_at_price && compare_at_price > price) {
      sale = true;
      if (productBadgesScrolling || typePercent) {
        percent = ((compare_at_price - price) / compare_at_price) * 100;
      } else {
        percent = compare_at_price - price;
      }
    }
    if (im === '') {
      soldOut = false;
      pre_order = false;
    } else {
      if (av && qty < 1) {
        pre_order = true;
      } else if (!av) {
        soldOut = true;
      }
    }
    this.renderLabel(sale, pre_order, soldOut, percent, this.productTarget);
  }
  updateMasterId(variantData) {
    return (this.currentVariant = variantData.find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    }));
  }
  updateOptions() {
    this.options = Array.from(
      this.productTarget.querySelectorAll(
        '.product__color-swatches--js.active'
      ),
      (select) => select.getAttribute('data-value')
    );

    this.variantData.find((variant) => {
      if (this.options.length == 1) {
        const variantOptions = {
          1: variant.option1,
          2: variant.option2,
          3: variant.option3,
        };
        if (variantOptions[this.position_swatch] === this.options[0]) {
          this.options = variant.options;
        }
      }
    });
  }
  applyCardMediaSource(nextImageSource) {
    if (!this.productTarget) return;
    const mediaImage = this.productTarget.querySelector(
      '.product__media .product-card-media-sync-target, .product__media img.product-image.first-image, .product__media picture img, .product__media img'
    );
    if (!nextImageSource || !mediaImage) return;
    const productItem = mediaImage.closest('.product-item');
    const picture = mediaImage.closest('picture');
    const normalizedSource = String(nextImageSource).trim();
    if (!normalizedSource) return;
    if (picture) {
      picture.querySelectorAll('source').forEach((source) => {
        if (source.getAttribute('srcset') !== normalizedSource) {
          source.setAttribute('srcset', normalizedSource);
        }
        source.removeAttribute('data-srcset');
      });
    }
    if (mediaImage.getAttribute('srcset') !== `${normalizedSource} 720w`) {
      mediaImage.setAttribute('srcset', `${normalizedSource} 720w`);
    }
    if (mediaImage.getAttribute('src') !== normalizedSource) {
      mediaImage.setAttribute('src', normalizedSource);
    }
    mediaImage.removeAttribute('data-srcset');
    mediaImage.classList.remove('hidden');
    if (productItem) {
      productItem
        .querySelectorAll('.product-card-primary-rich-media')
        .forEach((media) => media.classList.add('hidden'));
      productItem
        .querySelectorAll('.product-hover-media')
        .forEach((media) => media.classList.remove('hidden'));
    }
    const activeSwatch = this.querySelector('.product__color-swatches--js.active');
    this.applyCardHoverMediaSource(
      activeSwatch?.dataset?.productHoverImage || activeSwatch?.dataset?.productImage || ''
    );
  }
  applyCardHoverMediaSource(nextHoverImageSource) {
    if (!this.productTarget) return;
    const hoverImage = this.productTarget.querySelector(
      '.product__media img.product-hover-media, .product__media picture img.product-hover-media'
    );
    if (!nextHoverImageSource || !hoverImage) return;
    const picture = hoverImage.closest('picture');
    const normalizedSource = String(nextHoverImageSource).trim();
    if (!normalizedSource) return;
    if (picture) {
      picture.querySelectorAll('source').forEach((source) => {
        if (source.getAttribute('srcset') !== normalizedSource) {
          source.setAttribute('srcset', normalizedSource);
        }
        source.removeAttribute('data-srcset');
      });
    }
    if (hoverImage.getAttribute('srcset') !== `${normalizedSource} 720w`) {
      hoverImage.setAttribute('srcset', `${normalizedSource} 720w`);
    }
    if (hoverImage.getAttribute('src') !== normalizedSource) {
      hoverImage.setAttribute('src', normalizedSource);
    }
    hoverImage.removeAttribute('data-srcset');
  }
  syncCardMediaToActiveSwatch() {
    const activeSwatch = this.querySelector('.product__color-swatches--js.active');
    const productImage = activeSwatch?.dataset?.productImage || '';
    if (!productImage) return;
    this.productTarget = this.productTarget || this.closest('.product__item-js');
    this.applyCardMediaSource(productImage);
  }
  updateMedia(preferredSource = '') {
    if (!this.productTarget) return;
    const activeSwatch = this.querySelector(
      '.product__color-swatches--js.active'
    );
    const productImage = preferredSource || activeSwatch?.dataset?.productImage || '';
    const nextImageSource =
      productImage ||
      this.currentVariant?.featured_media?.preview_image?.src ||
      '';
    this.applyCardMediaSource(nextImageSource);
  }
}
customElements.define('variant-radios', VariantRadios);

class VariantRadiosDetail extends SwatchFunctions {
  constructor() {
    super();
    this.show_style_more_swatch = this.querySelector(".show_style_more_swatch");
    this.show_style_less_swatch = this.querySelector(".show_style_less_swatch");
    this.colorSwatchResizeTimeout = null;
    this.showStyleSwatch();
    this.showStyleLessSwatch();
    this.initColorSwatchOverflow();
    this.initMediaPosition();
  }
  getColorSwatchFieldsets() {
    return [...this.querySelectorAll('.product-form__input_color')].filter((fieldset) =>
      fieldset.querySelector('label.color-swatch-main-product')
      && fieldset.querySelector('.show_color_swatch')
    );
  }
  initColorSwatchOverflow() {
    const colorFieldsets = this.getColorSwatchFieldsets();
    if (colorFieldsets.length === 0) return;

    colorFieldsets.forEach((fieldset) => {
      const toggle = fieldset.querySelector('.show_color_swatch');
      if (!toggle || toggle.dataset.bound === 'true') return;

      toggle.dataset.bound = 'true';
      toggle.addEventListener('click', (e) => {
        const parentFieldset = e.currentTarget.closest('.product-form__input_color');
        if (!parentFieldset) return;

        parentFieldset.dataset.colorSwatchExpanded = 'true';
        this.resetColorSwatchOverflow(parentFieldset);
        this.hideColorSwatchToggle(e.currentTarget);
      });
    });

    if (!this.colorSwatchResizeObserver && 'ResizeObserver' in window) {
      this.colorSwatchResizeObserver = new ResizeObserver(() => {
        this.syncColorSwatchOverflow();
      });
      colorFieldsets.forEach((fieldset) => this.colorSwatchResizeObserver.observe(fieldset));
    } else if (!this.colorSwatchResizeObserver && !this.colorSwatchResizeHandler) {
      this.colorSwatchResizeHandler = () => {
        clearTimeout(this.colorSwatchResizeTimeout);
        this.colorSwatchResizeTimeout = setTimeout(() => {
          this.syncColorSwatchOverflow();
        }, 120);
      };
      window.addEventListener('resize', this.colorSwatchResizeHandler);
    }

    requestAnimationFrame(() => {
      this.syncColorSwatchOverflow();
    });
  }
  resetColorSwatchOverflow(fieldset) {
    fieldset.querySelectorAll('label.color-swatch-main-product.hidden').forEach((swatch) => {
      swatch.classList.remove('hidden');
      swatch.classList.remove('opacity-0');
    });
  }
  getThumbnailGallerySlides(swiper) {
    if (!swiper) return [];
    return Array.from(
      swiper.querySelectorAll(
        '.swiper-wrapper-preview .swiper-wrapper > .swiper-slide[data-media-id]'
      )
    ).filter((slide) => !slide.classList.contains('swiper-slide-duplicate'));
  }
  getThumbnailGallerySlideIndex(slide, fallbackIndex = 0) {
    if (!slide) return fallbackIndex;
    const dataIndex = Number.parseInt(
      slide.getAttribute('data-swiper-slide-index') || '',
      10
    );
    if (Number.isFinite(dataIndex)) return dataIndex;
    const propertyIndex = Number.parseInt(slide.swiperSlideIndex, 10);
    if (Number.isFinite(propertyIndex)) return propertyIndex;
    return fallbackIndex;
  }
  goToThumbnailGallerySlide(swiper, slide, fallbackIndex = 0) {
    if (!swiper || !slide) return false;
    const slideIndex = this.getThumbnailGallerySlideIndex(slide, fallbackIndex);
    callSlideWithThumbsMethod(swiper, 'functionGoto', [slideIndex]);
    return true;
  }
  goToThumbnailGalleryMedia(swiper, mediaId) {
    if (!swiper || !mediaId) return false;
    const slides = this.getThumbnailGallerySlides(swiper);
    const slideIndex = slides.findIndex(
      (slide) => slide.getAttribute('data-media-id') === mediaId
    );
    if (slideIndex < 0) return false;
    return this.goToThumbnailGallerySlide(swiper, slides[slideIndex], slideIndex);
  }
  getMediaPlaybackSettings() {
    return {
      autoplay: true,
      loop: true,
    };
  }
  getCurrentVariantMediaId(sectionId = this.dataset.section) {
    if (!sectionId || !this.currentVariant?.featured_media) return null;
    return `${sectionId}-${this.currentVariant.featured_media.id}`;
  }
  buildExternalVideoSrc(videoHost, videoId) {
    if (!videoHost || !videoId) return null;
    if (videoHost === 'youtube') {
      return `https://www.youtube.com/embed/${videoId}?enablejsapi=1&rel=0&autoplay=1&mute=1&loop=1&controls=0&disablekb=1&fs=0&playlist=${videoId}`;
    }
    if (videoHost === 'vimeo') {
      return `https://player.vimeo.com/video/${videoId}?autoplay=1&muted=1&loop=1&controls=0`;
    }
    return null;
  }
  setLocalVideoPlayback(videoElement, playbackSettings = this.getMediaPlaybackSettings()) {
    if (!videoElement) return;
    videoElement.setAttribute('playsinline', '');
    videoElement.playsInline = true;
    if (playbackSettings.autoplay) {
      videoElement.setAttribute('autoplay', '');
      videoElement.autoplay = true;
      videoElement.setAttribute('muted', '');
      videoElement.muted = true;
    } else {
      videoElement.removeAttribute('autoplay');
      videoElement.autoplay = false;
      videoElement.removeAttribute('muted');
      videoElement.muted = false;
    }
    if (playbackSettings.loop) {
      videoElement.setAttribute('loop', '');
      videoElement.loop = true;
    } else {
      videoElement.removeAttribute('loop');
      videoElement.loop = false;
    }
  }
  setExternalVideoPlayback(mediaElement) {
    const iframe = mediaElement?.querySelector('iframe');
    if (!iframe) return;
    const src = this.buildExternalVideoSrc(
      mediaElement.dataset.videoHost,
      mediaElement.dataset.videoId
    );
    if (!src) return;
    iframe.src = src;
  }
  applyMediaPlaybackSettings(mediaElement, playbackSettings = this.getMediaPlaybackSettings()) {
    if (!mediaElement) return;
    if (mediaElement.classList.contains('media-gallery__local-video')) {
      this.setLocalVideoPlayback(
        mediaElement.querySelector('video'),
        playbackSettings
      );
      return;
    }
    if (mediaElement.classList.contains('media-gallery__external-video')) {
      this.setExternalVideoPlayback(mediaElement);
    }
  }
  syncGroupedThumbnailMedia(swiper, sectionId = this.dataset.section) {
    if (!swiper) return;
    const targetMediaId = this.getCurrentVariantMediaId(sectionId);
    if (targetMediaId && this.goToThumbnailGalleryMedia(swiper, targetMediaId)) {
      return;
    }
    callSlideWithThumbsMethod(swiper, 'functionGoto', [0]);
  }
  syncGroupedGridMedia(galleryViewer, sectionId = this.dataset.section) {
    if (!galleryViewer) return;
    const targetMediaId = this.getCurrentVariantMediaId(sectionId);
    const targetMedia = targetMediaId
      ? galleryViewer.querySelector(`[data-media-id="${targetMediaId}"]`)
      : null;
    const fallbackMedia = galleryViewer.querySelector('[data-media-id]');
    const activeMedia = targetMedia || fallbackMedia;
    if (!activeMedia) return;
    galleryViewer.querySelectorAll('[data-media-id]').forEach((element) => {
      element.classList.remove('is-active');
    });
    activeMedia.classList.add('is-active');
    activeMedia.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  hideColorSwatchToggle(toggle) {
    toggle.classList.add('hidden');
    toggle.setAttribute('hidden', 'hidden');
  }
  syncColorSwatchOverflow() {
    this.getColorSwatchFieldsets().forEach((fieldset) => {
      const toggle = fieldset.querySelector('.show_color_swatch');
      const swatches = [...fieldset.querySelectorAll('label.color-swatch-main-product')];

      if (!toggle || swatches.length === 0) return;

      this.resetColorSwatchOverflow(fieldset);

      if (fieldset.dataset.colorSwatchExpanded === 'true') {
        this.hideColorSwatchToggle(toggle);
        return;
      }

      const firstRowTop = swatches[0].offsetTop;
      const overflowSwatches = swatches.filter((swatch) => swatch.offsetTop > firstRowTop + 1);
      const activeSwatch = fieldset.querySelector(
        'input[data-variant-input]:checked + label.color-swatch-main-product, label.color-swatch-main-product.active'
      );

      if (
        overflowSwatches.length === 0
        || (activeSwatch && overflowSwatches.includes(activeSwatch))
      ) {
        this.hideColorSwatchToggle(toggle);
        return;
      }

      overflowSwatches.forEach((swatch) => {
        swatch.classList.add('hidden');
        swatch.classList.add('opacity-0');
      });

      toggle.textContent = `+ ${overflowSwatches.length}`;
      toggle.classList.remove('hidden');
      toggle.removeAttribute('hidden');
    });
  }
  initMediaPosition() {
    this.productTarget = this.closest('.product__item-js');
    if (!this.productTarget) return;
    requestAnimationFrame(() => {
      setTimeout(() => {
        this.updateMediaBySelectedColor();
      }, 150);
    });
  }
  scrollToMediaByAlt(colorValue, options = {}) {
    const fallbackToVariantMedia = options.fallbackToVariantMedia !== false;
    const matchMode = options.matchMode || 'color';
    const styleMatchOptions = options.styleMatchOptions || {};
    if (!this.productTarget || !colorValue) {
      if (fallbackToVariantMedia) this.updateMedia();
      return false;
    }
    const normalizedValue =
      matchMode === 'style'
        ? this.normalizeStyleMediaValue(colorValue)
        : this.normalizeColorValue(colorValue);
    if (!normalizedValue) {
      if (fallbackToVariantMedia) this.updateMedia();
      return false;
    }
    const mediaGalleries = this.productTarget.querySelector('media-gallery');
    const layout = mediaGalleries?.dataset.layout;
    if (!layout) {
      if (fallbackToVariantMedia) this.updateMedia();
      return false;
    }
    if (layout === 'thumbnail') {
      const swiper = mediaGalleries.querySelector('slide-with-thumbs');
      if (!swiper) return false;
      const slides = this.getThumbnailGallerySlides(swiper);
      const matchedSlides = slides
        .map((slide, index) => ({
          slide,
          index,
          slideIndex: this.getThumbnailGallerySlideIndex(slide, index),
        }))
        .filter(({ slide }) =>
          (matchMode !== 'color' || slide.matches('.media-gallery__image')) &&
          this.isMediaAltMatchValue(
            slide.dataset.alt || '',
            colorValue,
            matchMode,
            styleMatchOptions
          )
        )
        .sort((a, b) => a.slideIndex - b.slideIndex);
      if (matchedSlides.length > 0) {
        const matchedSlide = matchedSlides[0];
        this.goToThumbnailGallerySlide(
          swiper,
          matchedSlide.slide,
          matchedSlide.index
        );
        return true;
      }
      if (fallbackToVariantMedia) this.updateMedia();
      return false;
    } else {
      const galleryViewer = mediaGalleries.querySelector('[id^="GalleryViewer"]');
      if (!galleryViewer) {
        if (fallbackToVariantMedia) this.updateMedia();
        return false;
      }
      const items = galleryViewer.querySelectorAll('[data-media-id]');
      for (const item of items) {
        if (
          (matchMode !== 'color' || item.matches('.media-gallery__image')) &&
          this.isMediaAltMatchValue(
            item.dataset.alt || '',
            colorValue,
            matchMode,
            styleMatchOptions
          )
        ) {
          items.forEach(el => el.classList.remove('is-active'));
          item.classList.add('is-active');
          item.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return true;
        }
      }
      if (fallbackToVariantMedia) this.updateMedia();
      return false;
    }
  }
  groupFunctionsAvailable(variantQtyData, target) {
    this.updateURL();
    this.updateVariantInput();
    this.updatePrice(this.productTarget);
    this.renderProductInfor(this.productTarget, variantQtyData, target);
    const colorValue = this.getColorValueFromTarget(target);
    if (colorValue) {
      this.scrollToMediaByAlt(colorValue);
    } else if (!this.syncMediaByChangedOption(target)) {
      this.updateMediaByCurrentVariant(target);
    }
    this.updateShareUrl();
    this.mapStickyDropdown();
    this.setAvailable();
    requestAnimationFrame(() => {
      this.syncColorSwatchOverflow();
    });
  }
  mapStickyDropdown() {
    if (!this.currentVariant || !this.productTarget) return;

    const stickyAddCart = this.productTarget.querySelector('sticky-add-cart');
    if (!stickyAddCart) return;

    const select = stickyAddCart.querySelector('select');
    const detailRadio = this.productTarget.querySelector(
      'variant-radios-detail, variant-group-detail'
    );
    if (!select && detailRadio) return;

    for (let i = 0; i < select.options.length; i++) {
      if (select.options[i].value === this.currentVariant.title) {
        select.options[i].selected = true;

        detailRadio.querySelectorAll('fieldset').forEach((fieldset, index) => {
          fieldset.querySelectorAll('input').forEach((input) => {
            input.removeAttribute('checked');
            if (input.value === this.currentVariant[`option${index + 1}`]) {
              input.checked = true;
            }
          });
        });
        break;
      }
    }
  }
  showStyleSwatch(){
    if(this.show_style_more_swatch != null){
      this.show_style_more_swatch.addEventListener("click", (e) => {
        e.currentTarget.classList.add("hidden");
        this.show_style_less_swatch.classList.remove("hidden");
        this.querySelectorAll(".product__style-option-wrapper.hidden").forEach((btn) => {
          btn.classList.remove("hidden");
          btn.classList.add("less-style");
          setTimeout(() =>{   
            btn.classList.remove("opacity-0")
          }, 100)
        
        });
      })
    }
  }
  showStyleLessSwatch(){
    if(this.show_style_less_swatch != null){
      this.show_style_less_swatch.addEventListener("click", (e) => {
        e.currentTarget.classList.add("hidden");
        this.show_style_more_swatch.classList.remove("hidden");
        this.querySelectorAll(".product__style-option-wrapper.less-style").forEach((btn) => {
          btn.classList.add("hidden");
          btn.classList.add("opacity-1")
        });
      })
    }
  }
  setInputAvailability(elementList,optionInputsValue, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);
      if (availableElement) {
        element.classList.add('available');
        element.classList.remove('option-disabled');
      }else{
        element.classList.remove('available');
        element.classList.add('option-disabled');
        if (
          window.variantStrings.hide_sold_out_variants &&
          !this.isManualSelectionMode()
        ) {
          element.classList.add('option-disabled')
          if (!element.checked) return;
          let inputsValue;
          availableValuesList.length > 0 ? inputsValue = availableValuesList : inputsValue = optionInputsValue;
          element.closest('.product-form__input').querySelector(`input[value="${inputsValue[0]}"]`).checked = true;
          this.dispatchEvent(new Event('change'));
        }
      }
    });
  }
  disconnectedCallback() {
    if (this.colorSwatchResizeObserver) {
      this.colorSwatchResizeObserver.disconnect();
    }
    if (this.colorSwatchResizeHandler) {
      window.removeEventListener('resize', this.colorSwatchResizeHandler);
    }
    if (this.colorSwatchResizeTimeout) {
      clearTimeout(this.colorSwatchResizeTimeout);
    }
  }
}
customElements.define('variant-radios-detail', VariantRadiosDetail);

class VariantRadiosSingle extends SwatchFunctions {
  constructor() {
    super();
  }
  groupFunctionsAvailable(variantQtyData) {
    this.updateVariantInput();
    this.updatePrice(this.productTarget);
    this.renderProductInfor(this.productTarget, variantQtyData);
    this.updateMedia();
  }
}
customElements.define('variant-radios-single', VariantRadiosSingle);

class VariantGroupDetail extends VariantRadiosDetail {
  constructor() {
    super();
    
    this.initDefaultColorMedia();
  }
  initMediaPosition() {}

  locateMediaByColorValue(colorValue) {
    if (!colorValue || typeof this.scrollToMediaByAlt !== 'function') return false;
    return this.scrollToMediaByAlt(colorValue, { fallbackToVariantMedia: false });
  }

  updateMediaBySelectedColor(target) {
    this.productTarget = this.productTarget || this.closest('.product__item-js');
    const colorValue =
      this.getColorValueFromTarget?.(target) || this.getSelectedOrFirstColorValue();
    this.locateMediaByColorValue(colorValue);
  }

  initDefaultColorMedia() {
      this.productTarget = this.closest('.product__item-js');
      if (!this.productTarget) return;
      const mainWrapper = this.productTarget.querySelector('.main-product');
      const colorString = this.productTarget.dataset.colorTrigger;
      if (!colorString) return;
      
      const colorArray = colorString
        .split(',')
        .map((name) => name.trim())
        .filter(Boolean);
      const activeColorOption =
        this.getCurrentActiveVariant(colorArray) || this.getSelectedOrFirstColorValue();
      requestAnimationFrame(() => {
        if (activeColorOption) {
          this.locateMediaByColorValue(activeColorOption);
          setTimeout(() => {
            if (mainWrapper) {
              mainWrapper.style.opacity = 1;
            }
          }, 450);
        }
      });
  }
  
  getCurrentActiveVariant(colorArray) {
    if (!colorArray || colorArray.length === 0) return null;
    
    let activeOption = null;
    
    this.querySelectorAll('.product__color-swatches--js.active, input[type="radio"]:checked').forEach(input => {
      const dataName = (input.dataset.name || input.name || '').trim();
      if (colorArray.includes(dataName)) {
        activeOption = input.dataset.value || input.dataset.colorValue || input.value;
      }
    });

    return activeOption;
  }

  async onVariantChange(e) {
    const requestId = this.startVariantChangeRequest();
    const isLatestRequest = () => this.isCurrentVariantChangeRequest(requestId);
    this.productTarget = this.closest('.product__item-js');
    this.syncFieldsetOptionValues(e.target);
    if (this.isManualSelectionMode()) {
      this.resetFollowingFieldsets(e.target);
    }
    let variantQtyData = null;
    const qtyScript = this.productTarget?.querySelector('.productVariantsQty');
    if (qtyScript) {
      try { variantQtyData = JSON.parse(qtyScript.textContent); } catch (err) { /* ignore */ }
    }
    this.groupFunctionsInit();
    this.setVariantResolutionLoading(true);

    const resolveCurrentVariant = async () => {
      const result = await this.resolveVariantAsync();
      if (!isLatestRequest()) return;
      const hasMissingSelections =
        this.isManualSelectionMode() && this.hasMissingSelections();

      if (result) {
        this.applyAvailabilityFromAPI(result.availability);
        if (result.variantQtyData) variantQtyData = result.variantQtyData;
      }

      if (hasMissingSelections) {
        this.currentVariant = null;
        return;
      }

      this.currentVariant = result?.variant || null;
    };
    await this.resolveWithCascade({
      resolveVariant: resolveCurrentVariant,
      cascadeFallback: () => (isLatestRequest() ? this.cascadeFallback() : false),
      allowCascade: true,
      refreshAfterCascade: async () => {
        if (!isLatestRequest()) return;
        this.updateOptions();
        this.updateMasterId();
        if (!this.currentVariant) {
          await resolveCurrentVariant();
        }
      }
    });
    if (!isLatestRequest()) return;

    if (this.currentVariant) {
      this.checkColorGroup(e);
      if (!this.syncMediaByChangedOption(e.target)) {
        this.updateMediaByCurrentVariant(e.target);
      }
      this.updateURL();
      this.updateVariantInput();
      this.updatePrice(this.productTarget);
      this.renderProductInfor(this.productTarget, variantQtyData, e.target);
      this.updateShareUrl();
      this.mapStickyDropdown();
      this.setAvailable();
      requestAnimationFrame(() => {
        this.syncColorSwatchOverflow();
      });
    } else {
      this.groupFunctionsUnavailable(e.target);
      this.checkColorGroup(e);
      this.syncMediaByChangedOption(e.target);
      requestAnimationFrame(() => {
        this.syncColorSwatchOverflow();
      });
    }
    this.setVariantResolutionLoading(false);
  }

  checkColorGroup(e) {
    const mediaColorValue = this.getColorValueFromTarget(e?.target);
    return this.locateMediaByColorValue(mediaColorValue);
  }

  updateMediaGroup(altValue) {
    const productHandle = this.dataset.productHandle;
    const desktopLayout = this.productTarget.dataset.desktopLayout;
    const mobileLayout = this.productTarget.dataset.mobileLayout;
    const zoom = this.productTarget.dataset.zoom;
    const sectionId = this.productTarget.dataset.section;
    const zoomAction = this.productTarget.querySelector('zoom-action');
    const elementFeatureProduct = this.productTarget.dataset.typeElement;
    const normalizedAltValue = this.normalizeColorValue(altValue);
    const allButtonValues = this.getAllButtonValue();
    const hasBracketTagsVariant =
      this.productTarget?.dataset?.hasAltTagsVariant === 'true';
    const getMediaTagValue = (rawAlt = '') =>
      this.normalizeColorValue(
        hasBracketTagsVariant
          ? this.extractBracketTagContent(rawAlt)
          : this.extractBracketContent(rawAlt)
      );
    if (!productHandle || !sectionId || !desktopLayout || !normalizedAltValue) return;
    if (
      desktopLayout !== 'grid_1_column' &&
      desktopLayout !== 'grid_2_column' &&
      desktopLayout !== 'stack'
    ) {
      fetch(`/products/${productHandle}?section_id=media-gallery-slide`)
      .then((response) => response.text())
      .then((text) => {
        const html = parser.parseFromString(text, 'text/html');
        if (!html) return;
        const playbackSettings = this.getMediaPlaybackSettings();
        
        let parentDiv = html.querySelector('slide-with-thumbs');
        parentDiv.classList.add(desktopLayout);
        parentDiv.dataset.autoPlayVideo = playbackSettings.autoplay ? 'true' : 'false';
        
        if (desktopLayout === 'thumbnail_left') {
          parentDiv.classList.add('flex-md', 'gap-10', 'overflow-hidden', 'justify-content-right');
        }
        
        parentDiv.dataset.thumbDirection = desktopLayout === 'thumbnail_left' ? 'vertical' : 'horizontal';
        
        let parentContainer = parentDiv.querySelector('.media-main-swiper .swiper-wrapper');
        parentContainer.innerHTML = '';
        
        let wrapperFeatureProduct = this.productTarget.querySelector('slide-with-thumbs');
        let slidePreviewFeatureProduct = wrapperFeatureProduct.querySelector('.media-main-swiper .swiper-wrapper');
        
        const mediaItems = [];
        let mediaSelector = '.media-gallery__append > div.media-gallery__image[data-pane-container], .media-gallery__append > .media-gallery__local-video, .media-gallery__append > [data-media-view="main"]';
        if (zoom === 'open_lightbox') {
          mediaSelector = '.media-gallery__append > a.media-gallery__image, .media-gallery__append > .media-gallery__local-video, .media-gallery__append > [data-media-view="main"]';
        } else if (zoom === 'no_zoom') {
          mediaSelector = '.media-gallery__append > div.media-gallery__image:not([data-pane-container]), .media-gallery__append > .media-gallery__local-video, .media-gallery__append > [data-media-view="main"]';
        }

        html.querySelectorAll(mediaSelector).forEach((item) => {
          const bracketContent = getMediaTagValue(item.dataset.alt || '');
          if (bracketContent !== normalizedAltValue && allButtonValues.includes(bracketContent)) {
            return;
          }
          const mediaDefaultId = item.dataset.media;
          if (mediaDefaultId) {
            item.setAttribute('data-media-id', `${sectionId}-${mediaDefaultId}`);
          }
          this.applyMediaPlaybackSettings(item, playbackSettings);
          mediaItems.push({
            element: item.cloneNode(true)
          });
        });

        mediaItems.forEach(item => {
          parentContainer.appendChild(item.element);
        });
        
        if (elementFeatureProduct) {
          slidePreviewFeatureProduct.innerHTML = parentContainer.innerHTML;
          callSlideWithThumbsMethod(wrapperFeatureProduct, 'updateSlide');
        }
        
        if (desktopLayout !== 'hidden_thumbnail') {
          let thumbHtml = html.querySelector('.media-gallery__append .media-thumb-swiper');
          let thumbHtmlFeatureProduct = wrapperFeatureProduct.querySelector('.media-thumb-swiper .swiper-wrapper');
          
          if (!thumbHtml || !thumbHtmlFeatureProduct) return;
          let thumbHtmlWrapper = thumbHtml.querySelector('.swiper-wrapper');
          if (!thumbHtmlWrapper) return;
          thumbHtmlWrapper.innerHTML = '';
          if (mobileLayout !== 'show_thumbnails') {
            thumbHtml.classList.add('thumbnail-slide__mobile--hidden');
            parentDiv.innerHTML += html.querySelector('.swiper-pagination').outerHTML;
          }
          
          if (desktopLayout === 'thumbnail_bottom') {
            thumbHtml.querySelector('.thumbnail-slide').classList.add('mt-10', 'thumb-bottom');
            thumbHtml.querySelector('.thumbnail-slide').setAttribute('style', '--gap: 15px');
          }
          
          if (desktopLayout === 'thumbnail_left') {
            thumbHtml.classList.add('mt-10');
            if (thumbHtml.querySelector('.thumbnail-slide')?.classList.contains('swiper-horizontal')) {
              thumbHtml.querySelector('.thumbnail-slide')?.classList.remove('swiper-horizontal');
              thumbHtml.querySelector('.thumbnail-slide')?.classList.add('swiper-vertical');
            }
          }
          const thumbItems = [];
          html.querySelectorAll('.media-gallery__append > div.media-gallery__image:not([data-pane-container]), .media-gallery__append > .media-gallery__image-video, .media-gallery__append > [data-media-view="thumb"]')
            .forEach((item) => {
              const bracketContent = getMediaTagValue(item.dataset.alt || '');
              if (bracketContent !== normalizedAltValue && allButtonValues.includes(bracketContent)) {
                return;
              }
              const mediaDefaultId = item.dataset.media;
              if (mediaDefaultId) {
                item.setAttribute('data-media-id', `${sectionId}-${mediaDefaultId}`);
              }
              this.applyMediaPlaybackSettings(item, playbackSettings);
              thumbItems.push({
                element: item.cloneNode(true)
              });
            });

          thumbItems.forEach(item => {
            thumbHtmlWrapper.appendChild(item.element);
          });
          
          parentDiv.innerHTML += thumbHtml.outerHTML;
          if (elementFeatureProduct) {
            thumbHtmlFeatureProduct.innerHTML = thumbHtmlWrapper.innerHTML;
            callSlideWithThumbsMethod(
              wrapperFeatureProduct,
              'updateThumbSlide'
            );
          }
        } else {
          parentDiv.innerHTML += html.querySelector('.swiper-pagination').outerHTML;
        }
        
        if (!zoomAction) return;
        zoomAction.innerHTML = parentDiv.outerHTML;
        zoomAction.drift = null;
      })
      .finally(() => {
        const sectionId = this.dataset.section;
        const playbackSettings = this.getMediaPlaybackSettings();
        const swipers = Array.from(
          new Set([
            this.productTarget?.querySelector('slide-with-thumbs'),
            document.querySelector(`slide-with-thumbs[data-section-id="${sectionId}"]`),
          ].filter(Boolean))
        );
        if (playbackSettings.autoplay && swipers.length > 0) {
          const videos = swipers.flatMap((swiperElement) =>
            Array.from(swiperElement.querySelectorAll('video'))
          );
          setTimeout(() => {
            videos.forEach((item) => {
              this.setLocalVideoPlayback(item, playbackSettings);
              item.currentTime = 0;
              
              const playPromise = item.play();
              if (playPromise !== undefined) {
                playPromise.catch(error => {
                  console.log(error);
                });
              }
            });
            
          }, 100);
        }
        swipers.forEach((swiperElement) => {
          this.syncGroupedThumbnailMedia(swiperElement, sectionId);
        });

        if (!zoomAction) return;
        if (zoom !== 'open_lightbox' && zoom !== 'no_zoom') {
          zoomAction.initDrift();
        }
        if (zoom === 'open_lightbox' && zoom !== 'no_zoom') {
          zoomAction.initLightBox();
        }
      })
      .catch((e) => {
        console.error(e);
      });
    } else {
      fetch(`/products/${productHandle}?section_id=media-gallery-grid`)
        .then((response) => response.text())
        .then((text) => {
          const html = parser.parseFromString(text, 'text/html');
          if (!html) return;
          const playbackSettings = this.getMediaPlaybackSettings();
          let parentDiv = document.createElement('div');
          if (desktopLayout === 'stack') {
            parentDiv.classList.add('stacked', 'grid', 'gap-10');
          }
          if (
            desktopLayout === 'grid_1_column' ||
            desktopLayout === 'grid_2_column'
          ) {
            parentDiv.classList.add('grid-cols', 'grid', 'gap');
          }
          if (
            desktopLayout === 'stack' ||
            desktopLayout === 'grid_1_column' ||
            desktopLayout === 'grid_2_column'
          ) {
            parentDiv.id = `GalleryViewer-${sectionId}`;
          }
          if (desktopLayout === 'grid_1_column') {
            parentDiv.setAttribute(
              'style',
              '--col-number: 1;--col-desktop: 1;--col-tablet: 1;--col-gap: 10px;'
            );
          }
          if (desktopLayout === 'grid_2_column') {
            parentDiv.setAttribute(
              'style',
              '--col-number: 2;--col-tablet: 2;--col-gap: 10px;'
            );
          }
          if (zoom === 'no_zoom') {
            const noZoomItems = html.querySelectorAll(
              'div.media-gallery__image:not([data-pane-container]), .media-gallery__local-video, .media-gallery__external-video, .media-gallery__model'
            );
            noZoomItems.forEach((item) => {
              const bracketContent = getMediaTagValue(item.dataset.alt || '');
              if (
                bracketContent === normalizedAltValue ||
                !allButtonValues.includes(bracketContent)
              ) {
                const mediaDefaultId = item.dataset.media;
                if (mediaDefaultId) {
                  item.setAttribute(
                    'data-media-id',
                    `${sectionId}-${mediaDefaultId}`
                  );
                }
                this.applyMediaPlaybackSettings(item, playbackSettings);
                parentDiv.innerHTML += item.outerHTML;
              }
            });
            if (elementFeatureProduct) {
              const wrapperGrid = this.productTarget.querySelector(
                `#GalleryViewer-${sectionId}`
              );
              wrapperGrid.innerHTML = parentDiv.innerHTML;
            }
          } else if (zoom !== 'open_lightbox') {
            const driftZoomItems = html.querySelectorAll(
              'div.media-gallery__image[data-pane-container], .media-gallery__local-video, .media-gallery__external-video, .media-gallery__model'
            );
            driftZoomItems.forEach((item) => {
              const bracketContent = getMediaTagValue(item.dataset.alt || '');
              if (
                bracketContent === normalizedAltValue ||
                !allButtonValues.includes(bracketContent)
              ) {
                const mediaDefaultId = item.dataset.media;
                if (mediaDefaultId) {
                  item.setAttribute(
                    'data-media-id',
                    `${sectionId}-${mediaDefaultId}`
                  );
                }
                this.applyMediaPlaybackSettings(item, playbackSettings);
                parentDiv.innerHTML += item.outerHTML;
              }
            });
          } else {
            const zoomItems = html.querySelectorAll(
              'a.media-gallery__image, .media-gallery__local-video, .media-gallery__external-video, .media-gallery__model'
            );
            zoomItems.forEach((item) => {
              const bracketContent = getMediaTagValue(item.dataset.alt || '');
              if (
                bracketContent === normalizedAltValue ||
                !allButtonValues.includes(bracketContent)
              ) {
                const mediaDefaultId = item.dataset.media;
                if (mediaDefaultId) {
                  item.setAttribute(
                    'data-media-id',
                    `${sectionId}-${mediaDefaultId}`
                  );
                }
                this.applyMediaPlaybackSettings(item, playbackSettings);
                parentDiv.innerHTML += item.outerHTML;
              }
            });
          }
          if (!zoomAction) return;
          zoomAction.innerHTML = parentDiv.outerHTML;
          zoomAction.drift = null;
        })
        .finally(() => {
          const galleryViewer = this.productTarget?.querySelector('[id^="GalleryViewer"]');
          this.syncGroupedGridMedia(galleryViewer, this.dataset.section);
          if (!zoomAction) return;
          if (zoom !== 'open_lightbox' && zoom !== 'no_zoom') {
            zoomAction.initDrift();
          }
          if (zoom === 'open_lightbox' && zoom !== 'no_zoom') {
            zoomAction.initLightBox();
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }
  getAllButtonValue() {
    const buttonArray = [];
    this.querySelectorAll(
      '.product__color-swatches--js, .product-sticky-js'
    ).forEach((btn) => {
      const rawValue =
        btn.dataset.value || btn.dataset.colorValue || btn.value || '';
      const normalizedValue = this.normalizeColorValue(rawValue);
      if (normalizedValue && !buttonArray.includes(normalizedValue)) {
        buttonArray.push(normalizedValue);
      }
    });
    return buttonArray;
  }
}
customElements.define('variant-group-detail', VariantGroupDetail);

class VariantRadiosSticky extends VariantRadiosDetail {
  constructor() {
    super();
  }
  groupFunctionsUnavailable(target) {
    if (this.isManualSelectionMode() && this.hasMissingSelections()) {
      this.clearVariantInput();
      const missingSelection = this.getMissingSelectionState();
      this.toggleAddButton(false, '', false);
      if (missingSelection) {
        this.applyVariantSelectionButtonPromptState(missingSelection.message);
      } else {
        this.clearVariantSelectionButtonPromptState();
      }
      this.setAvailable();
      return;
    }
    this.clearVariantSelectionButtonPromptState();
    this.toggleAddButton(true, '', true);
    this.setUnavailable(target);
  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `sticky-addcart-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
    const quantityLabel =
      Number.parseInt(
        productForm.querySelector('quantity-input')?.dataset.quantityLabel || '',
        10
      ) || 1;
    const existingPriceLabel = addButtonText?.querySelector('.price-label');
    const existingPrice = Number.parseInt(
      existingPriceLabel?.dataset?.price || '',
      10
    );
    let selectedVariantPrice = null;
    const selectedVariantScript = this.querySelector('script[data-selected-variant]');
    if (selectedVariantScript) {
      try {
        selectedVariantPrice = Number(
          JSON.parse(selectedVariantScript.textContent || '{}')?.price
        );
      } catch (error) {
        selectedVariantPrice = null;
      }
    }
    const variantPrice = Number.isFinite(this.currentVariant?.price)
      ? this.currentVariant.price
      : Number.isFinite(existingPrice)
        ? existingPrice
        : Number.isFinite(selectedVariantPrice)
          ? selectedVariantPrice
        : null;
    const moneyFormat =
      cartStrings?.money_default_format ||
      window.themeGlobalVariables?.settings?.money_default_format ||
      window.themeGlobalVariables?.settings?.money_format;
    const priceLabelClass = existingPriceLabel?.className || 'price-label';
    const priceCurrent =
      Number.isFinite(variantPrice) && moneyFormat
        ? `<span data-price="${variantPrice}" class="${priceLabelClass}">${Shopify.formatMoney(
            quantityLabel * variantPrice,
            moneyFormat
          )}</span>`
        : '';

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) {
        addButtonText.innerHTML = priceCurrent ? `${text} - ${priceCurrent}` : text;
      }
    } else {
      addButton.removeAttribute('disabled');
      const addToCartText = window.variantStrings?.addToCart || 'Add to Cart';
      addButtonText.innerHTML = priceCurrent
        ? `${addToCartText} - ${priceCurrent}`
        : addToCartText;
    }

    if (!modifyClass) return;
  }
  setUnavailable(target) {
    this.clearVariantSelectionButtonPromptState();
    const button = document.getElementById(
      `sticky-addcart-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(
      `Price-Per-Item-${this.dataset.section}`
    );
    const volumeNote = document.getElementById(
      `Volume-Note-${this.dataset.section}`
    );
    const volumeTable = document.getElementById(
      `Volume-${this.dataset.section}`
    );
    const qtyRules = document.getElementById(
      `Quantity-Rules-${this.dataset.section}`
    );

    this.syncFieldsetOptionValues(target);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }
}
customElements.define('variant-radios-sticky', VariantRadiosSticky);

class VariantGroupSticky extends VariantGroupDetail {
  constructor() {
    super();
  }
}
customElements.define('variant-group-sticky', VariantGroupSticky);

class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.hasExpired = false;
    this.hideOnExpiry = this.dataset.hideOnExpiry === 'true';
    this.timeoutMessage = this.dataset.timeoutMessage;
    this.format = this.dataset.format || 'dd:hh:mm:ss';
    this.interval = null;
    this.expiryTimeout = null;
    this.init();
  }

  disconnectedCallback() {
    requestAnimationFrame(() => {
      if (!this.isConnected) {
        this.clearTimers();
      }
    });
  }

  clearTimers() {
    clearInterval(this.interval);
    clearTimeout(this.expiryTimeout);
    this.interval = null;
    this.expiryTimeout = null;
  }

  init() {
    const cddl = this.dataset?.endtime;

    const minutesLeft = this.dataset.minutesLeft;
    const countdownAppend = this.querySelector('.countdown-inner');
    if (countdownAppend) {
      countdownAppend.innerHTML = this.appendChildHtml(minutesLeft).innerHTML;
    } else {
      this.innerHTML = this.appendChildHtml(minutesLeft).innerHTML;
    }

    const deadline = cddl ? this.parseEndTime(cddl) : null;
    this.mainFunction(deadline, minutesLeft);
  }

  mainFunction(endtime, minutesLeft) {
    let timeLeft = {};
    const calculateTimeLeft = (difference) => {
      let timeLeft = {};

      if (this.format.includes('dd')) {
        timeLeft.days_timer = Math.floor(difference / (1000 * 60 * 60 * 24));
      }

      if (this.format.includes('hh')) {
        if (this.format.includes('dd')) {
          timeLeft.hours_timer = Math.floor(
            (difference / (1000 * 60 * 60)) % 24
          );
        } else {
          timeLeft.hours_timer = Math.floor(difference / (1000 * 60 * 60));
        }
      }

      if (this.format.includes('mm')) {
        if (this.format === 'mm:ss') {
          timeLeft.minutes_timer = Math.floor(difference / 1000 / 60);
        } else {
          timeLeft.minutes_timer = Math.floor((difference / 1000 / 60) % 60);
        }
      }

      if (this.format.includes('ss')) {
        timeLeft.seconds_timer = Math.floor((difference / 1000) % 60);
      }

      return timeLeft;
    };

    if (endtime || minutesLeft) {
      let deadline = endtime;
      if (minutesLeft) {
        deadline = new Date(Date.now() + parseInt(minutesLeft) * 60000);
      }
      const updateCountdown = () => {
        const now = new Date();
        const difference = deadline - now;
        const hasTimeRemaining = difference > 0;
        if (hasTimeRemaining) {
          timeLeft = calculateTimeLeft(difference);
        } else {
          timeLeft = calculateTimeLeft(0);
        }

        if (hasTimeRemaining || (!this.timeoutMessage && !this.hideOnExpiry)) {
          Object.entries(timeLeft).forEach(([key, value]) => {
            if (this.querySelector('.' + key)) {
              this.querySelector('.' + key).innerHTML = value
                .toString()
                .padStart(2, '0');
            }
          });
          if (!hasTimeRemaining) {
            this.clearTimers();
          }
        } else if (this.timeoutMessage) {
          this.innerHTML = this.timeoutMessage;
          this.clearTimers();
        } else if (this.hideOnExpiry) {
          if (!this.hasExpired) {
            this.hasExpired = true;
            const announcementBar = this.closest('announcement-bar');
            const announcementBlock = this.closest('[data-announcement-block-id]');
            if (announcementBar?.expireAnnouncementBlock) {
              announcementBar.expireAnnouncementBlock(
                announcementBlock?.dataset.announcementBlockId
              );
            } else {
              const countdownWrapper =
                this.closest('.countdown-announcementBar') || this;
              countdownWrapper.classList.add('hidden');
            }
          }
          this.clearTimers();
          return;
        } else {
          this.clearTimers();
        }
        this.classList.remove('hidden');
        const badgesCountdown = this.closest('.product__badges-sale-countdown');
        if (badgesCountdown) {
          badgesCountdown.classList.remove('hidden');
          badgesCountdown.classList.add('inline-flex');
        }
      };
      this.interval = setInterval(updateCountdown, 1000);
      updateCountdown();
      const millisecondsUntilExpiry = deadline - new Date();
      if (
        (this.hideOnExpiry || this.timeoutMessage) &&
        millisecondsUntilExpiry > 0
      ) {
        this.expiryTimeout = setTimeout(
          updateCountdown,
          millisecondsUntilExpiry + 50
        );
      }
    } else {
      timeLeft = calculateTimeLeft(0);
      Object.entries(timeLeft).forEach(([key, value]) => {
        if (this.querySelector('.' + key)) {
          this.querySelector('.' + key).innerHTML = value
            .toString()
            .padStart(2, '0');
        }
      });
    }
  }

  appendChildHtml(minutesLeft) {
    const days = this.dataset?.days;
    const hours = this.dataset?.hours;
    const mins = this.dataset?.mins;
    const secs = this.dataset?.secs;
    const labelPrefix = this.dataset.compactLabels === 'true' ? '' : ' ';
    const container = document.createElement('div');
    container.innerHTML = `${
      !minutesLeft
        ? `${
            this.format.includes('dd')
              ? `<div class="countdown--container"><span class="days_timer count-timer"></span><span class="timer_announcementbar--text">${labelPrefix}${
                  days ? days : ''
                }</span></div>`
              : ''
          }${
            this.format.includes('hh')
              ? `<div class="countdown--container"><span class="hours_timer count-timer"></span><span class="timer_announcementbar--text">${labelPrefix}${
                  hours ? hours : ''
                }</span></div>`
              : ''
          }`
        : ''
    }<div class="countdown--container"><span class="minutes_timer count-timer"></span><span class="timer_announcementbar--text">${labelPrefix}${
      minutesLeft ? 'm' : mins ? mins : ''
    }</span></div><div class="countdown--container"><span class="seconds_timer count-timer"></span><span class="timer_announcementbar--text">${labelPrefix}${
      minutesLeft ? 's' : secs ? secs : ''
    }</span></div>`;
    return container;
  }
  parseEndTime(dateString) {
    const value = dateString.trim();
    const localDateFormats = [
      {
        regex: /^(\d{2})-(\d{2})-(\d{4})[ T](\d{2}):(\d{2}):(\d{2})$/,
        parts: ['month', 'day', 'year', 'hours', 'minutes', 'seconds'],
      },
      {
        regex: /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2}):(\d{2})$/,
        parts: ['year', 'month', 'day', 'hours', 'minutes', 'seconds'],
      },
    ];

    for (const { regex, parts } of localDateFormats) {
      const match = value.match(regex);
      if (match) {
        const dateParts = parts.reduce((result, part, index) => {
          result[part] = Number(match[index + 1]);
          return result;
        }, {});
        return this.createLocalDate(dateParts);
      }
    }

    const timestamp = Date.parse(value);
    return Number.isNaN(timestamp) ? null : new Date(timestamp);
  }

  createLocalDate({ year, month, day, hours, minutes, seconds }) {
    const date = new Date(year, month - 1, day, hours, minutes, seconds);
    const isValid =
      date.getFullYear() === year &&
      date.getMonth() === month - 1 &&
      date.getDate() === day &&
      date.getHours() === hours &&
      date.getMinutes() === minutes &&
      date.getSeconds() === seconds;

    return isValid ? date : null;
  }
}
customElements.define('countdown-timer', CountdownTimer);

// js for product form - not done yet
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends PopupBase {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (this.submitButton?.classList.contains('variant-selection-pending')) {
          this.submitButton.removeAttribute('disabled');
        }
        this.hideErrors = this.dataset.hideErrors === 'true';
        this.productItem =
          this.form.closest('.product-item') ||
          this.form.closest('sticky-add-cart');
        this.variantSelectionToast = null;
        this.variantSelectionToastTimer = null;
        this.variantScope = this.closest('.sec__featured-product') || document;
        this.variantScope.addEventListener(
          'change',
          this.onVariantSelectionChange.bind(this)
        );
        const initialSectionId = this.getVariantSectionId();
        if (initialSectionId) {
          syncSelectedVariantSummaries(this.variantScope, initialSectionId);
        }
      }

      getVariantSectionId() {
        const sectionId = this.dataset?.sectionId;
        if (sectionId !== undefined && sectionId !== null && `${sectionId}`.trim() !== '') {
          return `${sectionId}`.trim();
        }
        const rawFormId = this.form?.getAttribute('id');
        const formId = rawFormId == null ? '' : String(rawFormId);
        if (formId.indexOf('product-form-') === 0) {
          return formId.replace('product-form-', '');
        }
        if (formId.indexOf('sticky-addcart-form-') === 0) {
          return formId.replace('sticky-addcart-form-', '');
        }
        return null;
      }

      getFirstVisiblePicker(pickers = []) {
        const visiblePicker = pickers.find((picker) => {
          if (!picker) return false;
          const style = window.getComputedStyle(picker);
          return style.display !== 'none' && style.visibility !== 'hidden';
        });
        return visiblePicker || pickers[0] || null;
      }

      getManualSelectionPicker() {
        if (this.shouldSkipManualVariantValidation()) return null;
        const scope = this.closest('.sec__featured-product') || document;
        const sectionId = this.getVariantSectionId();
        if (sectionId) {
          const detailPickers = [
            ...scope.querySelectorAll(
              `variant-radios-detail[data-section="${sectionId}"], variant-group-detail[data-section="${sectionId}"]`
            ),
          ];
          if (detailPickers.length > 0) return this.getFirstVisiblePicker(detailPickers);

          const stickyPickers = [
            ...scope.querySelectorAll(
              `variant-radios-sticky[data-section="${sectionId}"], variant-group-sticky[data-section="${sectionId}"]`
            ),
          ];
          if (stickyPickers.length > 0) return this.getFirstVisiblePicker(stickyPickers);
        }

        const manualPickers = [
          ...scope.querySelectorAll(
            'variant-radios-detail[data-variant-selection-mode="manual"], variant-group-detail[data-variant-selection-mode="manual"], variant-radios-sticky[data-variant-selection-mode="manual"], variant-group-sticky[data-variant-selection-mode="manual"]'
          ),
        ];
        return this.getFirstVisiblePicker(manualPickers);
      }

      shouldSkipManualVariantValidation() {
        const rawFormId = this.form?.getAttribute('id');
        const formId = rawFormId == null ? '' : String(rawFormId);
        if (formId.indexOf('minicart-recommend-') === 0) return true;
        if (this.closest('minicart-recommendation-options')) return true;
        return false;
      }

      validateManualVariantSelection() {
        if (this.shouldSkipManualVariantValidation()) {
          return { valid: true };
        }
        const picker = this.getManualSelectionPicker();
        if (!picker || picker.dataset.variantSelectionMode !== 'manual') {
          return { valid: true };
        }
        const wrappers = [...picker.querySelectorAll('.product-form__input')];
        if (wrappers.length <= 1) return { valid: true };
        const firstMissing = wrappers.find(
          (wrapper) => !wrapper.querySelector('[data-variant-input]:checked')
        );
        if (!firstMissing) return { valid: true };
        const optionName = (firstMissing.querySelector('.bold')?.textContent || '')
          .replace(':', '')
          .trim();
        const chooseText = window.variantStrings?.pleaseChoose || 'Please Choose';
        const message = optionName ? `${chooseText} ${optionName}` : chooseText;
        return { valid: false, message, firstMissing };
      }

      clearVariantSelectionPrompt() {
        if (this.variantSelectionToastTimer) {
          clearTimeout(this.variantSelectionToastTimer);
          this.variantSelectionToastTimer = null;
        }
        const activeToast = this.variantSelectionToast;
        if (activeToast) {
          if (typeof closeToast === 'function') {
            closeToast(activeToast);
          } else {
            activeToast.remove();
          }
          this.variantSelectionToast = null;
        }
        document
          .querySelectorAll('#toast-container .variant-selection-toast')
          .forEach((node) => {
            if (node === activeToast) return;
            if (typeof closeToast === 'function') {
              closeToast(node);
            } else {
              node.remove();
            }
          });
        const scope = this.closest('.sec__featured-product') || document;
        scope
          .querySelectorAll('.variant-selection-error-message')
          .forEach((node) => node.remove());
        scope
          .querySelectorAll('.product-form__input.variant-selection-missing')
          .forEach((node) => node.classList.remove('variant-selection-missing'));
      }

      escapeHtml(value = '') {
        return String(value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');
      }

      getVariantPromptAnchor(fieldset) {
        if (!fieldset) return null;
        return (
          fieldset.querySelector('.form__label .bold') ||
          fieldset.querySelector('.form__label') ||
          fieldset
        );
      }

      showVariantSelectionPrompt(fieldset, message, delay = 0) {
        this.clearVariantSelectionPrompt();
        if (!fieldset || !message) return;
        const label = this.getVariantPromptAnchor(fieldset);
        fieldset.classList.add('variant-selection-missing');
        const toastMessage = `<div class="form__message error inline-flex align-center"><span class="product-form__error-message ml-5">${this.escapeHtml(message)}</span></div>`;
        const renderToast = () => {
          if (typeof showToast === 'function') {
            const positionOptions = { placement: 'right', offsetX: 12, offsetY: 0 };
            this.variantSelectionToast = showToast(
              toastMessage,
              3000,
              'modal-error variant-selection-toast',
              label,
              positionOptions
            );
            if (
              this.variantSelectionToast &&
              label instanceof Element &&
              typeof positionToastNearAnchor === 'function'
            ) {
              requestAnimationFrame(() => {
                if (this.variantSelectionToast?.isConnected) {
                  positionToastNearAnchor(
                    this.variantSelectionToast,
                    label,
                    positionOptions
                  );
                }
              });
              setTimeout(() => {
                if (this.variantSelectionToast?.isConnected) {
                  positionToastNearAnchor(
                    this.variantSelectionToast,
                    label,
                    positionOptions
                  );
                }
              }, 140);
            }
            return;
          }
          this.handleErrorMessagePopup(message);
        };
        if (delay > 0) {
          this.variantSelectionToastTimer = setTimeout(() => {
            renderToast();
            this.variantSelectionToastTimer = null;
          }, delay);
          return;
        }
        renderToast();
      }

      onVariantSelectionChange(event) {
        const sectionId = this.getVariantSectionId();
        const scope = this.variantScope || this.closest('.sec__featured-product') || document;
        if (sectionId) {
          requestAnimationFrame(() => {
            syncSelectedVariantSummaries(scope, sectionId);
          });
        }
        const picker = event.target?.closest(
          'variant-radios-detail, variant-group-detail, variant-radios-sticky, variant-group-sticky'
        );
        if (!picker || picker.dataset.variantSelectionMode !== 'manual') return;
        this.clearVariantSelectionPrompt();
      }

      waitForScrollSettled(timeout = 900, idleDelay = 120) {
        return new Promise((resolve) => {
          let idleTimer = null;
          let timeoutTimer = null;
          let resolved = false;
          const supportsScrollEnd = 'onscrollend' in window;

          const clearAll = () => {
            window.removeEventListener('scroll', onScroll);
            if (supportsScrollEnd) {
              window.removeEventListener('scrollend', onScrollEnd);
            }
            if (idleTimer) clearTimeout(idleTimer);
            if (timeoutTimer) clearTimeout(timeoutTimer);
          };

          const finish = () => {
            if (resolved) return;
            resolved = true;
            clearAll();
            resolve();
          };

          const scheduleIdleFinish = () => {
            if (idleTimer) clearTimeout(idleTimer);
            idleTimer = setTimeout(finish, idleDelay);
          };

          const onScroll = () => {
            scheduleIdleFinish();
          };

          const onScrollEnd = () => {
            finish();
          };

          window.addEventListener('scroll', onScroll, { passive: true });
          if (supportsScrollEnd) {
            window.addEventListener('scrollend', onScrollEnd);
          }
          timeoutTimer = setTimeout(finish, timeout);
          scheduleIdleFinish();
        });
      }

      async scrollToMissingOption(fieldset) {
        if (!fieldset) return;
        fieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });
        await this.waitForScrollSettled();
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.clearVariantSelectionPrompt();
        const selectionValidation = this.validateManualVariantSelection();
        if (!selectionValidation.valid) {
          await this.scrollToMissingOption(selectionValidation.firstMissing);
          this.showVariantSelectionPrompt(selectionValidation.firstMissing, selectionValidation.message);
          return;
        }
        this.submitButton.setAttribute('aria-disabled', true);
        const cartRecommend = document.querySelector('.cart-recommend');
        if (cartRecommend && cartRecommend.classList.contains('open')) {
          cartRecommend.classList.remove('open');
        }
        this.submitButton.classList.add('loading');
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const productInfo = this.form.closest('.product-detail__information');
        if (productInfo) {
          productInfo
            .querySelectorAll('product-property input')
            .forEach((property) => {
              if (property.classList.contains('file') && property.files[0]) {
                formData.append(property.name, property.files[0]);
              } else if (
                property.classList.contains('text') &&
                property.value
              ) {
                formData.append(property.name, property.value);
              }
            });
        }
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        const is_cart_page = document.body.classList.contains('template-cart');
        if (is_cart_page) {
          formData.append(
            'sections',
            this.getMainCartSectionRender().map((section) => section.id)
          );
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              if (this.productItem) {
                this.handleErrorMessagePopup(response.description);
              }
              return;
            } else if (response.sections) {
              if (!response.id && !response.items) {
                this.handleErrorMessagePopup(window.cartStrings.error);
                return;
              }
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            fetch('/cart.json')
              .then((res) => res.json())
              .then((cart) => {
                if (cart.item_count != undefined) {
                  document.querySelectorAll('.cart-count').forEach((el) => {
                    if (el.classList.contains('cart-count-drawer')) {
                      el.innerHTML = `(${cart.item_count})`;
                    } else {
                      el.innerHTML =
                        cart.item_count > 100 ? '~' : cart.item_count;
                    }
                  });
                  if (document.querySelector('header-total-price')) {
                    document
                      .querySelector('header-total-price')
                      .updateTotal(cart);
                  }
                }
              })
              .catch((error) => {
                throw error;
              });

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });
            const modalQuickview = document.querySelector(
              '.tingle-modal--visible.tingle-modal.quickview'
            );
            const modalShopableVideo = document.querySelector(
              '.tingle-modal--visible.tingle-modal.shopable-video'
            );
            const modalQuickviewMobile = document.querySelector(
              '.product-popup-mobile.product-quickview-mobile'
            );
            const shouldReturnToMinicartFromDiscover = Boolean(
              document.querySelector('.ss-cart-promotion-discover.is-open') &&
                (modalQuickview || modalQuickviewMobile)
            );
            if (modalQuickview || modalShopableVideo) {
              if (
                document.documentElement
                  .querySelector('body')
                  .classList.contains('tingle-enabled')
              ) {
                document.documentElement
                  .querySelector('body')
                  .classList.remove('tingle-enabled');
              }
              if (modalShopableVideo) {
                modalShopableVideo.remove();
              }
              if (modalQuickview) {
                modalQuickview.remove();
              }
            }
            const modal_mobile = document.querySelector('.product-popup-mobile');
            if (modal_mobile) {
              modal_mobile.classList.remove('open');
              document.querySelector('html').classList.remove('overflow-hidden');
              setTimeout(() => {
                modal_mobile.remove();
              }, 300);
            }
            const is_cart_page =
              document.body.classList.contains('template-cart');
            if (!is_cart_page) {
              if (!response.errors) {
                this.cart.renderContents(response);
                if (this.cart && this.cart.classList.contains('is-empty')) {
                  this.cart.classList.remove('is-empty');
                }
                this.cart.open();
                if (shouldReturnToMinicartFromDiscover) {
                  closeCartPromotionDiscoverPanels();
                }
              }
            } else {
              if (!response.errors) {
                this.getMainCartSectionRender().forEach((section) => {
                  if (section.selector != undefined) {
                    const elementToReplace =
                      document
                        .getElementById(section.id)
                        .querySelector(section.selector) ||
                      document.getElementById(section.id);
                    elementToReplace.innerHTML = this.getSectionInnerHTML(
                      response.sections[section.id],
                      section.selector
                    );
                  }
                });

                const totals = this.getSectionInnerHTML(
                  response.sections['main-cart-items'],
                  '.cart-info .totals'
                );
                const totals_content =
                  document.querySelector('.cart-info .totals');
                if (totals && totals_content) totals_content.innerHTML = totals;
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty'))
              this.cart.classList.remove('is-empty');
            this.submitButton.removeAttribute('aria-disabled');
            const cartRecommend = document.querySelector('.cart-recommend');
            if (
              cartRecommend &&
              !cartRecommend.classList.contains('hidden-recommend')
            ) {
              if (cartRecommend.classList.contains('cart-recommend-custom')) {
                const cartUpsellItem =
                  document.querySelectorAll('.cart-upsell-item');
                const cartUpsellSlide = document.querySelectorAll(
                  '.swiper-cart-upsell .swiper-slide'
                );
                if (cartUpsellItem.length > 0) {
                  setTimeout(function () {
                    cartRecommend.classList.add('open');
                  }, 800);
                } else if (cartUpsellSlide.length === 0) {
                  cartRecommend.classList.remove('block');
                  cartRecommend.classList.add('hidden');
                }
              } else {
                setTimeout(function () {
                  cartRecommend.classList.add('open');
                }, 800);
              }
            }
          });
      }

      getMainCartSectionRender() {
        return [
          {
            id: 'main-cart-items',
            section: document.getElementById('main-cart-items')?.dataset.id,
            selector: '.js-contents',
          },
        ];
      }

      getSectionInnerHTML(html, selector) {
        return new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector(selector).innerHTML;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      handleErrorMessagePopup(errorMessage = false) {
        const url = `${window.location.pathname}?section_id=form-message`;
        fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              'text/html'
            );
            const elementErrorMessage = html.querySelector(
              '.product-form__error-message-wrapper'
            );
            const elementMessage = elementErrorMessage.querySelector(
              '.product-form__error-message'
            );
            elementMessage.textContent = errorMessage;
            showToast(elementErrorMessage.innerHTML, 5000, 'modal-error');
          })
          .catch((e) => {
            throw e;
          });
      }
    }
  );
}

// js loadmor product for collection and section product grid
class Loadmore extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.collectionUrl = this.dataset.collectionUrl;
    this.sectionId = this.dataset.sectionId;
    this.all = this.dataset.allProducts;
    this.limit = this.dataset.limit;
    this.blockId = this.dataset.blockId;
    this.init();
  }
  init() {
    const _this = this;
    if (!this.button) return;
    this.button.addEventListener('click', function () {
      _this.scanData();
    });
  }
  scanData() {
    const _this = this;
    let url = this.dataset.url;
    if (!url) return;
    this.querySelector('button').classList.add('loading');
    fetch(this.collectionUrl + url + `&section_id=${this.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = parser.parseFromString(text, 'text/html');
        let parentDiv = this.closest('.sec__products-loadmore');
        if (!parentDiv) return;
        let elements,
          itemDiv,
          fetchDiv,
          page,
          times,
          limit,
          remainder,
          end_load;
        if (this.blockId) {
          itemDiv = parentDiv.querySelector(
            `.collection-tab-${this.blockId} .product-ajax__append`
          );
          fetchDiv = html.querySelector(
            `.sec__products-loadmore .collection-tab-${this.blockId} .product-ajax__append`
          );
          elements = fetchDiv.querySelectorAll('.grid-custom-item');
        } else {
          itemDiv = parentDiv.querySelector('.product-ajax__append');
          fetchDiv = html.querySelector(
            '.sec__products-loadmore .product-ajax__append'
          );
          elements = fetchDiv.querySelectorAll('.grid-custom-item');
        }
        if (!itemDiv || !fetchDiv) return;
        page = Number(this.dataset.url.replace('?page=', ''));
        times = page * this.limit;
        limit = this.limit;
        end_load = false;
        if (times >= this.all) {
          end_load = true;
          limit = this.limit - (times - this.all);
        }
        elements.forEach((prodNode, index) => {
          index = index + 1;
          if (end_load && limit < index) {
            return;
          }
          itemDiv.appendChild(prodNode);
        });
      })
      .finally(() => {
        _this.updateUrl(Number(this.dataset.url.replace('?page=', '')));
        this.querySelector('button')?.classList.remove('loading');
        BlsAnimations.innit();
        initLazyloadItem();
      })
      .catch((e) => {
        console.error(e);
      });
  }
  updateUrl(e) {
    if (this.all && this.limit && this.all > 0) {
      const times = ~~(this.all / this.limit);
      const remainder = this.all % this.limit;
      let pages = times;
      if (remainder > 0) {
        pages = times + 1;
      }
      if (e < pages) {
        this.dataset.url = '?page=' + ++e;
      } else {
        const btn = this.querySelector('button');
        if (btn) {
          btn.remove();
        }
      }
    }
  }

  handleCountItemToShow(pages) {
    if (this.all && this.limit && pages) {
      if (Number(this.all) < Number(this.limit) * pages) {
        const itemsNeedToRemove = Number(this.limit) * pages - Number(this.all);
        return itemsNeedToRemove;
      }
    }
    return 0;
  }
}
customElements.define('loadmore-function', Loadmore);

// js lookbook item
class LookbookItem extends HTMLElement {
  constructor() {
    super();
    this.itemPopup = this.querySelector('.lookbook-item__popup');
    this.type = this.dataset.type;
    this.position = this.dataset.productPosition;
    this.lookbookProductDiv = this.closest('.sec__lookbook-product');
    this.instagramShop = this.closest('.popup-content');
    this.allDots = this.closest('.sec__lookbook-product');
    this.init();
    document.body.addEventListener('click', this.onClickOutside.bind(this));
  }
  init() {
    if (this.type === 'open' || this.type === 'slide') {
      const atag = this.querySelector('a');
      if (!atag) return;
      atag.addEventListener('click', this.onClick.bind(this));
      const closeButton = this.querySelector('icon-close');
      if (!closeButton) return;
      closeButton.addEventListener('click', this.onClose.bind(this));
    }
  }
  onClickOutside(event) {
    if (!event.target.closest('lookbook-item')) {
      this.onClose();
    }
  }
  onClick() {
    if (this.type === 'open') {
      if (this.itemPopup) {
        const thisSection = this.closest('section');
        if (!thisSection) return;
        const allPopups = thisSection.querySelectorAll('.lookbook-item__popup');
        if (window.innerWidth >= 1024) {
          allPopups.forEach((popup) => {
            if (popup !== this.itemPopup) {
              popup.classList.add('invisible');
              const thisClosest = popup.closest('lookbook-item');
              if (thisClosest) {
                thisClosest.classList.remove('open');
              }
            }
          });
          this.onToggle();
        } else {
          const modal = new tingle.modal({
            footer: false,
            stickyFooter: false,
            closeMethods: ['overlay', 'button', 'escape'],
            closeLabel: 'Close',
            cssClass: ['lookbook-modal'],
            onOpen: function () {},
            onClose: function () {},
            beforeClose: function () {
              return true;
            },
          });
          modal.setContent(
            this.itemPopup.querySelector('.product-item').innerHTML
          );
          modal.open();
        }
      }
    } else {
      if (this.lookbookProductDiv && this.position) {
        const slideSEction = this.lookbookProductDiv.querySelector(
          'slide-section-lookbook'
        );
        const allDots = this.lookbookProductDiv.querySelectorAll(
          `lookbook-item[data-type="slide"]`
        );
        allDots.forEach((dot) => {
          dot.classList.remove('active');
        });
        this.classList.add('active');
        if (slideSEction) {
          slideSEction.functionGoto(this.position);
        }
      } else if (this.instagramShop && this.position) {
        const slideSEction = this.instagramShop.querySelector(
          'slide-section-instagram'
        );
        if (slideSEction) {
          slideSEction.functionGoto(this.position);
        }
      }
    }
  }
  onToggle() {
    this.itemPopup?.classList.toggle('invisible');
    this.classList.toggle('open');
  }
  onClose() {
    this.itemPopup?.classList.add('invisible');
    this.classList.remove('open');
  }
}
customElements.define('lookbook-item', LookbookItem);

// js lookbook item
class SectionSlideLookbook extends SlideSection {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.initSlide();
  }
  functionGoto(position) {
    this.globalSlide.slideTo(position - 1, 500);
  }
}
customElements.define('slide-section-lookbook', SectionSlideLookbook);

class SectionSlideInstagramShop extends SlideSection {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.initSlide();
  }
  functionGoto(position) {
    this.globalSlide.slideTo(position - 1, 500);
  }
}
customElements.define('slide-section-instagram', SectionSlideInstagramShop);

// js for tab item
class TabItems extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll('.collection-tab__tab-item');
    this.select = this.querySelector('.select-collection-tab');
    this.content = this.querySelectorAll('.collection-tab__tab-content');
    this.select_li = this.querySelectorAll('.collection_title_input');
    this.type = this.dataset.type;
    this.init();
  }
  init() {
    if (this.type === 'horizontal' || this.type === 'image') {
      const self = this;
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', function () {
          self.onClick(this);
        });
      });
    } else {
      const self = this;
      this.select.addEventListener('click', function (e) {
        if (e.target.classList.contains('select__selected_title')) {
          let select__dropdown = this.querySelector('.select-custom__content');
          this.classList.toggle('active');
          select__dropdown.classList.toggle('invisible');
        }
      });
      document.addEventListener('click', function (event) {
        if (!event.target.closest('.select-collection-tab')) {
          self.select.classList.remove('active');
          document
            .querySelectorAll('.select-collection-tab .select-custom__content')
            ?.forEach((item) => {
              item.classList.add('invisible');
            });
        }
      });
      this.select_li.forEach((item) => {
        item.addEventListener('click', function () {
          self.onClickBySelect(this);
          self.select.classList.remove('active');
          document
            .querySelectorAll('.select-collection-tab .select-custom__content')
            ?.forEach((item) => {
              item.classList.add('invisible');
            });
        });
      });
    }
  }
  onClick(tab) {
    const blockId = tab.dataset.blockId;
    this.showContent(blockId);
    this.tabs.forEach((t) => {
      t.classList.remove('active');
    });
    tab.classList.add('active');
  }

  onClickBySelect(selectedBlockId) {
    let select__selected_title = this.querySelector('.select__selected_title');
    select__selected_title.innerHTML =
      selectedBlockId.innerHTML +
      `<svg class="icon-down transition active-rotated" width="10" height="6">
    <use href="#icon-arrow-down"></use>
  </svg>`;
    this.showContent(selectedBlockId.dataset.id);
  }

  showContent(blockId) {
    this.content.forEach((content) => {
      if (content.dataset.blockId === blockId) {
        content.classList.add('active');
      } else {
        content.classList.remove('active');
      }
    });
  }
}
customElements.define('tab-items', TabItems);

// js for shopable video
class ShopableVideo extends PopupBase {
  constructor() {
    super();
    this.popupDiv = this.querySelector('.video-item__popup');
    this.init();
  }
  init() {
    if (!this.classList.contains('instagram-item')) {
      window.addEventListener('resize', this.responsive.bind(this));
      window.addEventListener('load', this.responsive.bind(this));
      this.addEventListener('click', this.onClick.bind(this));
      this.connectedCallback();
    }
  }
  onClick() {
    if (this.querySelector('.video-item__popup')) {
      this.popupDiv = this.querySelector('.video-item__popup');
      var html = this.querySelector('.video-item__popup');
      const popup = document.querySelector('.tingle-modal.shopable-video');
      if (!html || popup) return;
      setTimeout(() => {
        html.classList.remove('hidden');
        this.initPopup(html);
      }, 250);
    } else {
      if (this.classList.contains('instagram-item')) {
        const sectionId = this.dataset.sectionId;
        const index = this.dataset.index;
        const url = `${window.location.pathname}?section_id=${sectionId}&ajax=1`;
        var _this = this;
        fetch(`${url}`)
          .then((response) => {
            if (!response.ok) {
              var error = new Error(response.status);
              throw error;
            }
            return response.text();
          })
          .then((responseText) => {
            const newSection = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector(`.popup-index-${index}`);
            _this.appendChild(newSection);
          })
          .catch((error) => {
            throw error;
          })
          .finally(() => {
            const html = _this.querySelector('.popup-content');
            if (html) {
              pinMinicartProductListActions(html);
              html.classList.remove('hidden');
              this.initPopup(html);
            }
          });
      }
    }
  }
  onCloseEvent() {
    const popup = document.querySelector('.tingle-modal.shopable-video');
    if (!popup) return;
    const productInformation = popup.querySelector(
      '.shopable-video__product-information'
    );
    this.popupDiv.querySelector('video').pause();
    this.popupDiv.querySelector('video').muted = true;
    this.popupDiv.classList.add('hidden');
    this.popupDiv.querySelector('.wrapper-content-append').innerHTML = '';
    this.appendChild(this.popupDiv);
    if (!productInformation) return;
    productInformation.classList.add('hidden');
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      const videos = this.querySelectorAll('video');
      videos.forEach((video) => {
        const dataSrc = video.dataset.src;
        if (dataSrc) {
          video.src = dataSrc;
          video.removeAttribute('data-src');
        }
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 200px 0px',
    }).observe(this);
  }
  responsive() {
    const productDivs = document.querySelectorAll(
      '.shopable-video__product-information'
    );
    if (productDivs.length != 0) {
      if (window.innerWidth >= 768) {
        const flexDiv = this.querySelector('.video-item__popup')?.querySelector(
          '.video-item__popup--flex'
        );
        if (!flexDiv) return;
        productDivs.forEach((div) => {
          div.classList.remove('hidden');
        });
      } else {
        const flexDiv = this.querySelector('.video-item__popup')?.querySelector(
          '.video-item__popup--flex'
        );
        if (!flexDiv) return;
        productDivs.forEach((div) => {
          div.classList.add('hidden');
        });
      }
    }
  }
}
customElements.define('shopable-video', ShopableVideo);

// js for shopable video
class InstagramShop extends ShopableVideo {
  constructor() {
    super();
    this.popupDiv = this.querySelector('.popup-content');
    if (this.popupDiv || this.classList.contains('instagram-item')) {
      this.addEventListener('click', this.onClick.bind(this));
    }
  }
}
customElements.define('instagram-shop', InstagramShop);

// js for instagram shop
class InstagramSection extends HTMLElement {
  constructor() {
    super();
    this.accessToken = this.dataset.accessToken;
    this.type = this.dataset.type;
    this.ratio = this.dataset.ratio;
    this.init();
  }
  async init() {
    if (this.accessToken) {
      const resp = await this.fetchDataInstagram(
        `https://graph.instagram.com/me/media?fields=caption,id,media_type,media_url,permalink,thumbnail_url,timestamp,username&access_token=${this.accessToken}`
      );
      if (!resp) return;

      if (resp.error) {
        return console.error('Instagram error: ', resp.error?.message);
      }
      if (this.type === 'carousel') {
        this.generateCarousel(resp.data, this.ratio);
      } else {
        this.generateGrid(resp.data, this.ratio);
      }
    }
  }

  fetchDataInstagram(fetchUrl) {
    const map = new Map();
    return new Promise((resolve, reject) => {
      if (map.get(fetchUrl)) {
        return resolve(map.get(fetchUrl));
      }
      fetch(fetchUrl, {
        cache: 'force-cache',
      })
        .then((res) => {
          if (res.ok) {
            const json = res.json();
            resolve(json);
            map.set(fetchUrl, json);
            return json;
          } else {
            reject(res);
          }
        })
        .catch(reject);
    });
  }

  generateCarousel(items, ratio) {
    const wrapper = this.querySelector('.swiper-wrapper');
    if (wrapper) {
      let html = '';
      items.forEach((item) => {
        if (item.media_type === 'VIDEO') {
          html += `<a href="${item.permalink}" aria-label="${item.caption}" class="swiper-slide">
                                <div class="instagram-item__media--ratio" style="--aspect-ratio: ${ratio};">
                                    <video loop="true" muted="true" playsinline="true" autoplay="true" src="${item.media_url}"></video>
                                </div>
                            </a>`;
        } else {
          html += `<a href="${item.permalink}" aria-label="${item.caption}" class="swiper-slide">
                                <div class="instagram-item__media--ratio" style="--aspect-ratio: ${ratio};">
                                    <img src="${item.media_url}" srcset="${item.media_url}&amp;width=720 720w, ${item.media_url}&amp;width=660 660w, ${item.media_url}&amp;width=550 550w, ${item.media_url}&amp;width=480 480w, ${item.media_url}&amp;width=360 360w" width="1000" height="1000" loading="lazy" sizes="(min-width: 1200px) calc((100vw - 0px * 0) * 1), (min-width: 768px) calc( (100vw - 0px * 0 ) * 1), calc( (100vw - 0 * 0 ) * 1)" alt="${item.caption}">
                                </div>
                            </a>`;
        }
      });
      wrapper.innerHTML = html;
    }
  }

  generateGrid(items, ratio) {
    const wrapper = this.querySelector('.instagram--grid');
    if (wrapper) {
      let html = '';
      items.forEach((item) => {
        if (item.media_type === 'VIDEO') {
          html += `<a href="${item.permalink}" aria-label="${item.caption}">
                                <div class="instagram-item__media--ratio" style="--aspect-ratio: ${ratio};">
                                    <video loop="true" muted="true" playsinline="true" autoplay="true" src="${item.media_url}"></video>
                                </div>
                            </a>`;
        } else {
          html += `<a href="${item.permalink}" aria-label="${item.caption}">
                                <div class="instagram-item__media--ratio" style="--aspect-ratio: ${ratio};">
                                    <img src="${item.media_url}" srcset="${item.media_url}&amp;width=720 720w, ${item.media_url}&amp;width=660 660w, ${item.media_url}&amp;width=550 550w, ${item.media_url}&amp;width=480 480w, ${item.media_url}&amp;width=360 360w" width="1000" height="1000" loading="lazy" sizes="(min-width: 1200px) calc((100vw - 0px * 0) * 1), (min-width: 768px) calc( (100vw - 0px * 0 ) * 1), calc( (100vw - 0 * 0 ) * 1)" alt="${item.caption}">
                                </div>
                            </a>`;
        }
      });
      wrapper.innerHTML = html;
    }
  }
}
customElements.define('instagram-section', InstagramSection);

// js for grid custom
class GridCustom extends SlideSection {
  constructor() {
    super();
    this.enable = this.dataset.enable;
    this.parentElementt = document.querySelector(
      `#shopify-section-${this.dataset?.sectionId}`
    );
    this.loadmore = this.parentElementt?.querySelectorAll('loadmore-function');
    this.viewAll = this.parentElementt?.querySelector('.view_all');
    this.swiperSlideInnerHtml = this.innerHTML;
    this.init();
  }
  init() {
    if (this.enable == 'true') {
      let width = window.innerWidth;
      window.addEventListener('resize', () => {
        const newWidth = window.innerWidth;
        if (newWidth <= 767 && width > 767) {
          this.actionOnMobile();
        }
        if (newWidth > 767 && width <= 767) {
          this.actionOutMobile();
        }
        width = newWidth;
      });
      if (width <= 767) {
        this.actionOnMobile();
      }
    }
  }
  actionOnMobile() {
    this.classList.add('swiper');
    this.classList.remove('grid', 'grid-cols');
    if (this.viewAll) {
      this.viewAll.classList.add('hidden');
    }
    if (this.loadmore && this.loadmore.length > 0) {
      this.loadmore.forEach((button) => {
        button.classList.add('hidden');
        button.classList.remove('block');
      });
    }
    const html = this.swiperSlideInnerHtml.replaceAll(
      'grid-custom-item',
      'swiper-slide'
    );
    const wrapper = `<div class='swiper-wrapper'>${html}</div> <div
    class="swiper-pagination  ${
      this.enable && this.dataset.mobile != 1.5 ? 'flex' : 'hidden'
    } px-15 lh-1 bottom-30 justify-content-center"
    style="--swiper-pagination-bottom: 3rem;--swiper-pagination-position: static;"
  ></div> `;
    this.innerHTML = wrapper;
    this.initSlide();
  }
  actionOutMobile() {
    this.classList.remove('swiper');
    this.classList.add('grid', 'grid-cols');
    if (this.viewAll) {
      this.viewAll.classList.remove('hidden');
    }
    this.innerHTML = this.swiperSlideInnerHtml;
    if (this.loadmore && this.loadmore.length > 0) {
      this.loadmore.forEach((button) => {
        button.classList.add('block');
        button.classList.remove('hidden');
      });
    }
  }
}
customElements.define('grid-custom', GridCustom);

// js for slide with thumbnails
class SlideWithThumbs extends HTMLElement {
  constructor() {
    super();
    this.globalSlide = null;
    this.thumbnailSlide = null;
    this.isInitialized = false;
    this.initScheduled = false;
  }

  connectedCallback() {
    if (this.isInitialized || this.initScheduled) return;
    this.initScheduled = true;
    queueMicrotask(() => {
      this.initScheduled = false;
      if (!this.isConnected || this.isInitialized) return;
      this.isInitialized = true;
      this.init();
    });
  }

  parseNumericValue(value, fallback) {
    const parsedValue = Number.parseFloat(value);
    return Number.isFinite(parsedValue) ? parsedValue : fallback;
  }

  getActiveThumbIndex(targetIndex = null) {
    if (Number.isFinite(targetIndex)) {
      return Math.max(0, targetIndex);
    }
    if (!this.globalSlide) return 0;
    if (Number.isFinite(this.globalSlide.realIndex)) {
      return Math.max(0, this.globalSlide.realIndex);
    }
    return Math.max(0, this.globalSlide.activeIndex || 0);
  }

  getThumbnailVisibleCount() {
    if (!this.thumbnailSlide) return 1;
    const slidesPerView = this.parseNumericValue(
      this.thumbnailSlide.params?.slidesPerView,
      1
    );
    return Math.max(1, Math.floor(slidesPerView));
  }

  syncActiveThumbVisibility(targetIndex = null, force = false) {
    if (!this.thumbnailSlide || this.thumbnailSlide.destroyed) return;
    const thumbDirection = this.dataset.thumbDirection || 'horizontal';
    if (window.innerWidth < 768 || thumbDirection !== 'vertical') return;
    const resolvedTargetIndex = this.getActiveThumbIndex(targetIndex);
    const visibleCount = this.getThumbnailVisibleCount();
    const currentStartIndex = this.thumbnailSlide.activeIndex || 0;
    const currentEndIndex = currentStartIndex + visibleCount - 1;
    const totalSlides = this.thumbnailSlide.slides?.length || 0;
    const maxStartIndex = Math.max(totalSlides - visibleCount, 0);
    const isOutsideViewport =
      resolvedTargetIndex < currentStartIndex ||
      resolvedTargetIndex > currentEndIndex;

    if (!force && !isOutsideViewport) return;

    const nextIndex = Math.min(resolvedTargetIndex, maxStartIndex);
    this.thumbnailSlide.slideTo(nextIndex, 300);
  }

  init() {
    const nothumb = this.dataset?.nothumb;
    if (!nothumb) {
      this.initThumbnail();
      if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', () =>
          this.initThumbnail()
        );
      }
    }

    this.initSlide();
    this.playAllMedia();
  }

  getLoopRequirement(slidesPerView, centeredSlides = false, slidesPerGroup = 1) {
    if (slidesPerView === 'auto') return null;
    let visibleSlides = Math.ceil(parseFloat(slidesPerView));
    if (!Number.isFinite(visibleSlides) || visibleSlides < 1) {
      visibleSlides = 1;
    }
    if (centeredSlides && visibleSlides % 2 === 0) {
      visibleSlides += 1;
    }
    let groupedSlides = Math.ceil(parseFloat(slidesPerGroup));
    if (!Number.isFinite(groupedSlides) || groupedSlides < 1) {
      groupedSlides = 1;
    }
    return visibleSlides + groupedSlides;
  }

  canUseLoop(totalSlides, loopConfigs = []) {
    if (totalSlides <= 1) return false;
    const requirements = loopConfigs
      .map(({ slidesPerView, centeredSlides = false, slidesPerGroup = 1 }) =>
        this.getLoopRequirement(slidesPerView, centeredSlides, slidesPerGroup)
      )
      .filter(Number.isFinite);
    if (requirements.length === 0) {
      return totalSlides > 1;
    }
    return totalSlides >= Math.max(...requirements);
  }

  initSlide() {
    var autoplaying = this?.dataset.autoplay === 'true';
    const loop = this?.dataset.loop === 'true';
    const itemMobile = this?.dataset.mobile ? this?.dataset.mobile : 1;
    const itemMobileNumber = Number(itemMobile);
    const mobilePeek = Number.isFinite(itemMobileNumber) && itemMobileNumber > 1;
    var direction = this?.dataset.direction
      ? this?.dataset.direction
      : 'horizontal';
    var autoplaySpeed = this?.dataset.autoplaySpeed
      ? this?.dataset.autoplaySpeed * 1000
      : 3000;
    var speed = this?.dataset.speed ? this?.dataset.speed : 400;
    const effect = this?.dataset.effect ? this?.dataset.effect : 'slide';
    var spacing = this?.dataset.spacing ? this?.dataset.spacing : 30;
    const autoItem = this?.dataset.itemMobile === 'true';
    const itemDesktop = this?.dataset.desktop ? this?.dataset.desktop : 2;
    spacing = Number(spacing);
    autoplaySpeed = Number(autoplaySpeed);
    speed = Number(speed);
    const slideWithThumbs = this;
    if (autoplaying) {
      autoplaying = { delay: autoplaySpeed };
    }
    if (window.innerWidth < 767) {
      direction = 'horizontal';
    }
    const container = this.querySelector('.main-slide__navigation');
    const initSwiper = this.querySelector('.swiper-wrapper-preview');
    const totalSlides = initSwiper?.querySelectorAll('.swiper-wrapper > .swiper-slide').length || 0;
    const enableLoop =
      loop &&
      this.canUseLoop(totalSlides, [
        {
          slidesPerView: itemMobile,
          centeredSlides: mobilePeek,
        },
        {
          slidesPerView: autoItem ? 'auto' : itemDesktop,
        },
      ]);

    this.globalSlide = new Swiper(initSwiper, {
      slidesPerView: itemMobile,
      spaceBetween: spacing >= 15 ? 15 : spacing,
      centeredSlides: mobilePeek,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      autoplay: autoplaying,
      direction: direction,
      loop: enableLoop,
      effect: effect,
      speed: speed,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      navigation: {
        nextEl: container?.querySelector('.swiper-button-next'),
        prevEl: container?.querySelector('.swiper-button-prev'),
      },
      pagination: {
        clickable: true,
        el: this.querySelector('.swiper-pagination'),
        type: 'custom',
        renderCustom: function (swiper, current, total) {
          return current + '/' + total;
        },
      },
      breakpoints: {
        768: {
          slidesPerView: autoItem ? 'auto' : itemDesktop,
          centeredSlides: false,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
        }
      },
      on: {
        init: function () {
          if (initSwiper.closest('.main-product__no-group')) {
            initSwiper.closest('.main-product__no-group').style.opacity = '1';
            requestAnimationFrame(() => {
              window.dispatchEvent(new Event('resize'));
            });
          }
          requestAnimationFrame(() => {
            slideWithThumbs.syncActiveThumbVisibility(null, true);
          });
          const currentSlide = this.slides[this.activeIndex];
          if (
            currentSlide &&
            currentSlide.classList.contains('cloudimage-360')
          ) {
            this.allowTouchMove = false;
          } else {
            this.allowTouchMove = true;
          }
        },
        slideChange: function () {
          slideWithThumbs.syncActiveThumbVisibility();
          const currentSlide = this.slides[this.activeIndex];
          if (currentSlide) {
            if (
              currentSlide.classList.contains('media-gallery__model') ||
              currentSlide.classList.contains('cloudimage-360')
            ) {
              this.allowTouchMove = false;
            } else {
              this.allowTouchMove = true;
            }
          }
        },
      },
      thumbs: {
        swiper: this.thumbnailSlide ? this.thumbnailSlide : null,
      },
    });
  }

  initThumbnail() {
    const container = this.querySelector('.thumbnail-slide');
    if (!container) return;
    var direction = this.dataset.thumbDirection
      ? this.dataset.thumbDirection
      : 'horizontal';
    const thumbSlidesPerView = this.parseNumericValue(
      this.dataset.thumbSlidesPerView,
      4
    );
    const spaceBetween = this.parseNumericValue(
      this.dataset.thumbSpaceBetween,
      10
    );
    const watchSlidesVisibility =
      this.dataset.thumbWatchSlidesVisibility != null
        ? this.dataset.thumbWatchSlidesVisibility === 'true'
        : true;
    const watchOverflow =
      this.dataset.thumbWatchOverflow != null
        ? this.dataset.thumbWatchOverflow === 'true'
        : true;
    this.thumbnailSlide = new Swiper(container, {
      direction: 'horizontal',
      spaceBetween: spaceBetween,
      slidesPerView: 5,
      watchSlidesVisibility: watchSlidesVisibility,
      watchSlidesProgress: true,
      watchOverflow: watchOverflow,
      breakpoints: {
        768: {
          direction: direction,
          slidesPerView: direction == 'vertical' ? thumbSlidesPerView : 6,
        },
      },
    });
  }

  playAllMedia() {
    const self = this;
    this.globalSlide.on('slideChange', function () {
      self.playMedia();
    });
  }

  playMedia() {
    const autoplay = this?.dataset.autoPlayVideo === 'true';
    if (!autoplay) return;
    // Load Vimeo API
    var vimeoTag = document.createElement('script');
    vimeoTag.src = 'https://player.vimeo.com/api/player.js';
    document.head.appendChild(vimeoTag);
    this.globalSlide.on('slideChangeTransitionEnd', function () {
      var activeSlide = this.slides[this.activeIndex];
      var video = activeSlide.querySelector('.media-video');
      if (video) {
        if (video.tagName === 'VIDEO') {
          video.play();
        } else if (video.tagName === 'IFRAME') {
          // Play Vimeo
          if (video.src.includes('vimeo')) {
            var vimeoPlayer = new Vimeo.Player(video);
            vimeoPlayer.play();
          }
          // Play YouTube
          if (video.src.includes('youtube')) {
            video.contentWindow.postMessage(
              '{"event":"command","func":"playVideo","args":""}',
              '*'
            );
          }
        }
      }
    });
  }

  playActiveSlideVideo(swiper) {}

  functionGoto(position) {
    if (!this.globalSlide) return;
    this.syncActiveThumbVisibility(position);
    if (this.globalSlide.params?.loop && typeof this.globalSlide.slideToLoop === 'function') {
      this.globalSlide.slideToLoop(position, 0);
      return;
    }
    this.globalSlide.slideTo(position, 0);
  }

  updateSlide() {
    if (!this.globalSlide) return;
    this.globalSlide.update();
    this.syncActiveThumbVisibility();
  }

  updateThumbSlide() {
    if (!this.thumbnailSlide) return;
    this.thumbnailSlide.update();
    requestAnimationFrame(() => {
      this.syncActiveThumbVisibility(null, true);
    });
  }

  appendSlide(item) {
    this.globalSlide.appendSlide(item);
  }
}
customElements.define('slide-with-thumbs', SlideWithThumbs);

class ProductRecentlyViewed extends SlideSection {
  constructor() {
    super();
  }
  init() {
    this.connectedCallback();
  }
  initData() {
    var savedProductsArr = JSON.parse(
      localStorage.getItem('glozin__recently-viewed-products')
    );
    this.getStoredProducts(savedProductsArr);
  }
  getStoredProducts(p) {
    const limit = this.dataset?.limit;

    if (limit) {
      var query = '';
      var productAjaxURL = '';

      if (p && p.length > 0) {
        const sortedIds = p.slice();
        const idsToUse = sortedIds.slice(0, limit);
        query = idsToUse.join('%20OR%20id:');
        productAjaxURL = `&q=id:${query}`;
      }
    }
    fetch(`${this.dataset.url}${productAjaxURL}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recentlyViewedProducts = html.querySelector(
          'recently-viewed-products'
        );
        if (
          recentlyViewedProducts &&
          recentlyViewedProducts.innerHTML.trim().length
        ) {
          this.innerHTML = recentlyViewedProducts.innerHTML;
        }
        if (recentlyViewedProducts.innerHTML.trim().length === 0) {
          this.remove();
        }
      })
      .finally(() => {
        if (this.querySelector('.swiper-wrapper')) {
          this.initSlide();
        }
        initLazyloadItem();
      })
      .catch((e) => {
        console.error(e);
      });
  }
  connectedCallback() {
    const __this = this;
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      __this.initData();
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 400px 0px',
    }).observe(this);
  }
}
customElements.define('recently-viewed-products', ProductRecentlyViewed);

class ProductRecentlyViewedGrid extends HTMLElement {
  constructor() {
    super();
    this.initData();
  }
  initData() {
    var savedProductsArr = JSON.parse(
      localStorage.getItem('glozin__recently-viewed-products')
    );
    this.getStoredProducts(savedProductsArr);
  }
  getStoredProducts(p) {
    var query = '';
    var productAjaxURL = '';
    const rv_div = this;

    if (p && p.length > 0) {
      p.forEach((e, key, rv_items) => {
        if (!Object.is(rv_items.length - 1, key)) {
          query += e + "%20OR%20id:";
        } else {
          query += e;
        }
      });
    }

    const sectionId = this.dataset.sectionId
    productAjaxURL = "?section_id=" +
    sectionId +
          "&type=product&options[unavailable_products]=last&q=id:" +
          query;

    fetch(`${window.routes.search_url}${productAjaxURL}`)
      .then((response) => response.text())
      .then((text) => {
        const _this = this;
        const html = parser.parseFromString(text, "text/html");
        const results = document.createElement("div");
        results.classList.add("rv-results-tab");
        const exist_results = _this.querySelector(".rv-results-tab");
        if (exist_results) {
          exist_results.remove();
        }
        const er = html.querySelector(".products-recently-viewed-tab > .rv-results-tab");
        if (p && p.length !== 0 && er) {
          _this.innerHTML = html.querySelector(".products-recently-viewed-tab").innerHTML;
        } else {
          const emptyClass = _this.classList.contains('customer-account-sheet__recently-viewed')
            ? 'customer-account-sheet__empty text-center'
            : 'text-center';
          _this.innerHTML = `<p class="${emptyClass}">${window.recently.noProduct}</p>`;
        }

      })
      .finally(() => {
        initAccountSheetProductSwipers(this);
        initLazyloadItem();
      })
      .catch((e) => {
        console.error(e);
      });
  }
}
customElements.define('recently-viewed-products-grid', ProductRecentlyViewedGrid);

class WishlistTab extends HTMLElement {
  constructor() {
    super();
    this.initData();
  }
  initData() {
    var savedProductsArr = JSON.parse(
      localStorage.getItem('glozin__wishlist-items')
    );
    this.getStoredProducts(savedProductsArr);
  }
  getStoredProducts(p) {
    var query = '';
    var productAjaxURL = '';

    if (p && p.length > 0) {
      p.forEach((e, key, rv_items) => {
        if (!Object.is(rv_items.length - 1, key)) {
          query += e + "%20OR%20id:";
        } else {
          query += e;
        }
      });
    }

    const sectionId = this.dataset.sectionId
    productAjaxURL = "?section_id=" +
    sectionId +
          "&type=product&options[unavailable_products]=last&q=id:" +
          query;

    fetch(`${window.routes.search_url}${productAjaxURL}`)
      .then((response) => response.text())
      .then((text) => {
        const _this = this;
        const html = parser.parseFromString(text, "text/html");
        const results = document.createElement("div");
        results.classList.add("wishlist-results-tab");
        const exist_results = _this.querySelector(".wishlist-results-tab");
        if (exist_results) {
          exist_results.remove();
        }
        const er = html.querySelector(".products-wishlist-tab > .wishlist-results-tab");
        if (p?.length !== 0 && er) {
          _this.innerHTML = html.querySelector(".products-wishlist-tab").innerHTML;
        } else {
          const emptyClass = _this.classList.contains('customer-account-sheet__wishlist')
            ? 'customer-account-sheet__empty text-center'
            : 'text-center';
          _this.innerHTML = `<p class="${emptyClass}">${window.recently.noProductWishlist}</p>`;
        }

      })
      .finally(() => {
        initAccountSheetProductSwipers(this);
        initLazyloadItem();
      })
      .catch((e) => {
        console.error(e);
      });
  }
}
customElements.define('wishlist-tab', WishlistTab);

// js gallery
class MediaGallery extends HTMLElement {
  constructor() {
    super();
  }
  setActiveMedia(mediaId) {
    const galleryViewer = this.querySelector('[id^="GalleryViewer"]');
    if (!galleryViewer) return;
    const activeMedia = galleryViewer.querySelector(`[data-media-id="${mediaId}"]`);
    if (!activeMedia) return;
    galleryViewer.querySelectorAll('[data-media-id]').forEach((element) => {
      element.classList.remove('is-active');
    });
    activeMedia.classList.add('is-active');
  }
}
customElements.define('media-gallery', MediaGallery);

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*'
    );
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

var BlsCustomer = (function () {
  return {
    init: function () {
      this.toggleForm(), this.deleteAddresses(), this.addAddresses();
    },
    toggleForm: function () {
      const e = document.querySelector('.add-address');
      const c = document.querySelector('.cancel-add');
      if (e !== null && c !== null) {
        e.addEventListener('click', () => {
          if (e.getAttribute('aria-expanded') === 'false') {
            e.setAttribute('aria-expanded', 'true');
            e.closest('.bls-customer__address').classList.add('active');
          } else {
            e.setAttribute('aria-expanded', 'false');
            e.closest('.bls-customer__address').classList.remove('active');
          }
        });
        c.addEventListener('click', () => {
          if (
            c.closest('.bls-customer__address').classList.contains('active')
          ) {
            e.closest('.bls-customer__address').classList.remove('active');
            e.closest('.add-address').setAttribute('aria-expanded', 'false');
          }
        });
      }
    },
    deleteAddresses: function () {
      const btn = document.querySelectorAll('.address-delete');
      btn.forEach((e) => {
        e.addEventListener('click', () => {
          const id = e?.dataset.formId;
          const msg = e?.dataset.confirmMessage;
          if (confirm(msg || 'Are you sure you wish to delete this address?')) {
            Shopify.postLink('/account/addresses/' + id, {
              parameters: { _method: 'delete' },
            });
          }
        });
      });
    },
    addAddresses: function () {
      if (Shopify && document.getElementById('AddressCountryNew')) {
        new Shopify.CountryProvinceSelector(
          'AddressCountryNew',
          'AddressProvinceNew',
          {
            hideElement: 'AddressProvinceNewContainer',
          }
        );
      }
      const edit = document.querySelectorAll('.edit-country-option');
      edit.forEach((e) => {
        const formId = e?.dataset.formId;
        const editCountry = 'AddressCountry_' + formId;
        const editProvince = 'AddressProvince_' + formId;
        const editContainer = 'AddressProvinceContainer_' + formId;
        new Shopify.CountryProvinceSelector(editCountry, editProvince, {
          hideElement: editContainer,
        });
      });
    },
  };
})();
BlsCustomer.init();
class ideaProducts extends HTMLElement {
  constructor() {
    super();
    this.view_idea_product = this.querySelector('.view_idea_product');
    this.content = this.querySelector('.idea-product-list');
    this.close = this.querySelector('.close');
    this.init();
  }
  init() {
    const _this = this;
    this.view_idea_product.addEventListener('click', (e) => {
      _this.toggleViewIdeaProducts('show');
    });
    this.close.addEventListener('click', (e) => {
      _this.toggleViewIdeaProducts.bind(_this)();
    });
  }

  toggleViewIdeaProducts(type = 'hidden') {
    if (type == 'hidden') {
      this.classList.remove('active');
    } else {
      this.classList.add('active');
    }
  }
}

customElements.define('idea-product', ideaProducts);

const outfit_idea = document.querySelector('.outfit_idea');
if (outfit_idea) {
  document.body.addEventListener('click', function (event) {
    if (!event.target.closest('.idea-product')) {
      const ideaProductInstances = document.querySelectorAll('idea-product');
      ideaProductInstances.forEach((instance) => {
        instance.toggleViewIdeaProducts();
      });
    }
  });
}

class closeQuickview extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.addEventListener('click', (e) => {
      this.closest('.product-popup-mobile').classList.remove('open');
      document.querySelector('html').classList.remove('overflow-hidden');
      setTimeout(() => {
        if (this.closest('.product-popup-mobile')) {
          this.closest('.product-popup-mobile').remove();
        }
      }, 300);
    });
  }
}

customElements.define('close-quickview', closeQuickview);

const BlsMeasurement = (function () {
  return {
    init: function () {
      this.toggleMeasurement();
      this.highlightMatchingRows();
    },
    toggleMeasurement: function () {
      const measurementToggle = document.getElementById('measurement-toggle');
      const measurementElements = document.querySelectorAll('[data-measurement]');
      const formGroups = document.querySelectorAll('.form-group-measurement input');

      function cmToInch(cm) {
        return Math.ceil(cm / 2.54);
      }
      function inchToCm(inch) {
        return Math.ceil(inch * 2.54);
      }

  // 保存原始（cm）文本，仅针对静态显示元素
  measurementElements.forEach(element => {
    const value = element.textContent.trim();
    element.setAttribute('data-original-measurement', value);
  });

  function updateMeasurements() {
    // 更新表格内的静态区间显示
    measurementElements.forEach(element => {
      const originalValue = element.getAttribute('data-original-measurement');
      if (!originalValue) return;

      const values = originalValue.split('-').map(v => parseFloat(v));
      if (values.some(isNaN)) return;

      if (measurementToggle.checked) { // checked = inch
        const convertedValues = values.map(cmToInch);
        // 例如 80-86 -> 32"-34"
        element.textContent = convertedValues.join('"-') + '"';
      } else {
        element.textContent = originalValue; // 还原为 cm
      }
    });

    // 同步当前输入框的数值（双向换算）
    formGroups.forEach(input => {
      const currentValue = parseFloat((input.value || '').trim());
      if (!isNaN(currentValue)) {
        if (measurementToggle.checked) {
          // 切到 inch：把 cm -> inch
          input.value = cmToInch(currentValue);
        } else {
          // 切回 cm：把 inch -> cm
          input.value = inchToCm(currentValue);
        }
      }
    });

    // 触发一次 input，让高亮逻辑立刻重跑
    formGroups.forEach(i => i.dispatchEvent(new Event('input', { bubbles: true })));
  }

  // 监听切换
  measurementToggle?.addEventListener('change', updateMeasurements);

  // —— 关键：默认打开 inch 并立即换算一次 ——
  if (measurementToggle) {
    measurementToggle.checked = true; // 默认 inch
    updateMeasurements();             // 首次渲染就显示 inch
  }
},
    highlightMatchingRows: function () {
      const formGroups = document.querySelectorAll('.form-group-measurement input');
      const tableRows = document.querySelectorAll('.content-measurement tr');
      const appendSize = document.querySelector('.append-size');
      const contentHidden = document.querySelector('.content-hidden');
    
      formGroups.forEach(input => {
        input.addEventListener('input', function () {
          checkAllInputs();
        });
      });
    
      function checkAllInputs() {
        const filledInputs = Array.from(formGroups).filter(input => {
          const value = parseFloat(input.value.trim());
          return !isNaN(value);
        });
    
        let lastActiveRowSize = '';
        let hasInvalidInput = false;
    
        // Check for invalid inputs
        filledInputs.forEach(input => {
          const inputValue = parseFloat(input.value);
          const inputId = input.id;
          let valueInRange = false;
    
          tableRows.forEach(row => {
            const tdWithDataset = row.querySelector(`td[data-${inputId}]`);
            if (tdWithDataset) {
              // Remove " character and split by -
              const [min, max] = tdWithDataset.textContent.trim().replace(/"/g, '').split('-').map(parseFloat);
              console.log('min :>> ', min);
              if (inputValue >= min && inputValue <= max) {
                valueInRange = true;
              }
            }
          });
    
          if (!valueInRange) {
            hasInvalidInput = true;
          }
        });
    
        // Check each row and update lastActiveRowSize
        tableRows.forEach(row => {
          let matchesById = true;
          let matchesByRange = false;
          
          filledInputs.forEach(input => {
            const inputValue = parseFloat(input.value);
            const inputId = input.id;
            const tdWithDataset = row.querySelector(`td[data-${inputId}]`);
            
            if (tdWithDataset) {
              // Remove " character and split by -
              const [min, max] = tdWithDataset.textContent.trim().replace(/"/g, '').split('-').map(parseFloat);
              if (!(inputValue >= min && inputValue <= max)) {
                matchesById = false;
              }
              if (inputValue >= min && inputValue <= max) {
                matchesByRange = true;
              }
            }
          });
    
          if ((matchesById || matchesByRange) && filledInputs.length > 0) {
            row.classList.add('active');
            lastActiveRowSize = row.querySelector('[data-size]').textContent.trim();
          } else {
            row.classList.remove('active');
          }
        });
    
        // Update size display
        if (hasInvalidInput) {
          appendSize.classList.add('hidden');
          contentHidden.classList.remove('hidden');
        } else if (lastActiveRowSize) {
          appendSize.textContent = lastActiveRowSize;
          appendSize.classList.remove('hidden');
          contentHidden.classList.add('hidden');
        } else {
          appendSize.textContent = lastActiveRowSize;
          appendSize.classList.remove('hidden');
          contentHidden.classList.add('hidden');
        }
      }
    }
  };
})();

BlsMeasurement.init();


function resetSubmenu(parent) {
  const activeBlock = parent.querySelector(":scope > collapsible-block.active");
  if (activeBlock) {
    activeBlock.querySelectorAll(".subchildmenu-mobile > .level-1").forEach(item => {
      const menuItem = item.querySelector(":scope > menu-item");
      const link = menuItem?.querySelector(".menu_item-link");
      const submenu = item.querySelector(":scope > .sub-children-menu");
      if (submenu) {
        submenu.style.display = "block";
        menuItem?.classList.add("is-open");
        link?.classList.add("active");
      }
    });
  }
}

document.addEventListener("click", function (e) {
  const topLevelHeading = e.target.closest(
    ".nav-mobile .horizontal-list > .level0 > collapsible-block > .collapsible-heading"
  );

  if (topLevelHeading) {
    const nav = topLevelHeading.closest(".nav-mobile");
    const headingLink = e.target.closest("a");
    if (headingLink && topLevelHeading.contains(headingLink) && nav?.dataset.actionMobile !== "true") {
      e.preventDefault();
    }

    const li = topLevelHeading.closest("li.level0");
    if (li) {
      setTimeout(() => resetSubmenu(li), 100);
    }
    return;
  }

  const toggle = e.target.closest(".open-children-toggle");
  if (toggle) {
    const li = toggle.closest("li");
    if (li && li.classList.contains("level0")) {
      setTimeout(() => resetSubmenu(li), 100);
    }
  }
});
